/* tslint:disable */
/* eslint-disable */
// <auto-generated>
//   Generated using custom tool!
// </auto-generated>

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import { DefaultAxiosInstance } from './DefaultAxiosInstance';
import { Try } from '../framework/Try';

export async function agendaCommand_new(body: ICalendarEventModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<ICalendarEventModel>>> {
  try {

        let url_ = "/api/AgendaCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function agendaCommand_move(id: string, body: ICalendarEventMoveModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/AgendaCommand/{id}/move";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function agendaCommand_update(id: string, body: ICalendarEventModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ICalendarEventModel>>> {
  try {

        let url_ = "/api/AgendaCommand/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function agendaCommand_addExDate(id: string, body: Date, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/AgendaCommand/{id}/exDates/add";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function agendaCommand_updateRrule(id: string, body: ICalendarEventRruleModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/AgendaCommand/{id}/rrule/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function agendaCommand_delete(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/AgendaCommand/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function agendaCommand_noShow(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/AgendaCommand/{id}/noShow";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function agendaCommand_didShow(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/AgendaCommand/{id}/didShow";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function agendaCommand_scriptFix(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/AgendaCommand/script/fix";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function agendaQuery_query(body: IAgendaQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IAgendaResponse>> {
  try {

        let url_ = "/api/AgendaQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function agendaQuery_queryByUser(body: IAgendaQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICalendarEventDto[]>> {
  try {

        let url_ = "/api/AgendaQuery/queryByUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function agendaQuery_queryByPatient(body: ICalendarEventsByPatientQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICalendarEventDto[]>> {
  try {

        let url_ = "/api/AgendaQuery/queryByPatient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function agendaQuery_search(body: ICalendarEventsSearchQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICalendarEventDto[]>> {
  try {

        let url_ = "/api/AgendaQuery/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function agendaQuery_upcomingByPatient(patientId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICalendarEventDto[]>> {
  try {

        let url_ = "/api/AgendaQuery/patients/{patientId}/upcoming";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function agendaQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/AgendaQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function agendaQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICalendarEventDto>> {
  try {

        let url_ = "/api/AgendaQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function agendaQuery_settings(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICalendarSettings>> {
  try {

        let url_ = "/api/AgendaQuery/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function agendaQuery_export(body: ICalendarEventsExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/AgendaQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function agendaQuery_countForUser(userId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/AgendaQuery/countForUser/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function agendaQuery_countForLocation(locationId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/AgendaQuery/countForLocation/{locationId}";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function agendaSettingsCommand_updateRequiredProperties(body: string[], cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/AgendaSettingsCommand/requiredProperties/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function annotationsCommand_add(body: IAnnotationModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IAnnotationModel>>> {
  try {

        let url_ = "/api/AnnotationsCommand/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function annotationsCommand_update(id: string, body: IAnnotationUpdateModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/AnnotationsCommand/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function annotationsCommand_addAttachment(id: string, body: IAnnotationAttachmentModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/AnnotationsCommand/{id}/attachments/add";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function annotationsCommand_deleteAttachment(id: string, attachmentId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/AnnotationsCommand/{id}/attachments/{attachmentId}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function annotationsCommand_restore(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/AnnotationsCommand/{id}/restore";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function annotationsCommand_restoreAttachment(id: string, attachmentId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/AnnotationsCommand/{id}/attachments/{attachmentId}/restore";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function annotationsCommand_delete(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/AnnotationsCommand/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function annotationsQuery_query(isFollowUp: boolean, referenceId: string, body: IAnnotationsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IAnnotation>>> {
  try {

        let url_ = "/api/AnnotationsQuery/query/{isFollowUp}/{referenceId}";
        if (isFollowUp === undefined || isFollowUp === null)
            throw new Error("The parameter 'isFollowUp' must be defined.");
        url_ = url_.replace("{isFollowUp}", encodeURIComponent("" + isFollowUp));
        if (referenceId === undefined || referenceId === null)
            throw new Error("The parameter 'referenceId' must be defined.");
        url_ = url_.replace("{referenceId}", encodeURIComponent("" + referenceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function annotationsQuery_hasAnnotations(isFollowUp: boolean, referenceId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<boolean>> {
  try {

        let url_ = "/api/AnnotationsQuery/hasAnnotations/{isFollowUp}/{referenceId}";
        if (isFollowUp === undefined || isFollowUp === null)
            throw new Error("The parameter 'isFollowUp' must be defined.");
        url_ = url_.replace("{isFollowUp}", encodeURIComponent("" + isFollowUp));
        if (referenceId === undefined || referenceId === null)
            throw new Error("The parameter 'referenceId' must be defined.");
        url_ = url_.replace("{referenceId}", encodeURIComponent("" + referenceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function annotationsQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IAnnotation>> {
  try {

        let url_ = "/api/AnnotationsQuery/{id}/single";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function annotationsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/AnnotationsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function annotationsQuery_downloadAttachment(id: string, attachmentId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/AnnotationsQuery/{id}/attachments/{attachmentId}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function annotationTypesCommand_new(body: IAnnotationTypeModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IAnnotationTypeModel>>> {
  try {

        let url_ = "/api/AnnotationTypesCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function annotationTypesCommand_update(id: string, body: IAnnotationTypeModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IAnnotationTypeModel>>> {
  try {

        let url_ = "/api/AnnotationTypesCommand/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function annotationTypesCommand_updateColor(id: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/AnnotationTypesCommand/{id}/color/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function annotationTypesCommand_delete(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/AnnotationTypesCommand/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function annotationTypesQuery_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<IAnnotationType[]>>> {
  try {

        let url_ = "/api/AnnotationTypesQuery/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function annotationTypesQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/AnnotationTypesQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function annotationTypesQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IAnnotationType>> {
  try {

        let url_ = "/api/AnnotationTypesQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function apiTokensCommand_revokeAll(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/ApiTokensCommand/revoke-all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function apiTokensCommand_revoke(body: IRevokeApiTokenRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRevokeApiTokenRequest>>> {
  try {

        let url_ = "/api/ApiTokensCommand/revoke";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function apiTokensCommand_setUser(clientId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/ApiTokensCommand/{clientId}/setUser";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function apiTokensCommand_requestOrRenew(body: IGenerateOrRenewTokenRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IApiTokenResponse>> {
  try {

        let url_ = "/api/ApiTokensCommand/requestOrRenew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function apiTokensCommand_request(body: IGenerateApiTokenRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IApiTokenResponse>> {
  try {

        let url_ = "/api/ApiTokensCommand/request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function apiTokensCommand_renew(body: IRenewApiTokenRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IApiTokenResponse>> {
  try {

        let url_ = "/api/ApiTokensCommand/renew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function apiTokensQuery_query(body: IApiTokensQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IApiTokenDto>>> {
  try {

        let url_ = "/api/ApiTokensQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function apiTokensQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IApiTokenDto>> {
  try {

        let url_ = "/api/ApiTokensQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function apiTokensQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/ApiTokensQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function applicationSettingsCommand_patchLogoutMode(body: IPatchAppLogoutModeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchAppLogoutModeRequest>>> {
  try {

        let url_ = "/api/ApplicationSettingsCommand/logout-mode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function applicationSettingsCommand_noahDeviceReadOutMode(body: IPatchNoahDeviceReadOutModeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchNoahDeviceReadOutModeRequest>>> {
  try {

        let url_ = "/api/ApplicationSettingsCommand/noah-device-read-out-mode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function applicationSettingsCommand_clientClaims(body: IPatchClientClaimsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchClientClaimsRequest>>> {
  try {

        let url_ = "/api/ApplicationSettingsCommand/client-claims";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function applicationSettingsQuery_noahDeviceReadOutMode(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/ApplicationSettingsQuery/noah-device-read-out-mode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function applicationSettingsQuery_appSettings(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IApplicationSettings>> {
  try {

        let url_ = "/api/ApplicationSettingsQuery/app-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function applicationSettingsQuery_logoutMode(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ApplicationLogoutMode>> {
  try {

        let url_ = "/api/ApplicationSettingsQuery/logout-mode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function applicationSettingsQuery_calendarMode(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<CalendarMode>> {
  try {

        let url_ = "/api/ApplicationSettingsQuery/calendar-mode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function articlePropertyAutocompleteQuery_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<IArticlePropertyAutocomplete[]>>> {
  try {

        let url_ = "/api/ArticlePropertyAutocompleteQuery/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function articlePropertyAutocompleteQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/ArticlePropertyAutocompleteQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function articlePropertyKeysQuery_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<IArticlePropertyKey[]>>> {
  try {

        let url_ = "/api/ArticlePropertyKeysQuery/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function articlePropertyKeysQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/ArticlePropertyKeysQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function articlesInquiriesCommand_register(body: IRegisterArticlesInquiryRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IRegisterArticlesInquiryRequest>>> {
  try {

        let url_ = "/api/ArticlesInquiriesCommand/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function articlesInquiriesCommand_deleteLine(body: IDeleteArticlesInquiryLineRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IDeleteArticlesInquiryLineRequest>>> {
  try {

        let url_ = "/api/ArticlesInquiriesCommand/delete-line";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function articlesInquiriesCommand_addLines(body: IAddArticlesInquiryLinesRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IAddArticlesInquiryLinesRequest>>> {
  try {

        let url_ = "/api/ArticlesInquiriesCommand/add-lines";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function articlesInquiriesCommand_cancel(body: ICancelArticlesInquiryRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ICancelArticlesInquiryRequest>>> {
  try {

        let url_ = "/api/ArticlesInquiriesCommand/cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function articlesInquiriesCommand_patchHandlingUser(body: IPatchArticlesInquiryHandlingUserRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchArticlesInquiryHandlingUserRequest>>> {
  try {

        let url_ = "/api/ArticlesInquiriesCommand/handlingUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function articlesInquiriesCommand_registerNewOrder(body: IOrderArticlesInquiryRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IOrderArticlesInquiryRequest>>> {
  try {

        let url_ = "/api/ArticlesInquiriesCommand/order/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function articlesInquiriesCommand_addToExistingOrder(body: IAddArticlesInquiriesToExistingOrderRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IAddArticlesInquiriesToExistingOrderRequest>>> {
  try {

        let url_ = "/api/ArticlesInquiriesCommand/order/add-to-existing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function articlesInquiriesCommand_assignLineFromStock(body: IAssignArticlesInquiryLineFromStockRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IAssignArticlesInquiryLineFromStockRequest>>> {
  try {

        let url_ = "/api/ArticlesInquiriesCommand/assign-line-from-stock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function articlesInquiriesQuery_query(body: IArticlesInquiriesQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResultWithMetadata<IArticlesInquiry, IArticlesInquiriesMetadata>>> {
  try {

        let url_ = "/api/ArticlesInquiriesQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function articlesInquiriesQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IArticlesInquiryDto>> {
  try {

        let url_ = "/api/ArticlesInquiriesQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function articlesInquiriesQuery_nextReference(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/ArticlesInquiriesQuery/nextReference";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function articlesInquiriesQuery_settings(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IArticlesInquirySettings>> {
  try {

        let url_ = "/api/ArticlesInquiriesQuery/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function articlesInquiriesQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/ArticlesInquiriesQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function articlesInquiriesQuery_export(body: IArticlesInquiriesExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/ArticlesInquiriesQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function audiogramStandardsQuery_withTtaByPatient(patientId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IAudiogramStandardWithToneThresholdAudiogramsDto[]>> {
  try {

        let url_ = "/api/AudiogramStandardsQuery/withTta/byPatient/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function audiogramStandardsQuery_withSpeechByPatient(patientId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IAudiogramStandardWithSpeechAudiogramsDto[]>> {
  try {

        let url_ = "/api/AudiogramStandardsQuery/withSpeech/byPatient/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function audiogramStandardsQuery_tonalAudiogramImageSummariesByPatient(patientId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ITonalAudiogramImageSummary[]>> {
  try {

        let url_ = "/api/AudiogramStandardsQuery/tonalAudiogramImageSummaries/byPatient/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function audiogramStandardsQuery_tonalAudiogramImage(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ITonalAudiogramImage>> {
  try {

        let url_ = "/api/AudiogramStandardsQuery/{id}/tonalAudiogramImage";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function auth_info(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ILoginInfo>> {
  try {

        let url_ = "/api/Auth/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function auth_login(body: ILoginRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ILoginResponse>> {
  try {

        let url_ = "/api/Auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function auth_loginWithToken(body: ILoginWithTokenRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ILoginWithTokenResponse>> {
  try {

        let url_ = "/api/Auth/login-with-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function auth_sendLoginToken(body: ISendLoginTokenRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/Auth/send-login-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function auth_switchLocation(body: ISwitchLocationRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ILoginInfo>> {
  try {

        let url_ = "/api/Auth/switch-location";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function auth_confirm(body: IConfirmUserRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConfirmUserResponse>> {
  try {

        let url_ = "/api/Auth/confirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function auth_logout(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<void>> {
  try {

        let url_ = "/api/Auth/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function auth_endSession(body: IEndSessionRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IEndSessionRequest>>> {
  try {

        let url_ = "/api/Auth/end-session";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function auth_endAllUserSessions(body: IEndAllUserSessionsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IEndAllUserSessionsRequest>>> {
  try {

        let url_ = "/api/Auth/end-all-user-sessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function auth_sendResetPasswordLink(body: ISendResetPasswordLinkRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/Auth/send-reset-password-link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function auth_resetPassword(body: IResetPasswordRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IResetPasswordResponse>> {
  try {

        let url_ = "/api/Auth/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function bebatQuery_default(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<number>>> {
  try {

        let url_ = "/api/BebatQuery/default";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function bebatQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/BebatQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function businessDataCommand_patchGeneral(body: IPatchBusinessDataRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchBusinessDataRequest>>> {
  try {

        let url_ = "/api/BusinessDataCommand/general";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function businessDataCommand_patchBankAccount(body: IPatchBankAccountRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchBankAccountRequest>>> {
  try {

        let url_ = "/api/BusinessDataCommand/bank";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function businessDataCommand_patchAddress(body: IAddressModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IAddressModel>>> {
  try {

        let url_ = "/api/BusinessDataCommand/address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function businessDataCommand_patchAlternativeAddress(body: IAddressModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IAddressModel>>> {
  try {

        let url_ = "/api/BusinessDataCommand/alternative-address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function businessDataCommand_patchMainUser(body: IPatchBusinessDataMainUserRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchBusinessDataMainUserRequest>>> {
  try {

        let url_ = "/api/BusinessDataCommand/main-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function businessDataCommand_uploadLogo(body: IFileUploadRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IFileUploadRequest>>> {
  try {

        let url_ = "/api/BusinessDataCommand/logo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function businessDataCommand_uploadAlternativeLogo(body: IFileUploadRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IFileUploadRequest>>> {
  try {

        let url_ = "/api/BusinessDataCommand/alternativeLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function businessDataQuery_summary(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IBusinessData>> {
  try {

        let url_ = "/api/BusinessDataQuery/summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function businessDataQuery_details(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IBusinessDataWithImageDataDto>> {
  try {

        let url_ = "/api/BusinessDataQuery/details";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function businessDataQuery_logo(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/BusinessDataQuery/logo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function businessDataQuery_alternativeLogo(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/BusinessDataQuery/alternativeLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function calendarEventTypesCommand_new(body: ICalendarEventTypeModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<ICalendarEventTypeModel>>> {
  try {

        let url_ = "/api/CalendarEventTypesCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function calendarEventTypesCommand_update(id: string, body: ICalendarEventTypeModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ICalendarEventTypeModel>>> {
  try {

        let url_ = "/api/CalendarEventTypesCommand/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function calendarEventTypesCommand_updateColor(id: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/CalendarEventTypesCommand/{id}/color/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function calendarEventTypesCommand_delete(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/CalendarEventTypesCommand/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function calendarEventTypesQuery_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<ICalendarEventType[]>>> {
  try {

        let url_ = "/api/CalendarEventTypesQuery/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function calendarEventTypesQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/CalendarEventTypesQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function calendarEventTypesQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICalendarEventType>> {
  try {

        let url_ = "/api/CalendarEventTypesQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function calendarResourcesQuery_data(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<ICalendarResourcesDto>>> {
  try {

        let url_ = "/api/CalendarResourcesQuery/data";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function calendarResourcesQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/CalendarResourcesQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function cashRegisterCommand_new(body: ICashTransferModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<ICashTransferModel>>> {
  try {

        let url_ = "/api/CashRegisterCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function cashRegisterEntriesQuery_query(body: ICashRegisterEntriesQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<ICashRegisterEntry>>> {
  try {

        let url_ = "/api/CashRegisterEntriesQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function cashRegisterEntriesQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/CashRegisterEntriesQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function cashRegisterEntriesQuery_single(index: number, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICashRegisterEntry>> {
  try {

        let url_ = "/api/CashRegisterEntriesQuery/{index}";
        if (index === undefined || index === null)
            throw new Error("The parameter 'index' must be defined.");
        url_ = url_.replace("{index}", encodeURIComponent("" + index));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function cashRegisterEntriesQuery_export(body: ICashRegisterEntriesExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/CashRegisterEntriesQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function cashRegisterEntriesQuery_exportFormatted(body: ICashRegisterEntriesQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/CashRegisterEntriesQuery/export/formatted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function checkHasEazyworksData_handle(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<boolean>> {
  try {

        let url_ = "/api/has-ew-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionPayoutsCommand_new(body: ICommissionPayoutModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<ICommissionPayoutModel>>> {
  try {

        let url_ = "/api/CommissionPayoutsCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionPayoutsCommand_confirm(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/CommissionPayoutsCommand/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionPayoutsCommand_delete(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/CommissionPayoutsCommand/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionPayoutsQuery_query(body: ICommissionPayoutsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<ICommissionPayout>>> {
  try {

        let url_ = "/api/CommissionPayoutsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionPayoutsQuery_nextReference(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/CommissionPayoutsQuery/nextReference";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionPayoutsQuery_queryForUser(body: ICommissionPayoutsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<ICommissionPayout>>> {
  try {

        let url_ = "/api/CommissionPayoutsQuery/query/forUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionPayoutsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/CommissionPayoutsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionPayoutsQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICommissionPayout>> {
  try {

        let url_ = "/api/CommissionPayoutsQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionPayoutsQuery_settings(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICommissionPayoutSettings>> {
  try {

        let url_ = "/api/CommissionPayoutsQuery/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionPayoutsSettingsCommand_updateReferenceSettings(body: IReferenceSettingsModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IReferenceSettingsModel>>> {
  try {

        let url_ = "/api/CommissionPayoutsSettingsCommand/referenceSettings/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionRulesCommand_new(body: ICommissionRuleModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<ICommissionRuleModel>>> {
  try {

        let url_ = "/api/CommissionRulesCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionRulesCommand_update(id: string, body: ICommissionRuleModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ICommissionRuleModel>>> {
  try {

        let url_ = "/api/CommissionRulesCommand/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionRulesCommand_enable(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/CommissionRulesCommand/{id}/enable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionRulesCommand_disable(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/CommissionRulesCommand/{id}/disable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionRulesQuery_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<ICommissionRulesCache>>> {
  try {

        let url_ = "/api/CommissionRulesQuery/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionRulesQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/CommissionRulesQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionRulesQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICommissionRule>> {
  try {

        let url_ = "/api/CommissionRulesQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionsCommand_new(body: ICommissionModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<ICommissionModel>>> {
  try {

        let url_ = "/api/CommissionsCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionsCommand_delete(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/CommissionsCommand/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionsQuery_query(body: ICommissionsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<ICommission>>> {
  try {

        let url_ = "/api/CommissionsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionsQuery_queryForUser(body: ICommissionsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<ICommission>>> {
  try {

        let url_ = "/api/CommissionsQuery/query/forUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionsQuery_allNotPaidOutForUser(userId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICommission[]>> {
  try {

        let url_ = "/api/CommissionsQuery/notPaidOut/forUser/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionsQuery_usersWithNotPaidOutCommissions(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string[]>> {
  try {

        let url_ = "/api/CommissionsQuery/usersWithNotPaidOutCommissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionsQuery_export(body: ICommissionsExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/CommissionsQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/CommissionsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function commissionsQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICommission>> {
  try {

        let url_ = "/api/CommissionsQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function companiesCommand_new(body: IRegisterVatCustomerRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IRegisterVatCustomerRequest>>> {
  try {

        let url_ = "/api/CompaniesCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function companiesCommand_patchContact(body: IPatchVatCustomerContactInfoRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchVatCustomerContactInfoRequest>>> {
  try {

        let url_ = "/api/CompaniesCommand/contact-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function companiesCommand_patchAddress(body: IPatchVatCustomerAddressRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchVatCustomerAddressRequest>>> {
  try {

        let url_ = "/api/CompaniesCommand/address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function companiesCommand_patchName(body: IPatchVatCustomerNameRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchVatCustomerNameRequest>>> {
  try {

        let url_ = "/api/CompaniesCommand/name";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function companiesCommand_patchVatNumber(body: IPatchVatCustomerVatNumberRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchVatCustomerVatNumberRequest>>> {
  try {

        let url_ = "/api/CompaniesCommand/vat-number";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function companiesCommand_patchPhone(body: IPatchVatCustomerPhoneRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchVatCustomerPhoneRequest>>> {
  try {

        let url_ = "/api/CompaniesCommand/phone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function companiesCommand_patchEmail(body: IPatchVatCustomerEmailRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchVatCustomerEmailRequest>>> {
  try {

        let url_ = "/api/CompaniesCommand/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function companiesQuery_query(body: ICompaniesQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<ICompany>>> {
  try {

        let url_ = "/api/CompaniesQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function companiesQuery_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<ICompanySummary[]>>> {
  try {

        let url_ = "/api/CompaniesQuery/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function companiesQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/CompaniesQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function companiesQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICompany>> {
  try {

        let url_ = "/api/CompaniesQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function companiesQuery_singleRecipientAndAddress(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRecipientAndAddress>> {
  try {

        let url_ = "/api/CompaniesQuery/{id}/recipientAndAddress";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function companiesQuery_export(body: ICompaniesExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/CompaniesQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function cosiQuestionnaireCommand_new(body: ICosiQuestionnaireModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<ICosiQuestionnaireModel>>> {
  try {

        let url_ = "/api/CosiQuestionnaireCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function cosiQuestionnaireCommand_evaluate(body: ICosiQuestionnaireModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ICosiQuestionnaireModel>>> {
  try {

        let url_ = "/api/CosiQuestionnaireCommand/evaluate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function cosiQuestionnaireQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICosiQuestionnaire>> {
  try {

        let url_ = "/api/CosiQuestionnaireQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function cosiQuestionnaireQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/CosiQuestionnaireQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function cosiQuestionnaireQuery_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<string[]>>> {
  try {

        let url_ = "/api/CosiQuestionnaireQuery/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function customerAccountLinesQuery_query(customerAccountId: string, body: ICustomerAccountLinesQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<ICustomerAccountLine>>> {
  try {

        let url_ = "/api/CustomerAccountLinesQuery/query/customerAccounts/{customerAccountId}";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined.");
        url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function customerAccountLinesQuery_queryUnhandled(body: IUnhandledCustomerAccountLinesQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResultWithMetadata<ICustomerAccountLine, ICustomerAccountLineQueryMetadata>>> {
  try {

        let url_ = "/api/CustomerAccountLinesQuery/query/unhandled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function customerAccountLinesQuery_allForCustomerAccountNoSpsWithOutstandingBalance(customerAccountId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICustomerAccountLine[]>> {
  try {

        let url_ = "/api/CustomerAccountLinesQuery/all/customerAccounts/{customerAccountId}/noSpsWithOutstandingBalance";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined.");
        url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function customerAccountLinesQuery_allForSettlementProposalWithOutstandingBalance(customerAccountId: string, settlementProposalId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICustomerAccountLine[]>> {
  try {

        let url_ = "/api/CustomerAccountLinesQuery/all/customerAccounts/{customerAccountId}/settlementProposals/{settlementProposalId}/withOutstandingBalance";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined.");
        url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
        if (settlementProposalId === undefined || settlementProposalId === null)
            throw new Error("The parameter 'settlementProposalId' must be defined.");
        url_ = url_.replace("{settlementProposalId}", encodeURIComponent("" + settlementProposalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function customerAccountLinesQuery_allForSpsOrWithoutSpsWithOutstandingBalance(customerAccountId: string, settlementProposalId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICustomerAccountLine[]>> {
  try {

        let url_ = "/api/CustomerAccountLinesQuery/all/customerAccounts/{customerAccountId}/settlementProposals/{settlementProposalId}/update";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined.");
        url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
        if (settlementProposalId === undefined || settlementProposalId === null)
            throw new Error("The parameter 'settlementProposalId' must be defined.");
        url_ = url_.replace("{settlementProposalId}", encodeURIComponent("" + settlementProposalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function customerAccountLinesQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/CustomerAccountLinesQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function customerAccountLinesQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICustomerAccountLine>> {
  try {

        let url_ = "/api/CustomerAccountLinesQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function customerAccountLinesQuery_queryForSale(salesId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICustomerAccountLine[]>> {
  try {

        let url_ = "/api/CustomerAccountLinesQuery/sales/{salesId}";
        if (salesId === undefined || salesId === null)
            throw new Error("The parameter 'salesId' must be defined.");
        url_ = url_.replace("{salesId}", encodeURIComponent("" + salesId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function customerAccountLinesQuery_export(customerAccountId: string, body: ICustomerAccountLinesExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/CustomerAccountLinesQuery/export/customerAccount/{customerAccountId}";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined.");
        url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function customerAccountsQuery_query(body: ICustomerAccountsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResultWithMetadata<ICustomerAccount, ICustomerAccountQueryMetadata>>> {
  try {

        let url_ = "/api/CustomerAccountsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function customerAccountsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/CustomerAccountsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function customerAccountsQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICustomerAccount>> {
  try {

        let url_ = "/api/CustomerAccountsQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function customerAccountsQuery_detail(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICustomerAccountDetail>> {
  try {

        let url_ = "/api/CustomerAccountsQuery/{id}/detail";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function customerAccountsQuery_singleRecipientAndAddress(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRecipientAndAddress>> {
  try {

        let url_ = "/api/CustomerAccountsQuery/{id}/recipientAndAddress";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function customerAccountsQuery_isHifAndIsDeleted(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<boolean>> {
  try {

        let url_ = "/api/CustomerAccountsQuery/{id}/isHifAndIsDeleted";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function customerAccountsQuery_export(body: ICustomerAccountsExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/CustomerAccountsQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function customFeaturesCommand_consignmentFile_resume(resumeId: string, body: IConsignmentFileResumeModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConsignmentFileResponse>> {
  try {

        let url_ = "/api/CustomFeaturesCommand/consignmentFile/{resumeId}/resume";
        if (resumeId === undefined || resumeId === null)
            throw new Error("The parameter 'resumeId' must be defined.");
        url_ = url_.replace("{resumeId}", encodeURIComponent("" + resumeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function customFeaturesCommand_consignmentFile_initial(body: IExcelFileUploadModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConsignmentFileResponse>> {
  try {

        let url_ = "/api/CustomFeaturesCommand/consignmentFile/initial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function customFeaturesQuery_download(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/CustomFeaturesQuery/{id}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function dailyReceiptsQuery_query(body: IDailyReceiptsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IDailyReceipt>>> {
  try {

        let url_ = "/api/DailyReceiptsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function dailyReceiptsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/DailyReceiptsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function dailyReceiptsQuery_single(index: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IDailyReceipt>> {
  try {

        let url_ = "/api/DailyReceiptsQuery/{index}";
        if (index === undefined || index === null)
            throw new Error("The parameter 'index' must be defined.");
        url_ = url_.replace("{index}", encodeURIComponent("" + index));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function dailyReceiptsQuery_export(body: IDailyReceiptsExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/DailyReceiptsQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function dailyReceiptsQuery_exportFormatted(body: IDailyReceiptsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/DailyReceiptsQuery/export/formatted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function dashboardQuery_data(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IDashboardData>> {
  try {

        let url_ = "/api/DashboardQuery/data";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function deliveriesCommand_new(body: IRegisterDeliveryRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IRegisterDeliveryRequest>>> {
  try {

        let url_ = "/api/DeliveriesCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function deliveriesCommand_newNonTailorMadeInventoryItem(body: IRegisterDeliveryFromInventoryItemRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IRegisterDeliveryFromInventoryItemRequest>>> {
  try {

        let url_ = "/api/DeliveriesCommand/new/nonTailorMadeInventoryItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function deliveriesCommand_patchExternalReference(body: IPatchDeliveryExternalReferenceRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchDeliveryExternalReferenceRequest>>> {
  try {

        let url_ = "/api/DeliveriesCommand/externalReference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function deliveriesCommand_patchDispatchInfo(body: IPatchDeliveryDispatchInfoRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchDeliveryDispatchInfoRequest>>> {
  try {

        let url_ = "/api/DeliveriesCommand/dispatchInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function deliveriesCommand_patchDeliveryDate(body: IPatchDeliveryDateRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchDeliveryDateRequest>>> {
  try {

        let url_ = "/api/DeliveriesCommand/deliveryDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function deliveriesQuery_query(body: IDeliveriesQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IDelivery>>> {
  try {

        let url_ = "/api/DeliveriesQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function deliveriesQuery_nextReference(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/DeliveriesQuery/nextReference";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function deliveriesQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IDelivery>> {
  try {

        let url_ = "/api/DeliveriesQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function deliveriesQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/DeliveriesQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function deliveriesQuery_export(body: IDeliveriesExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/DeliveriesQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function deliveriesQuery_settings(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IDeliverySettings>> {
  try {

        let url_ = "/api/DeliveriesQuery/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function deliverySettingsCommand_patchReferenceSettings(body: IPatchDeliveryReferenceSettingsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchDeliveryReferenceSettingsRequest>>> {
  try {

        let url_ = "/api/DeliverySettingsCommand/reference-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function disableCochlearIntegration_handle(body: IDisableCochlearIntegrationRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IDisableCochlearIntegrationRequest>>> {
  try {

        let url_ = "/api/cochlear/disable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function disablePeppolIntegration_handle(body: IDisablePeppolIntegrationRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IDisablePeppolIntegrationRequest>>> {
  try {

        let url_ = "/api/peppol/disable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function documentsCommand_upload(body: IUploadDocumentRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IUploadDocumentRequest>>> {
  try {

        let url_ = "/api/DocumentsCommand/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function documentsCommand_createFromTemplate(body: IDocumentFromTemplateModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IDocumentFromTemplateModel>>> {
  try {

        let url_ = "/api/DocumentsCommand/create/fromTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function documentsCommand_save(body: ISaveDocumentRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/DocumentsCommand/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function documentsCommand_replace(body: IReplaceDocumentRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IReplaceDocumentRequest>>> {
  try {

        let url_ = "/api/DocumentsCommand/replace";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function documentsCommand_delete(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/DocumentsCommand/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function documentsCommand_rebuildFromTemplate(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/DocumentsCommand/{id}/rebuildFromTemplate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function documentsCommand_updateName(id: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/DocumentsCommand/{id}/name/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function documentsCommand_enableMustSign(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/DocumentsCommand/{id}/mustSign/enable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function documentsCommand_disableMustSign(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/DocumentsCommand/{id}/mustSign/disable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function documentsQuery_query(body: IDocumentsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IDocument>>> {
  try {

        let url_ = "/api/DocumentsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function documentsQuery_byIdAndContextNotDeleted(body: IDocumentsByContextAndIdParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IDocumentSummary[]>> {
  try {

        let url_ = "/api/DocumentsQuery/by-id-and-context-not-deleted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function documentsQuery_queryForPatient(patientId: string, body: IDocumentsQueryParamsForPatient, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IDocument>>> {
  try {

        let url_ = "/api/DocumentsQuery/query/patient/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function documentsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/DocumentsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function documentsQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IDocument>> {
  try {

        let url_ = "/api/DocumentsQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function documentsQuery_content(id: string, format: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IDocumentContent>> {
  try {

        let url_ = "/api/DocumentsQuery/{id}/content/{format}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function documentsQuery_historyContent(id: string, historyId: string, format: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IDocumentContent>> {
  try {

        let url_ = "/api/DocumentsQuery/{id}/history/{historyId}/content/{format}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (historyId === undefined || historyId === null)
            throw new Error("The parameter 'historyId' must be defined.");
        url_ = url_.replace("{historyId}", encodeURIComponent("" + historyId));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function documentsQuery_download(id: string, format: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/DocumentsQuery/{id}/download/{format}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function documentsQuery_historyDownload(id: string, historyId: string, format: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/DocumentsQuery/{id}/history/{historyId}/download/{format}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (historyId === undefined || historyId === null)
            throw new Error("The parameter 'historyId' must be defined.");
        url_ = url_.replace("{historyId}", encodeURIComponent("" + historyId));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function documentsQuery_downloadEazyworksDocument(attachmentId: string, filename: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/DocumentsQuery/eazyworks/{attachmentId}/{filename}";
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function downloadAcousoftDocument_handle(id: number, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/acousoft/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function downloads_application(application: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/Downloads/app/{application}";
        if (application === undefined || application === null)
            throw new Error("The parameter 'application' must be defined.");
        url_ = url_.replace("{application}", encodeURIComponent("" + application));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function enableCochlearIntegration_handle(body: IEnableCochlearIntegrationRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IEnableCochlearIntegrationRequest>>> {
  try {

        let url_ = "/api/cochlear/enable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function enablePeppolIntegration_handle(body: IEnablePeppolIntegrationRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IEnablePeppolIntegrationRequest>>> {
  try {

        let url_ = "/api/peppol/enable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function entPhysiciansCommand_new(body: IRegisterEntPhysicianRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IRegisterEntPhysicianRequest>>> {
  try {

        let url_ = "/api/EntPhysiciansCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function entPhysiciansCommand_delete(body: IDeleteEntPhysicianRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IDeleteEntPhysicianRequest>>> {
  try {

        let url_ = "/api/EntPhysiciansCommand/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function entPhysiciansCommand_restore(body: IRestoreEntPhysicianRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRestoreEntPhysicianRequest>>> {
  try {

        let url_ = "/api/EntPhysiciansCommand/restore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function entPhysiciansCommand_patchPersonalInfo(body: IPatchEntPhysicianPersonalInformationRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchEntPhysicianPersonalInformationRequest>>> {
  try {

        let url_ = "/api/EntPhysiciansCommand/personal-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function entPhysiciansCommand_patchRizivNumber(body: IPatchEntPhysicianRizivNumberRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchEntPhysicianRizivNumberRequest>>> {
  try {

        let url_ = "/api/EntPhysiciansCommand/riziv-number";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function entPhysiciansCommand_addOffice(body: IAddEntPhysicianOfficeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IAddEntPhysicianOfficeRequest>>> {
  try {

        let url_ = "/api/EntPhysiciansCommand/add-office";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function entPhysiciansCommand_patchOfficeAddress(body: IPatchEntPhysicianOfficeAddressRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchEntPhysicianOfficeAddressRequest>>> {
  try {

        let url_ = "/api/EntPhysiciansCommand/office/address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function entPhysiciansCommand_patchOfficeEmail(body: IPatchEntPhysicianOfficeEmailRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchEntPhysicianOfficeEmailRequest>>> {
  try {

        let url_ = "/api/EntPhysiciansCommand/office/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function entPhysiciansCommand_patchOfficePhone(body: IPatchEntPhysicianOfficePhoneRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchEntPhysicianOfficePhoneRequest>>> {
  try {

        let url_ = "/api/EntPhysiciansCommand/office/phone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function entPhysiciansCommand_makeOfficeDefault(body: IMakeEntPhysicianOfficeDefaultRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IMakeEntPhysicianOfficeDefaultRequest>>> {
  try {

        let url_ = "/api/EntPhysiciansCommand/office/make-default";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function entPhysiciansCommand_deleteOffice(body: IDeleteEntPhysicianOfficeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IDeleteEntPhysicianOfficeRequest>>> {
  try {

        let url_ = "/api/EntPhysiciansCommand/office/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function entPhysiciansCommand_restoreOffice(body: IRestoreEntPhysicianOfficeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRestoreEntPhysicianOfficeRequest>>> {
  try {

        let url_ = "/api/EntPhysiciansCommand/office/restore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function entPhysiciansQuery_query(body: IEntPhysiciansQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IEntPhysician>>> {
  try {

        let url_ = "/api/EntPhysiciansQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function entPhysiciansQuery_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<IEntPhysicianWithOfficesSummary[]>>> {
  try {

        let url_ = "/api/EntPhysiciansQuery/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function entPhysiciansQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/EntPhysiciansQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function entPhysiciansQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IEntPhysician>> {
  try {

        let url_ = "/api/EntPhysiciansQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function entPhysiciansQuery_searchData(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<IEntPhysiciansSearchData>>> {
  try {

        let url_ = "/api/EntPhysiciansQuery/searchData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function entPhysiciansQuery_singleOffice(id: string, officeId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IOfficeData>> {
  try {

        let url_ = "/api/EntPhysiciansQuery/{id}/offices/{officeId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (officeId === undefined || officeId === null)
            throw new Error("The parameter 'officeId' must be defined.");
        url_ = url_.replace("{officeId}", encodeURIComponent("" + officeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function entPhysiciansQuery_export(body: IEntPhysicianExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/EntPhysiciansQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeCostCenter_create(body: ICreateExactGlobeCostCenterRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<ICreateExactGlobeCostCenterRequest>>> {
  try {

        let url_ = "/api/ExactGlobeCostCenter/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeCostCenter_patch(body: IPatchExactGlobeCostCenterRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchExactGlobeCostCenterRequest>>> {
  try {

        let url_ = "/api/ExactGlobeCostCenter/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeCostCenter_delete(body: IDeleteExactGlobeCostCenterRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IDeleteExactGlobeCostCenterRequest>>> {
  try {

        let url_ = "/api/ExactGlobeCostCenter/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeCostCenter_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IExactGlobeCostCenter[]>> {
  try {

        let url_ = "/api/ExactGlobeCostCenter/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeCostUnit_create(body: ICreateExactGlobeCostUnitRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<ICreateExactGlobeCostUnitRequest>>> {
  try {

        let url_ = "/api/ExactGlobeCostUnit/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeCostUnit_patch(body: IPatchExactGlobeCostUnitRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchExactGlobeCostUnitRequest>>> {
  try {

        let url_ = "/api/ExactGlobeCostUnit/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeCostUnit_delete(body: IDeleteExactGlobeCostUnitRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IDeleteExactGlobeCostUnitRequest>>> {
  try {

        let url_ = "/api/ExactGlobeCostUnit/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeCostUnit_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IExactGlobeCostUnit[]>> {
  try {

        let url_ = "/api/ExactGlobeCostUnit/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeCustomerAccounts_query(body: IExactGlobeCustomerAccountQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IExactGlobeCustomerAccountDto>>> {
  try {

        let url_ = "/api/ExactGlobeCustomerAccounts/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeCustomerAccounts_exportUnhandled(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/ExactGlobeCustomerAccounts/export-unhandled";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeCustomerAccounts_exportSingle(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/ExactGlobeCustomerAccounts/export-single/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeCustomerAccounts_markAllAsHandled(body: IMarkExportedExactGlobeCustomerAccountsAsHandledRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IMarkExportedExactGlobeCustomerAccountsAsHandledRequest>>> {
  try {

        let url_ = "/api/ExactGlobeCustomerAccounts/mark-all-as-handled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeCustomerAccounts_markAsHandled(body: IMarkExactGlobeCustomerAccountAsHandledRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IMarkExactGlobeCustomerAccountAsHandledRequest>>> {
  try {

        let url_ = "/api/ExactGlobeCustomerAccounts/mark-as-handled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeCustomerAccounts_markAsExported(body: IMarkExactGlobeCustomerAccountAsExportedRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IMarkExactGlobeCustomerAccountAsExportedRequest>>> {
  try {

        let url_ = "/api/ExactGlobeCustomerAccounts/mark-as-exported";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeCustomerAccounts_patchDebtorCode(body: IPatchExactGlobeCustomerAccountDebtorCodeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchExactGlobeCustomerAccountDebtorCodeRequest>>> {
  try {

        let url_ = "/api/ExactGlobeCustomerAccounts/patch-debtor-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeCustomerAccounts_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/ExactGlobeCustomerAccounts/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeLocation_link(body: ILinkExactGlobeLocationRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ILinkExactGlobeLocationRequest>>> {
  try {

        let url_ = "/api/ExactGlobeLocation/link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeLocation_unlink(body: IUnlinkExactGlobeLocationRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IUnlinkExactGlobeLocationRequest>>> {
  try {

        let url_ = "/api/ExactGlobeLocation/unlink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeLocation_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IExactGlobeLocationDto[]>> {
  try {

        let url_ = "/api/ExactGlobeLocation/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeProductCatalogItem_link(body: ILinkExactGlobeProductCatalogItemRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ILinkExactGlobeProductCatalogItemRequest>>> {
  try {

        let url_ = "/api/ExactGlobeProductCatalogItem/link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeProductCatalogItem_batchLink(body: IBatchLinkExactGlobeProductCatalogItemRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IBatchLinkExactGlobeProductCatalogItemRequest>>> {
  try {

        let url_ = "/api/ExactGlobeProductCatalogItem/batch-link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeProductCatalogItem_unlink(body: IUnlinkExactGlobeProductCatalogItemRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IUnlinkExactGlobeProductCatalogItemRequest>>> {
  try {

        let url_ = "/api/ExactGlobeProductCatalogItem/unlink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeProductCatalogItem_query(body: IExactGlobeProductCatalogItemsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IExactGlobeProductCatalogItemDto>>> {
  try {

        let url_ = "/api/ExactGlobeProductCatalogItem/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeProductCatalogItem_idsForQuery(body: IExactGlobeProductCatalogItemsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string[]>> {
  try {

        let url_ = "/api/ExactGlobeProductCatalogItem/ids-for-query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeProductCatalogItem_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/ExactGlobeProductCatalogItem/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeSales_query(body: IExactGlobeSalesQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IExactGlobeSaleDto>>> {
  try {

        let url_ = "/api/ExactGlobeSales/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeSales_exportUnhandled(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/ExactGlobeSales/export-unhandled";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeSales_exportSingle(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/ExactGlobeSales/export-single/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeSales_check(body: ICheckExactGlobeSalesRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ICheckExactGlobeSalesRequest>>> {
  try {

        let url_ = "/api/ExactGlobeSales/check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeSales_markAllAsHandled(body: IMarkExportedExactGlobeSalesAsHandledRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IMarkExportedExactGlobeSalesAsHandledRequest>>> {
  try {

        let url_ = "/api/ExactGlobeSales/mark-all-as-handled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeSales_markAsHandled(body: IMarkExactGlobeSaleAsHandledRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IMarkExactGlobeSaleAsHandledRequest>>> {
  try {

        let url_ = "/api/ExactGlobeSales/mark-as-handled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeSales_markAsExported(body: IMarkExactGlobeSaleAsExportedRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IMarkExactGlobeSaleAsExportedRequest>>> {
  try {

        let url_ = "/api/ExactGlobeSales/mark-as-exported";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeSales_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/ExactGlobeSales/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeSettingsCommand_patch(body: IPatchExactGlobeSettingsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchExactGlobeSettingsRequest>>> {
  try {

        let url_ = "/api/ExactGlobeSettingsCommand/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeSettingsCommand_patchDivision(body: IPatchExactGlobeDivisionCodeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchExactGlobeDivisionCodeRequest>>> {
  try {

        let url_ = "/api/ExactGlobeSettingsCommand/patch-division";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeSettingsCommand_patchJournal(body: IPatchExactGlobeJournalCodeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchExactGlobeJournalCodeRequest>>> {
  try {

        let url_ = "/api/ExactGlobeSettingsCommand/patch-journal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeSettingsCommand_patchGLAccount(body: IPatchExactGlobeGLAccountCodeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchExactGlobeGLAccountCodeRequest>>> {
  try {

        let url_ = "/api/ExactGlobeSettingsCommand/patch-gl-account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeSettingsCommand_patchFallbackCostUnit(body: IPatchExactGlobeFallbackCostUnitRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchExactGlobeFallbackCostUnitRequest>>> {
  try {

        let url_ = "/api/ExactGlobeSettingsCommand/patch-fallback-cost-unit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeSettingsQuery_settings(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IExactGlobeSettings>> {
  try {

        let url_ = "/api/ExactGlobeSettingsQuery/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactGlobeStatus_status(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IExactGlobeStatusDto>> {
  try {

        let url_ = "/api/ExactGlobeStatus/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnline_startAuth(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/exact-online/start-auth";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineCostCentersQuery_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IExactOnlineCostCenter[]>> {
  try {

        let url_ = "/api/ExactOnlineCostCentersQuery/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineCostCentersQuery_export(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/ExactOnlineCostCentersQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineCrmAccountsQuery_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IExactOnlineCrmAccountDto[]>> {
  try {

        let url_ = "/api/ExactOnlineCrmAccountsQuery/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineCrmAccountsQuery_export(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/ExactOnlineCrmAccountsQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineCustomerAccountsCommand_push(body: IPushCustomerAccountToExactOnlineRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPushCustomerAccountToExactOnlineRequest>>> {
  try {

        let url_ = "/api/ExactOnlineCustomerAccountsCommand/push";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineCustomerAccountsCommand_link(body: ILinkCustomerAccountWithExactOnlineAccountRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ILinkCustomerAccountWithExactOnlineAccountRequest>>> {
  try {

        let url_ = "/api/ExactOnlineCustomerAccountsCommand/link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineCustomerAccountsCommand_unlink(body: IUnlinkCustomerAccountWithExactOnlineAccountRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IUnlinkCustomerAccountWithExactOnlineAccountRequest>>> {
  try {

        let url_ = "/api/ExactOnlineCustomerAccountsCommand/unlink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineCustomerAccountsQuery_query(body: IExactOnlineCustomerAccountQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IExactOnlineCustomerAccountDto>>> {
  try {

        let url_ = "/api/ExactOnlineCustomerAccountsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineCustomerAccountsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/ExactOnlineCustomerAccountsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineGLAccountsQuery_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IExactOnlineGLAccountDto[]>> {
  try {

        let url_ = "/api/ExactOnlineGLAccountsQuery/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineGLAccountsQuery_export(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/ExactOnlineGLAccountsQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineIntegrationQuery_status(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IExactOnlineStatusDto>> {
  try {

        let url_ = "/api/ExactOnlineIntegrationQuery/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineIntegrationQuery_myDivision(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/ExactOnlineIntegrationQuery/my-division";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineIntegrationQuery_isActive(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<boolean>> {
  try {

        let url_ = "/api/ExactOnlineIntegrationQuery/is-active";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineLocationsCommand_link(body: ILinkLocationWithExactOnlineCostCenterRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ILinkLocationWithExactOnlineCostCenterRequest>>> {
  try {

        let url_ = "/api/ExactOnlineLocationsCommand/link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineLocationsCommand_unlink(body: IUnlinkLocationFromExactOnlineCostCenterRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IUnlinkLocationFromExactOnlineCostCenterRequest>>> {
  try {

        let url_ = "/api/ExactOnlineLocationsCommand/unlink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineLocationsQuery_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IExactOnlineLocationDto[]>> {
  try {

        let url_ = "/api/ExactOnlineLocationsQuery/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineProductCatalogItemsCommand_link(body: ILinkProductCatalogItemWithExactOnlineGLAccountRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ILinkProductCatalogItemWithExactOnlineGLAccountRequest>>> {
  try {

        let url_ = "/api/ExactOnlineProductCatalogItemsCommand/link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineProductCatalogItemsCommand_unlink(body: IUnlinkProductCatalogItemWithExactOnlineGLAccountRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IUnlinkProductCatalogItemWithExactOnlineGLAccountRequest>>> {
  try {

        let url_ = "/api/ExactOnlineProductCatalogItemsCommand/unlink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineProductCatalogItemsCommand_linkCostCenter(body: ILinkProductCatalogItemWithExactOnlineCostCenterRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ILinkProductCatalogItemWithExactOnlineCostCenterRequest>>> {
  try {

        let url_ = "/api/ExactOnlineProductCatalogItemsCommand/link-cost-denter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineProductCatalogItemsCommand_unlinkCostCenter(body: IUnlinkProductCatalogItemFromExactOnlineCostCenterRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IUnlinkProductCatalogItemFromExactOnlineCostCenterRequest>>> {
  try {

        let url_ = "/api/ExactOnlineProductCatalogItemsCommand/unlink-cost-center";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineProductCatalogItemsQuery_query(body: IExactOnlineProductCatalogItemsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IExactOnlineProductCatalogItemDto>>> {
  try {

        let url_ = "/api/ExactOnlineProductCatalogItemsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineProductCatalogItemsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/ExactOnlineProductCatalogItemsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineSalesCommand_syncOrPush(body: ISyncOrPushSaleToExactOnlineRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ISyncOrPushSaleToExactOnlineRequest>>> {
  try {

        let url_ = "/api/ExactOnlineSalesCommand/sync-or-push";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineSalesCommand_ignore(body: IIgnoreExactOnlineSaleRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IIgnoreExactOnlineSaleRequest>>> {
  try {

        let url_ = "/api/ExactOnlineSalesCommand/ignore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineSalesCommand_revertIgnore(body: IRevertIgnoreExactOnlineSaleRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRevertIgnoreExactOnlineSaleRequest>>> {
  try {

        let url_ = "/api/ExactOnlineSalesCommand/revert-ignore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineSalesQuery_query(body: IExactOnlineSalesQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IExactOnlineSale>>> {
  try {

        let url_ = "/api/ExactOnlineSalesQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineSalesQuery_details(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IExactOnlineSaleDetails>> {
  try {

        let url_ = "/api/ExactOnlineSalesQuery/{id}/details";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineSalesQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/ExactOnlineSalesQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineSettingsCommand_enable(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/ExactOnlineSettingsCommand/enable";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineSettingsCommand_disable(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/ExactOnlineSettingsCommand/disable";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineSettingsCommand_enterOAuthOptions(body: IEnterOAuthOptionsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IEnterOAuthOptionsRequest>>> {
  try {

        let url_ = "/api/ExactOnlineSettingsCommand/o-auth-options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineSettingsCommand_clearOAuthOptions(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/ExactOnlineSettingsCommand/clear-o-auth-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineSettingsCommand_enterAuthorizationCode(body: IRequestOAuthTokenFromAuthorizationCodeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRequestOAuthTokenFromAuthorizationCodeRequest>>> {
  try {

        let url_ = "/api/ExactOnlineSettingsCommand/o-auth-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineSettingsCommand_clearOAuthToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/ExactOnlineSettingsCommand/clear-o-auth-token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineSettingsCommand_patchBaseUrl(body: IPatchExactOnlineBaseUrlRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchExactOnlineBaseUrlRequest>>> {
  try {

        let url_ = "/api/ExactOnlineSettingsCommand/base-url";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineSettingsCommand_patchFallbackGLAccount(body: IPatchExactOnlineFallbackGLAccountRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchExactOnlineFallbackGLAccountRequest>>> {
  try {

        let url_ = "/api/ExactOnlineSettingsCommand/fallback-gl-account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineSettingsCommand_patchGLAccountMathModel(body: IPatchExactOnlineGLAccountMatchModeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchExactOnlineGLAccountMatchModeRequest>>> {
  try {

        let url_ = "/api/ExactOnlineSettingsCommand/gl-account-match-mode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineSettingsCommand_patchCostCenterMode(body: IPatchExactOnlineCostCenterModeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchExactOnlineCostCenterModeRequest>>> {
  try {

        let url_ = "/api/ExactOnlineSettingsCommand/cost-center-mode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineSettingsCommand_patchJournal(body: IPatchExactOnlineJournalRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchExactOnlineJournalRequest>>> {
  try {

        let url_ = "/api/ExactOnlineSettingsCommand/journal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineSettingsCommand_patchDivision(body: IPatchExactOnlineDivisionRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchExactOnlineDivisionRequest>>> {
  try {

        let url_ = "/api/ExactOnlineSettingsCommand/division";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineSettingsQuery_settings(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IExactOnlineSettingsDto>> {
  try {

        let url_ = "/api/ExactOnlineSettingsQuery/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exactOnlineSettingsQuery_adminSettings(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IExactOnlineAdminSettingsDto>> {
  try {

        let url_ = "/api/ExactOnlineSettingsQuery/admin-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exampleTemplatesQuery_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IExampleTemplateDto[]>> {
  try {

        let url_ = "/api/ExampleTemplatesQuery/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exampleTemplatesQuery_byPredefinedType(predefinedType: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IExampleTemplateDto[]>> {
  try {

        let url_ = "/api/ExampleTemplatesQuery/query/byPredefinedType/{predefinedType}";
        if (predefinedType === undefined || predefinedType === null)
            throw new Error("The parameter 'predefinedType' must be defined.");
        url_ = url_.replace("{predefinedType}", encodeURIComponent("" + predefinedType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exampleTemplatesQuery_byMainContext(mainContext: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IExampleTemplateDto[]>> {
  try {

        let url_ = "/api/ExampleTemplatesQuery/query/byMainContext/{mainContext}";
        if (mainContext === undefined || mainContext === null)
            throw new Error("The parameter 'mainContext' must be defined.");
        url_ = url_.replace("{mainContext}", encodeURIComponent("" + mainContext));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exampleTemplatesQuery_content(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/ExampleTemplatesQuery/{id}/content";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exampleTemplatesQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/ExampleTemplatesQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exportCochlearInfoEvents_handle(body: IExportCochlearInfoEventsParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/cochlear/events/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exportCochlearPatients_handle(body: IExportCochlearPatientsParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/cochlear/patients/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exportCochlearReferralCenters_handle(body: IExportCochlearReferralCentersParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/cochlear/referral-centers/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exportColumnSelectionsCommand_new(view: string, body: IExportColumnSelectionModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IExportColumnSelectionModel>>> {
  try {

        let url_ = "/api/ExportColumnSelectionsCommand/{view}/new";
        if (view === undefined || view === null)
            throw new Error("The parameter 'view' must be defined.");
        url_ = url_.replace("{view}", encodeURIComponent("" + view));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exportColumnSelectionsCommand_update(id: string, body: string[], cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<string[]>>> {
  try {

        let url_ = "/api/ExportColumnSelectionsCommand/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exportColumnSelectionsCommand_delete(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/ExportColumnSelectionsCommand/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exportColumnSelectionsQuery_allByView(view: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IExportColumnSelection[]>> {
  try {

        let url_ = "/api/ExportColumnSelectionsQuery/all/{view}";
        if (view === undefined || view === null)
            throw new Error("The parameter 'view' must be defined.");
        url_ = url_.replace("{view}", encodeURIComponent("" + view));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function exportColumnSelectionsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/ExportColumnSelectionsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function failedEventsQuery_query(body: IFailedEventsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IFailedEvent>>> {
  try {

        let url_ = "/api/FailedEventsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function failedEventsQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFailedEvent>> {
  try {

        let url_ = "/api/FailedEventsQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function failedEventsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/FailedEventsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function filterSortPageCochlearPatients_handle(body: ICochlearPatientsFilterSortPageParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<ICochlearPatientSummaryDto>>> {
  try {

        let url_ = "/api/cochlear/patients/filter-sort-page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function filterSortPageCochlearPatients_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/cochlear/patients/concurrency-token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function filterSortPageEazyworksKlanten_handle(body: IEazyworksKlantenQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IEazyworksKlant>>> {
  try {

        let url_ = "/api/ew-patients/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function filterSortPageEazyworksKlanten_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/ew-patients/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function filterSortPagePeppolRecords_handle(body: IPeppolRecordsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IPeppolRecord>>> {
  try {

        let url_ = "/api/peppol/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function filterSortPagePeppolRecords_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/peppol/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function findEazyworksMatch_handle(id: number, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFindEazyworksMatchResponse>> {
  try {

        let url_ = "/api/find-ew-patient-match/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function generalPractitionersCommand_new(body: IRegisterGeneralPractitionerRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IRegisterGeneralPractitionerRequest>>> {
  try {

        let url_ = "/api/GeneralPractitionersCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function generalPractitionersCommand_delete(body: IDeleteGeneralPractitionerRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IDeleteGeneralPractitionerRequest>>> {
  try {

        let url_ = "/api/GeneralPractitionersCommand/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function generalPractitionersCommand_restore(body: IRestoreGeneralPractitionerRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRestoreGeneralPractitionerRequest>>> {
  try {

        let url_ = "/api/GeneralPractitionersCommand/restore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function generalPractitionersCommand_patchPersonalInfo(body: IPatchGeneralPractitionerPersonalInformationRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchGeneralPractitionerPersonalInformationRequest>>> {
  try {

        let url_ = "/api/GeneralPractitionersCommand/personal-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function generalPractitionersCommand_patchRizivNumber(body: IPatchGeneralPractitionerRizivNumberRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchGeneralPractitionerRizivNumberRequest>>> {
  try {

        let url_ = "/api/GeneralPractitionersCommand/riziv-number";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function generalPractitionersCommand_addOffice(body: IAddGeneralPractitionerOfficeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IAddGeneralPractitionerOfficeRequest>>> {
  try {

        let url_ = "/api/GeneralPractitionersCommand/add-office";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function generalPractitionersCommand_patchOfficeAddress(body: IPatchGeneralPractitionerOfficeAddressRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchGeneralPractitionerOfficeAddressRequest>>> {
  try {

        let url_ = "/api/GeneralPractitionersCommand/office/address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function generalPractitionersCommand_patchOfficeEmail(body: IPatchGeneralPractitionerOfficeEmailRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchGeneralPractitionerOfficeEmailRequest>>> {
  try {

        let url_ = "/api/GeneralPractitionersCommand/office/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function generalPractitionersCommand_patchOfficePhone(body: IPatchGeneralPractitionerOfficePhoneRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchGeneralPractitionerOfficePhoneRequest>>> {
  try {

        let url_ = "/api/GeneralPractitionersCommand/office/phone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function generalPractitionersCommand_makeOfficeDefault(body: IMakeGeneralPractitionerOfficeDefaultRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IMakeGeneralPractitionerOfficeDefaultRequest>>> {
  try {

        let url_ = "/api/GeneralPractitionersCommand/office/make-default";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function generalPractitionersCommand_deleteOffice(body: IDeleteGeneralPractitionerOfficeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IDeleteGeneralPractitionerOfficeRequest>>> {
  try {

        let url_ = "/api/GeneralPractitionersCommand/office/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function generalPractitionersCommand_restoreOffice(body: IRestoreGeneralPractitionerOfficeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRestoreGeneralPractitionerOfficeRequest>>> {
  try {

        let url_ = "/api/GeneralPractitionersCommand/office/restore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function generalPractitionersQuery_query(body: IGeneralPractitionersQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IGeneralPractitioner>>> {
  try {

        let url_ = "/api/GeneralPractitionersQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function generalPractitionersQuery_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<IGeneralPractitionerWithOfficesSummary[]>>> {
  try {

        let url_ = "/api/GeneralPractitionersQuery/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function generalPractitionersQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/GeneralPractitionersQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function generalPractitionersQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IGeneralPractitioner>> {
  try {

        let url_ = "/api/GeneralPractitionersQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function generalPractitionersQuery_singleOffice(id: string, officeId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IOfficeData>> {
  try {

        let url_ = "/api/GeneralPractitionersQuery/{id}/offices/{officeId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (officeId === undefined || officeId === null)
            throw new Error("The parameter 'officeId' must be defined.");
        url_ = url_.replace("{officeId}", encodeURIComponent("" + officeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function generalPractitionersQuery_searchData(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<IGeneralPractitionersSearchData>>> {
  try {

        let url_ = "/api/GeneralPractitionersQuery/searchData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function generalPractitionersQuery_export(body: IGeneralPractitionersExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/GeneralPractitionersQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function getCochlearCounselingStepModules_handle(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICochlearCounselingStepModuleDto[]>> {
  try {

        let url_ = "/api/cochlear/counseling-step-modules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function getCochlearInfoEvents_handle(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICochlearInfoEventDto[]>> {
  try {

        let url_ = "/api/cochlear/info-events";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function getCochlearPartnerTrainingModules_handle(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICochlearPartnerTrainingModuleDto[]>> {
  try {

        let url_ = "/api/cochlear/partner-training-modules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function getCochlearPatientDtoById_handle(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICochlearPatientDetailDto>> {
  try {

        let url_ = "/api/cochlear/patients/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function getCochlearReferralCenters_handle(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICochlearReferralCenterDto[]>> {
  try {

        let url_ = "/api/cochlear/referral-centers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function getCochlearReferralMaterials_handle(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICochlearReferralMaterialDto[]>> {
  try {

        let url_ = "/api/cochlear/referral-materials";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function getCochlearSettings_handle(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICochlearSettingsDto>> {
  try {

        let url_ = "/api/cochlear/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function getEazyworksPatientDataById_handle(id: number, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IEazyworksPatientData>> {
  try {

        let url_ = "/api/ew-patients/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function getNoahDeviceDtoById_handle(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<INoahDeviceDto>> {
  try {

        let url_ = "/api/noah-device-dtos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function getPeppolIntegrationStatus_handle(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IPeppolIntegrationStatus>> {
  try {

        let url_ = "/api/peppol/integration-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function getPeppolRecordById_handle(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IPeppolRecord>> {
  try {

        let url_ = "/api/peppol/outbox/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function getPeppolSettings_handle(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IPeppolSettings>> {
  try {

        let url_ = "/api/peppol/get-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function getSaleDtoById_handle(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ISalesDto>> {
  try {

        let url_ = "/api/sales/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function healthInsuranceFundMetaCommand_patchThirdPayerArrangementAddress(body: IPatchHifThirdPartyPayerArrangementAddressRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchHifThirdPartyPayerArrangementAddressRequest>>> {
  try {

        let url_ = "/api/HealthInsuranceFundMetaCommand/third-party-payer-arrangement-address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function healthInsuranceFundMetaCommand_patchAdvisoryPhysicianAddress(body: IPatchHifAdvisoryPhysicianAddressRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchHifAdvisoryPhysicianAddressRequest>>> {
  try {

        let url_ = "/api/HealthInsuranceFundMetaCommand/advisory-physician-address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function healthInsuranceFundMetaCommand_deleteThirdPayerArrangement(body: IDeleteHifThirdPartyPayerArrangementAddressRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IDeleteHifThirdPartyPayerArrangementAddressRequest>>> {
  try {

        let url_ = "/api/HealthInsuranceFundMetaCommand/third-party-payer-arrangement-address/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function healthInsuranceFundMetaCommand_deleteAdvisoryPhysicianAddress(body: IDeleteHifAdvisoryPhysicianAddressRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IDeleteHifAdvisoryPhysicianAddressRequest>>> {
  try {

        let url_ = "/api/HealthInsuranceFundMetaCommand/advisory-physician-address/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function healthInsuranceFundMetaQuery_query(body: IHealthInsuranceFundWithAddressDtoQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IHealthInsuranceFundWithAddressDto>>> {
  try {

        let url_ = "/api/HealthInsuranceFundMetaQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function healthInsuranceFundMetaQuery_single(code: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IHealthInsuranceFundWithAddressDto>> {
  try {

        let url_ = "/api/HealthInsuranceFundMetaQuery/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function healthInsuranceFundMetaQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/HealthInsuranceFundMetaQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function healthInsuranceFundsQuery_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<IHealthInsuranceFundCache>>> {
  try {

        let url_ = "/api/HealthInsuranceFundsQuery/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function healthInsuranceFundsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/HealthInsuranceFundsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function ignorePeppolRecord_handle(body: IIgnorePeppolRecordRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IIgnorePeppolRecordRequest>>> {
  try {

        let url_ = "/api/peppol/ignore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function importEazyworksPatient_handle(body: IImportEazyworksPatientRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IImportEazyworksPatientRequest>>> {
  try {

        let url_ = "/api/ew-patients/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_define(body: IInventoryItemModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IInventoryItemModel>>> {
  try {

        let url_ = "/api/InventoryItemsCommand/define";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_patchRizivHearingAidDefinitionV2IdentificationCode(body: IPatchInventoryItemRizivHearingAidDefinitionV2IdentificationCodeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchInventoryItemRizivHearingAidDefinitionV2IdentificationCodeRequest>>> {
  try {

        let url_ = "/api/InventoryItemsCommand/riziv-hearing-aid-definition-v2-identification-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_switchProductCatalogItem(body: ISwitchProductCatalogItemFromInventoryItemRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ISwitchProductCatalogItemFromInventoryItemRequest>>> {
  try {

        let url_ = "/api/InventoryItemsCommand/switch-product-catalog-item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_markDemo(body: IMarkInventoryItemAsDemoRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IMarkInventoryItemAsDemoRequest>>> {
  try {

        let url_ = "/api/InventoryItemsCommand/mark-as-demo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_unMarkDemo(body: IUnmarkInventoryItemAsDemoRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IUnmarkInventoryItemAsDemoRequest>>> {
  try {

        let url_ = "/api/InventoryItemsCommand/unmark-as-demo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_addReservation(body: IAddReservationToInventoryItemRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IAddReservationToInventoryItemRequest>>> {
  try {

        let url_ = "/api/InventoryItemsCommand/add-reservation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_clearReservation(body: IClearReservationFromInventoryItemRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IClearReservationFromInventoryItemRequest>>> {
  try {

        let url_ = "/api/InventoryItemsCommand/clear-reservation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_setTailorMadeForPatient(body: IPatchTailorMadeForPatientOnInventoryItemRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchTailorMadeForPatientOnInventoryItemRequest>>> {
  try {

        let url_ = "/api/InventoryItemsCommand/tailor-made-for-patient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_patchConsignmentReturnBeforeDate(body: IPatchConsignmentReturnBeforeDateOnInventoryItemRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchConsignmentReturnBeforeDateOnInventoryItemRequest>>> {
  try {

        let url_ = "/api/InventoryItemsCommand/consignment-return-before-date";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_clearConsignmentReturnBeforeDate(body: IClearConsignmentReturnBeforeDateOnInventoryItemRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IClearConsignmentReturnBeforeDateOnInventoryItemRequest>>> {
  try {

        let url_ = "/api/InventoryItemsCommand/clear-consignment-return-before-date";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_patchDispatchInfo(body: IPatchInventoryItemDispatchInfoRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchInventoryItemDispatchInfoRequest>>> {
  try {

        let url_ = "/api/InventoryItemsCommand/dispatch-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_registerAsSold(body: IRegisterInventoryItemAsSoldRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRegisterInventoryItemAsSoldRequest>>> {
  try {

        let url_ = "/api/InventoryItemsCommand/register-as-sold";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_undoRegisterAsSold(body: IUndoRegisterInventoryItemAsSoldRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IUndoRegisterInventoryItemAsSoldRequest>>> {
  try {

        let url_ = "/api/InventoryItemsCommand/undo-register-as-sold";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_registerAsBroken(body: IRegisterInventoryItemAsBrokenRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRegisterInventoryItemAsBrokenRequest>>> {
  try {

        let url_ = "/api/InventoryItemsCommand/register-as-broken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_undoRegisterAsBroken(body: IUndoRegisterInventoryItemAsBrokenRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IUndoRegisterInventoryItemAsBrokenRequest>>> {
  try {

        let url_ = "/api/InventoryItemsCommand/undo-register-as-broken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_patchArticleProperties(body: IPatchArticlePropertiesOnInventoryItemRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchArticlePropertiesOnInventoryItemRequest>>> {
  try {

        let url_ = "/api/InventoryItemsCommand/article-properties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_clearManuallySetWarrantyEndDate(body: IClearInventoryItemManualWarrantyEndDateRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IClearInventoryItemManualWarrantyEndDateRequest>>> {
  try {

        let url_ = "/api/InventoryItemsCommand/clear-manual-warranty-end-date";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_patchManuallySetWarrantyEndDate(body: IPatchInventoryItemManualWarrantyEndDateRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchInventoryItemManualWarrantyEndDateRequest>>> {
  try {

        let url_ = "/api/InventoryItemsCommand/manual-warranty-end-date";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_patchLabels(body: IPatchInventoryItemsLabelsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchInventoryItemsLabelsRequest>>> {
  try {

        let url_ = "/api/InventoryItemsCommand/labels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_queryForProductCatalog(productCatalogItemId: string, body: IInventoryItemsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IInventoryItem>>> {
  try {

        let url_ = "/api/InventoryItemsQuery/query/productCatalog/{productCatalogItemId}";
        if (productCatalogItemId === undefined || productCatalogItemId === null)
            throw new Error("The parameter 'productCatalogItemId' must be defined.");
        url_ = url_.replace("{productCatalogItemId}", encodeURIComponent("" + productCatalogItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_query(body: IInventoryItemsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IInventoryItem>>> {
  try {

        let url_ = "/api/InventoryItemsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_queryForPatient(patientId: string, body: IInventoryItemsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IInventoryItem>>> {
  try {

        let url_ = "/api/InventoryItemsQuery/query/patient/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_queryAssignToArticlesInquiryLine(body: IAssignInventoryItemToArticlesInquiryFromStockQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IInventoryItemWithMatchArticleProperties>>> {
  try {

        let url_ = "/api/InventoryItemsQuery/query/assign-ii-to-ai-line";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_reservedByPatient(patientId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IInventoryItem[]>> {
  try {

        let url_ = "/api/InventoryItemsQuery/reserved/patient/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_reservedByPatientIds(patientId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string[]>> {
  try {

        let url_ = "/api/InventoryItemsQuery/reserved/patient/{patientId}/ids";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IInventoryItem>> {
  try {

        let url_ = "/api/InventoryItemsQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_detail(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IInventoryItemDetail>> {
  try {

        let url_ = "/api/InventoryItemsQuery/{id}/detail";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_singleWithProductCatalogItem(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IInventoryItemWithProductCatalogItemDto>> {
  try {

        let url_ = "/api/InventoryItemsQuery/{id}/withProductCatalogItem";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_queryByIdsWithProductCatalogItem(body: string[], cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IInventoryItemWithProductCatalogItemDto[]>> {
  try {

        let url_ = "/api/InventoryItemsQuery/query/byIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/InventoryItemsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_queryForRepair(supplierId: string, body: IInventoryItemsQueryParamsForRepair, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IInventoryItem>>> {
  try {

        let url_ = "/api/InventoryItemsQuery/query/repair/suppliers/{supplierId}";
        if (supplierId === undefined || supplierId === null)
            throw new Error("The parameter 'supplierId' must be defined.");
        url_ = url_.replace("{supplierId}", encodeURIComponent("" + supplierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_queryForRepairForPatient(supplierId: string, patientId: string, body: IInventoryItemsQueryParamsForRepair, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IInventoryItem>>> {
  try {

        let url_ = "/api/InventoryItemsQuery/query/repair/suppliers/{supplierId}/patients/{patientId}";
        if (supplierId === undefined || supplierId === null)
            throw new Error("The parameter 'supplierId' must be defined.");
        url_ = url_.replace("{supplierId}", encodeURIComponent("" + supplierId));
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_queryForLoan(body: IInventoryItemsQueryParamsForLoan, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IInventoryItem>>> {
  try {

        let url_ = "/api/InventoryItemsQuery/query/loan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_queryForSale(body: IInventoryItemsQueryParamsForSale, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IInventoryItem>>> {
  try {

        let url_ = "/api/InventoryItemsQuery/query/sale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_queryForPurchaseOrCreditPurchase(body: IInventoryItemsQueryParamsForPurchaseOrCreditPurchase, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IInventoryItem>>> {
  try {

        let url_ = "/api/InventoryItemsQuery/query/purchaseOrCreditPurchase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_queryForPurchaseAssurance(body: IInventoryItemsQueryParamsForPurchaseAssurance, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IInventoryItem>>> {
  try {

        let url_ = "/api/InventoryItemsQuery/query/purchase/assurance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_queryForPurchaseCreditAssurance(assuranceProductCatalogId: string, body: IInventoryItemsQueryParamsForPurchaseCreditAssurance, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IInventoryItemSummaryWithPurchasedAssuranceDto>>> {
  try {

        let url_ = "/api/InventoryItemsQuery/query/purchase/assurance/credit/{assuranceProductCatalogId}";
        if (assuranceProductCatalogId === undefined || assuranceProductCatalogId === null)
            throw new Error("The parameter 'assuranceProductCatalogId' must be defined.");
        url_ = url_.replace("{assuranceProductCatalogId}", encodeURIComponent("" + assuranceProductCatalogId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_queryForReturn(body: IInventoryItemsQueryParamsForReturn, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IInventoryItem>>> {
  try {

        let url_ = "/api/InventoryItemsQuery/query/return";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_queryForStockMovement(body: IInventoryItemsQueryParamsForStockMovement, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IInventoryItem>>> {
  try {

        let url_ = "/api/InventoryItemsQuery/query/stockMovement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_searchData(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<IInventoryItemSearchData>>> {
  try {

        let url_ = "/api/InventoryItemsQuery/searchData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_export(body: IInventoryItemsExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/InventoryItemsQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_exportByProductCatalog(productCatalogItemId: string, body: IInventoryItemsExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/InventoryItemsQuery/export/productCatalog/{productCatalogItemId}";
        if (productCatalogItemId === undefined || productCatalogItemId === null)
            throw new Error("The parameter 'productCatalogItemId' must be defined.");
        url_ = url_.replace("{productCatalogItemId}", encodeURIComponent("" + productCatalogItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_exportByPatient(patientId: string, body: IInventoryItemsExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/InventoryItemsQuery/export/patient/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsScriptsCommand_scriptRegisterAsPurchased(body: IInventoryItemsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/InventoryItemsScriptsCommand/scripts/registerAsPurchased";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsScriptsCommand_scriptRegisterReturnedToSupplier(body: IInventoryItemsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/InventoryItemsScriptsCommand/scripts/registerReturnToSupplier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function invoiceForwardingCommand_forward(body: IForwardInvoiceRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IForwardInvoiceRequest>>> {
  try {

        let url_ = "/api/InvoiceForwardingCommand/forward";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function invoiceForwardingCommand_ignore(body: IIgnoreInvoiceForwardingRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IIgnoreInvoiceForwardingRequest>>> {
  try {

        let url_ = "/api/InvoiceForwardingCommand/ignore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function invoiceForwardingCommand_revertIgnore(body: IRevertIgnoreInvoiceForwardingRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRevertIgnoreInvoiceForwardingRequest>>> {
  try {

        let url_ = "/api/InvoiceForwardingCommand/revert-ignore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function invoiceForwardingQuery_query(body: IInvoiceForwardingQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IInvoiceForwardingRecord>>> {
  try {

        let url_ = "/api/InvoiceForwardingQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function invoiceForwardingQuery_details(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IInvoiceForwardingRecordDetails>> {
  try {

        let url_ = "/api/InvoiceForwardingQuery/{id}/details";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function invoiceForwardingQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/InvoiceForwardingQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function invoiceForwardingSettingsCommand_enable(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/InvoiceForwardingSettingsCommand/enable";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function invoiceForwardingSettingsCommand_disable(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/InvoiceForwardingSettingsCommand/disable";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function invoiceForwardingSettingsCommand_patchMode(body: IPatchInvoiceForwardingModeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchInvoiceForwardingModeRequest>>> {
  try {

        let url_ = "/api/InvoiceForwardingSettingsCommand/mode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function invoiceForwardingSettingsCommand_addEmailAddress(body: IAddInvoiceForwardingEmailRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IAddInvoiceForwardingEmailRequest>>> {
  try {

        let url_ = "/api/InvoiceForwardingSettingsCommand/add-email-addresses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function invoiceForwardingSettingsCommand_removeEmailAddress(body: IRemoveInvoiceForwardingEmailRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRemoveInvoiceForwardingEmailRequest>>> {
  try {

        let url_ = "/api/InvoiceForwardingSettingsCommand/remove-email-addresses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function invoiceForwardingSettingsCommand_attachPdf(body: IPatchAttachPdfInvoiceForwardingSettingsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchAttachPdfInvoiceForwardingSettingsRequest>>> {
  try {

        let url_ = "/api/InvoiceForwardingSettingsCommand/attach-pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function invoiceForwardingSettingsCommand_attachUbl(body: IPatchAttachUblInvoiceForwardingSettingsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchAttachUblInvoiceForwardingSettingsRequest>>> {
  try {

        let url_ = "/api/InvoiceForwardingSettingsCommand/attach-ubl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function invoiceForwardingSettingsQuery_get(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IInvoiceForwardingSettings>> {
  try {

        let url_ = "/api/InvoiceForwardingSettingsQuery/get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function invoiceForwardingSettingsQuery_isEnabled(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<boolean>> {
  try {

        let url_ = "/api/InvoiceForwardingSettingsQuery/is-enabled";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function invoiceForwardingSettingsQuery_status(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IInvoiceForwardingStatus>> {
  try {

        let url_ = "/api/InvoiceForwardingSettingsQuery/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function linkEazyworkKlantWithHamsPatient_handle(body: ILinkEazyworkKlantWithHamsPatientRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ILinkEazyworkKlantWithHamsPatientRequest>>> {
  try {

        let url_ = "/api/ew-patients/link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function loansCommand_register(body: IRegisterLoanRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IRegisterLoanRequest>>> {
  try {

        let url_ = "/api/LoansCommand/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function loansCommand_end(body: IEndLoanRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IEndLoanRequest>>> {
  try {

        let url_ = "/api/LoansCommand/end";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function loansCommand_patchStopDate(body: IPatchLoanStopDateRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchLoanStopDateRequest>>> {
  try {

        let url_ = "/api/LoansCommand/stop-date";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function loanSettingsCommand_patchDefaultDuration(body: IPatchLoanDefaultDurationRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchLoanDefaultDurationRequest>>> {
  try {

        let url_ = "/api/LoanSettingsCommand/default-duration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function loanSettingsCommand_patchReferenceSettings(body: IPatchLoanReferenceSettingsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchLoanReferenceSettingsRequest>>> {
  try {

        let url_ = "/api/LoanSettingsCommand/reference-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function loansQuery_query(body: ILoansQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<ILoan>>> {
  try {

        let url_ = "/api/LoansQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function loansQuery_nextReference(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/LoansQuery/nextReference";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function loansQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ILoan>> {
  try {

        let url_ = "/api/LoansQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function loansQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/LoansQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function loansQuery_export(body: ILoansExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/LoansQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function loansQuery_settings(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ILoanSettings>> {
  try {

        let url_ = "/api/LoansQuery/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function locationsCommand_new(body: ILocationModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<ILocationModel>>> {
  try {

        let url_ = "/api/LocationsCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function locationsCommand_patchName(body: IPatchLocationNameRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchLocationNameRequest>>> {
  try {

        let url_ = "/api/LocationsCommand/name";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function locationsCommand_patchPhone(body: IPatchLocationPhoneRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchLocationPhoneRequest>>> {
  try {

        let url_ = "/api/LocationsCommand/phone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function locationsCommand_patchEmail(body: IPatchLocationEmailRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchLocationEmailRequest>>> {
  try {

        let url_ = "/api/LocationsCommand/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function locationsCommand_patchAddress(body: IPatchLocationAddressRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchLocationAddressRequest>>> {
  try {

        let url_ = "/api/LocationsCommand/address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function locationsCommand_delete(body: IDeleteLocationRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IDeleteLocationRequest>>> {
  try {

        let url_ = "/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function locationsCommand_patchIsPlannable(body: IPatchLocationIsPlannableRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchLocationIsPlannableRequest>>> {
  try {

        let url_ = "/api/LocationsCommand/plannable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function locationsCommand_addRoom(id: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/LocationsCommand/{id}/rooms/add";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function locationsCommand_updateRoom(id: string, roomId: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/LocationsCommand/{id}/rooms/{roomId}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (roomId === undefined || roomId === null)
            throw new Error("The parameter 'roomId' must be defined.");
        url_ = url_.replace("{roomId}", encodeURIComponent("" + roomId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function locationsCommand_deleteRoom(id: string, roomId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/LocationsCommand/{id}/rooms/{roomId}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (roomId === undefined || roomId === null)
            throw new Error("The parameter 'roomId' must be defined.");
        url_ = url_.replace("{roomId}", encodeURIComponent("" + roomId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function locationsQuery_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ILocation[]>> {
  try {

        let url_ = "/api/LocationsQuery/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function locationsQuery_cache(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<ILocationsCache>>> {
  try {

        let url_ = "/api/LocationsQuery/cache";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function locationsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/LocationsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function locationsQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ILocation>> {
  try {

        let url_ = "/api/LocationsQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function markPeppolAttemptAsFailed_handle(body: IMarkPeppolAttemptAsFailedRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IMarkPeppolAttemptAsFailedRequest>>> {
  try {

        let url_ = "/api/peppol/mark-as-failed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function medicalTreatmentFeesQuery_multiple(body: IMultipleFeesModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IMedicalTreatmentFeeDto[]>> {
  try {

        let url_ = "/api/MedicalTreatmentFeesQuery/multiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function medicalTreatmentNomenclaturesQuery_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<IMedicalTreatmentNomenclatureForAudiology[]>>> {
  try {

        let url_ = "/api/MedicalTreatmentNomenclaturesQuery/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function medicalTreatmentNomenclaturesQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/MedicalTreatmentNomenclaturesQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function meta_build(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/meta/build";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function meta_ping(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<void>> {
  try {

        let url_ = "/api/meta/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function meta_url(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/meta/url";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function meta_now(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<Date>> {
  try {

        let url_ = "/api/meta/now";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDataCommand_deleteActions(body: string[], cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/NoahDataCommand/delete-actions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDataCommand_restoreActions(body: string[], cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/NoahDataCommand/restore-actions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDataCommand_fixIndices(body: IFixNoahIndicesForPatientRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/NoahDataCommand/fix-indices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDataQuery_sessionsByPatient(patientId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IPatientNoahSessionsDto>> {
  try {

        let url_ = "/api/NoahDataQuery/{patientId}/sessions";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDataQuery_indicesDebugInfo(patientId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IPatientNoahDataIndicesDebugInfo>> {
  try {

        let url_ = "/api/NoahDataQuery/{patientId}/indices-debug-info";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDataQuery_actualDevicesForPatient(patientId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IPatientActualNoahDevices>> {
  try {

        let url_ = "/api/NoahDataQuery/{patientId}/actual-devices";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDeviceInventoryItemMapsCommand_importFromReadOut(id: string, readOutId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/NoahDeviceInventoryItemMapsCommand/{id}/import/{readOutId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (readOutId === undefined || readOutId === null)
            throw new Error("The parameter 'readOutId' must be defined.");
        url_ = url_.replace("{readOutId}", encodeURIComponent("" + readOutId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDeviceInventoryItemMapsCommand_import(id: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/NoahDeviceInventoryItemMapsCommand/{id}/import";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDeviceInventoryItemMapsQuery_queryAll(body: INoahDeviceInventoryItemMapsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<INoahDeviceInventoryItemMapDetail>>> {
  try {

        let url_ = "/api/NoahDeviceInventoryItemMapsQuery/query/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDeviceInventoryItemMapsQuery_queryWithUsages(body: INoahDeviceInventoryItemMapsWithUsagesQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<INoahDeviceInventoryItemMap>>> {
  try {

        let url_ = "/api/NoahDeviceInventoryItemMapsQuery/query/withUsages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDeviceInventoryItemMapsQuery_searchWithUsages(body: INoahDeviceInventoryItemMapsWithUsagesSearchParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<INoahDeviceInventoryItemMap>>> {
  try {

        let url_ = "/api/NoahDeviceInventoryItemMapsQuery/search/withUsages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDeviceInventoryItemMapsQuery_byPatient(patientId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<INoahDeviceForPatient[]>> {
  try {

        let url_ = "/api/NoahDeviceInventoryItemMapsQuery/byPatient/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDeviceInventoryItemMapsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/NoahDeviceInventoryItemMapsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDeviceInventoryItemMapsQuery_single(body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<INoahDeviceWithLastLinkedProductCatalogItem>> {
  try {

        let url_ = "/api/NoahDeviceInventoryItemMapsQuery/single";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDeviceInventoryItemMapsQuery_readOut(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<INoahDeviceReadOut>> {
  try {

        let url_ = "/api/NoahDeviceInventoryItemMapsQuery/{id}/readOut";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDeviceInventoryItemMapsQuery_exportWithUsages(body: INoahDeviceInventoryItemMapsWithUsagesExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/NoahDeviceInventoryItemMapsQuery/export/withUsages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDeviceReadOutsCommand_ignore(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/NoahDeviceReadOutsCommand/{id}/ignore";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDeviceReadOutsCommand_restoreRule(id: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/NoahDeviceReadOutsCommand/{id}/rules/restore";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDeviceReadOutsCommand_deleteRule(id: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/NoahDeviceReadOutsCommand/{id}/rules/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDeviceReadOutsCommand_addRule(id: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/NoahDeviceReadOutsCommand/{id}/rules/add";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDeviceReadOutsQuery_query(body: INoahDeviceReadOutsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<INoahDeviceReadOut>>> {
  try {

        let url_ = "/api/NoahDeviceReadOutsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDeviceReadOutsQuery_queryNotLinkedNorIgnored(body: INotLinkedNorIgnoredNoahDeviceReadOutsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<INoahDeviceReadOut>>> {
  try {

        let url_ = "/api/NoahDeviceReadOutsQuery/queryNotLinkedNorIgnored";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDeviceReadOutsQuery_lastNonDeletedRuleForProductCatalogItem(productCatalogItemId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string[]>> {
  try {

        let url_ = "/api/NoahDeviceReadOutsQuery/readOutRules/productCatalogItem/{productCatalogItemId}/uniqueFields";
        if (productCatalogItemId === undefined || productCatalogItemId === null)
            throw new Error("The parameter 'productCatalogItemId' must be defined.");
        url_ = url_.replace("{productCatalogItemId}", encodeURIComponent("" + productCatalogItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDeviceReadOutsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/NoahDeviceReadOutsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahDeviceReadOutsQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<INoahDeviceReadOut>> {
  try {

        let url_ = "/api/NoahDeviceReadOutsQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahLicense_check(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<boolean>> {
  try {

        let url_ = "/api/NoahLicense/check";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahLicense_download(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/NoahLicense/download";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahLicense_upload(body: IFileUploadRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileUploadResponse>> {
  try {

        let url_ = "/api/NoahLicense/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahUserSetupsCommand_link(body: ILinkNoahUserSetupRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ILinkNoahUserSetupRequest>>> {
  try {

        let url_ = "/api/NoahUserSetupsCommand/link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahUserSetupsCommand_linkAll(body: ILinkAllUnlinkedNoahUserSetupsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ILinkAllUnlinkedNoahUserSetupsRequest>>> {
  try {

        let url_ = "/api/NoahUserSetupsCommand/link-all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahUserSetupsCommand_copy(body: ICopyNoahUserSetupRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ICopyNoahUserSetupRequest>>> {
  try {

        let url_ = "/api/NoahUserSetupsCommand/copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahUserSetupsCommand_copyAll(body: ICopyAllNoahUserSetupsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ICopyAllNoahUserSetupsRequest>>> {
  try {

        let url_ = "/api/NoahUserSetupsCommand/copy-all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahUserSetupsQuery_query(body: INoahUserSetupsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResultWithMetadata<INoahUserSetup, INoahUserSetupsQueryMetadata>>> {
  try {

        let url_ = "/api/NoahUserSetupsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function noahUserSetupsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/NoahUserSetupsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function notificationsCommand_markAsRead(body: IMarkNotificationAsReadRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/NotificationsCommand/markAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function notificationsCommand_markAsShown(body: IMarkNotificationsAsShownRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/NotificationsCommand/markAsShown";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function notificationsCommand_markAllNotificationsAsReadForAllUsers(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/NotificationsCommand/markAllNotificationsAsReadForAllUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function notificationsQuery_latest(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<INotificationWithStatusDto[]>>> {
  try {

        let url_ = "/api/NotificationsQuery/latest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function notificationsQuery_countUnreadForAllUsers(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/NotificationsQuery/countUnreadForAllUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function notificationsQuery_multiple(body: string[], cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<INotificationWithStatusDto[]>> {
  try {

        let url_ = "/api/NotificationsQuery/multiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function notificationsQuery_query(body: INotificationsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<INotificationWithStatusDto>>> {
  try {

        let url_ = "/api/NotificationsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function notificationsQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<INotificationWithStatusDto>> {
  try {

        let url_ = "/api/NotificationsQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function notificationsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/NotificationsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function ordersCommand_register(body: IRegisterOrderRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IRegisterOrderRequest>>> {
  try {

        let url_ = "/api/OrdersCommand/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function ordersCommand_placeWithSupplier(body: IPlaceOrderWithSupplierRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPlaceOrderWithSupplierRequest>>> {
  try {

        let url_ = "/api/OrdersCommand/place-with-supplier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function ordersCommand_undoPlaceWithSupplier(body: IUndoPlaceOrderWithSupplierRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IUndoPlaceOrderWithSupplierRequest>>> {
  try {

        let url_ = "/api/OrdersCommand/undo-place-with-supplier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function ordersCommand_deleteLine(body: IDeleteOrderLineRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IDeleteOrderLineRequest>>> {
  try {

        let url_ = "/api/OrdersCommand/delete-line";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function ordersCommand_addLines(body: IAddOrderLinesRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IAddOrderLinesRequest>>> {
  try {

        let url_ = "/api/OrdersCommand/add-lines";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function ordersCommand_registerDelivery(body: IRegisterOrderDeliveryRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRegisterOrderDeliveryRequest>>> {
  try {

        let url_ = "/api/OrdersCommand/register-delivery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function ordersCommand_cancel(body: ICancelOrderRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/OrdersCommand/cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function ordersCommand_patchHandlingUser(body: IPatchOrderHandlingUserRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/OrdersCommand/handlingUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function ordersCommand_patchExpectedDeliveryDate(body: IPatchOrderExpectedDeliveryDateRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/OrdersCommand/expectedDeliveryDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function ordersCommand_patchExternalReference(body: IPatchOrderExternalReferenceRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/OrdersCommand/externalReference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function orderSettingsCommand_patchDefaultDeliveryTime(body: IPatchOrderDefaultDeliveryTimeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchOrderDefaultDeliveryTimeRequest>>> {
  try {

        let url_ = "/api/OrderSettingsCommand/default-delivery-time";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function orderSettingsCommand_patchReferenceSettings(body: IPatchOrderReferenceSettingsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchOrderReferenceSettingsRequest>>> {
  try {

        let url_ = "/api/OrderSettingsCommand/reference-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function ordersQuery_query(body: IOrdersQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResultWithMetadata<IOrderV2, IOrdersQueryMetadata>>> {
  try {

        let url_ = "/api/OrdersQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function ordersQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IOrderV2>> {
  try {

        let url_ = "/api/OrdersQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function ordersQuery_detailLines(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IOrderLineWithInventoryItem[]>> {
  try {

        let url_ = "/api/OrdersQuery/{id}/lines-details";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function ordersQuery_nonDeliveredLines(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IOrderLineDtoForRegisterDelivery[]>> {
  try {

        let url_ = "/api/OrdersQuery/{id}/lines/notDelivered";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function ordersQuery_queryNotPlacedBySupplier(supplierId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IOrderV2[]>> {
  try {

        let url_ = "/api/OrdersQuery/query-not-placed-by-supplier/{supplierId}";
        if (supplierId === undefined || supplierId === null)
            throw new Error("The parameter 'supplierId' must be defined.");
        url_ = url_.replace("{supplierId}", encodeURIComponent("" + supplierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function ordersQuery_nextReference(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/OrdersQuery/nextReference";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function ordersQuery_settings(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IOrderSettings>> {
  try {

        let url_ = "/api/OrdersQuery/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function ordersQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/OrdersQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function ordersQuery_export(body: IOrderExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/OrdersQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patchCochlearPatientBimodallyFittedDate_handle(body: IPatchCochlearPatientBimodallyFittedDateRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchCochlearPatientBimodallyFittedDateRequest>>> {
  try {

        let url_ = "/api/cochlear/patients/bimodally-fitted-date";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patchCochlearPatientImplantedDate_handle(body: IPatchCochlearPatientImplantedDateRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchCochlearPatientImplantedDateRequest>>> {
  try {

        let url_ = "/api/cochlear/patients/implanted-date";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patchCochlearPatientInformedDate_handle(body: IPatchCochlearPatientInformedDateRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchCochlearPatientInformedDateRequest>>> {
  try {

        let url_ = "/api/cochlear/patients/informed-date";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patchCochlearPatientReferralCenter_handle(body: IPatchCochlearPatientReferralCenterRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchCochlearPatientReferralCenterRequest>>> {
  try {

        let url_ = "/api/cochlear/patients/referral-center";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patchCochlearPatientReferralDate_handle(body: IPatchCochlearPatientReferralDateRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchCochlearPatientReferralDateRequest>>> {
  try {

        let url_ = "/api/cochlear/patients/referral-date";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patchPeppolSettings_handle(body: IPatchPeppolSettingsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchPeppolSettingsRequest>>> {
  try {

        let url_ = "/api/peppol/patch-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientAssignedArticlesCommand_markAsVisible(body: IMarkAssignedArticleAsVisibleRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PatientAssignedArticlesCommand/mark-as-visible";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientAssignedArticlesCommand_markAsHidden(body: IMarkAssignedArticleAsHiddenRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PatientAssignedArticlesCommand/mark-as-hidden";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientAssignedArticlesCommand_patchOrientation(body: IPatchOrientationOfAssignedArticleRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PatientAssignedArticlesCommand/patch-orientation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientAssignedArticlesQuery_get(patientId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IAssignedOrInquiredArticleDto[]>> {
  try {

        let url_ = "/api/PatientAssignedArticlesQuery/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientContactInfosCommand_addContactInfo(body: IAddPatientContactInfoRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IAddPatientContactInfoRequest>>> {
  try {

        let url_ = "/api/PatientContactInfosCommand/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientContactInfosCommand_patchContactInfo(body: IPatchPatientContactInfoRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchPatientContactInfoRequest>>> {
  try {

        let url_ = "/api/PatientContactInfosCommand/patch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientContactInfosCommand_deleteContactInfo(body: IDeletePatientContactInfoRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PatientContactInfosCommand/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientContactInfosCommand_makeContactInfoPrimary(body: IMakeContactInfoPrimaryRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PatientContactInfosCommand/makePrimary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsCommand_newFromEid(body: IPatientEidModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateValidateResponse>> {
  try {

        let url_ = "/api/PatientsCommand/new/eid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsCommand_newFromModel(body: IPatientModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IPatientModel>>> {
  try {

        let url_ = "/api/PatientsCommand/new/model";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsCommand_patchMissingProperties(body: IPatchPatientMissingPropertiesRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchPatientMissingPropertiesRequest>>> {
  try {

        let url_ = "/api/PatientsCommand/missingProperties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsCommand_removeInvalidEidData(body: IRemoveInvalidEidDataFromPatientRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRemoveInvalidEidDataFromPatientRequest>>> {
  try {

        let url_ = "/api/PatientsCommand/remove-invalid-eid-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsCommand_updateEidData(id: string, body: IEidData, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PatientsCommand/{id}/updateEidData";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsCommand_updatePersonalInformation(id: string, body: IPatientPersonalInformationModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatientPersonalInformationModel>>> {
  try {

        let url_ = "/api/PatientsCommand/{id}/updatePersonalInformation";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsCommand_updateAddress(id: string, body: IAddressModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IAddressModel>>> {
  try {

        let url_ = "/api/PatientsCommand/{id}/updateAddress";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsCommand_registerManualHandoverDate(id: string, body: Date, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PatientsCommand/{id}/handover/register";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsCommand_markAsDeceased(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PatientsCommand/{id}/markAsDeceased";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsCommand_markAsInactive(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PatientsCommand/{id}/markAsInactive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsCommand_markAsActive(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PatientsCommand/{id}/markAsActive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsCommand_linkHealthInsuranceFund(id: string, code: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PatientsCommand/{id}/linkHealthInsuranceFund/{code}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsCommand_updateLocation(id: string, body: ILinkLocationWithPatientModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PatientsCommand/{id}/location/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsCommand_updateContactPerson(id: string, body: IContactPersonModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IContactPersonModel>>> {
  try {

        let url_ = "/api/PatientsCommand/{id}/contactPerson/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsCommand_updateAttendingAudiologist(id: string, body: ILinkAttendingAudiologistWithPatientModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PatientsCommand/{id}/attendingAudiologist/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsCommand_updateAttendingGeneralPractitioner(id: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PatientsCommand/{id}/attendingGeneralPractitioner/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsCommand_updateAttendingEntPhysician(id: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PatientsCommand/{id}/attendingEntPhysician/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsCommand_updateOrigins(id: string, body: string[], cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PatientsCommand/{id}/origins/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsCommand_updateLabels(id: string, body: string[], cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PatientsCommand/{id}/labels/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsCommand_hardDelete(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PatientsCommand/{id}/delete/hard";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsCommand_patchLanguage(body: IPatchPatientLanguageRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchPatientLanguageRequest>>> {
  try {

        let url_ = "/api/PatientsCommand/language";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsCommand_patchReference(body: IPatchPatientReferenceRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchPatientReferenceRequest>>> {
  try {

        let url_ = "/api/PatientsCommand/reference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsCommand_patchOriginalPatientNo(body: IPatchPatientOriginalNoRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchPatientOriginalNoRequest>>> {
  try {

        let url_ = "/api/PatientsCommand/original_patient_no";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsCommand_patchBsn(body: IPatchPatientBsnRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchPatientBsnRequest>>> {
  try {

        let url_ = "/api/PatientsCommand/bsn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientSettingsCommand_patchRequiredProperties(body: IPatchPatientsRequiredPropertiesRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchPatientsRequiredPropertiesRequest>>> {
  try {

        let url_ = "/api/PatientSettingsCommand/required-properties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientSettingsCommand_pathReferenceSettings(body: IPatchPatientsReferenceSettingsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchPatientsReferenceSettingsRequest>>> {
  try {

        let url_ = "/api/PatientSettingsCommand/reference-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientSettingsCommand_pathAutoFillReference(body: IPatchPatientsSettingsAutoFillReferenceRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchPatientsSettingsAutoFillReferenceRequest>>> {
  try {

        let url_ = "/api/PatientSettingsCommand/auto-fill-reference-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsNhaxCommand_batchImportNhaxPatients(body: IBatchImportNhaxPatientsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IBatchImportNhaxPatientsResponse>> {
  try {

        let url_ = "/api/PatientsNhaxCommand/batch-import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsNhaxCommand_validateNhaxFile(body: INhaxFileUploadModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<INhaxValidateResponse>> {
  try {

        let url_ = "/api/PatientsNhaxCommand/new/nhax/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsNhaxCommand_newResumeWithNhax(body: INhaxResumeModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateValidateResponse>> {
  try {

        let url_ = "/api/PatientsNhaxCommand/new/nhax/resume";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsNhaxCommand_updateFromNhax(id: string, body: INhaxFileUploadModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<INhaxImportResponse>> {
  try {

        let url_ = "/api/PatientsNhaxCommand/{id}/update/fromNhax";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsNhaxCommand_updateResumeWithNhax(id: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateValidateResponse>> {
  try {

        let url_ = "/api/PatientsNhaxCommand/{id}/update/fromNhax/resume";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsNhaxQuery_exportNhax(id: string, body: INhaxExportModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/{id}/exportNhax";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientSocialSecurityNumberValidation_validate(body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<boolean>> {
  try {

        let url_ = "/api/PatientSocialSecurityNumberValidation/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsQuery_query(body: IPatientsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IPatientSummary>>> {
  try {

        let url_ = "/api/PatientsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsQuery_search(body: IPatientSearchModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IPatientSearch[]>> {
  try {

        let url_ = "/api/PatientsQuery/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsQuery_filterData(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<IPatientsFilterData>>> {
  try {

        let url_ = "/api/PatientsQuery/filterData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IPatient>> {
  try {

        let url_ = "/api/PatientsQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsQuery_singleIdAndIdentifier(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IObjectWithIdAndIdentifier<string>>> {
  try {

        let url_ = "/api/PatientsQuery/{id}/single-id-and-identifier";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsQuery_singleSearch(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IPatientSearch>> {
  try {

        let url_ = "/api/PatientsQuery/{id}/search";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsQuery_details(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IPatientDetail>> {
  try {

        let url_ = "/api/PatientsQuery/{id}/details";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsQuery_winipro(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IWiniproPatientData>> {
  try {

        let url_ = "/api/PatientsQuery/{id}/winipro";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsQuery_acousoft(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IAcousoftPatientData>> {
  try {

        let url_ = "/api/PatientsQuery/{id}/acousoft";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsQuery_eazyworks(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IEazyworksPatientData>> {
  try {

        let url_ = "/api/PatientsQuery/{id}/eazyworks";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsQuery_singleMissingProperties(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string[]>> {
  try {

        let url_ = "/api/PatientsQuery/{id}/missingProperties";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsQuery_singlePhoto(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IPatientPhoto>> {
  try {

        let url_ = "/api/PatientsQuery/{id}/photo";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsQuery_singleRecipientAndAddress(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRecipientAndAddress>> {
  try {

        let url_ = "/api/PatientsQuery/{id}/recipientAndAddress";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsQuery_singleContactPersonRecipientAndAddress(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRecipientAndAddress>> {
  try {

        let url_ = "/api/PatientsQuery/{id}/contactPerson/recipientAndAddress";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsQuery_hasContactPerson(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<boolean>> {
  try {

        let url_ = "/api/PatientsQuery/{id}/hasContactPerson";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsQuery_filterForMedicalTreatmentNomenclatures(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IPatientFilterMedicalTreatmentDto>> {
  try {

        let url_ = "/api/PatientsQuery/{id}/filterForMedicalTreatmentNomenclatures";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/PatientsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsQuery_checkSsNumber(ssNumber: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICheckSsNumberResponse>> {
  try {

        let url_ = "/api/PatientsQuery/checkSsNumber/{ssNumber}";
        if (ssNumber === undefined || ssNumber === null)
            throw new Error("The parameter 'ssNumber' must be defined.");
        url_ = url_.replace("{ssNumber}", encodeURIComponent("" + ssNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsQuery_export(body: IPatientsExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/PatientsQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function patientsQuery_settings(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IPatientSettings>> {
  try {

        let url_ = "/api/PatientsQuery/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentMethodsCommand_new(body: IPaymentMethodModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IPaymentMethodModel>>> {
  try {

        let url_ = "/api/PaymentMethodsCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentMethodsCommand_patchName(body: IPatchPaymentMethodNameRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchPaymentMethodNameRequest>>> {
  try {

        let url_ = "/api/PaymentMethodsCommand/name";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentMethodsCommand_enable(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PaymentMethodsCommand/{id}/enable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentMethodsCommand_disable(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PaymentMethodsCommand/{id}/disable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentMethodsCommand_enableCashSale(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PaymentMethodsCommand/{id}/cashSale/enable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentMethodsCommand_disableCashSale(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PaymentMethodsCommand/{id}/cashSale/disable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentMethodsCommand_enableSale(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PaymentMethodsCommand/{id}/sale/enable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentMethodsCommand_disableSale(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PaymentMethodsCommand/{id}/sale/disable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentMethodsCommand_enablePurchase(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PaymentMethodsCommand/{id}/purchase/enable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentMethodsCommand_disablePurchase(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PaymentMethodsCommand/{id}/purchase/disable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentMethodsQuery_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IPaymentMethod[]>> {
  try {

        let url_ = "/api/PaymentMethodsQuery/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentMethodsQuery_cache(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<IPaymentMethodSummary[]>>> {
  try {

        let url_ = "/api/PaymentMethodsQuery/cache";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentMethodsQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IPaymentMethod>> {
  try {

        let url_ = "/api/PaymentMethodsQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentMethodsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/PaymentMethodsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentsCommand_updateReferenceDate(id: string, body: Date, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PaymentsCommand/{id}/referenceDate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentsCommand_updateComment(id: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PaymentsCommand/{id}/comment";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentsForPurchasesCommand_new(body: IPaymentForPurchaseModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IPaymentForPurchaseModel>>> {
  try {

        let url_ = "/api/PaymentsForPurchasesCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentsForPurchasesCommand_newGroup(body: IPaymentForPurchasesModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IPaymentForPurchasesModel>>> {
  try {

        let url_ = "/api/PaymentsForPurchasesCommand/new/group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentsForSalesCommand_newForCustomerAccountLine(customerAccountLineId: string, body: IPaymentForSaleModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IPaymentForSaleModel>>> {
  try {

        let url_ = "/api/PaymentsForSalesCommand/customerAccountLines/{customerAccountLineId}/new";
        if (customerAccountLineId === undefined || customerAccountLineId === null)
            throw new Error("The parameter 'customerAccountLineId' must be defined.");
        url_ = url_.replace("{customerAccountLineId}", encodeURIComponent("" + customerAccountLineId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentsForSalesCommand_newRefundForCustomerAccountLine(customerAccountLineId: string, body: IRefundForSaleModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IRefundForSaleModel>>> {
  try {

        let url_ = "/api/PaymentsForSalesCommand/customerAccountLines/{customerAccountLineId}/refund";
        if (customerAccountLineId === undefined || customerAccountLineId === null)
            throw new Error("The parameter 'customerAccountLineId' must be defined.");
        url_ = url_.replace("{customerAccountLineId}", encodeURIComponent("" + customerAccountLineId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentsForSalesCommand_newForCashSale(salesId: string, body: IPaymentForSaleModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IPaymentForSaleModel>>> {
  try {

        let url_ = "/api/PaymentsForSalesCommand/cashSales/{salesId}";
        if (salesId === undefined || salesId === null)
            throw new Error("The parameter 'salesId' must be defined.");
        url_ = url_.replace("{salesId}", encodeURIComponent("" + salesId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentsForSalesCommand_newRefundForCashSale(salesId: string, body: ICashSaleRefundModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<ICashSaleRefundModel>>> {
  try {

        let url_ = "/api/PaymentsForSalesCommand/cashSales/{salesId}/refund";
        if (salesId === undefined || salesId === null)
            throw new Error("The parameter 'salesId' must be defined.");
        url_ = url_.replace("{salesId}", encodeURIComponent("" + salesId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentsForSalesCommand_newForCustomerAccount(customerAccountId: string, body: IPaymentForSalesModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IPaymentForSalesModel>>> {
  try {

        let url_ = "/api/PaymentsForSalesCommand/customerAccount/{customerAccountId}";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined.");
        url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentsForSalesCommand_newForSettlementProposal(settlementProposalId: string, body: IPaymentFromSettlementProposalModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IPaymentFromSettlementProposalModel>>> {
  try {

        let url_ = "/api/PaymentsForSalesCommand/settlementProposal/{settlementProposalId}";
        if (settlementProposalId === undefined || settlementProposalId === null)
            throw new Error("The parameter 'settlementProposalId' must be defined.");
        url_ = url_.replace("{settlementProposalId}", encodeURIComponent("" + settlementProposalId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentsQuery_query(body: IPaymentsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IPayment>>> {
  try {

        let url_ = "/api/PaymentsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentsQuery_queryForCustomerAccount(customerAccountId: string, body: IPaymentsForCustomerAccountQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IPayment>>> {
  try {

        let url_ = "/api/PaymentsQuery/query/customerAccounts/{customerAccountId}";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined.");
        url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentsQuery_queryForSupplierAccount(supplierId: string, body: IPaymentsForSupplierAccountQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IPayment>>> {
  try {

        let url_ = "/api/PaymentsQuery/query/supplierAccounts/{supplierId}";
        if (supplierId === undefined || supplierId === null)
            throw new Error("The parameter 'supplierId' must be defined.");
        url_ = url_.replace("{supplierId}", encodeURIComponent("" + supplierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/PaymentsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentsQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IPayment>> {
  try {

        let url_ = "/api/PaymentsQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentsQuery_nextReference(reference: string | undefined, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/PaymentsQuery/nextReference?";
        if (reference === null)
            throw new Error("The parameter 'reference' cannot be null.");
        else if (reference !== undefined)
            url_ += "reference=" + encodeURIComponent("" + reference) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentsQuery_nextReferenceForPurchase(purchaseId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/PaymentsQuery/purchases/{purchaseId}/nextReference";
        if (purchaseId === undefined || purchaseId === null)
            throw new Error("The parameter 'purchaseId' must be defined.");
        url_ = url_.replace("{purchaseId}", encodeURIComponent("" + purchaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentsQuery_nextReferenceForSale(salesId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/PaymentsQuery/sales/{salesId}/nextReference";
        if (salesId === undefined || salesId === null)
            throw new Error("The parameter 'salesId' must be defined.");
        url_ = url_.replace("{salesId}", encodeURIComponent("" + salesId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentsQuery_export(body: IPaymentsExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/PaymentsQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentsQuery_exportForCustomerAccount(customerAccountId: string, body: IPaymentsForCustomerAccountExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/PaymentsQuery/export/customerAccount/{customerAccountId}";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined.");
        url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function paymentsQuery_exportForSupplierAccount(supplierId: string, body: IPaymentsForSupplierAccountExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/PaymentsQuery/export/supplierAccount/{supplierId}";
        if (supplierId === undefined || supplierId === null)
            throw new Error("The parameter 'supplierId' must be defined.");
        url_ = url_.replace("{supplierId}", encodeURIComponent("" + supplierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function physiciansSearch_searchByName(body: ISearchPhysicianByNameModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IWebPhysician[]>> {
  try {

        let url_ = "/api/PhysiciansSearch/searchByName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function physiciansSearch_searchByRizivNumber(body: ISearchPhysicianByRizivNumberModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IWebPhysician[]>> {
  try {

        let url_ = "/api/PhysiciansSearch/searchByRizivNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_importFromXlsx(body: IExcelFileUploadModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IImportProductCatalogItemsFromXlsxResponse>> {
  try {

        let url_ = "/api/ProductCatalogCommand/import/xlsx";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_newService(body: IServiceProductCatalogItemModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IServiceProductCatalogItemModel>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/new/service";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_newInsurance(body: IInsuranceProductCatalogItemModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IInsuranceProductCatalogItemModel>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/new/insurance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_newProlongedWarranty(body: IProlongedWarrantyProductCatalogItemModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IProlongedWarrantyProductCatalogItemModel>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/new/prolongedWarranty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_newHearingDevice(body: IHearingDeviceCatalogModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IHearingDeviceCatalogModel>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/new/hearingDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_newTangible(body: ICreateTangibleProductCatalogItemRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<ICreateTangibleProductCatalogItemRequest>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/new/tangible";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_newDistcountArticle(body: ICreateDiscountArticleRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<ICreateDiscountArticleRequest>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/new/discount-article";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_patchInternalReference(body: IPatchProductCatalogItemInternalReferenceRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchProductCatalogItemInternalReferenceRequest>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/internal-reference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_patchType(body: IPatchProductCatalogItemTypeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchProductCatalogItemTypeRequest>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_patchIsElectronics(body: IPatchProductCatalogItemIsElectronicsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchProductCatalogItemIsElectronicsRequest>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/is-electronics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_patchHasBatteries(body: IPatchProductCatalogItemHasBatteriesRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchProductCatalogItemHasBatteriesRequest>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/has-batteries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_patchVatPercentage(body: IPatchProductCatalogItemVatPercentageRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchProductCatalogItemVatPercentageRequest>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/vat-percentage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_patchSalesListPrice(body: IPatchProductCatalogItemSalesListPriceRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchProductCatalogItemSalesListPriceRequest>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/sales-list-price";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_patchPurchaseListPrice(body: IPatchProductCatalogItemPurchaseListPriceRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchProductCatalogItemPurchaseListPriceRequest>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/purchase-list-price";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_patchCategories(body: IPatchProductCatalogItemCategoriesRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchProductCatalogItemCategoriesRequest>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/categories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_patchManufacturerReferences(body: IPatchProductCatalogItemManufacturerReferencesRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchProductCatalogItemManufacturerReferencesRequest>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/manufacturer-references";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_patchName(body: IPatchProductCatalogItemNameRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchProductCatalogItemNameRequest>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/name";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_patchTerm(body: IPatchProductCatalogItemInsuranceOrProlongedWarrantyTermRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchProductCatalogItemInsuranceOrProlongedWarrantyTermRequest>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/term";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_patchDefaultWarranty(body: IPatchProductCatalogItemDefaultWarrantyRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchProductCatalogItemDefaultWarrantyRequest>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/default-warranty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_patchManufacturerAndModel(body: IPatchProductCatalogItemManufacturerAndModelRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchProductCatalogItemManufacturerAndModelRequest>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/manufacturer-and-model";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_patchHearingAidData(body: IPatchProductCatalogItemHearingAidDataRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchProductCatalogItemHearingAidDataRequest>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/hearing-aid-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_patchSuppliers(body: IPatchProductCatalogItemSuppliersRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchProductCatalogItemSuppliersRequest>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/suppliers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_patchRizivHearingAidDefinitionV2IdentificationCodes(body: IPatchProductCatalogItemRizivHearingAidDefinitionV2IdentificationCodesRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/ProductCatalogCommand/riziv-hearing-aid-definition-v2-identification-codes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_patchRecupel(body: IPatchProductCatalogItemRecupelCodeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchProductCatalogItemRecupelCodeRequest>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/recupel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_patchBebatUnitPrice(body: IPatchProductCatalogItemBebatUnitPriceRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchProductCatalogItemBebatUnitPriceRequest>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/bebat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_patchLabels(body: IPatchProductCatalogItemLabelsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchProductCatalogItemLabelsRequest>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/labels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_patchCanAlsoPurchase(body: IPatchProductCatalogItemCanAlsoPurchaseRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchProductCatalogItemCanAlsoPurchaseRequest>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/can-also-purchase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_delete(body: IDeleteProductCatalogItemRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IDeleteProductCatalogItemRequest>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_restore(body: IRestoreProductCatalogItemRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRestoreProductCatalogItemRequest>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/restore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_patchArticlePropertyDefinitions(body: IPatchProductCatalogItemArticlePropertyDefinitionsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchProductCatalogItemArticlePropertyDefinitionsRequest>>> {
  try {

        let url_ = "/api/ProductCatalogCommand/article-property-definitions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogCommand_scriptRectifyStock(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/ProductCatalogCommand/script/rectifyStock";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogQuery_query(body: IProductCatalogQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IProductCatalogItem>>> {
  try {

        let url_ = "/api/ProductCatalogQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogQuery_queryNonDeleted(body: ITypesAndCategoriesProductCatalogQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IProductCatalogItem>>> {
  try {

        let url_ = "/api/ProductCatalogQuery/query/nonDeleted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogQuery_queryUniquelyIdentifiable(body: ITypesAndCategoriesProductCatalogQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IProductCatalogItem>>> {
  try {

        let url_ = "/api/ProductCatalogQuery/query/uniquelyIdentifiable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogQuery_queryUniquelyIdentifiableByType(type: ProductCatalogItemType, body: ICategoriesProductCatalogQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IProductCatalogItem>>> {
  try {

        let url_ = "/api/ProductCatalogQuery/query/uniquelyIdentifiable/{type}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogQuery_queryForOrder(body: IProductCatalogQueryParamsForOrder, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IProductCatalogItem>>> {
  try {

        let url_ = "/api/ProductCatalogQuery/query/order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogQuery_queryForArticlesInquiry(body: IProductCatalogQueryParamsForArticlesInquiry, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IProductCatalogItem>>> {
  try {

        let url_ = "/api/ProductCatalogQuery/query/articles-inquiry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogQuery_queryForDelivery(body: IProductCatalogQueryParamsForDelivery, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IProductCatalogItem>>> {
  try {

        let url_ = "/api/ProductCatalogQuery/query/delivery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogQuery_queryForTender(body: IProductCatalogQueryParamsForTender, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IProductCatalogItem>>> {
  try {

        let url_ = "/api/ProductCatalogQuery/query/tender";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogQuery_queryForSale(body: IProductCatalogQueryParamsForSale, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IProductCatalogItem>>> {
  try {

        let url_ = "/api/ProductCatalogQuery/query/sale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogQuery_queryForPurchase(body: IProductCatalogQueryParamsForPurchase, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IProductCatalogItem>>> {
  try {

        let url_ = "/api/ProductCatalogQuery/query/purchase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogQuery_queryForReturn(body: IProductCatalogQueryParamsForReturn, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IProductCatalogItem>>> {
  try {

        let url_ = "/api/ProductCatalogQuery/query/return";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogQuery_queryForStockMovement(body: IProductCatalogQueryParamsForStockMovement, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IProductCatalogItem>>> {
  try {

        let url_ = "/api/ProductCatalogQuery/query/stockMovement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogQuery_queryTailorMade(supplierId: string, body: IProductCatalogQueryParamsForTailorMade, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IProductCatalogItem>>> {
  try {

        let url_ = "/api/ProductCatalogQuery/query/tailorMade/{supplierId}";
        if (supplierId === undefined || supplierId === null)
            throw new Error("The parameter 'supplierId' must be defined.");
        url_ = url_.replace("{supplierId}", encodeURIComponent("" + supplierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/ProductCatalogQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogQuery_searchNoahDevices(body: ISearchNoahDevicesQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IProductCatalogItem>>> {
  try {

        let url_ = "/api/ProductCatalogQuery/searchNoahDevices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IProductCatalogItem>> {
  try {

        let url_ = "/api/ProductCatalogQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogQuery_singleWithStockAtLocations(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IProductCatalogItemWithStockAtLocations>> {
  try {

        let url_ = "/api/ProductCatalogQuery/{id}/stockAtLocations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogQuery_singleWithStatsAndStockInfo(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IProductCatalogItemWithStatsAndStockInfo>> {
  try {

        let url_ = "/api/ProductCatalogQuery/{id}/withStatsAndStockInfo";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogQuery_searchData(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<IProductCatalogSearchData>>> {
  try {

        let url_ = "/api/ProductCatalogQuery/searchData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogQuery_export(body: IProductCatalogExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/ProductCatalogQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogSettingsCommand_patchDefaultVatPercentageHearingAids(body: IPatchDefaultVatPercentageHearingAidsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchDefaultVatPercentageHearingAidsRequest>>> {
  try {

        let url_ = "/api/ProductCatalogSettingsCommand/default-vat-percentage-ha";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogSettingsCommand_patchDefaultVatPercentageCharger(body: IPatchDefaultVatPercentageChargerRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchDefaultVatPercentageChargerRequest>>> {
  try {

        let url_ = "/api/ProductCatalogSettingsCommand/default-vat-percentage-charger";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function productCatalogSettingsQuery_settings(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IProductCatalogSettings>> {
  try {

        let url_ = "/api/ProductCatalogSettingsQuery/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesCommand_new(body: IRegisterPurchaseRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IRegisterPurchaseRequest>>> {
  try {

        let url_ = "/api/PurchasesCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesCommand_newFromInventoryItem(body: IPurchaseFromInventoryItemModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IPurchaseFromInventoryItemModel>>> {
  try {

        let url_ = "/api/PurchasesCommand/new/inventoryItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesCommand_newCreditNote(body: IPurchaseCreditNoteModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IPurchaseCreditNoteModel>>> {
  try {

        let url_ = "/api/PurchasesCommand/new/creditNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesCommand_newCreditNoteFromInventoryItem(body: ICreditPurchaseFromInventoryItemModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<ICreditPurchaseFromInventoryItemModel>>> {
  try {

        let url_ = "/api/PurchasesCommand/new/inventoryItem/credit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesCommand_patchExternalReference(body: IPatchPurchaseExternalReferenceRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchPurchaseExternalReferenceRequest>>> {
  try {

        let url_ = "/api/PurchasesCommand/externalReference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesCommand_patchReferenceDate(body: IPatchPurchaseReferenceDateRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchPurchaseReferenceDateRequest>>> {
  try {

        let url_ = "/api/PurchasesCommand/referenceDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesCommand_patchPayBeforeDate(body: IPatchPurchasePayBeforeDateRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchPurchasePayBeforeDateRequest>>> {
  try {

        let url_ = "/api/PurchasesCommand/payBeforeDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesCommand_patchLabels(body: IPatchPurchaseLabelsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchPurchaseLabelsRequest>>> {
  try {

        let url_ = "/api/PurchasesCommand/labels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchaseSettingsCommand_patchDefaultValidUntil(body: IPatchPurchaseDefaultValidUntilRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchPurchaseDefaultValidUntilRequest>>> {
  try {

        let url_ = "/api/PurchaseSettingsCommand/default-valid-unti";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchaseSettingsCommand_patchReferenceSettings(body: IPatchPurchaseReferenceSettingsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchPurchaseReferenceSettingsRequest>>> {
  try {

        let url_ = "/api/PurchaseSettingsCommand/reference-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesQuery_query(body: IPurchasesQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResultWithMetadata<IPurchase, IPurchasesQueryMetadata>>> {
  try {

        let url_ = "/api/PurchasesQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesQuery_filterData(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<IPurchasesFilterData>>> {
  try {

        let url_ = "/api/PurchasesQuery/filterData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesQuery_queryForSupplier(supplierId: string, body: IPurchasesForSupplierQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IPurchase>>> {
  try {

        let url_ = "/api/PurchasesQuery/query/supplier/{supplierId}";
        if (supplierId === undefined || supplierId === null)
            throw new Error("The parameter 'supplierId' must be defined.");
        url_ = url_.replace("{supplierId}", encodeURIComponent("" + supplierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesQuery_allForSupplier(supplierId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IPurchase[]>> {
  try {

        let url_ = "/api/PurchasesQuery/all/supplier/{supplierId}";
        if (supplierId === undefined || supplierId === null)
            throw new Error("The parameter 'supplierId' must be defined.");
        url_ = url_.replace("{supplierId}", encodeURIComponent("" + supplierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/PurchasesQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IPurchase>> {
  try {

        let url_ = "/api/PurchasesQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesQuery_export(body: IPurchasesExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/PurchasesQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesQuery_exportForSupplier(supplierId: string, body: IPurchasesForSupplierExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/PurchasesQuery/export/supplier/{supplierId}";
        if (supplierId === undefined || supplierId === null)
            throw new Error("The parameter 'supplierId' must be defined.");
        url_ = url_.replace("{supplierId}", encodeURIComponent("" + supplierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesQuery_nextReference(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/PurchasesQuery/nextReference";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesQuery_settings(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IPurchaseSettings>> {
  try {

        let url_ = "/api/PurchasesQuery/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesUblCommand_addToBuffer(body: IUploadMultipleFilesRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IAddUblsToBufferResponse>> {
  try {

        let url_ = "/api/PurchasesUblCommand/add-to-buffer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesUblCommand_removeFromBuffer(body: IRemovePurchaseUblBufferRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/PurchasesUblCommand/remove-buffer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesUblCommand_handleFromBuffer(body: IHandleUblFromBufferRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUblPurchaseFileUploadResponse>> {
  try {

        let url_ = "/api/PurchasesUblCommand/handle-from-buffer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesUblCommand_upload(body: IFileUploadRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUblPurchaseFileUploadResponse>> {
  try {

        let url_ = "/api/PurchasesUblCommand/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesUblCommand_register(body: IRegisterPurchaseFromUblRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IRegisterPurchaseFromUblRequest>>> {
  try {

        let url_ = "/api/PurchasesUblCommand/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesUblQuery_query(body: IPurchasesUblBufferQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IPurchaseUblBuffer>>> {
  try {

        let url_ = "/api/PurchasesUblQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesUblQuery_count(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/PurchasesUblQuery/count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesUblQuery_downloadUblFromBuffer(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/PurchasesUblQuery/{id}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function purchasesUblQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/PurchasesUblQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function recupelsQuery_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<IRecupelItemDto[]>>> {
  try {

        let url_ = "/api/RecupelsQuery/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function recupelsQuery_default(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<string>>> {
  try {

        let url_ = "/api/RecupelsQuery/default";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function recupelsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/RecupelsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function registerAsACochlearSpecialist_handle(body: IRegisterAsACochlearSpecialistRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRegisterAsACochlearSpecialistRequest>>> {
  try {

        let url_ = "/api/cochlear/register-specialist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function registerAudiologistForCochlearEvent_handle(body: IRegisterAudiologistForCochlearEventRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRegisterAudiologistForCochlearEventRequest>>> {
  try {

        let url_ = "/api/cochlear/register-audiologist-for-event";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function registerPatientForCochlearEvent_handle(body: IRegisterPatientForCochlearEventRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRegisterPatientForCochlearEventRequest>>> {
  try {

        let url_ = "/api/cochlear/register-patient-for-event";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairsCommand_new(body: IRegisterRepairRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IRegisterRepairRequest>>> {
  try {

        let url_ = "/api/RepairsCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairsCommand_newFromInventoryItem(body: IRepairFromInventoryItemModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IRepairFromInventoryItemModel>>> {
  try {

        let url_ = "/api/RepairsCommand/new/inventory-item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairsCommand_patchSteps(body: IPatchRepairStepsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchRepairStepsRequest>>> {
  try {

        let url_ = "/api/RepairsCommand/steps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairsCommand_addLine(body: IAddRepairLineRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IAddRepairLineRequest>>> {
  try {

        let url_ = "/api/RepairsCommand/add-line";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairsCommand_patchExpectedRedeliveryDate(body: IPatchRepairExpectedRedeliveryDateRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchRepairExpectedRedeliveryDateRequest>>> {
  try {

        let url_ = "/api/RepairsCommand/expectedRedeliveryDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairsCommand_patchExpectedHandoverDate(body: IPatchRepairExpectedHandoverDateRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchRepairExpectedHandoverDateRequest>>> {
  try {

        let url_ = "/api/RepairsCommand/expectedHandoverDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairsCommand_sendToSupplier(body: ISendRepairToSupplierRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ISendRepairToSupplierRequest>>> {
  try {

        let url_ = "/api/RepairsCommand/send-to-supplier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairsCommand_registerDelivery(body: IRegisterRepairDeliveryRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRegisterRepairDeliveryRequest>>> {
  try {

        let url_ = "/api/RepairsCommand/register-delivery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairsCommand_registerHandover(body: IRegisterRepairHandoverToPatientRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRegisterRepairHandoverToPatientRequest>>> {
  try {

        let url_ = "/api/RepairsCommand/register-handover";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairsCommand_cancel(body: ICancelRepairRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ICancelRepairRequest>>> {
  try {

        let url_ = "/api/RepairsCommand/cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairsCommand_unlinkFromPatient(body: IUnlinkRepairFromPatientRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IUnlinkRepairFromPatientRequest>>> {
  try {

        let url_ = "/api/RepairsCommand/unlink-from-patient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairsCommand_linkWithPatient(body: ILinkRepairWithPatientRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ILinkRepairWithPatientRequest>>> {
  try {

        let url_ = "/api/RepairsCommand/link-with-patient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairsCommand_patchHandlingUser(body: IPatchRepairHandlingUserRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchRepairHandlingUserRequest>>> {
  try {

        let url_ = "/api/RepairsCommand/handlingUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairsCommand_patchReference(body: IPatchRepairReferenceRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchRepairReferenceRequest>>> {
  try {

        let url_ = "/api/RepairsCommand/reference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairsCommand_patchExternalReference(body: IPatchRepairExternalReferenceRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchRepairExternalReferenceRequest>>> {
  try {

        let url_ = "/api/RepairsCommand/externalReference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairSettingsCommand_patchDefaultExpectedReturnTime(body: IPatchRepairDefaultExpectedReturnTimeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchRepairDefaultExpectedReturnTimeRequest>>> {
  try {

        let url_ = "/api/RepairSettingsCommand/default-expected-return-time";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairSettingsCommand_patchReferenceSettings(body: IPatchRepairReferenceSettingsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchRepairReferenceSettingsRequest>>> {
  try {

        let url_ = "/api/RepairSettingsCommand/reference-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairsQuery_query(body: IRepairsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResultWithMetadata<IRepair, IRepairsQueryMetadata>>> {
  try {

        let url_ = "/api/RepairsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairsQuery_notSent(inventoryItemId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRepair[]>> {
  try {

        let url_ = "/api/RepairsQuery/notSent/{inventoryItemId}";
        if (inventoryItemId === undefined || inventoryItemId === null)
            throw new Error("The parameter 'inventoryItemId' must be defined.");
        url_ = url_.replace("{inventoryItemId}", encodeURIComponent("" + inventoryItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairsQuery_reasons(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<string[]>>> {
  try {

        let url_ = "/api/RepairsQuery/reasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairsQuery_nextReference(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/RepairsQuery/nextReference";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairsQuery_settings(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRepairSettings>> {
  try {

        let url_ = "/api/RepairsQuery/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairsQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRepair>> {
  try {

        let url_ = "/api/RepairsQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/RepairsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function repairsQuery_export(body: IRepairExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/RepairsQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function returnsCommand_new(body: IReturnModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IReturnModel>>> {
  try {

        let url_ = "/api/ReturnsCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function returnsCommand_new_inventoryItem(body: IReturnFromInventoryItemModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IReturnFromInventoryItemModel>>> {
  try {

        let url_ = "/api/ReturnsCommand/new/inventoryItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function returnsCommand_patchExternalReference(body: IPatchReturnExternalReferenceRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchReturnExternalReferenceRequest>>> {
  try {

        let url_ = "/api/ReturnsCommand/externalReference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function returnsCommand_patchReturnDate(body: IPatchReturnDateRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchReturnDateRequest>>> {
  try {

        let url_ = "/api/ReturnsCommand/returnDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function returnSettingsCommand_patchReferenceSettings(body: IPatchReturnReferenceSettingsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchReturnReferenceSettingsRequest>>> {
  try {

        let url_ = "/api/ReturnSettingsCommand/reference-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function returnsQuery_query(body: IReturnsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IReturn>>> {
  try {

        let url_ = "/api/ReturnsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function returnsQuery_nextReference(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/ReturnsQuery/nextReference";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function returnsQuery_settings(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IReturnSettings>> {
  try {

        let url_ = "/api/ReturnsQuery/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function returnsQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IReturn>> {
  try {

        let url_ = "/api/ReturnsQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function returnsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/ReturnsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function returnsQuery_export(body: IReturnsExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/ReturnsQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiaDocumentsCommand_createLoanSlip(rfiaId: string, trialId: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateValidateResponse>> {
  try {

        let url_ = "/api/RfiaDocumentsCommand/{rfiaId}/trials/{trialId}/loanSlip/create";
        if (rfiaId === undefined || rfiaId === null)
            throw new Error("The parameter 'rfiaId' must be defined.");
        url_ = url_.replace("{rfiaId}", encodeURIComponent("" + rfiaId));
        if (trialId === undefined || trialId === null)
            throw new Error("The parameter 'trialId' must be defined.");
        url_ = url_.replace("{trialId}", encodeURIComponent("" + trialId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiaDocumentsCommand_createTrialReport(rfiaId: string, trialId: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateValidateResponse>> {
  try {

        let url_ = "/api/RfiaDocumentsCommand/{rfiaId}/trials/{trialId}/trialReport/create";
        if (rfiaId === undefined || rfiaId === null)
            throw new Error("The parameter 'rfiaId' must be defined.");
        url_ = url_.replace("{rfiaId}", encodeURIComponent("" + rfiaId));
        if (trialId === undefined || trialId === null)
            throw new Error("The parameter 'trialId' must be defined.");
        url_ = url_.replace("{trialId}", encodeURIComponent("" + trialId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiaDocumentsCommand_createLetterToEnt(rfiaId: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateValidateResponse>> {
  try {

        let url_ = "/api/RfiaDocumentsCommand/{rfiaId}/letterToEnt/create";
        if (rfiaId === undefined || rfiaId === null)
            throw new Error("The parameter 'rfiaId' must be defined.");
        url_ = url_.replace("{rfiaId}", encodeURIComponent("" + rfiaId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiaDocumentsCommand_createLetterToAdvisoryPhysician(rfiaId: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateValidateResponse>> {
  try {

        let url_ = "/api/RfiaDocumentsCommand/{rfiaId}/letterToAdvisoryPhysician/create";
        if (rfiaId === undefined || rfiaId === null)
            throw new Error("The parameter 'rfiaId' must be defined.");
        url_ = url_.replace("{rfiaId}", encodeURIComponent("" + rfiaId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiaDocumentsCommand_createHandoverCertificate(rfiaId: string, body: IFromTemplateModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateValidateResponse>> {
  try {

        let url_ = "/api/RfiaDocumentsCommand/{rfiaId}/handoverCertificate/create";
        if (rfiaId === undefined || rfiaId === null)
            throw new Error("The parameter 'rfiaId' must be defined.");
        url_ = url_.replace("{rfiaId}", encodeURIComponent("" + rfiaId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiaDocumentsCommand_createProformaHandoverCertificate(rfiaId: string, body: IFromTemplateModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateValidateResponse>> {
  try {

        let url_ = "/api/RfiaDocumentsCommand/{rfiaId}/handoverCertificate/proforma/create";
        if (rfiaId === undefined || rfiaId === null)
            throw new Error("The parameter 'rfiaId' must be defined.");
        url_ = url_.replace("{rfiaId}", encodeURIComponent("" + rfiaId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiaDocumentsCommand_createCosi(rfiaId: string, body: IFromTemplateModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateValidateResponse>> {
  try {

        let url_ = "/api/RfiaDocumentsCommand/{rfiaId}/cosi/create";
        if (rfiaId === undefined || rfiaId === null)
            throw new Error("The parameter 'rfiaId' must be defined.");
        url_ = url_.replace("{rfiaId}", encodeURIComponent("" + rfiaId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiaDocumentsCommand_uploadPrescription(body: IUploadPrescriptionScanRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IUploadPrescriptionScanRequest>>> {
  try {

        let url_ = "/api/RfiaDocumentsCommand/upload/prescription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiaDocumentsCommand_deletePrescriptionScanHistory(body: IDeletePrescriptionScanHistoryRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IDeletePrescriptionScanHistoryRequest>>> {
  try {

        let url_ = "/api/RfiaDocumentsCommand/delete-prescription-scan-history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiaDocumentsCommand_deletePrescriptionScan(body: IDeletePrescriptionScanRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IDeletePrescriptionScanRequest>>> {
  try {

        let url_ = "/api/RfiaDocumentsCommand/delete-prescription-scan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_new(body: IRfiaModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IRfiaModel>>> {
  try {

        let url_ = "/api/RfiasCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_registerSendDocumentsMedicalPrescription(id: string, body: IRegisterSendDocumentsModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRegisterSendDocumentsModel>>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/medicalPrescriptions/registerSendDocuments";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_updateExpectedReceptionDateForMedicalPrescription(id: string, stepId: string, body: Date, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/medicalPrescriptions/{stepId}/expectedReceptionDate/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (stepId === undefined || stepId === null)
            throw new Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_registerApprovalMedicalPrescription(id: string, body: Date, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/medicalPrescriptions/registerApproval";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_updateApprovalMedicalPrescriptionDate(id: string, stepId: string, body: Date, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/medicalPrescriptions/{stepId}/approval/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (stepId === undefined || stepId === null)
            throw new Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_deleteMedicalPrescription(id: string, stepId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/medicalPrescriptions/{stepId}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (stepId === undefined || stepId === null)
            throw new Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_registerDisapprovalMedicalPrescription(id: string, body: Date, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/medicalPrescriptions/registerDisapproval";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_registerSendDocumentsAdvisoryPhysician(id: string, body: IRegisterSendDocumentsModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRegisterSendDocumentsModel>>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/feedbackAdvisoryPhysician/registerSendDocuments";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_updateExpectedReceptionDateForAdvisoryPhysician(id: string, stepId: string, body: Date, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/feedbackAdvisoryPhysician/{stepId}/expectedReceptionDate/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (stepId === undefined || stepId === null)
            throw new Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_deleteApprovalFeedbackAdvisoryPhysician(id: string, stepId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/feedbackAdvisoryPhysician/{stepId}/approval/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (stepId === undefined || stepId === null)
            throw new Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_registerApprovalAdvisoryPhysician(id: string, body: IRegisterApprovalAdvisoryPhysicianModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRegisterApprovalAdvisoryPhysicianModel>>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/feedbackAdvisoryPhysician/registerApproval";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_updateExpectedHandoverDate(id: string, body: Date, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/expectedHandoverDate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_updateFeedbackAdvisoryPhysicianApprovalDate(id: string, stepId: string, body: Date, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/feedbackAdvisoryPhysician/{stepId}/approval/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (stepId === undefined || stepId === null)
            throw new Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_registerDisapprovalAdvisoryPhysician(id: string, body: Date, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/feedbackAdvisoryPhysician/registerDisapproval";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_selectMainMedicalTreatment(id: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/medicalTreatments/main";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_clearMainMedicalTreatment(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/medicalTreatments/main/clear";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_selectPseudoMedicalTreatment(id: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/medicalTreatments/pseudo";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_clearPseudoMedicalTreatment(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/medicalTreatments/pseudo/clear";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_selectSecondaryMedicalTreatments(id: string, body: string[], cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/medicalTreatments/secondary";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_clearSecondaryMedicalTreatment(id: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/medicalTreatments/secondary/clear";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_linkHealthInsuranceFund(id: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/healthInsuranceFund/link";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_setEntPhysician(id: string, body: ILinkEntPhysicianModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/entPhysician/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_setAudiologist(id: string, body: ILinkAudiologistWithRfiaModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/audiologist/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_updateLocation(id: string, body: ILinkLocationWithRfiaModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/location/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_setEntPhysicianOffice(id: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/entPhysician/setOffice";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_setThirdPartyPaymentScheme(id: string, body: boolean, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/setThirdPartyPaymentScheme";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_updateInvoiceProcessSteps(id: string, body: string[], cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/invoiceProcessSteps/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_updatePrescriptionForTrialDate(id: string, body: Date, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/prescriptionForTrialDate/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_receivePrescription(id: string, body: IPrescriptionModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPrescriptionModel>>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/prescription/receive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_registerFailure(id: string, body: IEndFailureTrialModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IEndFailureTrialModel>>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/failure/register";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_undoFailure(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/failure/undo";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_cancel(id: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/cancel";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_undoCancellation(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/cancel/undo";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_updateLabels(id: string, body: string[], cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/{id}/labels/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_cancelScript(body: IRfiasQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/script/cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasCommand_proformaToSale(body: IRfiasQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasCommand/script/proformaToSale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiaSettingsCommand_patchDefaultTrialDuration(body: IPatchRfiaDefaultTrialDurationRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchRfiaDefaultTrialDurationRequest>>> {
  try {

        let url_ = "/api/RfiaSettingsCommand/trial-duration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiaSettingsCommand_patchDefaultExpectedReceptionTermForMedicalPrescription(body: IPatchRfiaDefaultMedicalPrescriptionExpectedReceptionTermRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchRfiaDefaultMedicalPrescriptionExpectedReceptionTermRequest>>> {
  try {

        let url_ = "/api/RfiaSettingsCommand/expected-reception-term-medical-prescription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiaSettingsCommand_patchExpectedHandoverTermAfterApproval(body: IPatchRfiaDefaultExpectedHandoverTermAfterApprovalRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchRfiaDefaultExpectedHandoverTermAfterApprovalRequest>>> {
  try {

        let url_ = "/api/RfiaSettingsCommand/expected-handover-term-approval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiaSettingsCommand_patchDefaultFailedTrialVatPercentage(body: IPatchRfiaDefaultFailedTrialVatPercentageRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchRfiaDefaultFailedTrialVatPercentageRequest>>> {
  try {

        let url_ = "/api/RfiaSettingsCommand/failed-vat-percentage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiaSettingsCommand_patchDefaultRizivRefundVatPercentage(body: IPatchRfiaDefaultRizivRefundVatPercentageRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchRfiaDefaultRizivRefundVatPercentageRequest>>> {
  try {

        let url_ = "/api/RfiaSettingsCommand/riziv-refund-vat-percentage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiaSettingsCommand_patchDefaultExpectedReceptionTermForAdvisoryPhysician(body: IPatchRfiaDefaultAdvisoryPhysicianExpectedReceptionTermRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchRfiaDefaultAdvisoryPhysicianExpectedReceptionTermRequest>>> {
  try {

        let url_ = "/api/RfiaSettingsCommand/expected-reception-term-advisory-physician";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiaSettingsCommand_patchDefaultThirdPartyScheme(body: IPatchRfiaDefaultThirdPartySchemeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchRfiaDefaultThirdPartySchemeRequest>>> {
  try {

        let url_ = "/api/RfiaSettingsCommand/default-third-party-scheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiaSettingsCommand_updateDefaultInvoiceProcessSteps(body: IPatchRfiaDefaultInvoiceProcessStepsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchRfiaDefaultInvoiceProcessStepsRequest>>> {
  try {

        let url_ = "/api/RfiaSettingsCommand/default-invoice-process-steps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiaSettingsCommand_patchReferenceSettings(body: IPatchRfiaReferenceSettingsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchRfiaReferenceSettingsRequest>>> {
  try {

        let url_ = "/api/RfiaSettingsCommand/reference-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiaSettingsCommand_patchSaleGenerationMode(body: IPatchRfiaHandoverSaleGenerationModeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchRfiaReferenceSettingsRequest>>> {
  try {

        let url_ = "/api/RfiaSettingsCommand/sale-generation-mode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasHandoverCommand_registerHandoverSingle(body: IRegisterRfiaHandoverSingleRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ISingleHandoverResponse>> {
  try {

        let url_ = "/api/RfiasHandoverCommand/register-single";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasHandoverCommand_registerHandoverSplit(body: IRegisterRfiaHandoverSplitRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ISplitHandoverResponse>> {
  try {

        let url_ = "/api/RfiasHandoverCommand/register-split";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasHandoverCommand_registerHandoverProforma(body: IRegisterRfiaProformaHandoverRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRegisterRfiaProformaHandoverRequest>>> {
  try {

        let url_ = "/api/RfiasHandoverCommand/register-proforma";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasHandoverCommand_registerHandoverProformaFailure(body: IRegisterRfiaProformaHandoverFailureRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRegisterRfiaProformaHandoverFailureRequest>>> {
  try {

        let url_ = "/api/RfiasHandoverCommand/register-proforma-failure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasHandoverCommand_deleteProforma(body: IDeleteRfiaProformaHandoverRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RfiasHandoverCommand/proforma-delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasHandoverCommand_registerHandoverFailure(body: IRegisterRfiaFailureHandoverRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFailureHandoverResponse>> {
  try {

        let url_ = "/api/RfiasHandoverCommand/register-failure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasHandoverCommand_patchHandoverLine(body: IPatchRfiaHandoverLineRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchRfiaHandoverLineRequest>>> {
  try {

        let url_ = "/api/RfiasHandoverCommand/patch-line";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasQuery_query(body: IRfiasQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResultWithMetadata<IRequestForInsuranceAllowance, IRfiaQueryMetadata>>> {
  try {

        let url_ = "/api/RfiasQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasQuery_filterData(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<IRfiaFilterData>>> {
  try {

        let url_ = "/api/RfiasQuery/filterData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasQuery_settings(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRfiaSettings>> {
  try {

        let url_ = "/api/RfiasQuery/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRfiaDetail>> {
  try {

        let url_ = "/api/RfiasQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasQuery_countActiveForPatient(patientId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/RfiasQuery/forPatient/{patientId}/countActive";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasQuery_singleTrial(id: string, trialId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ITrialStepDto>> {
  try {

        let url_ = "/api/RfiasQuery/{id}/trials/{trialId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (trialId === undefined || trialId === null)
            throw new Error("The parameter 'trialId' must be defined.");
        url_ = url_.replace("{trialId}", encodeURIComponent("" + trialId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasQuery_singlePrescriptionScan(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IPrescriptionScan>> {
  try {

        let url_ = "/api/RfiasQuery/{id}/prescriptionScan";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/RfiasQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiasQuery_export(body: IRfiasExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/RfiasQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiaTrialsCommand_start(body: IRegisterRfiaTrialRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRegisterRfiaTrialRequest>>> {
  try {

        let url_ = "/api/RfiaTrialsCommand/start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiaTrialsCommand_endAdministrative(body: IEndRfiaTrialAdministrativeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IEndRfiaTrialAdministrativeRequest>>> {
  try {

        let url_ = "/api/RfiaTrialsCommand/end-administrative";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rfiaTrialsCommand_endAllTrials(body: IEndRfiaAllTrialsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IEndRfiaAllTrialsRequest>>> {
  try {

        let url_ = "/api/RfiaTrialsCommand/end-all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rizivHearingAidDefinitionsV2ManufacturerAndNameGroupQuery_query(body: IRizivHearingAidDefinitionsV2ManufacturerAndNameGroupQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IRizivHearingAidDefinitionV2ManufacturerAndNameGroupDto>>> {
  try {

        let url_ = "/api/RizivHearingAidDefinitionsV2ManufacturerAndNameGroupQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rizivHearingAidDefinitionsV2ManufacturerAndNameGroupQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/RizivHearingAidDefinitionsV2ManufacturerAndNameGroupQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rizivHearingAidDefinitionsV2Query_single(id: number, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRizivHearingAidDefinitionV2Dto>> {
  try {

        let url_ = "/api/RizivHearingAidDefinitionsV2Query/{id}/single";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rizivHearingAidDefinitionsV2Query_identifyAndConvertToV2(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRizivHearingAidDefinitionV2Dto>> {
  try {

        let url_ = "/api/RizivHearingAidDefinitionsV2Query/{id}/identify-and-convert-to-V2";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rizivHearingAidDefinitionsV2Query_multiple(body: number[], cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRizivHearingAidDefinitionV2Dto[]>> {
  try {

        let url_ = "/api/RizivHearingAidDefinitionsV2Query/multiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rizivHearingAidDefinitionsV2Query_filterData(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<IRizivHearingAidDefinitionV2FilterData>>> {
  try {

        let url_ = "/api/RizivHearingAidDefinitionsV2Query/filterData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rizivHearingAidDefinitionsV2Query_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/RizivHearingAidDefinitionsV2Query/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function roomsCommand_updateColor(id: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RoomsCommand/{id}/color/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function roomsQuery_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<IRoomsCache>>> {
  try {

        let url_ = "/api/RoomsQuery/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function roomsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/RoomsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function roomsQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRoom>> {
  try {

        let url_ = "/api/RoomsQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaEventsQuery_query(body: IRosaEventsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRosaEventsResponse>> {
  try {

        let url_ = "/api/RosaEventsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaEventsQuery_todayForUser(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRosaEventDto[]>> {
  try {

        let url_ = "/api/RosaEventsQuery/today-for-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaEventsQuery_queryByPatient(body: IRosaEventsByPatientQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResultWithMetadata<IRosaEventDto, IRosaEventsByPatientMetadata>>> {
  try {

        let url_ = "/api/RosaEventsQuery/query-for-patient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaEventsQuery_upcomingByPatient(patientId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpcomingRosaEventsForPatientResponse>> {
  try {

        let url_ = "/api/RosaEventsQuery/patients/{patientId}/upcoming";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaEventsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/RosaEventsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaIntegrationCommand_register(body: IRosaRegistrationRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IRosaRegistrationRequest>>> {
  try {

        let url_ = "/api/RosaIntegrationCommand/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaIntegrationCommand_enable(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RosaIntegrationCommand/enable";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaIntegrationCommand_disable(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RosaIntegrationCommand/disable";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaIntegrationCommand_remove(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RosaIntegrationCommand/remove";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaIntegrationQuery_integrationStatus(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRosaIntegrationStatusDto>> {
  try {

        let url_ = "/api/RosaIntegrationQuery/integration-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaIntegrationQuery_status(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRosaStatusDto>> {
  try {

        let url_ = "/api/RosaIntegrationQuery/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaIntegrationQuery_countUnlinkedUsers(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/RosaIntegrationQuery/count-unlinked-users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaIntegrationQuery_isEnabled(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<boolean>> {
  try {

        let url_ = "/api/RosaIntegrationQuery/is-enabled";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaIntegrationQuery_frontendUrl(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/RosaIntegrationQuery/frontend-url";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaLinkCommand_linkHp(body: ILinkHamsUserToRosaHpRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RosaLinkCommand/linkHp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaLinkQuery_get(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRosaUsersLinkDto>> {
  try {

        let url_ = "/api/RosaLinkQuery/get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaPatientsCommand_createInHams(body: ICreatePatientInHamsFromRosaRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateValidateResponse>> {
  try {

        let url_ = "/api/RosaPatientsCommand/create-in-hams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaPatientsCommand_createInRosa(body: ICreatePatientInRosaRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateValidateResponseWithStringId>> {
  try {

        let url_ = "/api/RosaPatientsCommand/create-in-rosa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaPatientsCommand_pushToRosa(body: IPushPatientDataToRosaRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RosaPatientsCommand/push-to-rosa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaPatientsCommand_link(body: ILinkRosaPatientRecordToHamsPatientRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RosaPatientsCommand/link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaPatientsCommand_unlink(body: IUnlinkRosaPatientRecordFromHamsPatientRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RosaPatientsCommand/unlink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaPatientsQuery_query(body: IRosaPatientRecordsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResultWithMetadata<IRosaPatientRecord, IRosaPatientsQueryMetadata>>> {
  try {

        let url_ = "/api/RosaPatientsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaPatientsQuery_findMatches(rosaPatientId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRosaPatientMatchResponse>> {
  try {

        let url_ = "/api/RosaPatientsQuery/{rosaPatientId}/find-matches";
        if (rosaPatientId === undefined || rosaPatientId === null)
            throw new Error("The parameter 'rosaPatientId' must be defined.");
        url_ = url_.replace("{rosaPatientId}", encodeURIComponent("" + rosaPatientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaPatientsQuery_singleRedirect(rosaPatientId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRosaPatientRecordRedirectResponse>> {
  try {

        let url_ = "/api/RosaPatientsQuery/{rosaPatientId}/redirect";
        if (rosaPatientId === undefined || rosaPatientId === null)
            throw new Error("The parameter 'rosaPatientId' must be defined.");
        url_ = url_.replace("{rosaPatientId}", encodeURIComponent("" + rosaPatientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaPatientsQuery_singleWithMemberEquality(rosaPatientId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRosaPatientRecordWithMemberEquality>> {
  try {

        let url_ = "/api/RosaPatientsQuery/{rosaPatientId}/memberEquality";
        if (rosaPatientId === undefined || rosaPatientId === null)
            throw new Error("The parameter 'rosaPatientId' must be defined.");
        url_ = url_.replace("{rosaPatientId}", encodeURIComponent("" + rosaPatientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaPatientsQuery_recordsByHamsPatientId(hamsPatientId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IHamsRosaPatientLinkDto>> {
  try {

        let url_ = "/api/RosaPatientsQuery/{hamsPatientId}/records";
        if (hamsPatientId === undefined || hamsPatientId === null)
            throw new Error("The parameter 'hamsPatientId' must be defined.");
        url_ = url_.replace("{hamsPatientId}", encodeURIComponent("" + hamsPatientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaPatientsQuery_isLinked(hamsPatientId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<boolean>> {
  try {

        let url_ = "/api/RosaPatientsQuery/{hamsPatientId}/isLinked";
        if (hamsPatientId === undefined || hamsPatientId === null)
            throw new Error("The parameter 'hamsPatientId' must be defined.");
        url_ = url_.replace("{hamsPatientId}", encodeURIComponent("" + hamsPatientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaPatientsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/RosaPatientsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaSyncCommand_motives(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RosaSyncCommand/motives";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaSyncCommand_sites(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RosaSyncCommand/sites";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaSyncCommand_calendars(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RosaSyncCommand/calendars";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaSyncCommand_pullEvents(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RosaSyncCommand/pull-events";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaSyncCommand_pullPatients(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RosaSyncCommand/pull-patients";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaSyncCommand_pushPatients(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IPushPatientsToRosaResponse>> {
  try {

        let url_ = "/api/RosaSyncCommand/push-patients";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaSyncCommand_patchSyncRecord(body: IPatchRosaHamsSyncRecordRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RosaSyncCommand/patch-sync-record";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaSyncQuery_status(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRosaSyncStatusResponse>> {
  try {

        let url_ = "/api/RosaSyncQuery/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaViewPreferencesCommand_set(body: ISetRosaViewPreferencesRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ISetRosaViewPreferencesRequest>>> {
  try {

        let url_ = "/api/RosaViewPreferencesCommand/set";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function rosaViewPreferencesQuery_get(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRosaViewPreferences>> {
  try {

        let url_ = "/api/RosaViewPreferencesQuery/get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesCommand_newCashSale(body: ICashSaleModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<ICashSaleModel>>> {
  try {

        let url_ = "/api/SalesCommand/new/cashSale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesCommand_newInvoice(body: IInvoiceModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IInvoiceModel>>> {
  try {

        let url_ = "/api/SalesCommand/new/invoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesCommand_newAdvanceInvoice(body: IAdvanceInvoiceModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IAdvanceInvoiceModel>>> {
  try {

        let url_ = "/api/SalesCommand/new/invoice/advance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesCommand_newRfiaAdvanceInvoice(rfiaId: string, body: IRfiaAdvanceInvoiceModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IRfiaAdvanceInvoiceModel>>> {
  try {

        let url_ = "/api/SalesCommand/{rfiaId}/new/invoice/advance";
        if (rfiaId === undefined || rfiaId === null)
            throw new Error("The parameter 'rfiaId' must be defined.");
        url_ = url_.replace("{rfiaId}", encodeURIComponent("" + rfiaId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesCommand_newCreditNote(body: ISaleCreditNoteModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<ISaleCreditNoteModel>>> {
  try {

        let url_ = "/api/SalesCommand/new/creditNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesCommand_scriptSetAsPaid(body: ISalesQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/SalesCommand/script/setAsPaid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesCommand_rectifyInvalidAmount(body: ISalesQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/SalesCommand/script/rectifyInvalidAmount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesCommand_patchLabels(body: IPatchSaleLabelsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchSaleLabelsRequest>>> {
  try {

        let url_ = "/api/SalesCommand/labels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesCommand_patchExternalReference(body: IPatchSaleExternalReferenceRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchSaleExternalReferenceRequest>>> {
  try {

        let url_ = "/api/SalesCommand/external-reference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesCommand_patchOrderReference(body: IPatchSaleOrderReferenceRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchSaleOrderReferenceRequest>>> {
  try {

        let url_ = "/api/SalesCommand/order-reference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesQuery_query(body: ISalesQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResultWithMetadata<ISale, ISalesQueryMetadata>>> {
  try {

        let url_ = "/api/SalesQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesQuery_filterData(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<ISalesFilterData>>> {
  try {

        let url_ = "/api/SalesQuery/filterData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesQuery_analyze(body: IAnalyzeSalesParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ISalesAnalysisData>> {
  try {

        let url_ = "/api/SalesQuery/analyze";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesQuery_queryForCommission(body: ISalesForCommissionQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<ISale>>> {
  try {

        let url_ = "/api/SalesQuery/query/commission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesQuery_byPatient(patientId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ISalesByPatientOverview>> {
  try {

        let url_ = "/api/SalesQuery/byPatient/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesQuery_byPatientX(patientId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ISalesByPatientResponse>> {
  try {

        let url_ = "/api/SalesQuery/byPatientX/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesQuery_queryLinesByPatient(patientId: string, body: ISalesLinesQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<ISalesLineDetails>>> {
  try {

        let url_ = "/api/SalesQuery/query/lines/byPatient/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesQuery_queryNonAssured(customerAccountId: string, assuranceId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ISalesLineForAssuranceDto[]>> {
  try {

        let url_ = "/api/SalesQuery/query/nonAssured/{customerAccountId}/{assuranceId}";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined.");
        url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
        if (assuranceId === undefined || assuranceId === null)
            throw new Error("The parameter 'assuranceId' must be defined.");
        url_ = url_.replace("{assuranceId}", encodeURIComponent("" + assuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/SalesQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ISale>> {
  try {

        let url_ = "/api/SalesQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesQuery_downloadUbl(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/SalesQuery/{id}/ubl";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesQuery_salesTicket(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ISalesTicket>> {
  try {

        let url_ = "/api/SalesQuery/{id}/salesTicket";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesQuery_checkDocumentsForNonCashSales(body: ISalesQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IMissingOrManuallyChangesDocumentsResponse>> {
  try {

        let url_ = "/api/SalesQuery/nonCashSales/documents/check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesQuery_exportNonCashSalesToZip(mode: string, body: ISalesQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/SalesQuery/nonCashSales/export/{mode}/zip";
        if (mode === undefined || mode === null)
            throw new Error("The parameter 'mode' must be defined.");
        url_ = url_.replace("{mode}", encodeURIComponent("" + mode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesQuery_export(body: ISalesExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/SalesQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesQuery_exportLines(body: ISalesExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/SalesQuery/export-lines";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesQuery_exportCashSales(body: ISalesQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/SalesQuery/cash-sales/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesQuery_nextInvoiceReference(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/SalesQuery/nextInvoiceReference";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesQuery_nextCashSaleReference(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/SalesQuery/nextCashSaleReference";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesQuery_nextInvoiceReferenceExclude(taken: string | undefined, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/SalesQuery/nextInvoiceReferenceExclude?";
        if (taken === null)
            throw new Error("The parameter 'taken' cannot be null.");
        else if (taken !== undefined)
            url_ += "taken=" + encodeURIComponent("" + taken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesQuery_settings(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ISalesSettings>> {
  try {

        let url_ = "/api/SalesQuery/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesSettingsCommand_patchDefaultValidUntilDate(body: IPatchSalesDefaultValidUntilDateRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchSalesDefaultValidUntilDateRequest>>> {
  try {

        let url_ = "/api/SalesSettingsCommand/default-valid-until-date";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesSettingsCommand_patchInvoiceReferenceSettings(body: IPatchSalesInvoiceReferenceSettingsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchSalesInvoiceReferenceSettingsRequest>>> {
  try {

        let url_ = "/api/SalesSettingsCommand/invoice-reference-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesSettingsCommand_patchCashSaleReferenceSettings(body: IPatchCashSalesReferenceSettingsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchCashSalesReferenceSettingsRequest>>> {
  try {

        let url_ = "/api/SalesSettingsCommand/cash-sales-reference-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function salesSettingsCommand_patchAutoSetToPaid(body: IPatchAutoSetSalesToPaidRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchAutoSetSalesToPaidRequest>>> {
  try {

        let url_ = "/api/SalesSettingsCommand/auto-set-to-paid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function sendInvoiceToPeppol_handle(body: ISendInvoiceToPeppolRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ISendInvoiceToPeppolRequest>>> {
  try {

        let url_ = "/api/peppol/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function serverMeta_dbName(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/ServerMeta/dbName";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function settlementProposalsCommand_new(body: ISettlementProposalModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<ISettlementProposalModel>>> {
  try {

        let url_ = "/api/SettlementProposalsCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function settlementProposalsCommand_delete(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/SettlementProposalsCommand/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function settlementProposalsCommand_addLine(id: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/SettlementProposalsCommand/{id}/add";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function settlementProposalsCommand_updateValidUntil(id: string, body: Date, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/SettlementProposalsCommand/{id}/validUntil/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function settlementProposalsCommand_deleteLine(id: string, lineId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/SettlementProposalsCommand/{id}/lines/{lineId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (lineId === undefined || lineId === null)
            throw new Error("The parameter 'lineId' must be defined.");
        url_ = url_.replace("{lineId}", encodeURIComponent("" + lineId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function settlementProposalsCommand_update(id: string, body: string[], cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/SettlementProposalsCommand/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function settlementProposalsCommand_scriptSetAsPaid(body: ISettlementProposalsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/SettlementProposalsCommand/script/setAsPaid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function settlementProposalsCommand_updateLabels(id: string, body: string[], cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/SettlementProposalsCommand/{id}/labels/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function settlementProposalSettingsCommand_updateReferenceSettings(body: IReferenceSettingsModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IReferenceSettingsModel>>> {
  try {

        let url_ = "/api/SettlementProposalSettingsCommand/referenceSettings/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function settlementProposalsQuery_query(body: ISettlementProposalsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResultWithMetadata<ISettlementProposal, ISettlementProposalQueryMetadata>>> {
  try {

        let url_ = "/api/SettlementProposalsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function settlementProposalsQuery_filterData(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<ISettlementProposalFilterData>>> {
  try {

        let url_ = "/api/SettlementProposalsQuery/filterData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function settlementProposalsQuery_queryForCustomerAccount(customerAccountId: string, body: ISettlementProposalsForCustomerAccountQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<ISettlementProposal>>> {
  try {

        let url_ = "/api/SettlementProposalsQuery/query/customerAccounts/{customerAccountId}";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined.");
        url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function settlementProposalsQuery_unhandledForCustomerAccount(customerAccountId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ISettlementProposal[]>> {
  try {

        let url_ = "/api/SettlementProposalsQuery/all/customerAccounts/{customerAccountId}/unhandled";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined.");
        url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function settlementProposalsQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ISettlementProposal>> {
  try {

        let url_ = "/api/SettlementProposalsQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function settlementProposalsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/SettlementProposalsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function settlementProposalsQuery_checkDocuments(body: ISettlementProposalsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IMissingOrManuallyChangesDocumentsResponse>> {
  try {

        let url_ = "/api/SettlementProposalsQuery/documents/check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function settlementProposalsQuery_exportToZip(mode: string, body: ISettlementProposalsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/SettlementProposalsQuery/export/{mode}/zip";
        if (mode === undefined || mode === null)
            throw new Error("The parameter 'mode' must be defined.");
        url_ = url_.replace("{mode}", encodeURIComponent("" + mode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function settlementProposalsQuery_export(body: ISettlementProposalsExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/SettlementProposalsQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function settlementProposalsQuery_exportForCustomerAccount(customerAccountId: string, body: ISettlementProposalsForCustomerAccountExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/SettlementProposalsQuery/export/customerAccounts/{customerAccountId}";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined.");
        url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function settlementProposalsQuery_nextReference(customerAccountId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/SettlementProposalsQuery/{customerAccountId}/nextReference";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined.");
        url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function settlementProposalsQuery_settings(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ISettlementProposalSettings>> {
  try {

        let url_ = "/api/SettlementProposalsQuery/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function softwareQuery_latestBuild(application: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<number>>> {
  try {

        let url_ = "/api/SoftwareQuery/{application}/latest";
        if (application === undefined || application === null)
            throw new Error("The parameter 'application' must be defined.");
        url_ = url_.replace("{application}", encodeURIComponent("" + application));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function softwareQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/SoftwareQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function speechChartsQuery_create(body: ISpeechImageModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ISpeechImageDto[]>> {
  try {

        let url_ = "/api/SpeechChartsQuery/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function standardDocumentsQuery_query(body: IStandardDocumentsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IStandardDocumentDto[]>> {
  try {

        let url_ = "/api/StandardDocumentsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockEntriesCommand_forceReculculation(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/StockEntriesCommand/force-recalculation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockEntriesCommand_recalculateEverything(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/StockEntriesCommand/recalculate-everything";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockEntriesQuery_query(body: IStockEntriesQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IStockEntryDto>>> {
  try {

        let url_ = "/api/StockEntriesQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockEntriesQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IStockEntryDto>> {
  try {

        let url_ = "/api/StockEntriesQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockEntriesQuery_current(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IStockEntryDto>> {
  try {

        let url_ = "/api/StockEntriesQuery/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockEntriesQuery_queryCurrentStockItems(body: IStockItemDtosQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IStockItemDto>>> {
  try {

        let url_ = "/api/StockEntriesQuery/current/stockItems/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockEntriesQuery_queryStockItems(id: string, body: IStockItemDtosQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IStockItemDto>>> {
  try {

        let url_ = "/api/StockEntriesQuery/{id}/stockItems/query";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockEntriesQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/StockEntriesQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockEntriesQuery_exportStockItems(id: string, body: IStockItemDtosExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/StockEntriesQuery/{id}/stockItems/export";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockEntriesQuery_exportFinancialFormatted(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/StockEntriesQuery/{id}/export/financial/formatted";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockItemsQuery_queryForRepair(supplierId: string, body: IStockItemsQueryParamsForRepair, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IProductCatalogItem>>> {
  try {

        let url_ = "/api/StockItemsQuery/query/repair/{supplierId}";
        if (supplierId === undefined || supplierId === null)
            throw new Error("The parameter 'supplierId' must be defined.");
        url_ = url_.replace("{supplierId}", encodeURIComponent("" + supplierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockItemsQuery_queryForLoan(body: IStockItemsQueryParamsForLoan, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IProductCatalogItem>>> {
  try {

        let url_ = "/api/StockItemsQuery/query/loan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockItemsQuery_filterArticleProperties(body: IStockItemsQueryParamsForArticleProperties, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IProductCatalogItemManufacturerModelAndType[]>> {
  try {

        let url_ = "/api/StockItemsQuery/filter/articleProperties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockItemsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/StockItemsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockMovementsCommand_new(body: IStockMovementModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IStockMovementModel>>> {
  try {

        let url_ = "/api/StockMovementsCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockMovementsCommand_new_inventoryItem(body: IStockMovementFromInventoryItemModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IStockMovementFromInventoryItemModel>>> {
  try {

        let url_ = "/api/StockMovementsCommand/new/inventoryItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockMovementSettingsCommand_patchReferenceSettings(body: IPatchStockMovementReferenceSettingsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchStockMovementReferenceSettingsRequest>>> {
  try {

        let url_ = "/api/StockMovementSettingsCommand/reference-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockMovementsQuery_query(body: IStockMovementsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IStockMovement>>> {
  try {

        let url_ = "/api/StockMovementsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockMovementsQuery_nextReference(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/StockMovementsQuery/nextReference";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockMovementsQuery_settings(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IStockMovementSettings>> {
  try {

        let url_ = "/api/StockMovementsQuery/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockMovementsQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IStockMovement>> {
  try {

        let url_ = "/api/StockMovementsQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockMovementsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/StockMovementsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockMovementsQuery_export(body: IStockMovementsExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/StockMovementsQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function subscriptionsQuery_query(body: ISubscriptionsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<ISubscriptionSummary>>> {
  try {

        let url_ = "/api/SubscriptionsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function subscriptionsQuery_single(key: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ISubscriptionSummary>> {
  try {

        let url_ = "/api/SubscriptionsQuery/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function subscriptionsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/SubscriptionsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function suppliersCommand_new(body: IRegisterSupplierRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IRegisterSupplierRequest>>> {
  try {

        let url_ = "/api/SuppliersCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function suppliersCommand_delete(body: IDeleteSupplierRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/SuppliersCommand/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function suppliersCommand_restore(body: IRestoreSupplierRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/SuppliersCommand/restore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function suppliersCommand_patchAddress(body: IPatchSupplierAddressRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchSupplierAddressRequest>>> {
  try {

        let url_ = "/api/SuppliersCommand/address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function suppliersCommand_patchName(body: IPatchSupplierNameRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchSupplierNameRequest>>> {
  try {

        let url_ = "/api/SuppliersCommand/name";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function suppliersCommand_patchEmail(body: IPatchSupplierEmailRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchSupplierEmailRequest>>> {
  try {

        let url_ = "/api/SuppliersCommand/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function suppliersCommand_patchVatNumber(body: IPatchSupplierVatNumberRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchSupplierVatNumberRequest>>> {
  try {

        let url_ = "/api/SuppliersCommand/vat-number";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function suppliersCommand_patchAccountNumber(body: IPatchSupplierAccountNumberRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchSupplierAccountNumberRequest>>> {
  try {

        let url_ = "/api/SuppliersCommand/account-number";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function suppliersCommand_patchContactPerson(body: IPatchSupplierContactPersonRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchSupplierContactPersonRequest>>> {
  try {

        let url_ = "/api/SuppliersCommand/contact-person";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function suppliersCommand_patchDefaultDeliveryTime(body: IPatchSupplierDefaultDeliveryTimeRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchSupplierDefaultDeliveryTimeRequest>>> {
  try {

        let url_ = "/api/SuppliersCommand/default-delivery-time";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function suppliersCommand_patchBrands(body: IPatchSupplierBrandsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchSupplierBrandsRequest>>> {
  try {

        let url_ = "/api/SuppliersCommand/brands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function suppliersQuery_query(body: ISuppliersQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<ISupplier>>> {
  try {

        let url_ = "/api/SuppliersQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function suppliersQuery_queryAccounts(body: ISupplierAccountsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<ISupplier>>> {
  try {

        let url_ = "/api/SuppliersQuery/query/accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function suppliersQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ISupplier>> {
  try {

        let url_ = "/api/SuppliersQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function suppliersQuery_overview(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ISupplierAccountOverview>> {
  try {

        let url_ = "/api/SuppliersQuery/{id}/overview";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function suppliersQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/SuppliersQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function suppliersQuery_searchData(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<ISuppliersFilterData>>> {
  try {

        let url_ = "/api/SuppliersQuery/searchData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function suppliersQuery_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<ISupplierSummary[]>>> {
  try {

        let url_ = "/api/SuppliersQuery/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function suppliersQuery_allWithOrderStats(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ISupplierSummaryWithOrderStats[]>> {
  try {

        let url_ = "/api/SuppliersQuery/with-order-stats";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function suppliersQuery_export(body: ISuppliersExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/SuppliersQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function suppliersQuery_exportAccounts(body: ISupplierAccountsExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/SuppliersQuery/export/accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function templatesCommand_new(body: ITemplateUploadModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<ITemplateUploadModel>>> {
  try {

        let url_ = "/api/TemplatesCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function templatesCommand_updateMeta(id: string, body: ITemplateMetaModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ITemplateMetaModel>>> {
  try {

        let url_ = "/api/TemplatesCommand/{id}/meta/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function templatesCommand_updateName(id: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/TemplatesCommand/{id}/name/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function templatesCommand_upload(id: string, body: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/TemplatesCommand/{id}/upload";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function templatesCommand_delete(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/TemplatesCommand/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function templatesCommand_restore(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/TemplatesCommand/{id}/restore";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function templatesCommand_importExamples(body: string[], cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/TemplatesCommand/examples/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function templatesQuery_query(body: ITemplatesQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<ITemplate>>> {
  try {

        let url_ = "/api/TemplatesQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function templatesQuery_byType(type: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ITemplate[]>> {
  try {

        let url_ = "/api/TemplatesQuery/query/byType/{type}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function templatesQuery_byContext(body: string[], cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ITemplate[]>> {
  try {

        let url_ = "/api/TemplatesQuery/query/byContext";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function templatesQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ITemplate>> {
  try {

        let url_ = "/api/TemplatesQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function templatesQuery_content(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/TemplatesQuery/{id}/content";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function templatesQuery_historyContent(id: string, historyId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/TemplatesQuery/{id}/history/{historyId}/content";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (historyId === undefined || historyId === null)
            throw new Error("The parameter 'historyId' must be defined.");
        url_ = url_.replace("{historyId}", encodeURIComponent("" + historyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function templatesQuery_historyDownload(id: string, historyId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/TemplatesQuery/{id}/history/{historyId}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (historyId === undefined || historyId === null)
            throw new Error("The parameter 'historyId' must be defined.");
        url_ = url_.replace("{historyId}", encodeURIComponent("" + historyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function templatesQuery_download(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/TemplatesQuery/{id}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function templatesQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/TemplatesQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function templatesQuery_keysForMainContext(mainContext: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IDocumentContextKey[]>> {
  try {

        let url_ = "/api/TemplatesQuery/keys/{mainContext}";
        if (mainContext === undefined || mainContext === null)
            throw new Error("The parameter 'mainContext' must be defined.");
        url_ = url_.replace("{mainContext}", encodeURIComponent("" + mainContext));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function templatesQuery_keysForTemplate(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IDocumentContextKey[]>> {
  try {

        let url_ = "/api/TemplatesQuery/{id}/keys";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function tendersCommand_newFromRfia(body: ICreateTenderFromRfiaRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<ICreateTenderFromRfiaRequest>>> {
  try {

        let url_ = "/api/TendersCommand/new-from-rfia";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function tendersCommand_new(body: ITenderModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<ITenderModel>>> {
  try {

        let url_ = "/api/TendersCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function tendersCommand_markAsLost(body: IMarkTenderAsLostRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IMarkTenderAsLostRequest>>> {
  try {

        let url_ = "/api/TendersCommand/mark-as-lost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function tendersCommand_delete(body: IDeleteTenderRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IDeleteTenderRequest>>> {
  try {

        let url_ = "/api/TendersCommand/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function tenderSettingsCommand_patchDefaultValidUntil(body: IPatchTenderDefaultValidUntilRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchTenderDefaultValidUntilRequest>>> {
  try {

        let url_ = "/api/TenderSettingsCommand/default-valid-until";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function tenderSettingsCommand_patchReferenceSettings(body: IPatchTenderReferenceSettingsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchTenderReferenceSettingsRequest>>> {
  try {

        let url_ = "/api/TenderSettingsCommand/refence-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function tendersQuery_query(body: ITendersQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResultWithMetadata<ITender, ITendersQueryMetadata>>> {
  try {

        let url_ = "/api/TendersQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function tendersQuery_byPatientX(patientId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ITender[]>> {
  try {

        let url_ = "/api/TendersQuery/byPatientX/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function tendersQuery_byPatient(patientId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ITenderSummary[]>> {
  try {

        let url_ = "/api/TendersQuery/byPatient/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function tendersQuery_nextReference(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/TendersQuery/nextReference";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function tendersQuery_settings(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ITenderSettings>> {
  try {

        let url_ = "/api/TendersQuery/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function tendersQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ITender>> {
  try {

        let url_ = "/api/TendersQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function tendersQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/TendersQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function tendersQuery_export(body: ITendersExportParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/TendersQuery/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function transactionsQuery_queryForProductCatalog(productCatalogItemId: string, body: ITransactionsQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<ITransactionDto>>> {
  try {

        let url_ = "/api/TransactionsQuery/query/productCatalog/{productCatalogItemId}";
        if (productCatalogItemId === undefined || productCatalogItemId === null)
            throw new Error("The parameter 'productCatalogItemId' must be defined.");
        url_ = url_.replace("{productCatalogItemId}", encodeURIComponent("" + productCatalogItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function transactionsQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ITransactionV2>> {
  try {

        let url_ = "/api/TransactionsQuery/{id}/single";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function transactionsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/TransactionsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsCommand_addClt(id: string, body: ICltModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ICltModel>>> {
  try {

        let url_ = "/api/TrialReportsCommand/{id}/clt/add";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsCommand_addOrientation(id: string, body: IOrientationModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IOrientationModel>>> {
  try {

        let url_ = "/api/TrialReportsCommand/{id}/orientation/add";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsCommand_setAverageHours(id: string, body: number, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/TrialReportsCommand/{id}/averageHours";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsCommand_addToneThresholdLeft(id: string, body: IMonoToneThresholdAudiogramTestModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IMonoToneThresholdAudiogramTestModel>>> {
  try {

        let url_ = "/api/TrialReportsCommand/{id}/toneThreshold/left";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsCommand_addToneThresholdRight(id: string, body: IMonoToneThresholdAudiogramTestModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IMonoToneThresholdAudiogramTestModel>>> {
  try {

        let url_ = "/api/TrialReportsCommand/{id}/toneThreshold/right";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsCommand_addToneThresholdBoth(id: string, body: IStereoToneThresholdAudiogramTestModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IStereoToneThresholdAudiogramTestModel>>> {
  try {

        let url_ = "/api/TrialReportsCommand/{id}/toneThreshold/both";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsCommand_addSpeechLeft(id: string, body: ISpeechAudiogramTestModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ISpeechAudiogramTestModel>>> {
  try {

        let url_ = "/api/TrialReportsCommand/{id}/speech/left";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsCommand_addSpeechRight(id: string, body: ISpeechAudiogramTestModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ISpeechAudiogramTestModel>>> {
  try {

        let url_ = "/api/TrialReportsCommand/{id}/speech/right";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsCommand_addSpeechStereo(id: string, body: ISpeechAudiogramTestModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ISpeechAudiogramTestModel>>> {
  try {

        let url_ = "/api/TrialReportsCommand/{id}/speech/stereo";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsCommand_addSpeechImages(id: string, body: ISpeechImageModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ISpeechImageModel>>> {
  try {

        let url_ = "/api/TrialReportsCommand/{id}/speech/images";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsCommand_deleteSpeechImages(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/TrialReportsCommand/{id}/speech/images/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsCommand_addSpeechInNoiseTest(id: string, body: ISpeechInNoiseTestModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ISpeechInNoiseTestModel>>> {
  try {

        let url_ = "/api/TrialReportsCommand/{id}/speechInNoiseTest/add";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsCommand_deleteLeftToneThreshold(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/TrialReportsCommand/{id}/toneThreshold/left/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsCommand_deleteRightToneThreshold(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/TrialReportsCommand/{id}/toneThreshold/right/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsCommand_deleteBothToneThreshold(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/TrialReportsCommand/{id}/toneThreshold/both/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsCommand_deleteLeftSpeech(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/TrialReportsCommand/{id}/speech/left/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsCommand_deleteRightSpeech(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/TrialReportsCommand/{id}/speech/right/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsCommand_deleteStereoSpeech(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/TrialReportsCommand/{id}/speech/stereo/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsCommand_deleteClt(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/TrialReportsCommand/{id}/clt/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsCommand_deleteSpeechInNoise(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/TrialReportsCommand/{id}/speechInNoiseTest/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsCommand_deleteOrientation(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/TrialReportsCommand/{id}/orientation/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ITrialReport>> {
  try {

        let url_ = "/api/TrialReportsQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsQuery_singleTone(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IToneThresholdAudiogramTestsDto>> {
  try {

        let url_ = "/api/TrialReportsQuery/{id}/tone";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsQuery_singleSpeech(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ISpeechImageDto[]>> {
  try {

        let url_ = "/api/TrialReportsQuery/{id}/speech";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trialReportsQuery_speechInNoiseTestWordsLists(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ISpeechInNoiseTestWordsList[]>> {
  try {

        let url_ = "/api/TrialReportsQuery/speechInNoiseTestWordsLists";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function undoIgnorePeppolRecord_handle(body: IUndoIgnorePeppolRecordRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IUndoIgnorePeppolRecordRequest>>> {
  try {

        let url_ = "/api/peppol/undo-ignore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function updateMeta_ping(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<void>> {
  try {

        let url_ = "/api/update-meta/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function userDefinedArticlePropertyKeysCommand_new(body: IArticlePropertyKeyModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IArticlePropertyKeyModel>>> {
  try {

        let url_ = "/api/UserDefinedArticlePropertyKeysCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function userDefinedArticlePropertyKeysCommand_update(id: string, body: IArticlePropertyKeyModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IArticlePropertyKeyModel>>> {
  try {

        let url_ = "/api/UserDefinedArticlePropertyKeysCommand/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function userPreferencesCommand_patchPatientDetailOverviewLayout(body: IPatchPatientDetailOverviewLayoutPreferencesRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchPatientDetailOverviewLayoutPreferencesRequest>>> {
  try {

        let url_ = "/api/UserPreferencesCommand/patient-detail-layout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function userPreferencesQuery_get(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUserPreferences>> {
  try {

        let url_ = "/api/UserPreferencesQuery/get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersCommand_register(body: IRegisterUserRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IRegisterUserRequest>>> {
  try {

        let url_ = "/api/UsersCommand/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersCommand_registerWithPassword(body: IRegisterUserWithPasswordModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IRegisterUserWithPasswordModel>>> {
  try {

        let url_ = "/api/UsersCommand/registerWithPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersCommand_resendRegistrationToken(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/UsersCommand/{id}/registrationToken/resend";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersCommand_delete(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/UsersCommand/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersCommand_unBlock(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/UsersCommand/{id}/unBlock";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersCommand_block(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/UsersCommand/{id}/block";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersCommand_patchEmail(body: IPatchUserEmailRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchUserEmailRequest>>> {
  try {

        let url_ = "/api/UsersCommand/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersCommand_patchIsPlannable(body: IPatchUserIsPlannableRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchUserIsPlannableRequest>>> {
  try {

        let url_ = "/api/UsersCommand/plannable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersCommand_patchPageClaims(body: IPatchUserPageClaimsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchUserPageClaimsRequest>>> {
  try {

        let url_ = "/api/UsersCommand/page-claims";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersCommand_patchFunctionalClaims(body: IPatchUserFunctionalClaimsRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchUserFunctionalClaimsRequest>>> {
  try {

        let url_ = "/api/UsersCommand/functional-claims";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersCommand_patchName(body: IPatchUserNameRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchUserNameRequest>>> {
  try {

        let url_ = "/api/UsersCommand/name";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersCommand_patchRole(body: IPatchUserRoleRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchUserRoleRequest>>> {
  try {

        let url_ = "/api/UsersCommand/role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersCommand_patchRizivNumber(body: IPatchUserRizivNumberRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchUserRizivNumberRequest>>> {
  try {

        let url_ = "/api/UsersCommand/riziv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersCommand_clearRizivNumber(body: IClearUserRizivNumberRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IClearUserRizivNumberRequest>>> {
  try {

        let url_ = "/api/UsersCommand/clear-riziv-number";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersCommand_patchPassword(body: IPatchUserPasswordRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchUserPasswordRequest>>> {
  try {

        let url_ = "/api/UsersCommand/password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersCommand_resetPassword(body: IResetUserPasswordRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IResetUserPasswordRequest>>> {
  try {

        let url_ = "/api/UsersCommand/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersCommand_patchPreferredLocation(body: IPatchUserPreferredLocationRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchUserPreferredLocationRequest>>> {
  try {

        let url_ = "/api/UsersCommand/preferred-location";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersCommand_patchCalendarColor(body: IPatchUserCalendarColorRequest, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPatchUserCalendarColorRequest>>> {
  try {

        let url_ = "/api/UsersCommand/calendar-color";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersQuery_query(body: IUsersQueryParams, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IUserDto>>> {
  try {

        let url_ = "/api/UsersQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersQuery_all(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<IUsersCache>>> {
  try {

        let url_ = "/api/UsersQuery/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/UsersQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUserDto>> {
  try {

        let url_ = "/api/UsersQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function viewColumnSelectionsCommand_new(view: string, body: IColumnSelectionModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IColumnSelectionModel>>> {
  try {

        let url_ = "/api/ViewColumnSelectionsCommand/{view}/new";
        if (view === undefined || view === null)
            throw new Error("The parameter 'view' must be defined.");
        url_ = url_.replace("{view}", encodeURIComponent("" + view));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function viewColumnSelectionsCommand_update(view: string, id: string, body: IColumnSelectionModel, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IColumnSelectionModel>>> {
  try {

        let url_ = "/api/ViewColumnSelectionsCommand/{view}/entries/{id}/update";
        if (view === undefined || view === null)
            throw new Error("The parameter 'view' must be defined.");
        url_ = url_.replace("{view}", encodeURIComponent("" + view));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function viewColumnSelectionsCommand_makeDefault(view: string, id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/ViewColumnSelectionsCommand/{view}/entries/{id}/default";
        if (view === undefined || view === null)
            throw new Error("The parameter 'view' must be defined.");
        url_ = url_.replace("{view}", encodeURIComponent("" + view));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function viewColumnSelectionsCommand_delete(view: string, id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/ViewColumnSelectionsCommand/{view}/entries/{id}";
        if (view === undefined || view === null)
            throw new Error("The parameter 'view' must be defined.");
        url_ = url_.replace("{view}", encodeURIComponent("" + view));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function viewColumnSelectionsQuery_defaults(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IDefaultColumnSelectionDto[]>> {
  try {

        let url_ = "/api/ViewColumnSelectionsQuery/defaults";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function viewColumnSelectionsQuery_single(id: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IViewColumnSelection>> {
  try {

        let url_ = "/api/ViewColumnSelectionsQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function viewColumnSelectionsQuery_concurrencyToken(cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/ViewColumnSelectionsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function workflowsQuery_queryPrimaryByPatient(patientId: string, cancelToken?: CancelToken | undefined, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IPrimaryWorkflowsByPatientResponse>> {
  try {

        let url_ = "/api/WorkflowsQuery/queryPrimaryByPatient/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export interface IAcousoftDocumentData {
    klant_DocumentID: number;
    klant_DocumentTypeID: number | undefined;
    documentTypeDescription: string | undefined;
    documentDatum: Date | undefined;
    documentnaam: string | undefined;
    bestandsnaam: string | undefined;
    attachmentId: string | undefined;
    hasAttachment: boolean;
}

export interface IAcousoftHpData {
    hP2_HeaderID: number;
    audicien: number | undefined;
    klantID: number;
    versie: string | undefined;
    rekenDatum: Date | undefined;
    score: number | undefined;
    categorieCode: number | undefined;
    categorieAfwijkend: number | undefined;
    redenAfwijking: string | undefined;
    handtekening: string | undefined;
    definitief: number | undefined;
    medisch_ArtsID: number | undefined;
    medisch_VoorschrijverID: number | undefined;
    receptDatum: Date | undefined;
    hV_Zorg_VerzekeraarID: number | undefined;
    hV_Zorg_ContractID: number | undefined;
    hV_Polisnummer: string | undefined;
    aV_Zorg_VerzekeraarID: number | undefined;
    aV_Zorg_ContractID: number | undefined;
    aV_Polisnummer: string | undefined;
    hoortoestelCategorieDatum: string | undefined;
    hoortoestelCategorieReferentie: string | undefined;
    hoortoestelCategorieGPH: string | undefined;
    preQuestionnaire: IHpPreQuestionnaire;
    preCosi: IHpCosiQuestionnaire;
    postQuestionnaire: IHpPostQuestionnaire;
    postCosi: IHpCosiQuestionnaire;
}

export interface IAcousoftIntakeData {
    id: number;
    type: string | undefined;
    intakeDatum: Date | undefined;
    omschrijving: string | undefined;
    groups: IAcousoftIntakeGroupData[];
}

export interface IAcousoftIntakeGroupData {
    id: number;
    naam: string | undefined;
    qAs: IAcousoftIntakeQA[];
}

export interface IAcousoftIntakeQA {
    antwoordId: number;
    vraagId: number;
    volgorde: number | undefined;
    vraag: string | undefined;
    antwoord: string | undefined;
}

export interface IAcousoftKlantSummary {
    klantID: number;
    voorletters: string | undefined;
    tussenvoegsel: string | undefined;
    achternaam: string | undefined;
    roepnaam: string | undefined;
    meisjesnaam: string | undefined;
    formatted: string | undefined;
}

export interface IAcousoftMemoData {
    klant_MemoID: number;
    datum: Date | undefined;
    memo: string | undefined;
    audicien: number | undefined;
    rapportageMemo: string | undefined;
    vastgepind: boolean;
    onzichtbaar: boolean;
    onderwerp: string | undefined;
}

export interface IAcousoftPatientData {
    klantNummer: string | undefined;
    klanten: IAcousoftKlantSummary[];
    memos: IAcousoftMemoData[];
    documents: IAcousoftDocumentData[];
    sales: IAcousoftSaleData[];
    intakes: IAcousoftIntakeData[];
    hoorprotocols: IAcousoftHpData[];
    id: string | undefined;
    hasMultipleKlantIds: boolean;
}

export interface IAcousoftSaleData {
    data: IAcousoftVerkoopHeader;
    lines: IAcousoftSalesLineData[];
    id: number;
    factuurdatum: Date | undefined;
    klantFactuurnummer: string | undefined;
    klantFactuurbedrag: number | undefined;
    zorgFactuurnummer: string | undefined;
    zorgFactuurbedrag: number | undefined;
}

export interface IAcousoftSalesLineData {
    data: IAcousoftVerkoopDetail;
    id: number;
    formatted: string | undefined;
    prijs: number | undefined;
}

export interface IAcousoftVerkoopDetail {
    verkoop_DetailID: number;
    verkoop_HeaderID: number;
    algemeen_BTWID: number | undefined;
    artikel_SerienummergebondenID: number | undefined;
    artikel_NietserienummergebondenID: number | undefined;
    regelnummer: number | undefined;
    aantal: number | undefined;
    prijs: number | undefined;
    prijsIngetikt: number | undefined;
    omschrijving: string | undefined;
    oor: string | undefined;
    serienummer: string | undefined;
    hoofdvergoeding: number | undefined;
    aanvullendevergoeding: number | undefined;
    eigenbijdrage: number | undefined;
    korting: number | undefined;
    mogelijke_AV: number | undefined;
    oorpspronkelijkeEigenBijdrage: number | undefined;
    adviesverkoopprijs: number | undefined;
    inkoopprijs: number | undefined;
    softwareprijs: number | undefined;
    brilprijs: number | undefined;
    vorigeVerkoopDatum: string | undefined;
    opnemenAfdruk: number | undefined;
    gedeclareerd: number | undefined;
    opgenomenInBoekhouding: number | undefined;
    verwijderd: number | undefined;
    opmerkingen: string | undefined;
    kleur: string | undefined;
    tegenboeking_Verkoop_DetailID: number | undefined;
    verkoop_PromotieID: number | undefined;
    promotieOmschrijving: string | undefined;
    recordToegevoegdDatum: string | undefined;
    recordGewijzigdDatum: string | undefined;
    recordVerwijderdDatum: string | undefined;
    rowGuid: string | undefined;
    artikel_Bon_DetailID: number | undefined;
    commentaar: string | undefined;
    soortKosten: string | undefined;
    zorgNgGPHID: number | undefined;
    zorgNgAGPHID: number | undefined;
    zorgNgProductgroepID: number | undefined;
    zorgNgAGPH2ID: number | undefined;
    packageID: number | undefined;
    id: number;
}

export interface IAcousoftVerkoopHeader {
    verkoop_HeaderID: number;
    artikel_Bon_HeaderID: number | undefined;
    leverbonnummer: string | undefined;
    debetCredit: string | undefined;
    offerte: number | undefined;
    reparatie: number | undefined;
    proefdatum: string | undefined;
    zorg_Rekendatum: string | undefined;
    hV_Polisnummer: string | undefined;
    hV_Machtigingsnummer: string | undefined;
    aV_Polisnummer: string | undefined;
    aV_Machtigingsnummer: string | undefined;
    hoofdvergoeding: number | undefined;
    aanvullendevergoeding: number | undefined;
    eigenbijdrage: number | undefined;
    korting: number | undefined;
    mogelijke_AV: number | undefined;
    factuurdatum: string | undefined;
    klantFactuurnummer: string | undefined;
    klantFactuurbedrag: number | undefined;
    zorgFactuurnummer: string | undefined;
    zorgFactuurbedrag: number | undefined;
    vanuitExterneBron: number | undefined;
    tegenboeking_Verkoop_HeaderID: number | undefined;
    particulierNotaNaarEnv: number | undefined;
    factuurNaarBedrijf: number | undefined;
    recordToegevoegdDatum: string | undefined;
    recordGewijzigdDatum: string | undefined;
    recordVerwijderdDatum: string | undefined;
    rowGuid: string | undefined;
    commentaar: string | undefined;
    declaratiememo: string | undefined;
    hV_ZorgNgVerzekeraarID: number | undefined;
    hV_ZorgNgContractID: number | undefined;
    aV_ZorgNgVerzekeraarID: number | undefined;
    aV_ZorgNgContractID: number | undefined;
    klant_Abonnement_HeaderID: number | undefined;
    klant_Abonnement_MailVerstuurd: number | undefined;
    klant_IncassoID: number | undefined;
    snelstartZorgId: number | undefined;
    snelstartKlantId: number | undefined;
    id: number;
}

export interface IActiveWorkflowStats {
    workflowType: string | undefined;
    count: number;
    countWarningNoError: number;
    countError: number;
    hasData: boolean;
    id: string | undefined;
}

export interface IAddArticlesInquiriesToExistingOrderRequest {
    articlesInquiryId: string;
    orderId: string;
    lines: IOrderArticlesInquiryLineRequest[];
}

export interface IAddArticlesInquiryLineRequest {
    zeroBasedIndex: number;
    productCatalogItemId: string;
    description: string | undefined;
    quantity: number;
    orientation: string | undefined;
    articleProperties: IArticlePropertyModel[];
}

export interface IAddArticlesInquiryLinesRequest {
    articlesInquiryId: string;
    lines: IAddArticlesInquiryLineRequest[];
}

export interface IAddEntPhysicianOfficeRequest {
    entPhysicianId: string;
    office: IOfficeModel;
}

export interface IAddGeneralPractitionerOfficeRequest {
    generalPractitionerId: string;
    office: IOfficeModel;
}

export interface IAddInvoiceForwardingEmailRequest {
    emailAddress: string | undefined;
}

export interface IAddOrderLineRequest {
    productCatalogItemId: string;
    description: string | undefined;
    quantity: number;
    patientId: string | undefined;
    orientation: string | undefined;
    articleProperties: IArticlePropertyModel[];
}

export interface IAddOrderLinesRequest {
    orderId: string;
    lines: IAddOrderLineRequest[];
}

export interface IAddPatientContactInfoRequest {
    patientId: string;
    type: ContactInfoType;
    value: string | undefined;
    description: string | undefined;
    phoneNumberRegion: PhoneNumberRegion;
}

export interface IAddRepairLineRequest {
    repairId: string;
    productCatalogId: string;
    inventoryItemId: string | undefined;
    quantity: number;
    reasons: string[];
}

export interface IAddReservationToInventoryItemRequest {
    inventoryItemId: string;
    patientId: string;
}

export interface IAddUblsToBufferResponse {
    errors: string[];
    error: string | undefined;
}

export interface IAddress {
    addressLine: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    country: string | undefined;
}

export interface IAddressModel {
    country: string | undefined;
    addressLine: string;
    zip: string;
    city: string;
}

export interface IAdvanceInvoiceLineModel {
    zeroBasedIndexNumber: number;
    description: string | undefined;
    quantity: number;
    vatPercentage: number;
    unitListPriceInVat: number;
    unitPriceInVat: number;
}

export interface IAdvanceInvoiceModel {
    patientId: string | undefined;
    companyId: string | undefined;
    reference: string | undefined;
    isAutoSelectReference: boolean;
    validUntil: Date;
    lines: IAdvanceInvoiceLineModel[];
    recipientName: string | undefined;
    addressLine: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    country: string | undefined;
    fromLocationId: string;
}

export interface IAgendaQueryParams {
    afterDate: Date;
    beforeDate: Date;
}

export interface IAgendaResponse {
    events: ICalendarEventDto[];
    concurrencyToken: number;
}

export interface IAnalyzeSalesParams {
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    paymentStatuses: string[];
    types: string[];
    creditedStatuses: string[];
    locationIds: string[];
    hasOutstandingBalance: boolean | undefined;
    isOverDue: boolean | undefined;
    labels: string[];
    zips: string[];
}

export interface IAnnotation {
    id: string;
    created: Date;
    lastUpdated: Date;
    linkViewContext: ILinkViewContext;
    content: string | undefined;
    attachments: IAnnotationAttachment[];
    annotationTypeId: string | undefined;
    isDeleted: boolean;
    isFollowUp: boolean;
    byUserId: string | undefined;
    linkViewContextType: string | undefined;
    referenceId: string;
    hasAttachment: boolean;
    hasNonDeletedAttachments: boolean;
    hasType: boolean;
}

export interface IAnnotationAttachment {
    attachmentId: string;
    fileName: string;
    isDeleted: boolean;
    id: string;
    extension: string | undefined;
}

export interface IAnnotationAttachmentModel {
    fileName: string;
    contentAsBase64: string | undefined;
}

export interface IAnnotationModel {
    contextId: string;
    linkViewContextType: string | undefined;
    content: string | undefined;
    annotationTypeId: string | undefined;
    isFollowUp: boolean;
}

export interface IAnnotationType {
    id: string;
    created: Date;
    lastUpdated: Date;
    name: string | undefined;
    isDeleted: boolean;
    isFollowUp: boolean;
    color: string;
    searchField: string | undefined;
    identifier: string;
}

export interface IAnnotationTypeModel {
    name: string | undefined;
    color: string | undefined;
    isFollowUp: boolean;
}

export interface IAnnotationUpdateModel {
    annotationTypeId: string | undefined;
    content: string | undefined;
}

export interface IAnnotationsQueryParams {
    createdAfterDate: Date | undefined;
    createdBeforeDate: Date | undefined;
    types: string[];
    sortParams: ISortParams<IAnnotation>;
    pageParams: IPageParams;
    alsoIncludeDeleted: boolean;
}

export interface IApiTokenDto {
    created: Date;
    clientId: string;
    firstFourKeyChars: string | undefined;
    computerName: string | undefined;
}

export interface IApiTokenResponse {
    url: string | undefined;
    apiKey: string;
    clientId: string;
}

export interface IApiTokensQueryParams {
    searchString: string;
    sortParams: ISortParams<IApiTokenDto>;
    pageParams: IPageParams;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
}

export interface IApplicationSettings {
    created: Date;
    lastUpdated: Date;
    noahDeviceReadOutMode: string | undefined;
    clientClaims: string[];
    applicationLogoutMode: ApplicationLogoutMode;
    id: string;
}

export interface IArticleProperty {
    key: string | undefined;
    values: string[];
    hasValues: boolean;
    hasMultiple: boolean;
    hasExactlyOne: boolean;
    singleValueOrEmpty: string | undefined;
    display: string | undefined;
}

export interface IArticlePropertyAutocomplete {
    key: string | undefined;
    values: string[];
}

export interface IArticlePropertyDefinition {
    key: string | undefined;
    allowMultiple: boolean;
    options: string[];
    hasOptions: boolean;
}

export interface IArticlePropertyDefinitionModel {
    key: string | undefined;
    allowMultiple: boolean;
    options: string[];
}

export interface IArticlePropertyKey {
    key: string | undefined;
    labelNl: string | undefined;
    labelFr: string | undefined;
    labelEn: string | undefined;
    userDefinedId: string | undefined;
    isUserDefined: boolean;
    isPredefined: boolean;
    isSameForEveryLanguage: boolean;
    id: string | undefined;
}

export interface IArticlePropertyKeyModel {
    labelNl: string | undefined;
    labelFr: string | undefined;
    labelEn: string | undefined;
}

export interface IArticlePropertyModel {
    key: string | undefined;
    values: string[];
}

export interface IArticlesInquiriesExportParams {
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    statuses: string[];
    handlingUserIds: string[];
    locationIds: string[];
    isAssigned: boolean | undefined;
    searchString: string;
    prefilter: ArticlesInquiriesPrefilter;
}

export interface IArticlesInquiriesMetadata {
    count: number;
    countNotAssigned: number;
}

export interface IArticlesInquiriesQueryParams {
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    statuses: string[];
    handlingUserIds: string[];
    locationIds: string[];
    isAssigned: boolean | undefined;
    searchString: string;
    sortParams: ISortParams<IArticlesInquiry>;
    pageParams: IPageParams;
    prefilter: ArticlesInquiriesPrefilter;
}

export interface IArticlesInquiry {
    id: string;
    created: Date;
    lastUpdated: Date;
    reference: string | undefined;
    patient: IObjectWithIdAndIdentifier<string>;
    lines: IArticlesInquiryLine[];
    location: IObjectWithIdAndIdentifier<string>;
    isCancelled: boolean;
    handlingUserId: string;
    locationId: string | undefined;
    patientId: string;
    patientIdentifier: string | undefined;
    isAssigned: boolean;
    countItems: number;
    status: string | undefined;
    canOrder: boolean;
    canAssignFromStock: boolean;
    searchField: string | undefined;
    hasWarning: boolean;
    isCompleted: boolean;
    hasError: boolean;
    needsNowAfter: Date | undefined;
    storedNow: Date;
    storedNowPreviousToNeedsNowAfter: boolean;
}

export interface IArticlesInquiryDto {
    id: string;
    created: Date;
    lastUpdated: Date;
    reference: string | undefined;
    patient: IObjectWithIdAndIdentifier<string>;
    lines: IArticlesInquiryLineDto[];
    location: IObjectWithIdAndIdentifier<string>;
    isCancelled: boolean;
    handlingUserId: string;
    status: string | undefined;
    isCompleted: boolean;
    canOrder: boolean;
    canAssignFromStock: boolean;
    locationId: string | undefined;
    patientId: string;
    patientIdentifier: string | undefined;
    isAssigned: boolean;
    countItems: number;
}

export interface IArticlesInquiryLine {
    id: string;
    productCatalogItem: IObjectWithIdAndIdentifier<string>;
    quantity: number;
    description: string | undefined;
    isUniquelyIdentifiable: boolean;
    articleProperties: IArticleProperty[];
    orientation: string | undefined;
    assignedQuantityFromStock: number;
    assignedFromStockInventoryItemId: string | undefined;
    order: IArticlesInquiryLineOrderData;
    assignedQuantity: number;
    quantityToAssign: number;
    isAssigned: boolean;
    hasOrder: boolean;
    inventoryItemId: string | undefined;
    status: string | undefined;
    hasInventoryItem: boolean;
    canOrder: boolean;
    canAssignFromStock: boolean;
    canDelete: boolean;
    productCatalogItemId: string;
}

export interface IArticlesInquiryLineDto {
    id: string;
    productCatalogItemId: string;
    quantity: number;
    description: string | undefined;
    isUniquelyIdentifiable: boolean;
    articlePropertiesX: IArticleProperty[];
    orientation: string | undefined;
    assignedQuantityFromStock: number;
    assignedFromStockInventoryItemId: string | undefined;
    order: IArticlesInquiryLineOrderData;
    status: string | undefined;
    canOrder: boolean;
    canAssignFromStock: boolean;
    canDelete: boolean;
    assignedQuantity: number;
    quantityToAssign: number;
    isAssigned: boolean;
    hasOrder: boolean;
    inventoryItemId: string | undefined;
    hasInventoryItem: boolean;
}

export interface IArticlesInquiryLineOrderData {
    id: string;
    reference: string | undefined;
    inventoryItemId: string | undefined;
    quantity: number;
}

export interface IArticlesInquirySettings {
    referenceSettings: IReferenceSettings;
    id: string;
}

export interface IAssignArticlesInquiryLineFromStockRequest {
    articlesInquiryId: string;
    articlesInquiryLineId: string;
    inventoryItemId: string | undefined;
    quantity: number;
    overwriteArticleProperties: boolean;
}

export interface IAssignInventoryItemToArticlesInquiryFromStockQueryParams {
    searchString: string;
    articlesInquiryId: string;
    articlesInquiryLineId: string;
    sortParams: ISortParams<IInventoryItem>;
    pageParams: IPageParams;
}

export interface IAssignedOrInquiredArticleDto {
    id: string;
    description: string | undefined;
    productCatalogItemId: string;
    type: ProductCatalogItemType;
    inventoryItemId: string | undefined;
    inventoryStatus: string | undefined;
    articlesInquiryId: string | undefined;
    articlesInquiryLineId: string | undefined;
    hearingAidData: IHearingAidData;
    articlePropertiesX: IArticleProperty[];
    orientation: string | undefined;
    isHidden: boolean;
    hasOrientation: boolean;
    isLeft: boolean;
    isRight: boolean;
    isHearingInstrument: boolean;
    isReceiver: boolean;
    isEarmould: boolean;
    isOther: boolean;
    hasInventoryItem: boolean;
    hasHearingAidData: boolean;
    order: number;
}

export interface IAssuranceLine {
    transactionLineId: string;
    productCatalogItem: IObjectWithIdAndIdentifier<string>;
    productCatalogItemType: ProductCatalogItemType;
    term: ITimeModel;
    transaction: IGuidObjectWithIdAndReference;
    transactionDate: Date;
    unitPrice: number;
    isInVat: boolean;
    creditedDate: Date | undefined;
    isCredited: boolean;
    productCatalogItemId: string;
    productCatalogItemName: string | undefined;
    transactionId: string;
    transactionReference: string | undefined;
    endDate: Date | undefined;
    isUnlimitedTerm: boolean;
    id: string;
    isProlongedWarranty: boolean;
    isInsurance: boolean;
}

export interface IAudiogramStandardWithSpeechAudiogramsDto {
    id: string;
    noahLastModifiedDate: Date;
    speechAudiograms: ISpeechAudiogram[];
    countSpeechAudiograms: number;
    hasSpeechAudiograms: boolean;
}

export interface IAudiogramStandardWithToneThresholdAudiogramsDto {
    id: string;
    noahLastModifiedDate: Date;
    bothEarImage: string | undefined;
    leftEarImage: string | undefined;
    rightEarImage: string | undefined;
    toneThresholdAudiograms: IToneThresholdAudiogram[];
    hasBothEarImage: boolean;
    hasLeftEarImage: boolean;
    hasRightEarImage: boolean;
    hasAnyImage: boolean;
    hasLeftAudiogram: boolean;
    hasRightAudiogram: boolean;
    hasBothAudiogram: boolean;
}

export interface IAuthDto {
    id: string;
    metadata: IRequestMetadata;
    lastActivity: Date;
}

export interface IBatchImportNhaxPatientsRequest {
    contentAsBase64: string | undefined;
    fileName: string;
    password: string | undefined;
    attendingAudiologistId: string;
    locationId: string;
    language: string | undefined;
}

export interface IBatchImportNhaxPatientsResponse {
    error: string | undefined;
    hasError: boolean;
}

export interface IBatchLinkExactGlobeProductCatalogItemRequest {
    hamsProductCatalogItemIds: string[];
    exactGlobeCostUnitId: string;
}

export interface IBusinessData {
    created: Date;
    lastUpdated: Date;
    companyName: string | undefined;
    vatNumber: string | undefined;
    enterpriseNumber: string | undefined;
    website: string | undefined;
    ibanBankAccount: string | undefined;
    bicBankAccount: string | undefined;
    address: IAddress;
    alternativeAddress: IAddress;
    phone: string | undefined;
    email: string | undefined;
    mainUser: IObjectWithIdAndIdentifier<string>;
    logoAttachmentId: string | undefined;
    alternativeLogoAttachmentId: string | undefined;
    id: string;
    mainUserId: string;
    hasAddress: boolean;
    hasAlternativeAddress: boolean;
    formattedAddress: string | undefined;
    formattedAddressMultipleLines: string | undefined;
    formattedAlternativeAddressMultipleLines: string | undefined;
}

export interface IBusinessDataDto {
    companyName: string | undefined;
    vatNumber: string | undefined;
    website: string | undefined;
    addressLine: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    phone: string | undefined;
    email: string | undefined;
}

export interface IBusinessDataWithImageDataDto {
    lastUpdated: Date;
    companyName: string | undefined;
    vatNumber: string | undefined;
    enterpriseNumber: string | undefined;
    website: string | undefined;
    ibanBankAccount: string | undefined;
    bicBankAccount: string | undefined;
    address: IAddress;
    alternativeAddress: IAddress;
    phone: string | undefined;
    email: string | undefined;
    mainUserId: string;
    logoImageData: string | undefined;
    alternativeLogoImageData: string | undefined;
    hasAddress: boolean;
    hasAlternativeAddress: boolean;
    formattedAddress: string | undefined;
    formattedAddressMultipleLines: string | undefined;
    formattedAlternativeAddressMultipleLines: string | undefined;
}

export interface ICalculatedSpeechPoint {
    stimulusLevel: number;
    scorePercentage: number;
    isInterpolated: boolean;
    intensity: number;
    x: number;
    y: number;
}

export interface ICalendarEventDto {
    id: string;
    created: Date;
    lastUpdated: Date;
    formTitle: string | undefined;
    contact: string | undefined;
    startDate: Date;
    endDate: Date;
    isAllDay: boolean;
    rRule: string | undefined;
    exDates: Date[];
    users: IObjectWithIdAndIdentifier<string>[];
    description: string | undefined;
    roomId: string | undefined;
    roomIdentifier: string | undefined;
    eventTypeId: string | undefined;
    eventTypeIdentifier: string | undefined;
    patientId: string | undefined;
    patientIdentifier: string | undefined;
    isRecurring: boolean;
    userGroupKeys: string[];
    createdByUserId: string;
    roomGroupKey: string;
    eventTypeColor: string;
    userColor: string;
    roomColor: string;
    eventTypeKey: string;
    userIdentifiersCsv: string | undefined;
    userIds: string[];
    hasRoom: boolean;
    hasUsers: boolean;
    hasEventType: boolean;
    hasPatient: boolean;
    hasComment: boolean;
    hasContact: boolean;
    spansMultipleDays: boolean;
    display: string | undefined;
    displayForPatient: string | undefined;
    exDate: string | undefined;
    title: string | undefined;
}

export interface ICalendarEventExport {
    formTitle: string | undefined;
    contact: string | undefined;
    startDate: Date;
    endDate: Date;
    allDay: boolean;
    userIdentifiersCsv: string | undefined;
    description: string | undefined;
    roomIdentifier: string | undefined;
    eventTypeIdentifier: string | undefined;
    patientIdentifier: string | undefined;
}

export interface ICalendarEventModel {
    isAllDay: boolean;
    startDate: Date;
    endDate: Date;
    title: string | undefined;
    contact: string | undefined;
    eventTypeId: string | undefined;
    userIds: string[];
    patientId: string | undefined;
    roomId: string | undefined;
    description: string | undefined;
    isRecurring: boolean;
    rRule: string | undefined;
    rEndDate: Date | undefined;
}

export interface ICalendarEventMoveModel {
    isAllDay: boolean;
    startDate: Date;
    endDate: Date;
    roomId: string | undefined;
    userIds: string[];
}

export interface ICalendarEventRruleModel {
    rrule: string | undefined;
    rEndDate: Date | undefined;
}

export interface ICalendarEventType {
    id: string;
    created: Date;
    lastUpdated: Date;
    name: string | undefined;
    defaultDuration: ITimeModel;
    isDeleted: boolean;
    color: string;
    searchField: string | undefined;
    identifier: string;
}

export interface ICalendarEventTypeModel {
    name: string | undefined;
    color: string | undefined;
    defaultDurationUnit: string | undefined;
    defaultDurationValue: number;
}

export interface ICalendarEventsByPatientQueryParams {
    patientId: string;
    searchString: string;
    afterDate: Date;
    beforeDate: Date;
    roomGroupKeys: string[];
    userGroupKeys: string[];
    eventTypeIds: string[];
}

export interface ICalendarEventsExportParams {
    events: ICalendarEventExport[];
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
}

export interface ICalendarEventsSearchQueryParams {
    searchString: string;
    afterDate: Date;
    beforeDate: Date;
    roomGroupKeys: string[];
    userGroupKeys: string[];
    eventTypeIds: string[];
}

export interface ICalendarResourceDto {
    isDeleted: boolean;
    isPlannable: boolean;
    key: string;
    name: string;
    color: string;
    isEmpty: boolean;
    id: string;
    identifier: string;
}

export interface ICalendarResourcesDto {
    eventTypes: ICalendarResourceDto[];
    users: ICalendarResourceDto[];
    rooms: ICalendarResourceDto[];
    emptyGroupKey: string | undefined;
    defaultCalendarColor: string | undefined;
    plannableEventTypes: ICalendarResourceDto[];
    plannableUsers: ICalendarResourceDto[];
    plannableRooms: ICalendarResourceDto[];
}

export interface ICalendarSettings {
    created: Date;
    lastUpdated: Date;
    requiredProperties: string[];
    id: string;
}

export interface ICancelArticlesInquiryRequest {
    articlesInquiryId: string;
}

export interface ICancelOrderRequest {
    orderId: string;
}

export interface ICancelRepairRequest {
    repairId: string;
}

export interface ICashRegisterEntriesExportParams {
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
    searchString: string;
    referenceDateBefore: Date | undefined;
    referenceDateAfter: Date | undefined;
    locationIds: string[];
}

export interface ICashRegisterEntriesQueryParams {
    sortParams: ISortParams<ICashRegisterEntry>;
    pageParams: IPageParams;
    searchString: string;
    referenceDateBefore: Date | undefined;
    referenceDateAfter: Date | undefined;
    locationIds: string[];
}

export interface ICashRegisterEntry {
    id: number;
    referenceDate: Date;
    value: number;
    entryBalances: { [key: string]: number; } | undefined;
    location: IObjectWithIdAndIdentifier<string>;
    payment: IGuidObjectWithIdAndReference;
    transfer: IGuidObjectWithIdAndDescription;
    globalResultingBalance: number;
    resultingBalances: { [key: string]: number; } | undefined;
    paymentReferenceOrDescription: string | undefined;
    locationId: string;
    locationIdentifier: string | undefined;
    searchField: string | undefined;
    index: number;
    paymentId: string | undefined;
    value_Ccy: number;
}

export interface ICashSaleDto {
    date: Date;
    reference: string | undefined;
    location: string | undefined;
    lines: ISalesLineDto[];
    vatSplits: IVatSplit[];
    priceInVat: number;
    priceExVat: number;
    vatAmount: number;
}

export interface ICashSaleModel {
    patientId: string | undefined;
    reference: string | undefined;
    isAutoSelectReference: boolean;
    lines: ISalesLineModel[];
    payments: ICashSalePaymentModel[];
    fromLocationId: string;
}

export interface ICashSalePaymentModel {
    methodId: string;
    value: number;
}

export interface ICashSaleRefundModel {
    reference: string | undefined;
    isAutoSelectReference: boolean;
    methodId: string;
    value: number;
    referenceDate: Date;
}

export interface ICashTransferModel {
    description: string | undefined;
    value: number;
}

export interface ICategoriesProductCatalogQueryParams {
    sortParams: ISortParams<IProductCatalogItem>;
    pageParams: IPageParams;
    categories: string[];
    subcategories: string[];
    searchString: string;
}

export interface ICheckExactGlobeSalesRequest {
}

export interface ICheckSsNumberResponse {
    patientId: string | undefined;
    exists: boolean;
}

export interface IClearConsignmentReturnBeforeDateOnInventoryItemRequest {
    inventoryItemId: string;
}

export interface IClearInventoryItemManualWarrantyEndDateRequest {
    inventoryItemId: string;
}

export interface IClearReservationFromInventoryItemRequest {
    inventoryItemId: string;
}

export interface IClearUserRizivNumberRequest {
    userId: string;
}

export interface ICltModel {
    mono: number;
    stereo: number;
    monoLeft: number | undefined;
    monoRight: number | undefined;
}

export interface ICltTest {
    date: Date;
    mono: number;
    stereo: number;
    monoLeft: number | undefined;
    monoRight: number | undefined;
    leftImprovement: number;
    rightImprovement: number;
    improvement: number;
}

export interface ICochlearAddress {
    street: string | undefined;
    number: string | undefined;
    postalCode: string | undefined;
    locality: string | undefined;
    administrativeAreas: string | undefined;
    country: string | undefined;
    streetAndNumber: string | undefined;
    postalCodeLocalityCountry: string | undefined;
    formatted: string | undefined;
    formattedMultiline: string | undefined;
    hasStreet: boolean;
    hasNumber: boolean;
    hasCountry: boolean;
}

export interface ICochlearAudiogramStandard {
    audiogramStandardId: string;
    noahActionCreatedDate: Date;
    noahActionLastModifiedDate: Date;
    toneThresholdAudiograms: ICochlearToneThresholdAudiogram[];
    id: string;
    maxPta: number | undefined;
}

export interface ICochlearCounselingStepModuleDto {
    id: string;
    lastUpdated: Date;
    order: number;
    title: string | undefined;
    htmlContent: string | undefined;
    mediaAssets: ICochlearMediaAsset[];
}

export interface ICochlearInfoEventDto {
    id: string;
    lastUpdated: Date;
    title: string | undefined;
    description: string | undefined;
    type: CochlearInfoEventType;
    date: Date;
    address: ICochlearAddress;
    registrationUrl: string | undefined;
    registrationEmail: string | undefined;
}

export interface ICochlearMediaAsset {
    id: string;
    lastUpdated: Date;
    url: string | undefined;
    thumbnailUrl: string | undefined;
    description: string | undefined;
    mediaType: CochlearMediaType;
}

export interface ICochlearPartnerTrainingModuleDto {
    id: string;
    lastUpdated: Date;
    order: number;
    title: string | undefined;
    htmlContent: string | undefined;
    mediaAssets: ICochlearMediaAsset[];
}

export interface ICochlearPatient {
    id: string;
    firstName: string | undefined;
    lastName: string | undefined;
    audiograms: ICochlearAudiogramStandard[];
    events: ICochlearPatientEventData[];
    informedDate: Date | undefined;
    referralDate: Date | undefined;
    implantedDate: Date | undefined;
    bimodallyFittedDate: Date | undefined;
    referralCenterId: string | undefined;
    identifier: string;
    status: CochlearPatientStatus;
    maxPta: number | undefined;
    isCiCandidate: boolean;
    searchField: string | undefined;
}

export interface ICochlearPatientDetailDto {
    data: ICochlearPatient;
    id: string;
}

export interface ICochlearPatientEventData {
    eventId: string;
    date: Date;
    title: string | undefined;
}

export interface ICochlearPatientSummaryDto {
    data: ICochlearPatient;
    dateOfBirth: Date | undefined;
    socialSecurityNumber: string | undefined;
    gender: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    addressLine: string | undefined;
    country: string | undefined;
    email: string | undefined;
    referralCenterName: string | undefined;
    formattedAddress: string | undefined;
    id: string;
    lastName: string | undefined;
    firstName: string | undefined;
}

export interface ICochlearPatientsFilterSortPageParams {
    searchString: string;
    sortParams: ISortParams<ICochlearPatientSummaryDto>;
    pageParams: IPageParams;
    statuses: CochlearPatientStatus[];
    isCiCandidate: boolean | undefined;
    informedDateBefore: Date | undefined;
    informedDateAfter: Date | undefined;
    referralDateBefore: Date | undefined;
    referralDateAfter: Date | undefined;
    implantedDateBefore: Date | undefined;
    implantedDateAfter: Date | undefined;
    bimodallyFittedDateBefore: Date | undefined;
    bimodallyFittedDateAfter: Date | undefined;
    patientId: string | undefined;
}

export interface ICochlearPta {
    leftSideEquation: string | undefined;
    result: number | undefined;
    rightSideEquation: string | undefined;
}

export interface ICochlearReferralCenterDto {
    id: string;
    lastUpdated: Date;
    name: string | undefined;
    address: ICochlearAddress;
    phoneNumber: string | undefined;
    email: string | undefined;
}

export interface ICochlearReferralMaterialDto {
    id: string;
    lastUpdated: Date;
    title: string | undefined;
    type: CochlearReferralMaterialType;
    language: CochlearReferralMaterialLanguage;
    downloadUrl: string | undefined;
}

export interface ICochlearSettingsDto {
    enabled: boolean;
    isPartner: boolean;
}

export interface ICochlearToneThresholdAudiogram {
    points: ITonePoint[];
    signalOutputType: string | undefined;
    hearingInstrumentConditionType: string | undefined;
    signalOutputTypeDisplay: string | undefined;
    hearingInstrumentConditionTypeDisplay: string | undefined;
    display: string | undefined;
    isLeft: boolean;
    isRight: boolean;
    ptaRecord: ICochlearPta;
    pta: number | undefined;
}

export interface IColumnSelection {
    id: string;
    columns: string[];
    name: string | undefined;
    useAsDefault: boolean;
}

export interface IColumnSelectionModel {
    columns: string[];
    name: string | undefined;
    useAsDefault: boolean;
}

export interface ICommission {
    id: string;
    created: Date;
    lastUpdated: Date;
    commissionRule: ICommissionRuleData;
    user: IObjectWithIdAndIdentifier<string>;
    sale: ISalesSummary;
    totalValueExVatOfSale: number;
    totalValueExVatOfDevices: number;
    payoutId: string | undefined;
    payoutDate: Date | undefined;
    commissionRuleId: string;
    userId: string;
    userIdentifier: string | undefined;
    isPaidOut: boolean;
    value: number;
    isPaidByPatientOrCompany: boolean;
    isPaidByHif: boolean;
    isFullyPaid: boolean;
    isFullyCredited: boolean;
    ruleMethod: string | undefined;
    ruleName: string | undefined;
    rulePercentage: number;
    salesReference: string | undefined;
    salesId: string;
    salesDate: Date;
    salesRecipientName: string | undefined;
    searchField: string | undefined;
}

export interface ICommissionModel {
    salesId: string;
    commissionRuleId: string;
    userId: string;
}

export interface ICommissionPayout {
    id: string;
    created: Date;
    lastUpdated: Date;
    reference: string | undefined;
    user: IObjectWithIdAndIdentifier<string>;
    payoutDate: Date;
    lines: ICommissionPayoutLine[];
    isConfirmed: boolean;
    value: number;
    userId: string;
    userIdentifier: string | undefined;
    searchField: string | undefined;
}

export interface ICommissionPayoutLine {
    commissionId: string;
    sale: ISalesData;
    value: number;
    commissionRule: ICommissionRuleData;
    salesReference: string | undefined;
}

export interface ICommissionPayoutModel {
    reference: string | undefined;
    isAutoSelectReference: boolean;
    userId: string;
    commissionIds: string[];
    payoutDate: Date;
}

export interface ICommissionPayoutSettings {
    created: Date;
    lastUpdated: Date;
    referenceSettings: IReferenceSettings;
    id: string;
}

export interface ICommissionPayoutsQueryParams {
    searchString: string;
    sortParams: ISortParams<ICommissionPayout>;
    pageParams: IPageParams;
    payoutBefore: Date | undefined;
    payoutAfter: Date | undefined;
    userIds: string[];
}

export interface ICommissionRule {
    id: string;
    created: Date;
    lastUpdated: Date;
    percentage: number;
    name: string | undefined;
    method: string | undefined;
    isEnabled: boolean;
}

export interface ICommissionRuleData {
    id: string;
    name: string | undefined;
    percentage: number;
    method: string | undefined;
}

export interface ICommissionRuleModel {
    name: string | undefined;
    percentage: number;
    method: string | undefined;
}

export interface ICommissionRulesCache {
    all: ICommissionRule[];
    enabled: ICommissionRule[];
}

export interface ICommissionsExportParams {
    searchString: string;
    userIds: string[];
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    commissionRuleIds: string[];
    isPaidOut: boolean | undefined;
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
}

export interface ICommissionsQueryParams {
    searchString: string;
    userIds: string[];
    sortParams: ISortParams<ICommission>;
    pageParams: IPageParams;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    commissionRuleIds: string[];
    isPaidOut: boolean | undefined;
}

export interface ICompaniesExportParams {
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
}

export interface ICompaniesQueryParams {
    searchString: string;
    sortParams: ISortParams<ICompany>;
    pageParams: IPageParams;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
}

export interface ICompany {
    id: string;
    created: Date;
    lastUpdated: Date;
    linkedPatients: IObjectWithIdAndIdentifier<string>[];
    name: string | undefined;
    vatNumber: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    salutation: string | undefined;
    addressLine: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    country: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    address: string | undefined;
    contact: string | undefined;
    linkedPatientIds: string[];
    searchField: string | undefined;
    identifier: string;
}

export interface ICompanySummary {
    id: string;
    identifier: string;
    address: string | undefined;
    contact: string | undefined;
}

export interface IConfirmUserRequest {
    registrationTokenId: string;
    email: string;
    password: string;
}

export interface IConfirmUserResponse {
    user: IUserInfo;
    errors: IValidationError<IConfirmUserRequest>[];
    locations: ILocationSummary[];
    hasError: boolean;
    mustSelectLocation: boolean;
}

export interface IConsignmentFileResponse {
    error: string | undefined;
    isIncorrectPassword: boolean;
    resumeId: string | undefined;
    fileResponseId: string | undefined;
    worksheets: IWorksheetInfo[];
    mustSelectSheetAndSerialNumberHeader: boolean;
}

export interface IConsignmentFileResumeModel {
    password: string | undefined;
    worksheetName: string | undefined;
    serialNumberHeaderIndex: number;
}

export interface IContactInfo {
    id: string;
    type: ContactInfoType;
    value: string | undefined;
    description: string | undefined;
    isPrimary: boolean;
    isPhone: boolean;
    isEmail: boolean;
    isValid: boolean;
    formattedValue: string | undefined;
    phoneNumberRegion: PhoneNumberRegion;
    isMobilePhone: boolean;
    canMakePrimary: boolean;
    isValidForRosa: boolean;
}

export interface IContactModel {
    firstName: string | undefined;
    lastName: string | undefined;
    salutation: string | undefined;
}

export interface IContactPerson {
    departmentOrLocation: string | undefined;
    name: string | undefined;
    addressLine: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    country: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    addressFormatted: string | undefined;
}

export interface IContactPersonModel {
    departmentOrLocation: string | undefined;
    name: string | undefined;
    addressLine: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    country: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
}

export interface IContributionLine {
    id: string;
    shortDescription: string | undefined;
    longDescription: string | undefined;
    unitPrice: number;
    quantity: number;
    formattedDescription: string | undefined;
    linePrice: number;
}

export interface ICopyAllNoahUserSetupsRequest {
    fromClientId: string;
    toClientId: string;
}

export interface ICopyNoahUserSetupRequest {
    noahUserSetupId: string;
    toClientId: string;
}

export interface ICosiLine {
    description: string | undefined;
    priority: number;
    degreeOfChange: string | undefined;
    endResult: string | undefined;
}

export interface ICosiLineModel {
    description: string | undefined;
    priority: number;
    degreeOfChange: string | undefined;
    endResult: string | undefined;
}

export interface ICosiQuestionnaire {
    id: string;
    created: Date;
    lastUpdated: Date;
    documentDataLastUpdated: Date;
    patient: IObjectWithIdAndIdentifier<string>;
    evaluationDate: Date | undefined;
    remarks: string | undefined;
    lines: ICosiLine[];
    document: IDocumentSummary;
    isDocumentInSync: boolean;
    documentId: string | undefined;
    hasDocument: boolean;
    linkViewContexts: ILinkViewContext[];
    rfiaId: string;
    patientId: string;
    patientIdentifier: string | undefined;
    hasLines: boolean;
    isEvaluated: boolean;
    allLinesEvaluated: boolean;
    cosi1: ICosiLine;
    cosi2: ICosiLine;
    cosi3: ICosiLine;
    cosi4: ICosiLine;
    cosi5: ICosiLine;
}

export interface ICosiQuestionnaireModel {
    rfiaId: string;
    remarks: string | undefined;
    evaluationDate: Date | undefined;
    lines: ICosiLineModel[];
}

export interface ICosiQuestionnaireSummary {
    id: string;
    created: Date;
    documentId: string | undefined;
    evaluationDate: Date | undefined;
    isDocumentInSync: boolean;
    hasDocument: boolean;
    isEvaluated: boolean;
}

export interface ICreateDiscountArticleRequest {
    name: string | undefined;
    value: number;
    vatPercentage: number;
    category: string | undefined;
    subcategory: string | undefined;
}

export interface ICreateExactGlobeCostCenterRequest {
    code: string | undefined;
    description: string | undefined;
}

export interface ICreateExactGlobeCostUnitRequest {
    code: string | undefined;
    description: string | undefined;
}

export interface ICreatePatientInHamsFromRosaRequest {
    rosaPatientRecordId: string | undefined;
}

export interface ICreatePatientInRosaRequest {
    hamsPatientId: string;
}

export interface ICreateTangibleProductCatalogItemRequest {
    type: ProductCatalogItemType;
    manufacturer: string | undefined;
    model: string | undefined;
    listPrice: number;
    vatPercentage: number;
    hasSerialNumber: boolean;
    isTailorMade: boolean;
    isElectronics: boolean;
    hasBatteries: boolean;
    category: string | undefined;
    subcategory: string | undefined;
    recupelCode: string | undefined;
    bebatUnitPriceInVat: number;
}

export interface ICreateTenderFromRfiaRequest {
    rfiaId: string;
    reference: string | undefined;
    isAutoSelectReference: boolean;
    expectedHandoverDate: Date;
    validUntil: Date;
    lines: ITenderLineModel[];
    fees: IMedicalTreatmentFeeDto[];
    companyId: string | undefined;
    recipientName: string | undefined;
    addressLine: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    country: string | undefined;
}

export interface ICreateValidateResponse {
    objectId: string;
    error: string;
    hasError: boolean;
}

export interface ICreateValidateResponseWithStringId {
    objectId: string;
    error: string;
    hasError: boolean;
}

export interface ICreditPurchaseFromInventoryItemModel {
    inventoryItemId: string;
    reference: string | undefined;
    isAutoSelectReference: boolean;
    externalReference: string | undefined;
    creditDate: Date;
    validUntil: Date;
    vatPercentage: number;
    unitListPriceExVat: number;
    unitPriceExVat: number;
}

export interface ICustomerAccount {
    id: string;
    created: Date;
    lastUpdated: Date;
    link: ICustomerAccountLink;
    value: number;
    amountPaid: number;
    settlementProposals: ISettlementProposalForCustomerAccountSummary[];
    accountType: string | undefined;
    lastSettlementProposal: ISettlementProposalForCustomerAccountSummary;
    lastSettlementProposalReference: string | undefined;
    lastSettlementProposalMetaReference: string | undefined;
    amountToPay: number;
    outstandingBalance: number;
    outstandingBalanceOnSettlementProposals: number;
    outstandingBalanceNotOnSettlementProposals: number;
    hasOutstandingBalanceNotOnSettlementProposals: boolean;
    hasOutstandingBalance: boolean;
    searchField: string | undefined;
    identifier: string;
    accountLinkIdAsString: string | undefined;
    accountLinkIdAsGuid: string | undefined;
    isCompany: boolean;
    isPatient: boolean;
    isCompanyOrPatient: boolean;
    isHif: boolean;
}

export interface ICustomerAccountData {
    id: string;
    identifier: string;
    accountType: string | undefined;
}

export interface ICustomerAccountDetail {
    data: ICustomerAccount;
    metadata: ICustomerAccountMetadata;
}

export interface ICustomerAccountLine {
    id: string;
    created: Date;
    lastUpdated: Date;
    customerAccount: ICustomerAccountData;
    sale: ISalesDataWithType;
    value: number;
    isPrimary: boolean;
    payments: IPaymentLineData[];
    unhandledSettlementProposal: IGuidObjectWithIdAndReference;
    handledSettlementProposal: IGuidObjectWithIdAndReference;
    referencePatient: IObjectWithIdAndIdentifier<string>;
    isOverrideSetToFullyPaid: boolean;
    belgianStructuredCreditorReference: string | undefined;
    customerAccountId: string;
    customerAccountIdentifier: string;
    customerAccountType: string | undefined;
    referencePatientId: string | undefined;
    referencePatientIdentifier: string | undefined;
    hasReferencePatient: boolean;
    salesId: string;
    salesReference: string;
    salesRecipientName: string;
    salesDate: Date;
    salesTotalPriceInVat: number;
    amountToPay: number;
    amountPaid: number;
    outstandingBalance: number;
    hasOutstandingBalance: boolean;
    isFullyPaid: boolean;
    isPartlyPaid: boolean;
    isNothingPaid: boolean;
    paymentStatus: string | undefined;
    hasPayments: boolean;
    unhandledSettlementProposalId: string | undefined;
    unhandledSettlementProposalReference: string | undefined;
    hasUnhandledSettlementProposal: boolean;
    handledSettlementProposalId: string | undefined;
    handledSettlementProposalReference: string | undefined;
    hasHandledSettlementProposal: boolean;
    settlementProposalId: string | undefined;
    settlementProposalReference: string | undefined;
    hasSettlementProposal: boolean;
    canCreateRefund: boolean;
    searchField: string | undefined;
}

export interface ICustomerAccountLineData {
    id: string;
    customerAccountId: string;
    value: number;
    isPrimary: boolean;
    payments: IPaymentLineData[];
    link: ICustomerAccountLink;
    isOverrideSetToFullyPaid: boolean;
    belgianStructuredCreditorReference: string | undefined;
    accountType: string | undefined;
    amountToPay: number;
    amountPaid: number;
    outstandingBalance: number;
    hasOutstandingBalance: boolean;
    isFullyPaid: boolean;
    isPartlyPaid: boolean;
    isNothingPaid: boolean;
    paymentStatus: string | undefined;
    hasPayments: boolean;
    customerAccountIdentifier: string;
    customerAccountData: ICustomerAccountData;
    isCompany: boolean;
    isPatient: boolean;
    isHif: boolean;
    isCompanyOrPatient: boolean;
    canCreateRefund: boolean;
}

export interface ICustomerAccountLineQueryMetadata {
    customerAccounts: IObjectWithIdAndIdentifier<string>[];
    countThisMonth: number;
    countPreviousMonth: number;
    unfilteredCount: number;
    countExceptThisMonthExceptPreviousMonth: number;
}

export interface ICustomerAccountLineSummary {
    id: string;
    customerAccountId: string;
    accountType: string | undefined;
    value: number;
    amountPaid: number;
    amountToPay: number;
    isFullyPaid: boolean;
    isPartlyPaid: boolean;
    isNothingPaid: boolean;
    paymentStatus: string | undefined;
}

export interface ICustomerAccountLinesExportParams {
    searchString: string;
    outstandingBalanceLessThan: number | undefined;
    outstandingBalanceMoreThan: number | undefined;
    salesDateBefore: Date | undefined;
    salesDateCreatedAfter: Date | undefined;
    hasOutstandingBalance: boolean | undefined;
    hasSettlementProposal: boolean | undefined;
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
}

export interface ICustomerAccountLinesQueryParams {
    searchString: string;
    outstandingBalanceLessThan: number | undefined;
    outstandingBalanceMoreThan: number | undefined;
    salesDateBefore: Date | undefined;
    salesDateCreatedAfter: Date | undefined;
    hasOutstandingBalance: boolean | undefined;
    hasSettlementProposal: boolean | undefined;
    sortParams: ISortParams<ICustomerAccountLine>;
    pageParams: IPageParams;
}

export interface ICustomerAccountLink {
    idAsGuid: string | undefined;
    idAsString: string | undefined;
    identifier: string;
    type: string | undefined;
    isHif: boolean;
}

export interface ICustomerAccountMetadata {
    countCustomerAccountLines: number;
    countCustomerAccountLinesWithOutstandingBalance: number;
    countCustomerAccountLinesWithOutstandingBalanceAndWithoutSettlementProposal: number;
    countPayments: number;
    countSettlementProposals: number;
    countSettlementProposalsWithOutstandingBalance: number;
    hasLinesWithOutstandingBalance: boolean;
}

export interface ICustomerAccountQueryMetadata {
    countWithOutstandingBalance: number;
    totalOutstandingBalance: number;
}

export interface ICustomerAccountsExportParams {
    searchString: string;
    outstandingBalanceLessThan: number | undefined;
    outstandingBalanceMoreThan: number | undefined;
    hasOutstandingBalance: boolean | undefined;
    hasOutstandingBalanceNotOnSettlementProposals: boolean | undefined;
    accountTypes: string[];
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
}

export interface ICustomerAccountsQueryParams {
    searchString: string;
    sortParams: ISortParams<ICustomerAccount>;
    pageParams: IPageParams;
    outstandingBalanceLessThan: number | undefined;
    outstandingBalanceMoreThan: number | undefined;
    hasOutstandingBalance: boolean | undefined;
    hasOutstandingBalanceNotOnSettlementProposals: boolean | undefined;
    accountTypes: string[];
}

export interface IDailyReceipt {
    id: string | undefined;
    created: Date;
    lastUpdated: Date;
    location: IObjectWithIdAndIdentifier<string>;
    sales: IDailyReceiptSalesData[];
    locationId: string | undefined;
    locationIdentifier: string | undefined;
    isGlobal: boolean;
    isForLocation: boolean;
    onDate: Date;
    lines: IDailyReceiptSalesLine[];
    vatSplits: IVatSplit[];
    priceInVat: number;
    priceExVat: number;
    vatAmount: number;
    vatSplitAt0: IVatSplit;
    vatSplitAt6: IVatSplit;
    vatSplitAt9: IVatSplit;
    vatSplitAt12: IVatSplit;
    vatSplitAt21: IVatSplit;
    priceInVatAt0: number;
    priceInVatAt6: number;
    priceInVatAt9: number;
    priceInVatAt12: number;
    priceInVatAt21: number;
    searchField: string | undefined;
}

export interface IDailyReceiptSalesData {
    id: string;
    date: Date;
    location: IObjectWithIdAndIdentifier<string>;
    reference: string | undefined;
    lines: IDailyReceiptSalesLine[];
}

export interface IDailyReceiptSalesLine {
    id: string;
    productCatalogItemId: string | undefined;
    productCatalogItemType: ProductCatalogItemType;
    inventoryItemId: string | undefined;
    description: string | undefined;
    vatPercentage: number;
    linePriceInVat: number;
}

export interface IDailyReceiptsExportParams {
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
    searchString: string;
    referenceDateBefore: Date | undefined;
    referenceDateAfter: Date | undefined;
    locationIds: string[];
    isGlobal: boolean;
}

export interface IDailyReceiptsQueryParams {
    sortParams: ISortParams<IDailyReceipt>;
    pageParams: IPageParams;
    searchString: string;
    referenceDateBefore: Date | undefined;
    referenceDateAfter: Date | undefined;
    locationIds: string[];
    isGlobal: boolean;
}

export interface IDashboardData {
    rfiasStats: IActiveWorkflowStats;
    ordersStats: IActiveWorkflowStats;
    repairsStats: IActiveWorkflowStats;
    loansStats: IActiveWorkflowStats;
    articlesInquiriesStats: IActiveWorkflowStats;
    salesStats: ISalesStats;
    settlementProposalsStats: ISettlementProposalsStats;
    salesKpi: IDashboardKpi;
    patientsKpi: IDashboardKpi;
    rfiaIntakeKpi: IDashboardKpi;
    rfiaHandoverKpi: IDashboardKpi;
    canShowKpis: boolean;
    notifications: IDashboardNotification[];
    hasSummaryData: boolean;
}

export interface IDashboardKpi {
    last30Days: IIntChange;
    last7Days: IIntChange;
}

export interface IDashboardNotification {
    type: string | undefined;
    message: string | undefined;
    level: string | undefined;
}

export interface IDefaultColumnSelectionDto {
    view: string | undefined;
    columns: string[];
}

export interface IDeleteArticlesInquiryLineRequest {
    articlesInquiryId: string;
    articlesInquiryLineId: string;
}

export interface IDeleteEntPhysicianOfficeRequest {
    entPhysicianId: string;
    officeId: string;
}

export interface IDeleteEntPhysicianRequest {
    entPhysicianId: string;
}

export interface IDeleteExactGlobeCostCenterRequest {
    id: string;
}

export interface IDeleteExactGlobeCostUnitRequest {
    id: string;
}

export interface IDeleteGeneralPractitionerOfficeRequest {
    generalPractitionerId: string;
    officeId: string;
}

export interface IDeleteGeneralPractitionerRequest {
    generalPractitionerId: string;
}

export interface IDeleteHifAdvisoryPhysicianAddressRequest {
    hifCode: string | undefined;
}

export interface IDeleteHifThirdPartyPayerArrangementAddressRequest {
    hifCode: string | undefined;
}

export interface IDeleteLocationRequest {
    locationId: string;
}

export interface IDeleteOrderLineRequest {
    orderId: string;
    orderLineId: string;
}

export interface IDeletePatientContactInfoRequest {
    patientId: string;
    contactInfoId: string;
}

export interface IDeletePrescriptionScanHistoryRequest {
    rfiaId: string;
    historyId: string;
}

export interface IDeletePrescriptionScanRequest {
    rfiaId: string;
}

export interface IDeleteProductCatalogItemRequest {
    productCatalogItemId: string;
}

export interface IDeleteRfiaProformaHandoverRequest {
    rfiaId: string;
}

export interface IDeleteSupplierRequest {
    supplierId: string;
}

export interface IDeleteTenderRequest {
    tenderId: string;
}

export interface IDeliveriesExportParams {
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    deliveredBefore: Date | undefined;
    deliveredAfter: Date | undefined;
    supplierIds: string[];
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
}

export interface IDeliveriesQueryParams {
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    deliveredBefore: Date | undefined;
    deliveredAfter: Date | undefined;
    supplierIds: string[];
    sortParams: ISortParams<IDelivery>;
    pageParams: IPageParams;
}

export interface IDelivery {
    id: string;
    created: Date;
    lastUpdated: Date;
    reference: string | undefined;
    externalReference: string | undefined;
    deliveryDate: Date;
    dispatchReference: string | undefined;
    dispatchDate: Date | undefined;
    supplier: IObjectWithIdAndIdentifier<string>;
    location: IObjectWithIdAndIdentifier<string>;
    lines: IDeliveryLine[];
    linkViewContext: ILinkViewContext;
    supplierId: string;
    supplierIdentifier: string | undefined;
    countItems: number;
    locationId: string;
    locationIdentifier: string | undefined;
    orderId: string | undefined;
    isLinkedToOrder: boolean;
    repairId: string | undefined;
    isLinkedToRepair: boolean;
    searchField: string | undefined;
}

export interface IDeliveryLine {
    id: string;
    index: number;
    productCatalogItem: IObjectWithIdAndIdentifier<string>;
    inventoryItemId: string | undefined;
    description: string | undefined;
    quantity: number;
    serialNumber: string | undefined;
    productCatalogItemId: string;
    hasSerialNumber: boolean;
}

export interface IDeliverySettings {
    referenceSettings: IReferenceSettings;
    id: string;
}

export interface IDisableCochlearIntegrationRequest {
}

export interface IDisablePeppolIntegrationRequest {
    empty: string | undefined;
}

export interface IDispatchInfo {
    autoReference: string | undefined;
    autoDate: Date | undefined;
    manualReference: string | undefined;
    manualDate: Date | undefined;
    reference: string | undefined;
    date: Date | undefined;
    isManualReference: boolean;
    isManualDate: boolean;
}

export interface IDocument {
    id: string;
    created: Date;
    lastUpdated: Date;
    history: IDocumentHistory[];
    templateId: string | undefined;
    standardDocumentId: string | undefined;
    templateType: string | undefined;
    templateName: string | undefined;
    predefinedType: string | undefined;
    userDefinedName: string | undefined;
    canEdit: boolean;
    mustSign: boolean;
    canViewOnline: boolean;
    linkViewContext: ILinkViewContext;
    isDeleted: boolean;
    typeOrName: string | undefined;
    historyOrderedDesc: IDocumentHistory[];
    hasSignature: boolean;
    lastBuildFromTemplateDate: Date | undefined;
    originalDocument: IDocumentHistory;
    hasHistory: boolean;
    lastDocument: IDocumentHistory;
    lastHistoryId: string;
    attachmentId: string;
    extension: string | undefined;
    isDocx: boolean;
    isPdf: boolean;
    canConvertToPdf: boolean;
    isDocxAndCanEditAndCanViewOnline: boolean;
    isDocxAndCanViewOnlineButCannotEdit: boolean;
    isFromTemplate: boolean;
    isUserUpload: boolean;
    linkViewContextType: string | undefined;
    linkViewContextId: string;
    searchField: string | undefined;
}

export interface IDocumentContent {
    id: string;
    historyId: string;
    content: string;
}

export interface IDocumentContextKey {
    key: string | undefined;
    description: string | undefined;
    keys: IDocumentKeyDto[];
}

export interface IDocumentFromTemplateModel {
    templateId: string | undefined;
    standardDocumentId: string | undefined;
    contextId: string;
    linkViewContextType: string | undefined;
}

export interface IDocumentHistory {
    id: string;
    date: Date;
    attachmentId: string;
    extension: string | undefined;
    hasSignature: boolean;
    action: string | undefined;
    fromTemplateId: string | undefined;
    fromTemplateHistoryAndAttachmentId: string | undefined;
    standardDocumentId: string | undefined;
    isDocx: boolean;
    isPdf: boolean;
    canConvertToPdf: boolean;
}

export interface IDocumentIdAndPredefinedType {
    id: string;
    predefinedType: string | undefined;
}

export interface IDocumentKeyDto {
    description: string | undefined;
    type: string | undefined;
    tableKeys: ITableDocumentKeyDto[];
    isPrivate: boolean;
    key: string;
    keyWithBrackets: string;
    isList: boolean;
    isImage: boolean;
    isPublic: boolean;
}

export interface IDocumentSummary {
    id: string;
    created: Date;
    hasSignature: boolean;
    extension: string | undefined;
    templateType: string | undefined;
    templateName: string | undefined;
    predefinedType: string | undefined;
    userDefinedName: string | undefined;
    mustSign: boolean;
    templateId: string | undefined;
    standardDocumentId: string | undefined;
    canEdit: boolean;
    canViewOnline: boolean;
    linkViewContext: ILinkViewContext;
    lastBuildFromTemplateDate: Date | undefined;
    isDeleted: boolean;
    linkViewContextId: string;
    linkViewContextType: string | undefined;
    isPdf: boolean;
    isDocx: boolean;
    isDocxAndCanEditAndCanViewOnline: boolean;
    isDocxAndCanViewOnlineButCannotEdit: boolean;
    isFromTemplate: boolean;
    typeOrName: string | undefined;
}

export interface IDocumentsByContextAndIdParams {
    linkViewContextId: string;
    linkViewContextType: string | undefined;
}

export interface IDocumentsQueryParams {
    sortParams: ISortParams<IDocument>;
    pageParams: IPageParams;
    searchString: string;
    linkViewContextTypes: string[];
    predefinedTypes: string[];
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
}

export interface IDocumentsQueryParamsForPatient {
    searchString: string;
    sortParams: ISortParams<IDocument>;
    pageParams: IPageParams;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    predefinedTypes: string[];
}

export interface IDoubleChange {
    previous: number;
    current: number;
    absoluteChange: number;
    isChangePositive: boolean;
    isChanged: boolean;
    isPreviousZero: boolean;
    relativeChange: number;
}

export interface IEazyworksBlocnote {
    eazyworksKlantId: number;
    content: string | undefined;
    id: number;
}

export interface IEazyworksDocument {
    documentName: string | undefined;
    klantId: number;
    attachmentId: string;
    id: string | undefined;
}

export interface IEazyworksKlant {
    id: number;
    fileNumber: number;
    salutation: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    hamsGender: string | undefined;
    language: string | undefined;
    nationality: string | undefined;
    addressLine: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    country: string | undefined;
    primaryPhoneNumber: string | undefined;
    secondaryPhoneNumber: string | undefined;
    primaryMobilePhoneNumber: string | undefined;
    secondaryMobilePhoneNumber: string | undefined;
    dateOfBirth: Date | undefined;
    isDeceased: boolean;
    dateCreated: Date | undefined;
    socialSecurityNumber: string | undefined;
    identityCardNumber: string | undefined;
    prescriptionDate: Date | undefined;
    dateLastSale: Date | undefined;
    endWarrantyDate: Date | undefined;
    formattedAddress: string | undefined;
}

export interface IEazyworksKlantRaw {
    id: string | undefined;
    idAsInt: number;
    clcleunik: string | undefined;
    nodos: string | undefined;
    clE_USER: string | undefined;
    entete: string | undefined;
    prenom: string | undefined;
    sexe: string | undefined;
    nom: string | undefined;
    lang: string | undefined;
    languemat: string | undefined;
    nationalite: string | undefined;
    adresse: string | undefined;
    adressebis: string | undefined;
    codepost: string | undefined;
    lieu: string | undefined;
    pays: string | undefined;
    telp: string | undefined;
    telb: string | undefined;
    gsm: string | undefined;
    gsM2: string | undefined;
    relgsM2: string | undefined;
    nomgsM2: string | undefined;
    telf: string | undefined;
    reltelf: string | undefined;
    nomtelf: string | undefined;
    adremail: string | undefined;
    reladremail: string | undefined;
    nomemal: string | undefined;
    datenaiss: string | undefined;
    decede: string | undefined;
    hospitalise: string | undefined;
    prof: string | undefined;
    datecrea: string | undefined;
    utcleunik: string | undefined;
    utcleuniK2: string | undefined;
    cecleunik: string | undefined;
    datepremcor: string | undefined;
    datecontfut: string | undefined;
    typecor: string | undefined;
    corencours: string | undefined;
    domicile: string | undefined;
    nopass: string | undefined;
    nomut: string | undefined;
    tiersp: string | undefined;
    titulaire: string | undefined;
    couvlim: string | undefined;
    coderemb: string | undefined;
    pseudocode: string | undefined;
    coderemB2: string | undefined;
    condos: string | undefined;
    remb: string | undefined;
    remise: string | undefined;
    raisrem: string | undefined;
    noinig: string | undefined;
    fonds: string | undefined;
    orig: string | undefined;
    datepresc: string | undefined;
    datederven: string | undefined;
    nbaca: string | undefined;
    typaca: string | undefined;
    prixpaye: string | undefined;
    prixtotal: string | undefined;
    datepiles: string | undefined;
    dateentr: string | undefined;
    rapautom: string | undefined;
    diV1: string | undefined;
    diV2: string | undefined;
    diV3: string | undefined;
    diV4: string | undefined;
    diV5: string | undefined;
    diV6: string | undefined;
    diV7: string | undefined;
    diV8: string | undefined;
    diV9: string | undefined;
    diV10: string | undefined;
    datE_COM: string | undefined;
    acaprep: string | undefined;
    dateacaprep: string | undefined;
    credit: string | undefined;
    personnalite: string | undefined;
    bessociaux: string | undefined;
    acompte: string | undefined;
    negatif: string | undefined;
    rncleunik: string | undefined;
    datefingar: string | undefined;
    datedermut: string | undefined;
    datederneg: string | undefined;
    raisnegatif: string | undefined;
    datederacc: string | undefined;
    poinT1: string | undefined;
    poinT2: string | undefined;
    poinT3: string | undefined;
    preC_DATE: string | undefined;
    preC_TYPE: string | undefined;
    preC_QTE: string | undefined;
    preC_CAT: string | undefined;
    preC_PRIX: string | undefined;
    preC_RES: string | undefined;
    motivation: string | undefined;
    pouvachat: string | undefined;
    datemouv: string | undefined;
    mouve: string | undefined;
    reM2: string | undefined;
    nomfirme: string | undefined;
    tvafirme: string | undefined;
    noM2: string | undefined;
    adressE2: string | undefined;
    adressebiS2: string | undefined;
    reladressE2: string | undefined;
    codeposT2: string | undefined;
    lieU2: string | undefined;
    payS2: string | undefined;
    telP2: string | undefined;
    facT2: string | undefined;
    focleunik: string | undefined;
    nosis: string | undefined;
    mucleunik: string | undefined;
    gecleunik: string | undefined;
    ambassadeur: string | undefined;
    amB_COMPT: string | undefined;
    envoyeur: string | undefined;
    dateimport: string | undefined;
    dateexport: string | undefined;
    dernlettres: string | undefined;
    orcleunik: string | undefined;
    cmcleunik: string | undefined;
    datetest: string | undefined;
    perted: string | undefined;
    perteg: string | undefined;
    prcleunik: string | undefined;
    numero: string | undefined;
    cscleunik: string | undefined;
    dateorl: string | undefined;
    dateapp: string | undefined;
    dateprempret: string | undefined;
    daterapport: string | undefined;
    datemut: string | undefined;
    datemedcons: string | undefined;
    datederaca: string | undefined;
    dateclotdos: string | undefined;
    datedercont: string | undefined;
    acA1: string | undefined;
    acA2: string | undefined;
    acA3: string | undefined;
    acA4: string | undefined;
    puB_LET: string | undefined;
    puB_MAIL: string | undefined;
    puB_SMS: string | undefined;
    puB_TEL: string | undefined;
    puB_TIERS: string | undefined;
    chn1: string | undefined;
    chn2: string | undefined;
    chn3: string | undefined;
    chn4: string | undefined;
    chn5: string | undefined;
    ent1: string | undefined;
    ent2: string | undefined;
    ent3: string | undefined;
    ent4: string | undefined;
    ent5: string | undefined;
    idUser: string | undefined;
    datedermod: string | undefined;
}

export interface IEazyworksKlantenQueryParams {
    searchString: string;
    sortParams: ISortParams<IEazyworksKlant>;
    pageParams: IPageParams;
}

export interface IEazyworksPatientData {
    klantId: number;
    data: IEazyworksKlant;
    rawData: IEazyworksKlantRaw;
    blocnotes: IEazyworksBlocnote[];
    documents: IEazyworksDocument[];
    id: number;
    countBlocnotes: number;
    countDocuments: number;
}

export interface IEidData {
    dateOfBirth: Date;
    validityBeginDate: Date;
    validityEndDate: Date;
    photo: string | undefined;
    surName: string;
    firstNames: string;
    cardNumber: string;
    nationality: string;
    gender: string;
    addressStreetAndNumber: string;
    addressZip: string;
    addressMunicipality: string;
    socialSecurityNumber: string;
    locationOfBirth: string;
    issuedMunicipality: string;
}

export interface IEidDataWithoutPhoto {
    surName: string | undefined;
    firstNames: string | undefined;
    dateOfBirth: Date;
    cardNumber: string | undefined;
    nationality: string | undefined;
    gender: string | undefined;
    addressStreetAndNumber: string | undefined;
    addressZip: string | undefined;
    addressMunicipality: string | undefined;
    socialSecurityNumber: string | undefined;
    locationOfBirth: string | undefined;
    issuedMunicipality: string | undefined;
    validityBeginDate: Date;
    validityEndDate: Date;
}

export interface IEnableCochlearIntegrationRequest {
}

export interface IEnablePeppolIntegrationRequest {
    empty: string | undefined;
}

export interface IEndAllUserSessionsRequest {
    userId: string;
}

export interface IEndFailureTrialModel {
    stopDate: Date;
    returnToLocationId: string;
    medicalTreatmentNomenclatureCode: string | undefined;
}

export interface IEndLoanRequest {
    loanId: string;
    stopDate: Date;
    returnToLocationId: string;
}

export interface IEndLoanStep {
    endDate: Date;
    returnToLocation: IObjectWithIdAndIdentifier<string>;
}

export interface IEndRfiaAllTrialsRequest {
    rfiaId: string;
    stopDate: Date;
    returnToLocationId: string;
}

export interface IEndRfiaTrialAdministrativeRequest {
    rfiaId: string;
    trialId: string;
    date: Date;
}

export interface IEndSessionRequest {
    authId: string;
}

export interface IEntPhysician {
    id: string;
    created: Date;
    lastUpdated: Date;
    salutation: string | undefined;
    gender: string | undefined;
    isImportedFromWeb: boolean;
    offices: IOfficeData[];
    isDeleted: boolean;
    countRequestsToInsuranceAllowance: number;
    firstName: string;
    lastName: string;
    rizivCode: string;
    conventionedRizivNumber: string | undefined;
    notDeletedOffices: IOfficeData[];
    defaultOffice: IOfficeData;
    defaultOfficeId: string | undefined;
    hasDefaultOffice: boolean;
    countOffices: number;
    hasOffices: boolean;
    hasRequestsToInsuranceAllowance: boolean;
    defaultEmail: string | undefined;
    defaultPhone: string | undefined;
    searchField: string | undefined;
    zips: string[];
    officesCsv: string | undefined;
    identifier: string;
}

export interface IEntPhysicianExportParams {
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
    searchString: string;
    zips: string[];
    hasRequestsToInsuranceAllowance: boolean | undefined;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    gender: string | undefined;
    hasOffices: boolean | undefined;
    showDeleted: boolean;
}

export interface IEntPhysicianWithOfficesSummary {
    id: string;
    identifier: string;
    offices: IOfficeSummary[];
    defaultOffice: IOfficeSummary;
    hasOffices: boolean;
}

export interface IEntPhysiciansQueryParams {
    sortParams: ISortParams<IEntPhysician>;
    pageParams: IPageParams;
    zips: string[];
    searchString: string;
    hasRequestsToInsuranceAllowance: boolean | undefined;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    gender: string | undefined;
    hasOffices: boolean | undefined;
    showDeleted: boolean;
}

export interface IEntPhysiciansSearchData {
    zipCodes: string[];
}

export interface IEnterOAuthOptionsRequest {
    clientId: string | undefined;
    clientSecret: string | undefined;
    redirectUri: string | undefined;
    endpoint: string | undefined;
}

export interface IEquipmentDeliveryLine {
    id: string;
    productCatalogItemId: string | undefined;
    inventoryItemId: string | undefined;
    description: string | undefined;
    manufacturer: string | undefined;
    model: string | undefined;
    serialNumber: string | undefined;
    indexNumber: number;
    isRefundable: boolean;
    rizivRefundableHearingInstrumentCode: string | undefined;
    isIncludeOnHandoverCertificate: boolean;
    unitPrice: number;
    unitListPrice: number;
    vatPercentage: number;
    quantity: number;
    isVatIncluded: boolean;
    isInventoryItem: boolean;
    salesLineId: string;
    manufacturerCommaModel: string | undefined;
    manufacturerCommaModelDefaultDescription: string | undefined;
    hasProductCatalogItem: boolean;
    descriptionBracketsRizivCodeOrDefault: string | undefined;
    rizivHearingAidDefinitionV1IdentificationCode: string | undefined;
    rizivHearingAidDefinitionV2IdentificationCode: number | undefined;
    unitPriceInVat: number;
    unitListPriceInVat: number;
    linePriceInVat: number;
    lineListPriceInVat: number;
    unitPriceExVat: number;
    unitListPriceExVat: number;
    linePriceExVat: number;
    lineListPriceExVat: number;
    unitVatValue: number;
    lineVatValue: number;
    unitDiscountValueInVat: number;
    unitDiscountValueExVat: number;
    lineDiscountValueInVat: number;
    lineDiscountValueExVat: number;
    discountPercentage: number;
}

export interface IEquipmentDeliveryStep {
    expectedHandoverDate: Date | undefined;
    handoverDate: Date | undefined;
    proformaHandoverDate: Date | undefined;
    lines: IEquipmentDeliveryLine[];
    fees: IMedicalTreatmentFeeDto[];
    totalPriceInVat: number;
    totalContributions: number;
    patientPriceInVat: number;
    hasHandoverDate: boolean;
    hasProformaData: boolean;
    vatSplits: IVatSplit[];
    priceInVat: number;
    priceExVat: number;
    vatAmount: number;
}

export interface IExactGlobeCostCenter {
    id: string;
    code: string | undefined;
    description: string | undefined;
}

export interface IExactGlobeCostUnit {
    id: string;
    code: string | undefined;
    description: string | undefined;
}

export interface IExactGlobeCustomerAccountDto {
    hamsId: string;
    identifier: string;
    type: ExactGlobeCustomerAccountType;
    status: ExactGlobeCustomerAccountStatus;
    patientReference: string | undefined;
    overrideDebtorCode: string | undefined;
    address: IAddress;
    isNotAPatientAndHasNoDebtorCode: boolean;
    hasError: boolean;
    id: string;
    hasAddress: boolean;
    isPatient: boolean;
    debtorCode: string | undefined;
    searchField: string | undefined;
}

export interface IExactGlobeCustomerAccountQueryParams {
    searchString: string;
    sortParams: ISortParams<IExactGlobeCustomerAccountDto>;
    pageParams: IPageParams;
    prefilter: ExactGlobeCustomerAccountPrefilter;
}

export interface IExactGlobeLocationDto {
    hamsId: string;
    identifier: string;
    costCenter: IExactGlobeCostCenter;
    id: string;
    exactGlobeCostCenterId: string | undefined;
    isLinked: boolean;
}

export interface IExactGlobeProductCatalogItemDto {
    id: string;
    identifier: string;
    type: ProductCatalogItemType;
    costUnit: IExactGlobeCostUnit;
    costUnitId: string | undefined;
    isLinked: boolean;
    searchField: string | undefined;
}

export interface IExactGlobeProductCatalogItemsQueryParams {
    searchString: string;
    sortParams: ISortParams<IExactGlobeProductCatalogItemDto>;
    pageParams: IPageParams;
    types: ProductCatalogItemType[];
    prefilter: ExactGlobeProductCatalogItemPrefilter;
}

export interface IExactGlobeSaleDto {
    hamsId: string;
    date: Date;
    reference: string | undefined;
    status: ExactGlobeSaleStatus;
    validation: IExactGlobeSaleValidation;
    id: string;
    hasError: boolean;
    searchField: string | undefined;
}

export interface IExactGlobeSaleValidation {
    hasMultipleCustomerAccounts: boolean;
    customerAccountHasNoDebtorCode: boolean;
    hasAnyUnlinkedProductCatalogItems: boolean;
    hasError: boolean;
}

export interface IExactGlobeSalesQueryParams {
    searchString: string;
    sortParams: ISortParams<IExactGlobeSaleDto>;
    pageParams: IPageParams;
    prefilter: ExactGlobeSalePrefilter;
}

export interface IExactGlobeSettings {
    divisionCode: string | undefined;
    journalCode: string | undefined;
    glAccountCode: string | undefined;
    fallbackCostUnit: string | undefined;
}

export interface IExactGlobeStatusDto {
    countUnhandledSales: number;
    countUnlinkedPcs: number;
    countUnlinkedLocations: number;
    countUnhandledCustomerAccounts: number;
    hasNotifications: boolean;
}

export interface IExactOnlineAdminSettingsDto {
    isEnabled: boolean;
    oAuthOptions: IOAuthOptionsObfuscated;
    oAuthToken: IOAuthTokenObfuscated;
    last5IssuedTokens: IOAuthTokenObfuscated[];
    hasOAuthOptions: boolean;
    hasOAuthToken: boolean;
    canPushPull: boolean;
}

export interface IExactOnlineBulkFinancialGLAccount {
    code: string | undefined;
    description: string | undefined;
    iD: string;
    __metadata: IExactOnlineMetadata;
}

export interface IExactOnlineCostCenter {
    id: string;
    code: string | undefined;
    description: string | undefined;
    active: boolean;
    iD: string;
    __metadata: IExactOnlineMetadata;
}

export interface IExactOnlineCrmAccountDto {
    id: string;
    code: string | undefined;
    name: string | undefined;
}

export interface IExactOnlineCustomerAccountDto {
    hamsId: string;
    name: string | undefined;
    exactOnlineId: string | undefined;
    exactOnlineCode: string | undefined;
    isLinked: boolean;
    searchField: string | undefined;
}

export interface IExactOnlineCustomerAccountQueryParams {
    searchString: string;
    sortParams: ISortParams<IExactOnlineCustomerAccountDto>;
    pageParams: IPageParams;
    prefilter: ExactOnlineCustomerAccountPrefilter;
}

export interface IExactOnlineFallbackGLAccountDto {
    vatPercentage: number;
    exactOnlineGLAccountId: string;
    exactOnlineGLAccountCode: string | undefined;
}

export interface IExactOnlineGLAccountDto {
    id: string;
    code: string | undefined;
    description: string | undefined;
}

export interface IExactOnlineLocationDto {
    id: string;
    identifier: string;
    isDeleted: boolean;
    exactOnlineCostCenter: IExactOnlineCostCenter;
    exactOnlineCostCenterId: string | undefined;
    linked: boolean;
}

export interface IExactOnlineMetadata {
    uri: string | undefined;
    type: string | undefined;
}

export interface IExactOnlineProductCatalogItemDto {
    id: string;
    identifier: string;
    isDeleted: boolean;
    glAccount: IExactOnlineBulkFinancialGLAccount;
    costCenter: IExactOnlineCostCenter;
    exactOnlineGLAccountId: string | undefined;
    exactOnlineGLAccountCode: string | undefined;
    isLinked: boolean;
    exactOnlineCostCenterId: string | undefined;
    exactOnlineCostCenterCode: string | undefined;
    hasCostCenter: boolean;
    searchField: string | undefined;
}

export interface IExactOnlineProductCatalogItemsQueryParams {
    searchString: string;
    sortParams: ISortParams<IExactOnlineProductCatalogItemDto>;
    pageParams: IPageParams;
    isDeleted: boolean | undefined;
    hasCostCenter: boolean | undefined;
    isLinked: boolean | undefined;
}

export interface IExactOnlineSale {
    hamsSalesId: string;
    created: Date;
    reference: string | undefined;
    exactOnlineSalesEntryId: string | undefined;
    isIgnored: boolean;
    hamsDocumentId: string | undefined;
    exactOnlineDocumentAttachmentId: string | undefined;
    isDocumentDirty: boolean;
    paymentReference: string | undefined;
    isPaymentReferencePushed: boolean;
    isPushedToExactOnline: boolean;
    id: string;
    isDocumentInSync: boolean;
    isPaymentReferenceInSync: boolean;
    isSynced: boolean;
    searchField: string | undefined;
}

export interface IExactOnlineSaleDetails {
    sale: IExactOnlineSale;
    customerAccounts: IExactOnlineCustomerAccountDto[];
    lines: IExactOnlineSalesLineDetails[];
    validation: IExactOnlineSaleValidation;
    isValid: boolean;
}

export interface IExactOnlineSaleValidation {
    isCashSale: boolean;
    countCustomerAccounts: number;
    reference: string | undefined;
    hasAnyProductsWithoutGLAccountCode: boolean;
    hasAnyProductsNotFoundInMapping: boolean;
    hasMissingFallbackGLAccounts: boolean;
    hasUnlinkedCustomerAccounts: boolean;
    hasMissingCostCenters: boolean;
    referenceAsANumber: number | undefined;
    referenceIsANumber: boolean;
    hasMultipleCustomerAccounts: boolean;
    hasNoCustomerCustomerAccount: boolean;
    isValid: boolean;
}

export interface IExactOnlineSalesLineDetails {
    id: string;
    description: string | undefined;
    productCatalogItemId: string | undefined;
    quantity: number;
    vatPercentage: number;
    lineListPriceExVat: number;
    exactOnlineProductCatalogItem: IExactOnlineProductCatalogItemDto;
    exactOnlineGLAccountId: string | undefined;
    exactOnlineGLAccountCode: string | undefined;
    isLinked: boolean;
    mustLink: boolean;
}

export interface IExactOnlineSalesQueryParams {
    searchString: string;
    sortParams: ISortParams<IExactOnlineSale>;
    pageParams: IPageParams;
    prefilter: ExactOnlineSalePrefilter;
}

export interface IExactOnlineSettingsDto {
    canConnect: boolean;
    isEnabled: boolean;
    hasOAuthOptions: boolean;
    hasOAuthToken: boolean;
    canPushPull: boolean;
    baseUrl: string | undefined;
    fallbackGLAccounts: IExactOnlineFallbackGLAccountDto[];
    glAccountMatchMode: ExactOnlineGLAccountMatchMode;
    costCenterMode: ExactOnlineCostCenterMode;
    journal: string | undefined;
    division: number | undefined;
    canGetMyDivision: boolean;
    fallbackGLAccountCode0Percent: string | undefined;
    fallbackGLAccountCode6Percent: string | undefined;
    fallbackGLAccountCode21Percent: string | undefined;
    has0PercentFallbackGLAccount: boolean;
    has6PercentFallbackGLAccount: boolean;
    has21PercentFallbackGLAccount: boolean;
    hasBaseUrl: boolean;
    hasJournal: boolean;
    hasDivision: boolean;
}

export interface IExactOnlineStatusDto {
    countUnprocessedSales: number;
    countUnprocessedCustomerAccounts: number;
    countUnlinkedProductCatalogItems: number;
    countUnlinkedLocations: number;
    useGLAccountsOfProductCatalogToMatchGLAccount: boolean;
    useCostCenters: boolean;
    hasNotification: boolean;
}

export interface IExampleTemplateDto {
    id: string;
    language: string | undefined;
    predefinedType: string | undefined;
    mainContext: string | undefined;
    mustSign: boolean;
    canEdit: boolean;
    canViewOnline: boolean;
    isStandardDocument: boolean;
    name: string;
    isPredefinedType: boolean;
}

export interface IExcelFileUploadModel {
    contentAsBase64: string | undefined;
    fileName: string;
    password: string | undefined;
}

export interface IExportCochlearInfoEventsParams {
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
}

export interface IExportCochlearPatientsParams {
    searchString: string;
    statuses: CochlearPatientStatus[];
    isCiCandidate: boolean | undefined;
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
    informedDateBefore: Date | undefined;
    informedDateAfter: Date | undefined;
    referralDateBefore: Date | undefined;
    referralDateAfter: Date | undefined;
    implantedDateBefore: Date | undefined;
    implantedDateAfter: Date | undefined;
    bimodallyFittedDateBefore: Date | undefined;
    bimodallyFittedDateAfter: Date | undefined;
    patientId: string | undefined;
}

export interface IExportCochlearReferralCentersParams {
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
}

export interface IExportColumnSelection {
    id: string;
    created: Date;
    lastUpdated: Date;
    view: string | undefined;
    name: string | undefined;
    columns: string[];
}

export interface IExportColumnSelectionModel {
    name: string | undefined;
    columns: string[];
}

export interface IFailedEvent {
    id: string;
    created: Date;
    lastUpdated: Date;
    pos: number;
    subscriptionKey: string | undefined;
    isResolved: boolean;
    isIgnored: boolean;
    resolveDate: Date | undefined;
    status: string | undefined;
    searchField: string | undefined;
}

export interface IFailedEventsQueryParams {
    searchString: string;
    sortParams: ISortParams<IFailedEvent>;
    pageParams: IPageParams;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    statuses: string[];
}

export interface IFailureHandoverResponse {
    salesId: string;
    errors: IValidationError<IRegisterRfiaFailureHandoverRequest>[];
    hasError: boolean;
    isSuccess: boolean;
}

export interface IFeedbackAdvisoryPhysicianStep {
    id: string;
    sentDate: Date | undefined;
    expectedReceptionDate: Date | undefined;
    receptionDate: Date | undefined;
    approvalDate: Date | undefined;
    letterId: string | undefined;
    isApproved: boolean;
    isDisapproved: boolean;
    hasReceived: boolean;
    hasLetter: boolean;
    hasSent: boolean;
    canCreateLetter: boolean;
}

export interface IFileUploadRequest {
    contentAsBase64: string | undefined;
    fileName: string;
}

export interface IFileUploadResponse {
    error: string | undefined;
    hasError: boolean;
    isSuccess: boolean;
}

export interface IFindEazyworksMatchResponse {
    alreadyLinked: IPatient[];
    matchOnSsNr: IPatient[];
    matchOnName: IPatient[];
    hasMatchOnSsnr: boolean;
    hasMatchOnName: boolean;
}

export interface IFixNoahIndicesForPatientRequest {
    patientId: string;
}

export interface IForwardInvoiceRequest {
    salesId: string;
}

export interface IFromTemplateModel {
    templateId: string | undefined;
    standardDocumentId: string | undefined;
}

export interface IGeneralPractitioner {
    id: string;
    created: Date;
    lastUpdated: Date;
    salutation: string | undefined;
    gender: string | undefined;
    isImportedFromWeb: boolean;
    offices: IOfficeData[];
    isDeleted: boolean;
    firstName: string;
    lastName: string;
    rizivCode: string;
    conventionedRizivNumber: string | undefined;
    notDeletedOffices: IOfficeData[];
    defaultOffice: IOfficeData;
    defaultOfficeId: string | undefined;
    hasDefaultOffice: boolean;
    countOffices: number;
    hasOffices: boolean;
    defaultEmail: string | undefined;
    defaultPhone: string | undefined;
    formattedName: string | undefined;
    searchField: string | undefined;
    zips: string[];
    officesCsv: string | undefined;
    identifier: string;
}

export interface IGeneralPractitionerWithOfficesSummary {
    id: string;
    identifier: string;
    offices: IOfficeSummary[];
    defaultOffice: IOfficeSummary;
    hasOffices: boolean;
}

export interface IGeneralPractitionersExportParams {
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
    searchString: string;
    zips: string[];
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    gender: string | undefined;
    hasOffices: boolean | undefined;
    showDeleted: boolean;
}

export interface IGeneralPractitionersQueryParams {
    sortParams: ISortParams<IGeneralPractitioner>;
    pageParams: IPageParams;
    zips: string[];
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    gender: string | undefined;
    hasOffices: boolean | undefined;
    showDeleted: boolean;
}

export interface IGeneralPractitionersSearchData {
    zipCodes: string[];
}

export interface IGenerateApiTokenRequest {
    computerName: string | undefined;
}

export interface IGenerateOrRenewTokenRequest {
    clientId: string;
    computerName: string | undefined;
}

export interface IGuidObjectWithIdAndDescription {
    id: string;
    description: string | undefined;
}

export interface IGuidObjectWithIdAndReference {
    id: string;
    reference: string | undefined;
}

export interface IHamsRosaPatientLinkDto {
    rosaPatientRecords: IRosaPatientRecordWithMemberEquality[];
    isLinked: boolean;
    isLinkedToMultiple: boolean;
}

export interface IHandleUblFromBufferRequest {
    bufferId: string;
}

export interface IHeaderInfo {
    column: number;
    value: string | undefined;
}

export interface IHealthInsuranceFundCache {
    nl: IObjectWithIdAndIdentifier<string>[];
    fr: IObjectWithIdAndIdentifier<string>[];
    en: IObjectWithIdAndIdentifier<string>[];
}

export interface IHealthInsuranceFundWithAddressDto {
    code: string | undefined;
    created: Date;
    lastUpdated: Date;
    language: string | undefined;
    name: string | undefined;
    addressLine: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    country: string | undefined;
    email: string | undefined;
    alternativeEmail: string | undefined;
    phone: string | undefined;
    alternativePhone: string | undefined;
    fax: string | undefined;
    website: string | undefined;
    thirdPayerArrangementAddress: IAddress;
    advisoryPhysicianAddress: IAddress;
    codeCommaName: string | undefined;
    formattedAddress: string | undefined;
    thirdPayerArrangementFormattedAddress: string | undefined;
    advisoryPhysicianFormattedAddress: string | undefined;
    hasThirdPayerArrangementAddress: boolean;
    hasAdvisoryPhysicianAddress: boolean;
    hasMetaData: boolean;
}

export interface IHealthInsuranceFundWithAddressDtoQueryParams {
    sortParams: ISortParams<IHealthInsuranceFundWithAddressDto>;
    pageParams: IPageParams;
    searchString: string;
    hasThirdPayerArrangementAddress: boolean | undefined;
    hasAdvisoryPhysicianAddress: boolean | undefined;
    hasMetadata: boolean | undefined;
}

export interface IHearingAidData {
    type: string | undefined;
    batteryType: string | undefined;
    hasSeparateReceiver: boolean;
    hasSeparateEarmould: boolean;
    isBehindTheEar: boolean;
    isInTheEar: boolean;
}

export interface IHearingDeviceCatalogModel {
    category: string | undefined;
    subcategory: string | undefined;
    listPrice: number;
    vatPercentage: number;
    hasBatteries: boolean;
    isHearingInstrument: boolean;
    recupelCode: string | undefined;
    bebatUnitPriceInVat: number;
    hearingAidType: string | undefined;
    batteryType: string | undefined;
    hasSeparateEarmould: boolean;
    hasSeparateReceiver: boolean;
    rizivHearingAidDefinitionV2ManufacturerAndNameGroupId: string | undefined;
    manufacturer: string;
    model: string;
}

export interface IHpCosiDomainTargets {
    domain1: number;
    domain2: number;
    domain3: number;
    domain4: number;
    domain5: number;
    domain6: number;
}

export interface IHpCosiEntry {
    situation: string | undefined;
    priority: number;
    otherHearingAids: boolean;
    degreeOfChange: HpCosiDegreeOfChange;
    endResult: HpCosiEndResult;
    domains: HpCosiDomain[];
}

export interface IHpCosiQuestionnaire {
    entries: IHpCosiEntry[];
    targets: IHpCosiDomainTargets;
}

export interface IHpPostQuestionnaire {
    part1: IHpQuestPart1;
    part3: IHpQuestPart3;
    score: IHpQuestScore;
}

export interface IHpPreQuestionnaire {
    part1: IHpQuestPart1;
    part2: IHpQuestPart2;
    part3: IHpQuestPart3;
    score: IHpQuestScore;
}

export interface IHpQuestPart1 {
    currentlyWearingHearingAids: boolean;
    entries: IHpQuestPart1Entry[];
}

export interface IHpQuestPart1Entry {
    question: number;
    answer: FrequencyIntensity;
}

export interface IHpQuestPart2 {
    entries: IHpQuestPart2Entry[];
    otherThingsToDiscuss: string | undefined;
}

export interface IHpQuestPart2Entry {
    situation: string | undefined;
    answer: FrequencyPeriodicity;
}

export interface IHpQuestPart3 {
    questions: IHpQuestPart3Entry[];
    answeredQuestionsIndependently: boolean;
    whoHelpedAnsweringTheQuestions: string | undefined;
    place: string | undefined;
}

export interface IHpQuestPart3Entry {
    question: number;
    answer: IntensityLevel;
}

export interface IHpQuestScore {
    domain1: number;
    domain2: number;
    domain3: number;
    domain4: number;
    domain5: number;
    domain6: number;
}

export interface IIgnoreExactOnlineSaleRequest {
    hamsSalesId: string;
}

export interface IIgnoreInvoiceForwardingRequest {
    salesId: string;
}

export interface IIgnorePeppolRecordRequest {
    id: string;
}

export interface IImportEazyworksPatientRequest {
    eazyworksKlantId: number;
}

export interface IImportProductCatalogItemsFromXlsxResponse {
    countImported: number;
    error: string | undefined;
}

export interface IInsuranceProductCatalogItemModel {
    category: string | undefined;
    subcategory: string | undefined;
    listPrice: number;
    vatPercentage: number;
    termUnit: string | undefined;
    termValue: number;
    isUnlimitedTerm: boolean;
    canAlsoPurchase: boolean;
    name: string;
}

export interface IIntChange {
    previous: number;
    current: number;
    absoluteChange: number;
    isChangePositive: boolean;
    isChanged: boolean;
    isPreviousZero: boolean;
    relativeChange: number;
}

export interface IInventoryItem {
    id: string;
    created: Date;
    lastUpdated: Date;
    productCatalogData: IProductCatalogItemSummary;
    serialNumber: string | undefined;
    salesPrice: number;
    purchasePrice: number;
    transactions: ITransactionSummary[];
    isDemo: boolean;
    rizivHearingAidDefinitionV2IdentificationCode: number | undefined;
    oldSerialNumbers: string[];
    annotationIds: string[];
    dispatchInfo: IDispatchInfo;
    consignmentReturnBeforeDate: Date | undefined;
    soldAssurances: IAssuranceLine[];
    purchasedAssurances: IAssuranceLine[];
    tailorMadeForPatient: IObjectWithIdAndIdentifier<string>;
    articleProperties: IArticleProperty[];
    manualWarrantyEndDate: Date | undefined;
    labels: string[];
    latestOrientation: string | undefined;
    productCatalogId: string;
    manufacturer: string | undefined;
    model: string | undefined;
    salesListPrice: number;
    purchaseListPrice: number;
    vatPercentage: number;
    category: string | undefined;
    subcategory: string | undefined;
    hasSerialNumber: boolean;
    isTailorMade: boolean;
    isElectronics: boolean;
    hasBatteries: boolean;
    description: string | undefined;
    type: ProductCatalogItemType;
    bebatUnitPriceInVat: number;
    hasBebat: boolean;
    isHearingInstrument: boolean;
    isRemoteControl: boolean;
    newestFirstOrderedTransactions: ITransactionSummaryForInventoryItem[];
    orderedTransactions: ITransactionSummary[];
    isSold: boolean;
    isPurchased: boolean;
    isSalesCredited: boolean;
    isPurchaseCredited: boolean;
    isInRepair: boolean;
    isReturnedToSupplier: boolean;
    isBroken: boolean;
    isInLoan: boolean;
    isInOrder: boolean;
    isDelivered: boolean;
    purchaseDate: Date | undefined;
    dateSold: Date | undefined;
    orderDate: Date | undefined;
    firstDeliveryDate: Date | undefined;
    returnToSupplierDate: Date | undefined;
    dateSentToSupplierForRepair: Date | undefined;
    purchaseCreditDate: Date | undefined;
    salesCreditDate: Date | undefined;
    purchaseReference: string | undefined;
    salesReference: string | undefined;
    salesCreditNoteReference: string | undefined;
    purchaseCreditNoteReference: string | undefined;
    status: string | undefined;
    hasSerialNumberDefined: boolean;
    manufacturerAndModel: string | undefined;
    manufacturerModelAndSerialNumber: string | undefined;
    canSelectForSale: boolean;
    canSelectForPurchase: boolean;
    canSelectForCreditPurchase: boolean;
    canSelectForReturn: boolean;
    canSelectForStockMovement: boolean;
    canSelectForRepair: boolean;
    canSelectForLoan: boolean;
    canRegisterAsSold: boolean;
    canUndolRegisterAsSold: boolean;
    canRegisterAsBroken: boolean;
    canUndoRegisterAsBroken: boolean;
    isInventoried: boolean;
    hasSupplierDefined: boolean;
    searchField: string | undefined;
    identifier: string;
    countTransactions: number;
    hasSwitchedSerialNumber: boolean;
    dispatchReference: string | undefined;
    dispatchDate: Date | undefined;
    hasRizivHearingAidDefinitionV2CodeSet: boolean;
    canLinkRizivRefundableHearingInstrument: boolean;
    hasAnnotations: boolean;
    storedNow: Date;
    hasConsignmentReturnBeforeDate: boolean;
    consignmentReturnBeforeDateMinusOneWeek: Date | undefined;
    isOnConsignment: boolean;
    isConsignmentExpired: boolean;
    consignmentExpiresWithinAWeek: boolean;
    storedNowPreviousToNeedsNowAfter: boolean;
    needsNowAfter: Date | undefined;
    isPurchasedOrReturnedToSupplier: boolean;
    supplier: IObjectWithIdAndIdentifier<string>;
    patient: IObjectWithIdAndIdentifier<string>;
    currentLocation: IObjectWithIdAndIdentifier<string>;
    supplierFromPurchase: IObjectWithIdAndIdentifier<string>;
    locationWhereSold: IObjectWithIdAndIdentifier<string>;
    supplierId: string | undefined;
    supplierIdentifier: string | undefined;
    supplierFromPurchaseId: string | undefined;
    supplierFromPurchaseIdentifier: string | undefined;
    patientId: string | undefined;
    patientIdentifier: string | undefined;
    currentLocationId: string | undefined;
    currentLocationIdentifier: string | undefined;
    currentLocationType: string | undefined;
    propertyOf: string | undefined;
    reservedForPatient: IObjectWithIdAndIdentifier<string>;
    reservedForPatientId: string | undefined;
    reservedForPatientIdentifier: string | undefined;
    isReserved: boolean;
    hasSoldInsurance: boolean;
    hasSoldProlongedWarranty: boolean;
    hasPurchasedInsurance: boolean;
    hasPurchasedProlongedWarranty: boolean;
    hasSoldAssurances: boolean;
    hasPurchasedAssurances: boolean;
    warrantyEndDate: Date | undefined;
    defaultWarrantyEndDate: Date | undefined;
    hasOtherThanDefaultWarrantyEndDate: boolean;
    hasTailorMadeForPatient: boolean;
    tailorMadeForPatientId: string | undefined;
    tailorMadeForPatientIdentifier: string | undefined;
    locationWhereSoldId: string | undefined;
    locationWhereSoldIdentifier: string | undefined;
    hasManualEndWarrantyDate: boolean;
    purchasedAssurancesProductCatalogIds: string[];
    patientIds: string[];
    locationIds: string[];
    supplierIds: string[];
    oldSerialNumbersCsv: string | undefined;
    salesPriceExVat: number;
    profit: number;
    margin: number;
    markup: number;
    articlePropertiesX: IArticleProperty[];
    hasAnyArticlePropertyWithValues: boolean;
    canReserve: boolean;
    rizivHearingAidDefinitionV1IdentificationCode: string | undefined;
    lastLoanStartedDate: Date | undefined;
    lastLoanFromLocation: IObjectWithIdAndIdentifier<string>;
    lastLoanFromLocationIdentifier: string | undefined;
}

export interface IInventoryItemDetail {
    data: IInventoryItem;
    noahDeviceWithLastLinkedProductCatalogItem: INoahDeviceWithLastLinkedProductCatalogItem;
    countRemarks: number;
    hasLinkedNoahDevice: boolean;
}

export interface IInventoryItemModel {
    productCatalogItemId: string;
    serialNumber: string | undefined;
    tailorMadeForPatientId: string | undefined;
}

export interface IInventoryItemSearchData {
    manufacturers: string[];
    categories: string[];
    subcategories: string[];
    labels: string[];
}

export interface IInventoryItemSummaryWithPurchasedAssuranceDto {
    assuredInventoryItemId: string;
    assuredProductCatalogItemId: string;
    manufacturer: string | undefined;
    model: string | undefined;
    serialNumber: string | undefined;
    transactionLineId: string;
    transaction: IGuidObjectWithIdAndReference;
    transactionDate: Date;
    assuranceProductCatalogItemId: string;
    display: string | undefined;
}

export interface IInventoryItemWithMatchArticleProperties {
    data: IInventoryItem;
    mismatchKeys: string[];
    id: string;
    hasMismatchingProperties: boolean;
}

export interface IInventoryItemWithProductCatalogItemDto {
    inventoryItem: IInventoryItem;
    productCatalogItem: IProductCatalogItem;
}

export interface IInventoryItemsExportParams {
    searchString: string;
    manufacturers: string[];
    types: ProductCatalogItemType[];
    categories: string[];
    subcategories: string[];
    statuses: string[];
    vatPercentage: number | undefined;
    isElectronics: boolean | undefined;
    hasBatteries: boolean | undefined;
    isSold: boolean | undefined;
    isPurchased: boolean | undefined;
    isSalesCredited: boolean | undefined;
    isPurchaseCredited: boolean | undefined;
    isAtSupplierForRepair: boolean | undefined;
    isReturnedToSupplier: boolean | undefined;
    salesPriceLessThan: number | undefined;
    salesPriceMoreThan: number | undefined;
    listPriceLessThan: number | undefined;
    listPriceMoreThan: number | undefined;
    orderedBefore: Date | undefined;
    orderedAfter: Date | undefined;
    deliveredBefore: Date | undefined;
    deliveredAfter: Date | undefined;
    returnedBefore: Date | undefined;
    returnedAfter: Date | undefined;
    purchasedBefore: Date | undefined;
    purchasedAfter: Date | undefined;
    soldBefore: Date | undefined;
    soldAfter: Date | undefined;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    lastUpdatedBefore: Date | undefined;
    lastUpdatedAfter: Date | undefined;
    atLocationIds: string[];
    supplierIds: string[];
    vatPercentages: number[];
    keyFilterType: ProductCatalogItemType | undefined;
    isDemo: boolean | undefined;
    isReserved: boolean | undefined;
    locationTypes: string[];
    propertyOfTypes: string[];
    consignmentReturnBeforeDateAfter: Date | undefined;
    consignmentReturnBeforeDateBefore: Date | undefined;
    isOnConsignment: boolean | undefined;
    isConsignmentExpired: boolean | undefined;
    consignmentExpiresWithinAWeek: boolean | undefined;
    hasSoldInsurance: boolean | undefined;
    hasSoldProlongedWarranty: boolean | undefined;
    hasPurchasedInsurance: boolean | undefined;
    hasPurchasedProlongedWarranty: boolean | undefined;
    purchaseCreditDateBefore: Date | undefined;
    purchaseCreditDateAfter: Date | undefined;
    salesCreditDateBefore: Date | undefined;
    salesCreditDateAfter: Date | undefined;
    isTailorMade: boolean | undefined;
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
    hasBebat: boolean | undefined;
    labels: string[];
}

export interface IInventoryItemsQueryParams {
    searchString: string;
    manufacturers: string[];
    types: ProductCatalogItemType[];
    categories: string[];
    subcategories: string[];
    statuses: string[];
    vatPercentage: number | undefined;
    isElectronics: boolean | undefined;
    hasBatteries: boolean | undefined;
    isSold: boolean | undefined;
    isPurchased: boolean | undefined;
    isSalesCredited: boolean | undefined;
    isPurchaseCredited: boolean | undefined;
    isAtSupplierForRepair: boolean | undefined;
    isReturnedToSupplier: boolean | undefined;
    salesPriceLessThan: number | undefined;
    salesPriceMoreThan: number | undefined;
    listPriceLessThan: number | undefined;
    listPriceMoreThan: number | undefined;
    orderedBefore: Date | undefined;
    orderedAfter: Date | undefined;
    deliveredBefore: Date | undefined;
    deliveredAfter: Date | undefined;
    returnedBefore: Date | undefined;
    returnedAfter: Date | undefined;
    purchasedBefore: Date | undefined;
    purchasedAfter: Date | undefined;
    soldBefore: Date | undefined;
    soldAfter: Date | undefined;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    lastUpdatedBefore: Date | undefined;
    lastUpdatedAfter: Date | undefined;
    atLocationIds: string[];
    supplierIds: string[];
    vatPercentages: number[];
    keyFilterType: ProductCatalogItemType | undefined;
    isDemo: boolean | undefined;
    isReserved: boolean | undefined;
    locationTypes: string[];
    propertyOfTypes: string[];
    consignmentReturnBeforeDateAfter: Date | undefined;
    consignmentReturnBeforeDateBefore: Date | undefined;
    isOnConsignment: boolean | undefined;
    isConsignmentExpired: boolean | undefined;
    consignmentExpiresWithinAWeek: boolean | undefined;
    hasSoldInsurance: boolean | undefined;
    hasSoldProlongedWarranty: boolean | undefined;
    hasPurchasedInsurance: boolean | undefined;
    hasPurchasedProlongedWarranty: boolean | undefined;
    purchaseCreditDateBefore: Date | undefined;
    purchaseCreditDateAfter: Date | undefined;
    salesCreditDateBefore: Date | undefined;
    salesCreditDateAfter: Date | undefined;
    isTailorMade: boolean | undefined;
    sortParams: ISortParams<IInventoryItem>;
    pageParams: IPageParams;
    hasBebat: boolean | undefined;
    labels: string[];
}

export interface IInventoryItemsQueryParamsForLoan {
    searchString: string;
    sortParams: ISortParams<IInventoryItem>;
    pageParams: IPageParams;
    categories: string[];
    subcategories: string[];
    forProductCatalogId: string | undefined;
    isShowAll: boolean;
}

export interface IInventoryItemsQueryParamsForPurchaseAssurance {
    searchString: string;
    sortParams: ISortParams<IInventoryItem>;
    pageParams: IPageParams;
    categories: string[];
    subcategories: string[];
    supplierId: string;
    isShowAll: boolean;
}

export interface IInventoryItemsQueryParamsForPurchaseCreditAssurance {
    searchString: string;
    sortParams: ISortParams<IInventoryItemSummaryWithPurchasedAssuranceDto>;
    pageParams: IPageParams;
}

export interface IInventoryItemsQueryParamsForPurchaseOrCreditPurchase {
    searchString: string;
    sortParams: ISortParams<IInventoryItem>;
    pageParams: IPageParams;
    categories: string[];
    subcategories: string[];
    forProductCatalogId: string | undefined;
    supplierId: string | undefined;
    isShowAll: boolean;
}

export interface IInventoryItemsQueryParamsForRepair {
    searchString: string;
    sortParams: ISortParams<IInventoryItem>;
    pageParams: IPageParams;
    categories: string[];
    subcategories: string[];
    isShowAll: boolean;
}

export interface IInventoryItemsQueryParamsForReturn {
    searchString: string;
    sortParams: ISortParams<IInventoryItem>;
    pageParams: IPageParams;
    categories: string[];
    subcategories: string[];
    forProductCatalogId: string | undefined;
    isShowAll: boolean;
}

export interface IInventoryItemsQueryParamsForSale {
    searchString: string;
    sortParams: ISortParams<IInventoryItem>;
    pageParams: IPageParams;
    categories: string[];
    subcategories: string[];
    forProductCatalogId: string | undefined;
    forPatientId: string | undefined;
    isShowAll: boolean;
}

export interface IInventoryItemsQueryParamsForStockMovement {
    searchString: string;
    sortParams: ISortParams<IInventoryItem>;
    pageParams: IPageParams;
    categories: string[];
    subcategories: string[];
    forProductCatalogId: string | undefined;
    isShowAll: boolean;
}

export interface IInvoiceForwardingQueryParams {
    searchString: string;
    sortParams: ISortParams<IInvoiceForwardingRecord>;
    pageParams: IPageParams;
    prefilter: InvoiceForwardingPrefilter;
}

export interface IInvoiceForwardingRecord {
    salesId: string;
    created: Date;
    reference: string | undefined;
    isIgnored: boolean;
    forwardedToEmailAddresses: string[];
    forwardedDate: Date | undefined;
    isForwarded: boolean;
    id: string;
    searchField: string | undefined;
}

export interface IInvoiceForwardingRecordDetails {
    record: IInvoiceForwardingRecord;
    validation: IInvoiceForwardingRecordValidation;
    canForward: boolean;
}

export interface IInvoiceForwardingRecordValidation {
    hasDocument: boolean;
    forwardModeIsOnDocumentCreated: boolean;
    hasPaymentReference: boolean;
    canForward: boolean;
}

export interface IInvoiceForwardingSettings {
    isEnabled: boolean;
    emailAddresses: string[];
    mode: InvoiceForwardingMode;
    attachUbl: boolean;
    attachPdf: boolean;
    canForward: boolean;
}

export interface IInvoiceForwardingStatus {
    countSalesNotIgnoredNorForwarded: number;
}

export interface IInvoiceModel {
    patientId: string | undefined;
    companyId: string | undefined;
    reference: string | undefined;
    isAutoSelectReference: boolean;
    validUntil: Date;
    lines: ISalesLineModel[];
    recipientName: string | undefined;
    addressLine: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    country: string | undefined;
    fromLocationId: string;
    orderReference: string | undefined;
}

export interface IKeyDoubleValue {
    key: string | undefined;
    value: number;
}

export interface ILinkAllUnlinkedNoahUserSetupsRequest {
    clientId: string;
}

export interface ILinkAttendingAudiologistWithPatientModel {
    audiologistId: string;
    alsoUpdateAudiologistOnRunningProcesses: boolean;
}

export interface ILinkAudiologistWithRfiaModel {
    audiologistId: string;
    alsoUpdateAttendingAudiologistOnPatient: boolean;
}

export interface ILinkCustomerAccountWithExactOnlineAccountRequest {
    hamsId: string;
    exactOnlineAccountId: string;
}

export interface ILinkEazyworkKlantWithHamsPatientRequest {
    eazyworksKlantId: number;
    hamsPatientId: string;
}

export interface ILinkEntPhysicianModel {
    entPhysicianId: string;
    officeId: string | undefined;
}

export interface ILinkExactGlobeLocationRequest {
    hamsLocationId: string;
    exactGlobeCostCenterId: string;
}

export interface ILinkExactGlobeProductCatalogItemRequest {
    hamsProductCatalogItemId: string;
    exactGlobeCostUnitId: string;
}

export interface ILinkHamsUserToRosaHpRequest {
    rosaHpId: string | undefined;
    hamsUserId: string;
}

export interface ILinkLocationWithExactOnlineCostCenterRequest {
    locationId: string;
    exactOnlineCostCenterId: string;
}

export interface ILinkLocationWithPatientModel {
    locationId: string;
    alsoUpdateLocationOnRunningProcesses: boolean;
}

export interface ILinkLocationWithRfiaModel {
    locationId: string;
    alsoUpdateLocationOnPatient: boolean;
}

export interface ILinkNoahUserSetupRequest {
    noahUserSetupId: string;
    clientId: string;
}

export interface ILinkProductCatalogItemWithExactOnlineCostCenterRequest {
    productCatalogItemId: string;
    costCenterId: string;
}

export interface ILinkProductCatalogItemWithExactOnlineGLAccountRequest {
    productCatalogItemId: string;
    glAccountId: string;
}

export interface ILinkRepairWithPatientRequest {
    repairId: string;
    patientId: string;
}

export interface ILinkRosaPatientRecordToHamsPatientRequest {
    rosaPatientRecordId: string | undefined;
    hamsPatientId: string;
}

export interface ILinkViewContext {
    id: string;
    type: string | undefined;
}

export interface ILoan {
    id: string;
    created: Date;
    lastUpdated: Date;
    reference: string | undefined;
    fromLocation: IObjectWithIdAndIdentifier<string>;
    patient: IObjectWithIdAndIdentifier<string>;
    startDate: Date;
    stopDate: Date;
    onlyAdministrativeTrialEndDate: Date | undefined;
    endLoanStep: IEndLoanStep;
    lines: ILoanLine[];
    isCancelled: boolean;
    loanSlip: IDocumentSummary;
    linkViewContext: ILinkViewContext;
    hasReturnedItems: boolean;
    canReturnItems: boolean;
    status: string | undefined;
    hasLoanSlip: boolean;
    rfiaId: string | undefined;
    isSubProcess: boolean;
    hasEndWarning: boolean;
    forPatientId: string;
    forPatientIdentifier: string | undefined;
    countItems: number;
    actualStopDate: Date | undefined;
    progress: number;
    vatSplits: IVatSplit[];
    priceInVat: number;
    priceExVat: number;
    vatAmount: number;
    searchField: string | undefined;
    formattedContent: string | undefined;
    hasWarning: boolean;
    isCompleted: boolean;
    hasError: boolean;
    needsNowAfter: Date | undefined;
    storedNow: Date;
    storedNowPreviousToNeedsNowAfter: boolean;
}

export interface ILoanLine {
    id: string;
    productCatalogItemId: string;
    inventoryItemId: string | undefined;
    description: string | undefined;
    indexNumber: number;
    unitPrice: number;
    unitListPrice: number;
    vatPercentage: number;
    quantity: number;
    isVatIncluded: boolean;
    isInventoryItem: boolean;
    unitPriceInVat: number;
    unitListPriceInVat: number;
    linePriceInVat: number;
    lineListPriceInVat: number;
    unitPriceExVat: number;
    unitListPriceExVat: number;
    linePriceExVat: number;
    lineListPriceExVat: number;
    unitVatValue: number;
    lineVatValue: number;
    unitDiscountValueInVat: number;
    unitDiscountValueExVat: number;
    lineDiscountValueInVat: number;
    lineDiscountValueExVat: number;
    discountPercentage: number;
}

export interface ILoanSettings {
    defaultDuration: ITimeModel;
    referenceSettings: IReferenceSettings;
    id: string;
}

export interface ILoanSummary {
    id: string;
    linkViewContext: ILinkViewContext;
    startDate: Date;
    expectedStopDate: Date;
    onlyAdministrativeTrialEndDate: Date | undefined;
    loanEndDate: Date | undefined;
    loanSlipId: string | undefined;
    linkViewContextType: string | undefined;
    linkViewContextId: string | undefined;
    hasLoanSlip: boolean;
    isEnded: boolean;
    actualOrExpectedEndDate: Date;
    administrativeOrExpectedEndDate: Date;
    actualOrAdministrativeOrExpected: Date;
}

export interface ILoansExportParams {
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    statuses: string[];
    forPatientId: string | undefined;
    stopDateBefore: Date | undefined;
    stopDateAfter: Date | undefined;
    searchString: string;
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
    prefilter: LoansPrefilter;
}

export interface ILoansQueryParams {
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    statuses: string[];
    forPatientId: string | undefined;
    stopDateBefore: Date | undefined;
    stopDateAfter: Date | undefined;
    searchString: string;
    sortParams: ISortParams<ILoan>;
    pageParams: IPageParams;
    prefilter: LoansPrefilter;
}

export interface ILocation {
    id: string;
    created: Date;
    lastUpdated: Date;
    name: string | undefined;
    addressLine: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    country: string | undefined;
    isDeleted: boolean;
    rooms: IRoomData[];
    phone: string | undefined;
    email: string | undefined;
    isPlannable: boolean;
    searchField: string | undefined;
    addressFormatted: string | undefined;
    identifier: string;
    countRooms: number;
    hasRooms: boolean;
    roomIds: string[];
}

export interface ILocationModel {
    name: string | undefined;
    country: string | undefined;
    isPlannable: boolean;
    addressLine: string;
    zip: string;
    city: string;
}

export interface ILocationSummary {
    id: string;
    name: string | undefined;
    rooms: IRoomData[];
    isPlannable: boolean;
    countRooms: number;
    identifier: string;
}

export interface ILocationsCache {
    locations: ILocation[];
    nonDeletedSummaries: ILocationSummary[];
}

export interface ILoginInfo {
    user: IUserInfo;
    locationId: string;
}

export interface ILoginRequest {
    email: string;
    password: string;
}

export interface ILoginResponse {
    user: IUserInfo;
    errorEmail: string | undefined;
    errorPassword: string | undefined;
    locations: ILocationSummary[];
    hasError: boolean;
    mustSelectLocation: boolean;
}

export interface ILoginWithTokenRequest {
    email: string | undefined;
    token: string | undefined;
}

export interface ILoginWithTokenResponse {
    user: IUserInfo;
    error: string | undefined;
    locations: ILocationSummary[];
    hasError: boolean;
    mustSelectLocation: boolean;
}

export interface IMakeContactInfoPrimaryRequest {
    patientId: string;
    contactInfoId: string;
}

export interface IMakeEntPhysicianOfficeDefaultRequest {
    entPhysicianId: string;
    officeId: string;
}

export interface IMakeGeneralPractitionerOfficeDefaultRequest {
    generalPractitionerId: string;
    officeId: string;
}

export interface IMarkAssignedArticleAsHiddenRequest {
    patientId: string;
    articleId: string;
}

export interface IMarkAssignedArticleAsVisibleRequest {
    patientId: string;
    articleId: string;
}

export interface IMarkExactGlobeCustomerAccountAsExportedRequest {
    exactGlobeCustomerAccountId: string;
}

export interface IMarkExactGlobeCustomerAccountAsHandledRequest {
    exactGlobeCustomerAccountId: string;
}

export interface IMarkExactGlobeSaleAsExportedRequest {
    exactGlobeSaleId: string;
}

export interface IMarkExactGlobeSaleAsHandledRequest {
    exactGlobeSaleId: string;
}

export interface IMarkExportedExactGlobeCustomerAccountsAsHandledRequest {
}

export interface IMarkExportedExactGlobeSalesAsHandledRequest {
}

export interface IMarkInventoryItemAsDemoRequest {
    inventoryItemId: string;
}

export interface IMarkNotificationAsReadRequest {
    notificationId: string;
}

export interface IMarkNotificationsAsShownRequest {
    notificationIds: string[];
}

export interface IMarkPeppolAttemptAsFailedRequest {
    peppolRecordId: string;
    attemptId: string;
}

export interface IMarkTenderAsLostRequest {
    tenderId: string;
}

export interface IMedicalPrescriptionStep {
    id: string;
    sentDate: Date | undefined;
    expectedReceptionDate: Date | undefined;
    receptionDate: Date | undefined;
    prescriptionDate: Date | undefined;
    letterId: string | undefined;
    isApproved: boolean;
    hasReceived: boolean;
    hasLetter: boolean;
    hasSent: boolean;
    isDisapproved: boolean;
    canCreateLetter: boolean;
}

export interface IMedicalTreatmentFeeDto {
    code: string | undefined;
    nomenDescriptionNl: string | undefined;
    nomenDescriptionFr: string | undefined;
    validityStart: Date;
    validityEnd: Date | undefined;
    value: number;
    contribution: number;
    personalShare: number;
    hasValidityEnd: boolean;
}

export interface IMedicalTreatmentFeeModel {
    data: IMedicalTreatmentFeeDto;
    patientDescription: string | undefined;
    rizivDescription: string | undefined;
}

export interface IMedicalTreatmentNomenclatureForAudiology {
    data: IMedicalTreatmentNomenclatureWithCurrentFeeDto;
    code: string | undefined;
    validityStart: Date;
    validityEnd: Date | undefined;
    subArticle: string | undefined;
    isPseudoCode: boolean;
    isContraLateral: boolean;
    isHearingLossMoreThan35dB: boolean;
    isHearingLossMoreThan40dB: boolean;
    isSpeechAudiometryPossible: boolean;
    isLumpSumPassedAway: boolean;
    isLumpSumNegativeTrial: boolean;
    isLumpSum: boolean;
    isStereo: boolean;
    isMono: boolean;
    isBoneAnchorage: boolean;
    isSecondary: boolean;
    isMain: boolean;
    isAgeRestrictedToLessThan18Years: boolean;
    isAgeRestrictedBetween18And65Years: boolean;
    isAgeRestrictedToOlderThan65Years: boolean;
    isAgeRestrictedToOlderThan18Years: boolean;
    isAgeRestricted: boolean;
    searchField: string | undefined;
}

export interface IMedicalTreatmentNomenclatureWithCurrentFeeDto {
    validityStart: Date;
    validityEnd: Date | undefined;
    subArticle: string | undefined;
    subArticleDescriptionNl: string | undefined;
    subArticleDescriptionFr: string | undefined;
    fees: IMedicalTreatmentFeeDto[];
    code: string;
    descriptionNl: string;
    descriptionFr: string;
    isAmbulant: boolean;
    isHospitalized: boolean;
    hasValidityEnd: boolean;
    currentFee: IMedicalTreatmentFeeDto;
    isCurrentlyValid: boolean;
    currentFeeValue: number;
    currentFeeContribution: number;
    currentFeePersonalShare: number;
    hasCurrentFee: boolean;
}

export interface IMissingOrManuallyChangesDocumentsResponse {
    referencesWithoutDocument: string[];
    referencesWithManuallyChangedDocument: string[];
    hasReferencesWithoutDocument: boolean;
    hasReferencesWithManuallyChangedDocument: boolean;
    hasWarning: boolean;
}

export interface IMonoToneThresholdAudiogramTestModel {
    audiogramStandardId: string;
    data: IToneThresholdAudiogram;
    pointsForPta: number[];
}

export interface IMultipleFeesModel {
    codes: string[];
    date: Date;
}

export interface INamedProperty {
    property: string;
    text: string;
}

export interface INhaxExportModel {
    password: string | undefined;
}

export interface INhaxFileUploadModel {
    contentAsBase64: string | undefined;
    fileName: string;
    password: string | undefined;
}

export interface INhaxImportResponse {
    patientId: string;
    error: string | undefined;
    invalidPassword: boolean;
    resumeWithFileId: string;
    warning: string | undefined;
    needsAudiologistAndLocationId: boolean;
    hasError: boolean;
    hasWarning: boolean;
    isSuccess: boolean;
}

export interface INhaxResumeModel {
    resumeId: string;
    attendingAudiologistId: string;
    locationId: string;
    language: string | undefined;
}

export interface INhaxValidateResponse {
    resumeWithFileId: string;
    invalidPassword: boolean;
    error: string | undefined;
    warning: string | undefined;
    patientId: string | undefined;
    hasExistingPatient: boolean;
}

export interface INoahActionGroupDisplay {
    actions: INoahActionSummary[];
    noahActionGroup: Date | undefined;
    firstCreated: Date | undefined;
    firstManufacturer: string | undefined;
    firstDescription: string | undefined;
    firstIndex: number;
    firstUserInitials: string | undefined;
    actionIds: string[];
    areAllDeleted: boolean;
    singleDescriptionOrDefault: string | undefined;
    display: string | undefined;
}

export interface INoahActionReference {
    description: string | undefined;
    manufacturer: string | undefined;
    noahCreatedDate: Date | undefined;
    noahLastModifiedDate: Date | undefined;
}

export interface INoahActionSummary {
    id: string;
    index: number;
    description: string | undefined;
    userInitials: string | undefined;
    manufacturer: string | undefined;
    noahCreatedDate: Date | undefined;
    noahLastModifiedDate: Date | undefined;
    references: INoahActionReference[];
    isHamsDeleted: boolean;
}

export interface INoahDeviceDto {
    data: INoahDeviceInventoryItemMap;
    readOut: INoahDeviceReadOut;
    productCatalogItem: IProductCatalogItem;
    inventoryItem: IInventoryItem;
    hasInventoryItem: boolean;
    hasProductCatalogItem: boolean;
    canRegisterSale: boolean;
    canRegisterPurchase: boolean;
}

export interface INoahDeviceForPatient {
    manufacturer: string | undefined;
    instrumentTypeName: string | undefined;
    serialNumber: string | undefined;
    isHearingInstrument: boolean;
    usages: INoahDeviceUsage[];
    inventoryItemId: string | undefined;
    id: string;
    isLinkedToInventoryItem: boolean;
    orderedUsages: INoahDeviceUsage[];
    lastUsage: INoahDeviceUsage;
    lastSelectionDate: Date;
    manufacturerCommaInstrumentTypeName: string | undefined;
}

export interface INoahDeviceInventoryItemMap {
    serialNumber: string | undefined;
    created: Date;
    lastUpdated: Date;
    isHearingInstrument: boolean;
    usages: INoahDeviceUsage[];
    inventoryItemId: string | undefined;
    id: string;
    type: string | undefined;
    isLinkedToInventoryItem: boolean;
    hasUsages: boolean;
    isRemoteControl: boolean;
    readOuts: INoahDeviceReadOutData[];
    hasDifferentReadOuts: boolean;
    orderedUsages: INoahDeviceUsage[];
    patientIds: string[];
    patientIdentifiers: string[];
    lastUsage: INoahDeviceUsage;
    firstUsage: INoahDeviceUsage;
    firstUsageDate: Date | undefined;
    lastUsageDate: Date | undefined;
    lastReadOut: INoahDeviceReadOutData;
    manufacturer: string | undefined;
    instrumentTypeName: string | undefined;
    readOutsUniqueField: string[];
    formattedReadOutsUniqueField: string | undefined;
    searchField: string | undefined;
    manufacturerCommaInstrumentTypeName: string | undefined;
}

export interface INoahDeviceInventoryItemMapDetail {
    inventoryItemId: string | undefined;
    hasNoahUsages: boolean;
    patientFromLastUsage: IObjectWithIdAndIdentifier<string>;
    patientFromInventoryItem: IObjectWithIdAndIdentifier<string>;
    serialNumber: string;
    hasPatientFromLastUsage: boolean;
    hasPatientFromInventoryItem: boolean;
}

export interface INoahDeviceInventoryItemMapsQueryParams {
    searchString: string;
    sortParams: ISortParams<INoahDeviceInventoryItemMapDetail>;
    pageParams: IPageParams;
}

export interface INoahDeviceInventoryItemMapsWithUsagesExportParams {
    searchString: string;
    firstUsageBefore: Date | undefined;
    firstUsageAfter: Date | undefined;
    lastUsageBefore: Date | undefined;
    lastUsageAfter: Date | undefined;
    types: string[];
    isLinkedToInventoryItem: boolean | undefined;
    hasDifferentReadOuts: boolean | undefined;
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
}

export interface INoahDeviceInventoryItemMapsWithUsagesQueryParams {
    searchString: string;
    firstUsageBefore: Date | undefined;
    firstUsageAfter: Date | undefined;
    lastUsageBefore: Date | undefined;
    lastUsageAfter: Date | undefined;
    types: string[];
    isLinkedToInventoryItem: boolean | undefined;
    hasDifferentReadOuts: boolean | undefined;
    sortParams: ISortParams<INoahDeviceInventoryItemMap>;
    pageParams: IPageParams;
}

export interface INoahDeviceInventoryItemMapsWithUsagesSearchParams {
    searchString: string;
    sortParams: ISortParams<INoahDeviceInventoryItemMap>;
    pageParams: IPageParams;
    isLinkedWithInventoryItem: boolean | undefined;
}

export interface INoahDeviceReadOut {
    created: Date;
    lastUpdated: Date;
    manufacturer: string | undefined;
    instrumentTypeName: string | undefined;
    isHearingInstrument: boolean;
    productCatalogs: IReadOutRule[];
    lastReadOutDate: Date;
    isIgnored: boolean;
    id: string;
    type: string | undefined;
    status: string | undefined;
    manufacturerCommaModelFromProductCatalogs: string[];
    manufacturerCommaModelFromProductCatalogsCsv: string | undefined;
    nonDeletedProductCatalogIds: string[];
    lastNonDeletedProductCatalogId: string | undefined;
    isRemote: boolean;
    uniqueField: string | undefined;
    searchField: string | undefined;
    hasMultipleLinks: boolean;
    isLinkedToProductCatalog: boolean;
    isNotLinkedToProductCatalog: boolean;
    isSingleLinkedToProductCatalog: boolean;
    countNonDeletedProductCatalogIds: number;
    formattedManufacturerCommaModelFromProductCatalogs: string | undefined;
}

export interface INoahDeviceReadOutData {
    manufacturer: string | undefined;
    instrumentTypeName: string | undefined;
    uniqueField: string | undefined;
}

export interface INoahDeviceReadOutsQueryParams {
    searchString: string;
    sortParams: ISortParams<INoahDeviceReadOut>;
    pageParams: IPageParams;
    statuses: string[];
    lastReadOutDateBefore: Date | undefined;
    lastReadOutDateAfter: Date | undefined;
    types: string[];
    keyFilterStatus: string | undefined;
}

export interface INoahDeviceUsage {
    noahActionId: string;
    readOut: INoahDeviceReadOutData;
    noahActionDate: Date;
    patient: IObjectWithIdAndIdentifier<string>;
    isLeft: boolean;
    isRight: boolean;
    patientId: string;
    patientIdentifier: string | undefined;
}

export interface INoahDeviceUsageData {
    serialNumber: string | undefined;
    manufacturer: string | undefined;
    instrumentTypeName: string | undefined;
    actionCreatedDateFromNoah: Date;
    leftRightOrRemoteType: string | undefined;
    isLeft: boolean;
    isRight: boolean;
}

export interface INoahDeviceWithLastLinkedProductCatalogItem {
    data: INoahDeviceInventoryItemMap;
    lastLinked: IProductCatalogItem;
    hasLastLinked: boolean;
}

export interface INoahSessionSummary {
    date: Date;
    actionGroups: INoahActionGroupDisplay[];
    isDeleted: boolean;
}

export interface INoahUserSetup {
    id: string;
    created: Date;
    lastUpdated: Date;
    clientId: string | undefined;
    moduleId: number;
    attachmentId: string;
    isLinked: boolean;
}

export interface INoahUserSetupsQueryMetadata {
    countUnlinked: number;
    clientIds: string[];
    moduleIds: number[];
}

export interface INoahUserSetupsQueryParams {
    isLinked: boolean | undefined;
    clientIds: string[];
    moduleIds: number[];
    sortParams: ISortParams<INoahUserSetup>;
    pageParams: IPageParams;
}

export interface INotLinkedNorIgnoredNoahDeviceReadOutsQueryParams {
    searchString: string;
    sortParams: ISortParams<INoahDeviceReadOut>;
    pageParams: IPageParams;
}

export interface INotificationWithStatusDto {
    id: string;
    created: Date;
    title: string | undefined;
    description: string | undefined;
    readMoreLink: string | undefined;
    type: string | undefined;
    hasReadMoreLink: boolean;
    hasShown: boolean;
    isRead: boolean;
}

export interface INotificationsQueryParams {
    pageParams: IPageParams;
    searchString: string;
    types: string[];
    after: Date | undefined;
    before: Date | undefined;
}

export interface IOAuthOptionsObfuscated {
    clientId: string | undefined;
    clientSecretFirstFourChars: string | undefined;
    redirectUri: string | undefined;
    endpoint: string | undefined;
}

export interface IOAuthTokenObfuscated {
    accessTokenFirstFourChars: string | undefined;
    refreshTokenFirstFourChars: string | undefined;
    expiresIn: number;
    tokenType: string | undefined;
    issuedAt: Date;
    expiresAt: Date;
}

export interface IOfficeData {
    id: string;
    country: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    isDefault: boolean;
    isDeleted: boolean;
    addressLine: string;
    zip: string;
    city: string;
    formattedAddress: string | undefined;
    identifier: string;
}

export interface IOfficeModel {
    country: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    addressLine: string;
    zip: string;
    city: string;
}

export interface IOfficeSummary {
    id: string;
    identifier: string;
    isDefault: boolean;
}

export interface IOrderArticlesInquiryLineRequest {
    zeroBasedIndex: number;
    articlesInquiryLineId: string;
    quantity: number;
}

export interface IOrderArticlesInquiryRequest {
    articlesInquiryId: string;
    supplierId: string;
    locationId: string;
    isAutoSelectReference: boolean;
    reference: string | undefined;
    externalReference: string | undefined;
    expectedDeliveryDate: Date;
    lines: IOrderArticlesInquiryLineRequest[];
    placeOrderImmediately: boolean;
    handlingUserId: string;
}

export interface IOrderDeliveryData {
    id: string;
    date: Date;
    reference: string | undefined;
    dispatchReference: string | undefined;
    dispatchDate: Date | undefined;
    location: IObjectWithIdAndIdentifier<string>;
    hasDispatchReference: boolean;
    hasDispatchDate: boolean;
}

export interface IOrderExportParams {
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    supplierIds: string[];
    statuses: string[];
    handlingUserIds: string[];
    locationIds: string[];
    patientId: string | undefined;
    isCompletelyDelivered: boolean | undefined;
    deliveredBefore: Date | undefined;
    deliveredAfter: Date | undefined;
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
    prefilter: OrderPrefilter;
}

export interface IOrderLineDtoForRegisterDelivery {
    data: IOrderLineV2;
    productCatalogItem: IProductCatalogItem;
    inventoryItem: IInventoryItem;
}

export interface IOrderLineV2 {
    id: string;
    productCatalogItem: IObjectWithIdAndIdentifier<string>;
    inventoryItemId: string | undefined;
    quantity: number;
    isUniquelyIdentifiable: boolean;
    description: string | undefined;
    indexNumber: number;
    patient: IObjectWithIdAndIdentifier<string>;
    deliveries: IOrderLineV2DeliveryData[];
    articlesInquiryId: string | undefined;
    articlesInquiryLineId: string | undefined;
    isCancelled: boolean;
    status: string | undefined;
    deliveredQuantity: number;
    remainingQuantity: number;
    isCompletelyDelivered: boolean;
    productCatalogItemId: string;
    patientId: string | undefined;
    patientIdentifier: string | undefined;
    deliveryIds: string[];
    hasPatient: boolean;
}

export interface IOrderLineV2DeliveryData {
    deliveryId: string;
    deliveryLineId: string;
    quantity: number;
}

export interface IOrderLineWithInventoryItem {
    data: IOrderLineV2;
    inventoryItem: IInventoryItem;
    patientReference: string | undefined;
    patient: IObjectWithIdAndIdentifier<string>;
    hasInventroyItem: boolean;
}

export interface IOrderSettings {
    defaultDeliveryTime: ITimeModel;
    referenceSettings: IReferenceSettings;
    id: string;
}

export interface IOrderV2 {
    id: string;
    created: Date;
    lastUpdated: Date;
    reference: string | undefined;
    externalReference: string | undefined;
    expectedDeliveryDate: Date;
    supplier: IObjectWithIdAndIdentifier<string>;
    location: IObjectWithIdAndIdentifier<string>;
    lines: IOrderLineV2[];
    deliveries: IOrderDeliveryData[];
    isCancelled: boolean;
    handlingUserId: string;
    placedWithSupplierDate: Date | undefined;
    canUndoPlaceWithSupplier: boolean;
    canAddOrDeleteLines: boolean;
    isPlacedWithSupplier: boolean;
    patients: IObjectWithIdAndIdentifier<string>[];
    patientIds: string[];
    patientIdentifiers: string[];
    isForSinglePatient: boolean;
    singlePatient: IObjectWithIdAndIdentifier<string>;
    singlePatientId: string | undefined;
    singlePatientIdentifier: string | undefined;
    patientIdentifiersCsv: string | undefined;
    isOverDue: boolean;
    wasOverDue: boolean;
    status: string | undefined;
    firstActualDeliveryDate: Date | undefined;
    lastActualDeliveryDate: Date | undefined;
    isDeliveredInMultipleSteps: boolean;
    isCompletelyDelivered: boolean;
    isPartialDelivered: boolean;
    deliveryDates: Date[];
    supplierId: string;
    supplierIdentifier: string | undefined;
    countItems: number;
    locationId: string;
    locationIdentifier: string | undefined;
    canCancel: boolean;
    canPlaceWithSupplier: boolean;
    searchField: string | undefined;
    canRegisterDelivery: boolean;
    progress: number;
    formattedContent: string | undefined;
    hasWarning: boolean;
    isCompleted: boolean;
    hasError: boolean;
    needsNowAfter: Date | undefined;
    storedNow: Date;
    storedNowPreviousToNeedsNowAfter: boolean;
}

export interface IOrdersQueryMetadata {
    count: number;
    countNotDelivered: number;
    countOverdue: number;
    countNotPlacedWithSupplier: number;
}

export interface IOrdersQueryParams {
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    supplierIds: string[];
    statuses: string[];
    handlingUserIds: string[];
    locationIds: string[];
    patientId: string | undefined;
    isCompletelyDelivered: boolean | undefined;
    deliveredBefore: Date | undefined;
    deliveredAfter: Date | undefined;
    sortParams: ISortParams<IOrderV2>;
    pageParams: IPageParams;
    prefilter: OrderPrefilter;
}

export interface IOrientationModel {
    left: number;
    right: number;
    bothEarsWithDevices: number;
    bothEarsWithoutDevices: number;
}

export interface IOrientationTest {
    date: Date;
    left: number;
    right: number;
    bothEarsWithDevices: number;
    bothEarsWithoutDevices: number;
}

export interface IPageParams {
    index: number;
    size: number;
}

export interface IPatchAppLogoutModeRequest {
    mode: ApplicationLogoutMode;
}

export interface IPatchArticlePropertiesOnInventoryItemRequest {
    inventoryItemId: string;
    articleProperties: IArticlePropertyModel[];
}

export interface IPatchArticlesInquiryHandlingUserRequest {
    articlesInquiryId: string;
    userId: string;
}

export interface IPatchAttachPdfInvoiceForwardingSettingsRequest {
    attach: boolean;
}

export interface IPatchAttachUblInvoiceForwardingSettingsRequest {
    attach: boolean;
}

export interface IPatchAutoSetSalesToPaidRequest {
    autoSetToPaid: boolean;
}

export interface IPatchBankAccountRequest {
    iban: string | undefined;
    bic: string | undefined;
}

export interface IPatchBusinessDataMainUserRequest {
    mainUserId: string;
}

export interface IPatchBusinessDataRequest {
    name: string | undefined;
    website: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    vatNumber: string | undefined;
    enterpriseNumber: string | undefined;
}

export interface IPatchCashSalesReferenceSettingsRequest {
    prefix: string | undefined;
    withYear: boolean;
    separator: string | undefined;
    countLeadingZeros: number;
    isShortYearFormat: boolean;
}

export interface IPatchClientClaimsRequest {
    clientClaims: string[];
}

export interface IPatchCochlearPatientBimodallyFittedDateRequest {
    id: string;
    date: Date | undefined;
}

export interface IPatchCochlearPatientImplantedDateRequest {
    id: string;
    date: Date | undefined;
}

export interface IPatchCochlearPatientInformedDateRequest {
    id: string;
    date: Date | undefined;
}

export interface IPatchCochlearPatientReferralCenterRequest {
    id: string;
    referralCenterId: string | undefined;
}

export interface IPatchCochlearPatientReferralDateRequest {
    id: string;
    date: Date | undefined;
}

export interface IPatchConsignmentReturnBeforeDateOnInventoryItemRequest {
    inventoryItemId: string;
    date: Date;
}

export interface IPatchDefaultVatPercentageChargerRequest {
    vatPercentage: number;
}

export interface IPatchDefaultVatPercentageHearingAidsRequest {
    vatPercentage: number;
}

export interface IPatchDeliveryDateRequest {
    deliveryId: string;
    deliveryDate: Date;
}

export interface IPatchDeliveryDispatchInfoRequest {
    deliveryId: string;
    dispatchReference: string | undefined;
    dispatchDate: Date;
}

export interface IPatchDeliveryExternalReferenceRequest {
    deliveryId: string;
    externalReference: string | undefined;
}

export interface IPatchDeliveryReferenceSettingsRequest {
    prefix: string | undefined;
    withYear: boolean;
    separator: string | undefined;
    countLeadingZeros: number;
    isShortYearFormat: boolean;
}

export interface IPatchEntPhysicianOfficeAddressRequest {
    entPhysicianId: string;
    officeId: string;
    address: IAddressModel;
}

export interface IPatchEntPhysicianOfficeEmailRequest {
    entPhysicianId: string;
    officeId: string;
    email: string | undefined;
}

export interface IPatchEntPhysicianOfficePhoneRequest {
    entPhysicianId: string;
    officeId: string;
    phone: string | undefined;
}

export interface IPatchEntPhysicianPersonalInformationRequest {
    entPhysicianId: string;
    salutation: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    gender: string | undefined;
}

export interface IPatchEntPhysicianRizivNumberRequest {
    entPhysicianId: string;
    rizivNumber: string | undefined;
}

export interface IPatchExactGlobeCostCenterRequest {
    id: string;
    code: string | undefined;
    description: string | undefined;
}

export interface IPatchExactGlobeCostUnitRequest {
    id: string;
    code: string | undefined;
    description: string | undefined;
}

export interface IPatchExactGlobeCustomerAccountDebtorCodeRequest {
    exactGlobeCustomerAccountId: string;
    debtorCode: string | undefined;
}

export interface IPatchExactGlobeDivisionCodeRequest {
    divisionCode: string | undefined;
}

export interface IPatchExactGlobeFallbackCostUnitRequest {
    fallbackCostUnit: string | undefined;
}

export interface IPatchExactGlobeGLAccountCodeRequest {
    glAccountCode: string | undefined;
}

export interface IPatchExactGlobeJournalCodeRequest {
    journalCode: string | undefined;
}

export interface IPatchExactGlobeSettingsRequest {
    divisionCode: string | undefined;
    journalCode: string | undefined;
    glAccountCode: string | undefined;
    fallbackCostUnit: string | undefined;
}

export interface IPatchExactOnlineBaseUrlRequest {
    baseUrl: string | undefined;
}

export interface IPatchExactOnlineCostCenterModeRequest {
    mode: ExactOnlineCostCenterMode;
}

export interface IPatchExactOnlineDivisionRequest {
    division: number;
}

export interface IPatchExactOnlineFallbackGLAccountRequest {
    vatPercentage: number;
    glAccountId: string;
}

export interface IPatchExactOnlineGLAccountMatchModeRequest {
    matchMode: ExactOnlineGLAccountMatchMode;
}

export interface IPatchExactOnlineJournalRequest {
    journal: string | undefined;
}

export interface IPatchGeneralPractitionerOfficeAddressRequest {
    generalPractitionerId: string;
    officeId: string;
    address: IAddressModel;
}

export interface IPatchGeneralPractitionerOfficeEmailRequest {
    generalPractitionerId: string;
    officeId: string;
    email: string | undefined;
}

export interface IPatchGeneralPractitionerOfficePhoneRequest {
    generalPractitionerId: string;
    officeId: string;
    phone: string | undefined;
}

export interface IPatchGeneralPractitionerPersonalInformationRequest {
    generalPractitionerId: string;
    salutation: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    gender: string | undefined;
}

export interface IPatchGeneralPractitionerRizivNumberRequest {
    generalPractitionerId: string;
    rizivNumber: string | undefined;
}

export interface IPatchHifAdvisoryPhysicianAddressRequest {
    hifCode: string | undefined;
    isUseSame: boolean;
    address: IAddressModel;
}

export interface IPatchHifThirdPartyPayerArrangementAddressRequest {
    hifCode: string | undefined;
    isUseSame: boolean;
    address: IAddressModel;
}

export interface IPatchInventoryItemDispatchInfoRequest {
    inventoryItemId: string;
    reference: string | undefined;
    date: Date;
}

export interface IPatchInventoryItemManualWarrantyEndDateRequest {
    inventoryItemId: string;
    warrantyEndDate: Date;
}

export interface IPatchInventoryItemRizivHearingAidDefinitionV2IdentificationCodeRequest {
    inventoryItemId: string;
    rizivHearingAidDefinitionV2IdentificationCode: number;
}

export interface IPatchInventoryItemsLabelsRequest {
    inventoryItemId: string;
    labels: string[];
}

export interface IPatchInvoiceForwardingModeRequest {
    mode: InvoiceForwardingMode;
}

export interface IPatchLoanDefaultDurationRequest {
    defaultDuration: ITimeModel;
}

export interface IPatchLoanReferenceSettingsRequest {
    prefix: string | undefined;
    withYear: boolean;
    separator: string | undefined;
    countLeadingZeros: number;
    isShortYearFormat: boolean;
}

export interface IPatchLoanStopDateRequest {
    trialId: string;
    stopDate: Date;
}

export interface IPatchLocationAddressRequest {
    locationId: string;
    model: IAddressModel;
}

export interface IPatchLocationEmailRequest {
    locationId: string;
    email: string | undefined;
}

export interface IPatchLocationIsPlannableRequest {
    locationId: string;
    isPlannable: boolean;
}

export interface IPatchLocationNameRequest {
    locationId: string;
    name: string | undefined;
}

export interface IPatchLocationPhoneRequest {
    locationId: string;
    phone: string | undefined;
}

export interface IPatchNoahDeviceReadOutModeRequest {
    mode: string | undefined;
}

export interface IPatchOrderDefaultDeliveryTimeRequest {
    defaultDeliveryTime: ITimeModel;
}

export interface IPatchOrderExpectedDeliveryDateRequest {
    orderId: string;
    expectedDeliveryDate: Date;
}

export interface IPatchOrderExternalReferenceRequest {
    orderId: string;
    externalReference: string | undefined;
}

export interface IPatchOrderHandlingUserRequest {
    orderId: string;
    userId: string;
}

export interface IPatchOrderReferenceSettingsRequest {
    prefix: string | undefined;
    withYear: boolean;
    separator: string | undefined;
    countLeadingZeros: number;
    isShortYearFormat: boolean;
}

export interface IPatchOrientationOfAssignedArticleRequest {
    patientId: string;
    articleId: string;
    orientation: string | undefined;
}

export interface IPatchPatientBsnRequest {
    patientId: string;
    bsn: string | undefined;
}

export interface IPatchPatientContactInfoRequest {
    patientId: string;
    contactInfoId: string;
    value: string | undefined;
    description: string | undefined;
    phoneNumberRegion: PhoneNumberRegion;
}

export interface IPatchPatientDetailOverviewLayoutPreferencesRequest {
    leftElements: string[];
    rightElements: string[];
}

export interface IPatchPatientLanguageRequest {
    patientId: string;
    language: string | undefined;
}

export interface IPatchPatientMissingPropertiesRequest {
    patientId: string;
    dateOfBirth: Date | undefined;
    zip: string | undefined;
    city: string | undefined;
    addressLine: string | undefined;
    country: string | undefined;
    phone: string | undefined;
    phoneNumberRegion: PhoneNumberRegion;
    email: string | undefined;
    socialSecurityNumber: string | undefined;
    onLocationId: string | undefined;
    attendingAudiologistId: string | undefined;
    attendingEntPhysicianId: string | undefined;
    attendingGeneralPractitionerId: string | undefined;
    origins: string[];
    hifCode: string | undefined;
    labels: string[];
    fromMissingProperties: string[];
    reference: string | undefined;
}

export interface IPatchPatientOriginalNoRequest {
    patientId: string;
    originalNo: string | undefined;
}

export interface IPatchPatientReferenceRequest {
    patientId: string;
    reference: string | undefined;
}

export interface IPatchPatientsReferenceSettingsRequest {
    prefix: string | undefined;
    withYear: boolean;
    separator: string | undefined;
    countLeadingZeros: number;
    isShortYearFormat: boolean;
}

export interface IPatchPatientsRequiredPropertiesRequest {
    requiredProperties: string[];
}

export interface IPatchPatientsSettingsAutoFillReferenceRequest {
    autoFillReference: boolean;
}

export interface IPatchPaymentMethodNameRequest {
    paymentMethodId: string;
    name: string | undefined;
}

export interface IPatchPeppolSettingsRequest {
    autoSend: boolean;
    waitForDocument: boolean;
}

export interface IPatchProductCatalogItemArticlePropertyDefinitionsRequest {
    productCatalogItemId: string;
    lines: IArticlePropertyDefinitionModel[];
    alsoApplyOnIds: string[];
}

export interface IPatchProductCatalogItemBebatUnitPriceRequest {
    productCatalogItemId: string;
    bebatUnitPriceInVat: number;
}

export interface IPatchProductCatalogItemCanAlsoPurchaseRequest {
    productCatalogItemId: string;
    canAlsoPurchase: boolean;
}

export interface IPatchProductCatalogItemCategoriesRequest {
    productCatalogItemId: string;
    category: string | undefined;
    subcategory: string | undefined;
}

export interface IPatchProductCatalogItemDefaultWarrantyRequest {
    productCatalogItemId: string;
    unit: string | undefined;
    value: number;
}

export interface IPatchProductCatalogItemHasBatteriesRequest {
    productCatalogItemId: string;
    hasBatteries: boolean;
}

export interface IPatchProductCatalogItemHearingAidDataRequest {
    productCatalogItemId: string;
    type: string | undefined;
    batteryType: string | undefined;
    hasSeparateEarmould: boolean;
    hasSeparateReceiver: boolean;
}

export interface IPatchProductCatalogItemInsuranceOrProlongedWarrantyTermRequest {
    productCatalogItemId: string;
    unit: string | undefined;
    value: number;
    isUnlimited: boolean;
}

export interface IPatchProductCatalogItemInternalReferenceRequest {
    productCatalogItemId: string;
    internalReference: string | undefined;
}

export interface IPatchProductCatalogItemIsElectronicsRequest {
    productCatalogItemId: string;
    isElectronics: boolean;
}

export interface IPatchProductCatalogItemLabelsRequest {
    productCatalogItemId: string;
    labels: string[];
}

export interface IPatchProductCatalogItemManufacturerAndModelRequest {
    productCatalogItemId: string;
    manufacturer: string | undefined;
    model: string | undefined;
}

export interface IPatchProductCatalogItemManufacturerReferencesRequest {
    productCatalogItemId: string;
    manufacturerReferences: string[];
}

export interface IPatchProductCatalogItemNameRequest {
    productCatalogItemId: string;
    name: string | undefined;
}

export interface IPatchProductCatalogItemPurchaseListPriceRequest {
    productCatalogItemId: string;
    listPrice: number;
}

export interface IPatchProductCatalogItemRecupelCodeRequest {
    productCatalogItemId: string;
    recupelCode: string | undefined;
}

export interface IPatchProductCatalogItemRizivHearingAidDefinitionV2IdentificationCodesRequest {
    productCatalogItemId: string;
    rizivHearingAidDefinitionV2IdentificationCodes: number[];
}

export interface IPatchProductCatalogItemSalesListPriceRequest {
    productCatalogItem: string;
    listPrice: number;
}

export interface IPatchProductCatalogItemSuppliersRequest {
    productCatalogItemId: string;
    supplierIds: string[];
}

export interface IPatchProductCatalogItemTypeRequest {
    productCatalogItemId: string;
    type: ProductCatalogItemType;
}

export interface IPatchProductCatalogItemVatPercentageRequest {
    productCatalogItemId: string;
    vatPercentage: number;
}

export interface IPatchPurchaseDefaultValidUntilRequest {
    defaultValidUntil: ITimeModel;
}

export interface IPatchPurchaseExternalReferenceRequest {
    purchaseId: string;
    externalReference: string | undefined;
}

export interface IPatchPurchaseLabelsRequest {
    purchaseId: string;
    labels: string[];
}

export interface IPatchPurchasePayBeforeDateRequest {
    purchaseId: string;
    payBeforeDate: Date;
}

export interface IPatchPurchaseReferenceDateRequest {
    purchaseId: string;
    referenceDate: Date;
}

export interface IPatchPurchaseReferenceSettingsRequest {
    prefix: string | undefined;
    withYear: boolean;
    separator: string | undefined;
    countLeadingZeros: number;
    isShortYearFormat: boolean;
}

export interface IPatchRepairDefaultExpectedReturnTimeRequest {
    defaultExpectedReturnTime: ITimeModel;
}

export interface IPatchRepairExpectedHandoverDateRequest {
    repairId: string;
    expectedHandoverDate: Date;
}

export interface IPatchRepairExpectedRedeliveryDateRequest {
    repairId: string;
    expectedRedeliveryDate: Date;
}

export interface IPatchRepairExternalReferenceRequest {
    repairId: string;
    externalReference: string | undefined;
}

export interface IPatchRepairHandlingUserRequest {
    repairId: string;
    handlingUserId: string;
}

export interface IPatchRepairReferenceRequest {
    repairId: string;
    reference: string | undefined;
}

export interface IPatchRepairReferenceSettingsRequest {
    prefix: string | undefined;
    withYear: boolean;
    separator: string | undefined;
    countLeadingZeros: number;
    isShortYearFormat: boolean;
}

export interface IPatchRepairStepsRequest {
    repairId: string;
    steps: string[];
}

export interface IPatchReturnDateRequest {
    returnId: string;
    returnDate: Date;
}

export interface IPatchReturnExternalReferenceRequest {
    returnId: string;
    externalReference: string | undefined;
}

export interface IPatchReturnReferenceSettingsRequest {
    prefix: string | undefined;
    withYear: boolean;
    separator: string | undefined;
    countLeadingZeros: number;
    isShortYearFormat: boolean;
}

export interface IPatchRfiaDefaultAdvisoryPhysicianExpectedReceptionTermRequest {
    timeModel: ITimeModel;
}

export interface IPatchRfiaDefaultExpectedHandoverTermAfterApprovalRequest {
    timeModel: ITimeModel;
}

export interface IPatchRfiaDefaultFailedTrialVatPercentageRequest {
    vatPercentage: number;
}

export interface IPatchRfiaDefaultInvoiceProcessStepsRequest {
    defaultInvoiceProcessSteps: string[];
}

export interface IPatchRfiaDefaultMedicalPrescriptionExpectedReceptionTermRequest {
    timeModel: ITimeModel;
}

export interface IPatchRfiaDefaultRizivRefundVatPercentageRequest {
    vatPercentage: number;
}

export interface IPatchRfiaDefaultThirdPartySchemeRequest {
    defaultApply: boolean;
}

export interface IPatchRfiaDefaultTrialDurationRequest {
    timeModel: ITimeModel;
}

export interface IPatchRfiaHandoverLineRequest {
    rfiaId: string;
    lineId: string;
    isRefundable: boolean;
    rizivHearingAidDefinitionIdentificationCode: number | undefined;
    isIncludeOnHandoverCertificate: boolean;
    manufacturer: string | undefined;
    model: string | undefined;
}

export interface IPatchRfiaHandoverSaleGenerationModeRequest {
    mode: string | undefined;
}

export interface IPatchRfiaReferenceSettingsRequest {
    prefix: string | undefined;
    withYear: boolean;
    separator: string | undefined;
    countLeadingZeros: number;
    isShortYearFormat: boolean;
}

export interface IPatchRosaHamsSyncRecordRequest {
    patientLastUpdatedSince: Date;
    eventsLastUpdatedSince: Date;
}

export interface IPatchSaleExternalReferenceRequest {
    salesId: string;
    externalReference: string | undefined;
}

export interface IPatchSaleLabelsRequest {
    salesId: string;
    labels: string[];
}

export interface IPatchSaleOrderReferenceRequest {
    salesId: string;
    orderReference: string | undefined;
}

export interface IPatchSalesDefaultValidUntilDateRequest {
    defaultValidUntilTimeModel: ITimeModel;
}

export interface IPatchSalesInvoiceReferenceSettingsRequest {
    prefix: string | undefined;
    withYear: boolean;
    separator: string | undefined;
    countLeadingZeros: number;
    isShortYearFormat: boolean;
}

export interface IPatchStockMovementReferenceSettingsRequest {
    prefix: string | undefined;
    withYear: boolean;
    separator: string | undefined;
    countLeadingZeros: number;
    isShortYearFormat: boolean;
}

export interface IPatchSupplierAccountNumberRequest {
    supplierId: string;
    accountNumber: string | undefined;
}

export interface IPatchSupplierAddressRequest {
    supplierId: string;
    address: IAddressModel;
}

export interface IPatchSupplierBrandsRequest {
    supplierId: string;
    brands: string[];
}

export interface IPatchSupplierContactPersonRequest {
    supplierId: string;
    contact: IContactModel;
}

export interface IPatchSupplierDefaultDeliveryTimeRequest {
    supplierId: string;
    defaultDeliveryTime: ITimeModel;
}

export interface IPatchSupplierEmailRequest {
    supplierId: string;
    email: string | undefined;
}

export interface IPatchSupplierNameRequest {
    supplierId: string;
    name: string | undefined;
}

export interface IPatchSupplierVatNumberRequest {
    supplierId: string;
    vatNumber: string | undefined;
}

export interface IPatchTailorMadeForPatientOnInventoryItemRequest {
    inventoryItemId: string;
    patientId: string;
}

export interface IPatchTenderDefaultValidUntilRequest {
    defaultValidUntil: ITimeModel;
}

export interface IPatchTenderReferenceSettingsRequest {
    prefix: string | undefined;
    withYear: boolean;
    separator: string | undefined;
    countLeadingZeros: number;
    isShortYearFormat: boolean;
}

export interface IPatchUserCalendarColorRequest {
    userId: string;
    color: string | undefined;
}

export interface IPatchUserEmailRequest {
    userId: string;
    email: string | undefined;
}

export interface IPatchUserFunctionalClaimsRequest {
    userId: string;
    functionalClaims: string[];
}

export interface IPatchUserIsPlannableRequest {
    userId: string;
    isPlannable: boolean;
}

export interface IPatchUserNameRequest {
    userId: string;
    salutation: string | undefined;
    firstName: string;
    lastName: string;
}

export interface IPatchUserPageClaimsRequest {
    userId: string;
    pageClaims: string[];
}

export interface IPatchUserPasswordRequest {
    userId: string;
    oldPassword: string;
    newPassword: string;
}

export interface IPatchUserPreferredLocationRequest {
    userId: string;
    preferredLocationId: string;
}

export interface IPatchUserRizivNumberRequest {
    userId: string;
    rizivNumber: string | undefined;
}

export interface IPatchUserRoleRequest {
    userId: string;
    role: UserRole;
}

export interface IPatchVatCustomerAddressRequest {
    vatCustomerId: string;
    address: IAddressModel;
}

export interface IPatchVatCustomerContactInfoRequest {
    vatCustomerId: string;
    contactInfo: IContactModel;
}

export interface IPatchVatCustomerEmailRequest {
    vatCustomerId: string;
    email: string | undefined;
}

export interface IPatchVatCustomerNameRequest {
    vatCustomerId: string;
    name: string | undefined;
}

export interface IPatchVatCustomerPhoneRequest {
    vatCustomerId: string;
    phone: string | undefined;
}

export interface IPatchVatCustomerVatNumberRequest {
    vatCustomerId: string;
    vatNumber: string | undefined;
}

export interface IPatient {
    id: string;
    created: Date;
    lastUpdated: Date;
    firstName: string | undefined;
    lastName: string | undefined;
    gender: string | undefined;
    dateOfBirth: Date | undefined;
    salutation: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    addressLine: string | undefined;
    country: string | undefined;
    socialSecurityNumber: string | undefined;
    eidData: IEidDataWithoutPhoto;
    eidDataLastRead: Date | undefined;
    createdByUserId: string;
    healthInsuranceFundCode: string | undefined;
    healthInsuranceSetDate: Date | undefined;
    attendingAudiologist: IObjectWithIdAndIdentifier<string>;
    location: IObjectWithIdAndIdentifier<string>;
    attendingGeneralPractitioner: IObjectWithIdAndIdentifier<string>;
    attendingEntPhysician: IObjectWithIdAndIdentifier<string>;
    photoAttachmentId: string | undefined;
    isDeceased: boolean;
    isMarkedAsInactive: boolean;
    origins: string[];
    renewalInfo: IRenewalInfo;
    contactPerson: IContactPerson;
    nickName: string | undefined;
    labels: string[];
    contactInfos: IContactInfo[];
    language: string | undefined;
    reference: string | undefined;
    originalPatientNo: string | undefined;
    bsn: string | undefined;
    formattedSocialSecurityNumber: string | undefined;
    isValidSocialSecurityNumber: boolean;
    hasSocialSecurityNumber: boolean;
    lastHandoverDate: Date | undefined;
    canRenewAfter: Date | undefined;
    originsCsv: string | undefined;
    labelsCsv: string | undefined;
    status: string | undefined;
    isActive: boolean;
    attendingAudiologistIdentifier: string | undefined;
    locationIdentifier: string | undefined;
    attendingGeneralPractitionerIdentifier: string | undefined;
    attendingEntPhysicianIdentifier: string | undefined;
    attendingAudiologistId: string | undefined;
    locationId: string | undefined;
    attendingGeneralPractitionerId: string | undefined;
    attendingEntPhysicianId: string | undefined;
    monthOfBirth: number | undefined;
    dobSearchField: string | undefined;
    addressFormatted: string | undefined;
    hasDobSet: boolean;
    hasEidData: boolean;
    age: number;
    phoneNumbersDisplay: string | undefined;
    search: IPatientSearch;
    hasPhoneContactInformation: boolean;
    hasEmailContactInformation: boolean;
    hasAddressInformation: boolean;
    phoneSearchField: string | undefined;
    searchField: string | undefined;
    hasHealthInsuranceFundSet: boolean;
    lastNameCommaFirstNameBracketsNickName: string | undefined;
    lastNameCommaFirstNameBracketsNickNameSearchField: string | undefined;
    identifier: string;
    hasRenewalDate: boolean;
    renewalTermInYears: number;
    noahCompareLastUpdated: Date;
    hasContactPerson: boolean;
    phone: string | undefined;
    email: string | undefined;
    nameKey: string | undefined;
}

export interface IPatientActualNoahDevices {
    leftHearingInstrument: INoahDeviceUsageData;
    rightHearingInstrument: INoahDeviceUsageData;
    remoteControl: INoahDeviceUsageData;
    hasLeftHis: boolean;
    hasRightHist: boolean;
    hasRemote: boolean;
}

export interface IPatientDetail {
    patient: IPatient;
    missingProperties: string[];
    photo: IPatientPhoto;
    hasCustomerAccount: boolean;
    countNonFollowUpAnnotations: number;
    countFollowUpAnnotations: number;
    countSales: number;
    countWorkflows: number;
    countActiveWorkflows: number;
    countWorkflowsWithWarning: number;
    countWorkflowsWithError: number;
    countTenders: number;
    countDocuments: number;
    countAppointments: number;
    countUpcomingAppointments: number;
    hasWiniproData: boolean;
    hasAcousoftData: boolean;
    hasEazyworksData: boolean;
    showCiCandidateLabel: boolean;
    hasEidDataAndIsValid: boolean;
    countPastAppointments: number;
}

export interface IPatientDetailOverviewLayoutViewPreferences {
    leftElements: string[];
    rightElements: string[];
}

export interface IPatientEidModel {
    eidData: IEidData;
    attendingAudiologistId: string;
    locationId: string;
    language: string | undefined;
}

export interface IPatientFilterMedicalTreatmentDto {
    isSpeechPossible: boolean | undefined;
    age: number | undefined;
    isHearingLossMoreThan35dB: boolean | undefined;
    isStereo: boolean | undefined;
    isAmbulant: boolean | undefined;
}

export interface IPatientMatchSummary {
    id: string;
    gender: string | undefined;
    lastNameCommaFirstNameBracketsNickName: string | undefined;
    phoneNumber: string | undefined;
    addressFormatted: string | undefined;
    socialSecurityNumber: string | undefined;
    dateOfBirth: Date | undefined;
    isLinkedToARosaPatient: boolean;
}

export interface IPatientModel {
    salutation: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    socialSecurityNumber: string | undefined;
    gender: string | undefined;
    dateOfBirth: Date | undefined;
    nickName: string | undefined;
    attendingAudiologistId: string;
    locationId: string;
    language: string | undefined;
}

export interface IPatientNoahDataIndicesDebugInfo {
    patientId: string;
    patientIndex: number | undefined;
    indexExists: boolean;
    rIndexExists: boolean;
    noahActions: IShadowIndexDebugInfo[];
    noahSessions: IShadowIndexDebugInfo[];
    hasPatientIndexError: boolean;
    hasError: boolean;
}

export interface IPatientNoahSessionsDto {
    patientIndex: number;
    noahSessions: INoahSessionSummary[];
    hasIndexError: boolean;
}

export interface IPatientPersonalInformationModel {
    salutation: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    socialSecurityNumber: string | undefined;
    gender: string | undefined;
    dateOfBirth: Date | undefined;
    nickName: string | undefined;
}

export interface IPatientPhoto {
    data: string | undefined;
    hasPhoto: boolean;
}

export interface IPatientSearch {
    id: string;
    gender: string | undefined;
    lastNameCommaFirstNameBracketsNickName: string | undefined;
    phoneNumber: string | undefined;
    addressFormatted: string | undefined;
    socialSecurityNumber: string | undefined;
    dateOfBirth: Date | undefined;
}

export interface IPatientSearchModel {
    mode: string | undefined;
    searchString: string;
}

export interface IPatientSettings {
    requiredProperties: string[];
    referenceSettings: IReferenceSettings;
    autoFillReference: boolean;
    id: string;
}

export interface IPatientSummary {
    id: string;
    created: Date;
    lastUpdated: Date;
    dateOfBirth: Date | undefined;
    status: string | undefined;
    canRenewAfter: Date | undefined;
    lastHandoverDate: Date | undefined;
    phoneNumbersDisplay: string | undefined;
    socialSecurityNumber: string | undefined;
    addressFormatted: string | undefined;
    labels: string[];
    reference: string | undefined;
    firstName: string;
    lastName: string;
    gender: string;
    lastNameCommaFirstNameBracketsNickName: string;
}

export interface IPatientWithIdAndNameKeyDto {
    id: string;
    nameKey: string | undefined;
}

export interface IPatientsExportParams {
    searchString: string;
    statuses: string[];
    origins: string[];
    generalPractitionerIds: string[];
    entPhysicianIds: string[];
    audiologistIds: string[];
    locationIds: string[];
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    lastUpdatedBefore: Date | undefined;
    lastUpdatedAfter: Date | undefined;
    canRenewBefore: Date | undefined;
    canRenewAfter: Date | undefined;
    lastHandoverDateBefore: Date | undefined;
    lastHandoverDateAfter: Date | undefined;
    keyStatus: string | undefined;
    searchMode: string | undefined;
    monthsOfBirth: number[];
    labels: string[];
    zips: string[];
    gender: string | undefined;
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
}

export interface IPatientsFilterData {
    origins: string[];
    labels: string[];
    zips: string[];
}

export interface IPatientsQueryParams {
    searchString: string;
    sortParams: ISortParams<IPatientSummary>;
    pageParams: IPageParams;
    gender: string | undefined;
    statuses: string[];
    origins: string[];
    generalPractitionerIds: string[];
    entPhysicianIds: string[];
    audiologistIds: string[];
    locationIds: string[];
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    lastUpdatedBefore: Date | undefined;
    lastUpdatedAfter: Date | undefined;
    canRenewBefore: Date | undefined;
    canRenewAfter: Date | undefined;
    lastHandoverDateBefore: Date | undefined;
    lastHandoverDateAfter: Date | undefined;
    keyStatus: string | undefined;
    searchMode: string | undefined;
    monthsOfBirth: number[];
    labels: string[];
    zips: string[];
}

export interface IPayment {
    id: string;
    created: Date;
    lastUpdated: Date;
    reference: string | undefined;
    paymentMethod: IObjectWithIdAndIdentifier<string>;
    paymentDate: Date;
    lines: IPaymentLine[];
    customerAccount: ICustomerAccountData;
    supplierAccount: IObjectWithIdAndIdentifier<string>;
    isCashSale: boolean;
    isCreditNote: boolean;
    cashSaleForPatient: IObjectWithIdAndIdentifier<string>;
    settlementProposal: IGuidObjectWithIdAndReference;
    comment: string | undefined;
    customerAccountType: string | undefined;
    customerAccountIdentifier: string | undefined;
    customerAccountId: string | undefined;
    supplierAccountId: string | undefined;
    supplierIdentifier: string | undefined;
    hasComment: boolean;
    isSalesCreditNote: boolean;
    isPurchaseCreditNote: boolean;
    hasALink: boolean;
    salesType: string | undefined;
    expenseOrIncomeType: string | undefined;
    singleLine: IPaymentLine;
    isSingleLine: boolean;
    isMultipleLines: boolean;
    amountPaid: number;
    isExpense: boolean;
    isIncome: boolean;
    isLinkedToASale: boolean;
    isLinkedToAPurchase: boolean;
    isForSupplierAccount: boolean;
    isForCustomerAccount: boolean;
    cashSaleForPatientIdentifier: string | undefined;
    paymentMethodIdentifier: string | undefined;
    paymentMethodId: string;
    customerOrSupplierAccountIdentifier: string | undefined;
    settlementProposalId: string | undefined;
    settlementProposalReference: string | undefined;
    hasSettlementProposal: boolean;
    searchField: string | undefined;
    saleOrPurchaseReferencesCsv: string | undefined;
    recipientsCsv: string | undefined;
}

export interface IPaymentForPurchaseModel {
    reference: string | undefined;
    isAutoSelectReference: boolean;
    purchaseId: string;
    methodId: string;
    value: number;
    date: Date;
}

export interface IPaymentForPurchasesModel {
    reference: string | undefined;
    isAutoSelectReference: boolean;
    date: Date;
    supplierId: string;
    methodId: string;
    purchaseIds: string[];
}

export interface IPaymentForSaleModel {
    reference: string | undefined;
    isAutoSelectReference: boolean;
    methodId: string;
    value: number;
    referenceDate: Date;
}

export interface IPaymentForSalesModel {
    reference: string | undefined;
    isAutoSelectReference: boolean;
    date: Date;
    methodId: string;
    customerAccountLineIds: string[];
}

export interface IPaymentFromSettlementProposalModel {
    reference: string | undefined;
    isUseSettlementProposalReference: boolean;
    date: Date;
    methodId: string;
    customerAccountLineIds: string[];
}

export interface IPaymentLine {
    id: string;
    value: number;
    saleOrPurchaseId: string;
    saleOrPurchaseReference: string | undefined;
    recipient: string | undefined;
    date: Date;
}

export interface IPaymentLineData {
    created: Date;
    paymentId: string;
    reference: string | undefined;
    paymentMethod: IObjectWithIdAndIdentifier<string>;
    value: number;
    paymentMethodId: string;
    paymentMethodIdentifier: string;
}

export interface IPaymentMethod {
    id: string;
    created: Date;
    lastUpdated: Date;
    identifier: string;
    isPredefined: boolean;
    isCreditNotePayment: boolean;
    canUseForCashSale: boolean;
    canUseForPurchase: boolean;
    canUseForSale: boolean;
    isDeleted: boolean;
    isEnabled: boolean;
    searchField: string | undefined;
    isCash: boolean;
}

export interface IPaymentMethodModel {
    name: string | undefined;
    canUseForCashSale: boolean;
    canUseForSale: boolean;
    canUseForPurchase: boolean;
}

export interface IPaymentMethodSummary {
    id: string;
    identifier: string;
    isPredefined: boolean;
    canUseForCashSale: boolean;
    canUserForSale: boolean;
    canUseForPurchase: boolean;
}

export interface IPaymentsExportParams {
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    paymentDateBefore: Date | undefined;
    paymentDateAfter: Date | undefined;
    paymentMethodIds: string[];
    amountPaidLessThan: number | undefined;
    amountPaidMoreThan: number | undefined;
    expenseOrIncomeTypes: string[];
    customerAccountTypes: string[];
    saleTypes: string[];
    isLinkedToASale: boolean | undefined;
    isLinkedToAPurchase: boolean | undefined;
    hasComment: boolean | undefined;
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
}

export interface IPaymentsForCustomerAccountExportParams {
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    paymentDateBefore: Date | undefined;
    paymentDateAfter: Date | undefined;
    paymentMethodIds: string[];
    amountPaidLessThan: number | undefined;
    amountPaidMoreThan: number | undefined;
    expenseOrIncomeTypes: string[];
    hasComment: boolean | undefined;
    saleTypes: string[];
    isMultipleLines: boolean | undefined;
    isSingleLine: boolean | undefined;
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
}

export interface IPaymentsForCustomerAccountQueryParams {
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    paymentDateBefore: Date | undefined;
    paymentDateAfter: Date | undefined;
    paymentMethodIds: string[];
    amountPaidLessThan: number | undefined;
    amountPaidMoreThan: number | undefined;
    expenseOrIncomeTypes: string[];
    hasComment: boolean | undefined;
    saleTypes: string[];
    isMultipleLines: boolean | undefined;
    isSingleLine: boolean | undefined;
    sortParams: ISortParams<IPayment>;
    pageParams: IPageParams;
}

export interface IPaymentsForSupplierAccountExportParams {
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    paymentDateBefore: Date | undefined;
    paymentDateAfter: Date | undefined;
    paymentMethodIds: string[];
    amountPaidLessThan: number | undefined;
    amountPaidMoreThan: number | undefined;
    expenseOrIncomeTypes: string[];
    hasComment: boolean | undefined;
    isMultipleLines: boolean | undefined;
    isSingleLine: boolean | undefined;
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
}

export interface IPaymentsForSupplierAccountQueryParams {
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    paymentDateBefore: Date | undefined;
    paymentDateAfter: Date | undefined;
    paymentMethodIds: string[];
    amountPaidLessThan: number | undefined;
    amountPaidMoreThan: number | undefined;
    expenseOrIncomeTypes: string[];
    hasComment: boolean | undefined;
    isMultipleLines: boolean | undefined;
    isSingleLine: boolean | undefined;
    sortParams: ISortParams<IPayment>;
    pageParams: IPageParams;
}

export interface IPaymentsQueryParams {
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    paymentDateBefore: Date | undefined;
    paymentDateAfter: Date | undefined;
    paymentMethodIds: string[];
    amountPaidLessThan: number | undefined;
    amountPaidMoreThan: number | undefined;
    expenseOrIncomeTypes: string[];
    customerAccountTypes: string[];
    saleTypes: string[];
    isLinkedToASale: boolean | undefined;
    isLinkedToAPurchase: boolean | undefined;
    hasComment: boolean | undefined;
    sortParams: ISortParams<IPayment>;
    pageParams: IPageParams;
}

export interface IPeppolIntegrationStatus {
    peppolSettings: IPeppolSettings;
    environment: PeppolEnvironment;
    enterpriseNumber: string | undefined;
    vatNumber: string | undefined;
    rootEndpointId: string | undefined;
    iban: string | undefined;
    bic: string | undefined;
    countNewPeppolRecords: number;
    hasIban: boolean;
    hasBic: boolean;
    hasEnterpriseNumber: boolean;
    hasVatNumber: boolean;
    mismatchEnterpriseNumberAndVatNumber: boolean;
    mismatchEnterpriseNumberAndRootEndpointId: boolean;
    canEnable: boolean;
}

export interface IPeppolRecord {
    salesId: string;
    created: Date;
    reference: string | undefined;
    recipientsVatNumber: string | undefined;
    attempts: IPeppolRecordAttempt[];
    ignored: boolean;
    recipientExistsOnPeppolNetwork: boolean | undefined;
    recipientCanAcceptInvoices: boolean | undefined;
    id: string;
    canSendToPeppol: boolean;
    lastAttempt: IPeppolRecordAttempt;
    status: PeppolRecordStatus;
    searchField: string | undefined;
}

export interface IPeppolRecordAttempt {
    id: string;
    created: Date;
    validationErrors: string[];
    isSending: boolean;
    isValid: boolean | undefined;
    isSent: boolean | undefined;
    status: PeppolRecordStatus;
    isProcessed: boolean;
    isProcessing: boolean;
}

export interface IPeppolRecordsQueryParams {
    searchString: string;
    sortParams: ISortParams<IPeppolRecord>;
    pageParams: IPageParams;
    prefilter: PeppolRecordPrefilter;
}

export interface IPeppolSettings {
    enabled: boolean;
    autoSend: boolean;
    waitForDocument: boolean;
}

export interface IPlaceOrderWithSupplierRequest {
    orderId: string;
    externalReference: string | undefined;
    placedWithSupplierDate: Date;
}

export interface IPrescriptionModel {
    entPhysician: string;
    prescriptionForTrialDate: Date;
}

export interface IPrescriptionScan {
    id: string;
    created: Date;
    lastUpdated: Date;
    history: IPrescriptionScanHistory[];
    lastScan: IPrescriptionScanHistory;
    attachmentId: string;
    extension: string | undefined;
    isPdf: boolean;
    step: number;
    historyOrderedDesc: IPrescriptionScanHistory[];
}

export interface IPrescriptionScanHistory {
    id: string;
    date: Date;
    attachmentId: string;
    extension: string | undefined;
    step: number;
    isPdf: boolean;
}

export interface IPrimaryWorkflowsByPatientResponse {
    patientId: string;
    workflows: IWorkflowSummary[];
    countActive: number;
    countHasError: number;
    countHasWarning: number;
    countCompleted: number;
}

export interface IProductCatalogExportParams {
    searchString: string;
    manufacturers: string[];
    categories: string[];
    subcategories: string[];
    vatPercentages: number[];
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    lastUpdatedBefore: Date | undefined;
    lastUpdatedAfter: Date | undefined;
    listPriceLessThan: number | undefined;
    listPriceMoreThan: number | undefined;
    isElectronics: boolean | undefined;
    hasBatteries: boolean | undefined;
    rizivHearingAidDefinitionV2LinkStatuses: string[];
    isTailorMade: boolean | undefined;
    types: ProductCatalogItemType[];
    hasSerialNumber: boolean | undefined;
    suppliers: string[];
    keyFilterType: ProductCatalogItemType | undefined;
    isTangible: boolean | undefined;
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
    alsoIncludeDeleted: boolean;
    isDeleted: boolean | undefined;
    labels: string[];
}

export interface IProductCatalogItem {
    id: string;
    created: Date;
    lastUpdated: Date;
    name: string | undefined;
    manufacturer: string | undefined;
    model: string | undefined;
    type: ProductCatalogItemType;
    category: string | undefined;
    subcategory: string | undefined;
    internalReference: string | undefined;
    manufacturerReferences: string[];
    salesListPrice: number;
    purchaseListPrice: number;
    vatPercentage: number;
    hasSerialNumber: boolean;
    isTailorMade: boolean;
    isElectronics: boolean;
    hasBatteries: boolean;
    suppliers: IObjectWithIdAndIdentifier<string>[];
    rizivHearingAidDefinitionV2IdentificationCodes: number[];
    annotationIds: string[];
    recupelCode: string | undefined;
    bebatUnitPriceInVat: number;
    insuranceOrProlongedWarrantyTerm: ITimeModel;
    canAlsoPurchase: boolean;
    defaultWarranty: ITimeModel;
    isDeleted: boolean;
    hearingAidData: IHearingAidData;
    articlePropertyDefinitions: IArticlePropertyDefinition[];
    labels: string[];
    isUniquelyIdentifiable: boolean;
    manufacturerCommaModel: string | undefined;
    rizivHearingAidDefinitionV2LinkStatus: string | undefined;
    rizivHearingAidDefinitionV2IdentificationCodesCsv: string | undefined;
    isTangible: boolean;
    isTangibleOrDiscountArticle: boolean;
    isIntangible: boolean;
    isInsurance: boolean;
    isProlongedWarranty: boolean;
    isInsuranceOrProlongedWarranty: boolean;
    isHearingInstrument: boolean;
    isRemoteControl: boolean;
    supplierIds: string[];
    supplierIdentifierCsv: string | undefined;
    searchField: string | undefined;
    identifier: string;
    hasRecupelCode: boolean;
    hasBebat: boolean;
    salesListPriceExVat: number;
    isInterchangeableType: boolean;
    listProfit: number;
    listMargin: number;
    listMarkup: number;
    manufacturerReferencesCsv: string | undefined;
    labelsCsv: string | undefined;
}

export interface IProductCatalogItemManufacturerModelAndType {
    id: string;
    manufacturer: string | undefined;
    model: string | undefined;
    type: ProductCatalogItemType;
    manufacturerCommaModel: string | undefined;
}

export interface IProductCatalogItemStats {
    countInventoryItems: number;
    countTransactions: number;
    countComments: number;
}

export interface IProductCatalogItemSummary {
    id: string;
    manufacturer: string | undefined;
    model: string | undefined;
    identifier: string;
    salesListPrice: number;
    purchaseListPrice: number;
    vatPercentage: number;
    type: ProductCatalogItemType;
    category: string | undefined;
    subcategory: string | undefined;
    hasSerialNumber: boolean;
    isTailorMade: boolean;
    isElectronics: boolean;
    hasBatteries: boolean;
    rizivHearingAidDefinitionV2IdentificationCodes: number[];
    recupelCode: string | undefined;
    bebatUnitPriceInVat: number;
    defaultWarranty: ITimeModel;
    hearingAidData: IHearingAidData;
    articlePropertyDefinitions: IArticlePropertyDefinition[];
    hasRizivRefundableHearingInstruments: boolean;
    hasMultipleRizivRefundableHearingInstruments: boolean;
    hasRecupelCode: boolean;
    hasBebat: boolean;
    defaultWarrantyUnit: string | undefined;
    defaultWarrantyValue: number | undefined;
}

export interface IProductCatalogItemSummaryForUblPurchase {
    id: string;
    identifier: string;
    manufacturerReferences: string[];
    type: ProductCatalogItemType;
    purchaseListPrice: number;
    isUniquelyIdentifiable: boolean;
    vatPercentage: number;
}

export interface IProductCatalogItemWithStatsAndStockInfo {
    item: IProductCatalogItem;
    stats: IProductCatalogItemStats;
    stockInfo: IStockInfo;
    stockInfoIsDirty: boolean;
}

export interface IProductCatalogItemWithStockAtLocations {
    item: IProductCatalogItem;
    stockAtLocations: IStockAtLocation[];
}

export interface IProductCatalogQueryParams {
    searchString: string;
    manufacturers: string[];
    categories: string[];
    subcategories: string[];
    vatPercentages: number[];
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    lastUpdatedBefore: Date | undefined;
    lastUpdatedAfter: Date | undefined;
    listPriceLessThan: number | undefined;
    listPriceMoreThan: number | undefined;
    isElectronics: boolean | undefined;
    hasBatteries: boolean | undefined;
    rizivHearingAidDefinitionV2LinkStatuses: string[];
    isTailorMade: boolean | undefined;
    types: ProductCatalogItemType[];
    hasSerialNumber: boolean | undefined;
    suppliers: string[];
    keyFilterType: ProductCatalogItemType | undefined;
    isTangible: boolean | undefined;
    sortParams: ISortParams<IProductCatalogItem>;
    pageParams: IPageParams;
    alsoIncludeDeleted: boolean;
    isDeleted: boolean | undefined;
    labels: string[];
}

export interface IProductCatalogQueryParamsForArticlesInquiry {
    searchString: string;
    sortParams: ISortParams<IProductCatalogItem>;
    pageParams: IPageParams;
    types: ProductCatalogItemType[];
    categories: string[];
    subcategories: string[];
}

export interface IProductCatalogQueryParamsForDelivery {
    searchString: string;
    sortParams: ISortParams<IProductCatalogItem>;
    pageParams: IPageParams;
    types: ProductCatalogItemType[];
    categories: string[];
    subcategories: string[];
}

export interface IProductCatalogQueryParamsForOrder {
    searchString: string;
    sortParams: ISortParams<IProductCatalogItem>;
    pageParams: IPageParams;
    types: ProductCatalogItemType[];
    categories: string[];
    subcategories: string[];
}

export interface IProductCatalogQueryParamsForPurchase {
    searchString: string;
    sortParams: ISortParams<IProductCatalogItem>;
    pageParams: IPageParams;
    types: ProductCatalogItemType[];
    categories: string[];
    subcategories: string[];
    hasSerialNumber: boolean | undefined;
}

export interface IProductCatalogQueryParamsForReturn {
    searchString: string;
    sortParams: ISortParams<IProductCatalogItem>;
    pageParams: IPageParams;
    types: ProductCatalogItemType[];
    categories: string[];
    subcategories: string[];
}

export interface IProductCatalogQueryParamsForSale {
    searchString: string;
    sortParams: ISortParams<IProductCatalogItem>;
    pageParams: IPageParams;
    types: ProductCatalogItemType[];
    categories: string[];
    subcategories: string[];
    hasSerialNumber: boolean | undefined;
}

export interface IProductCatalogQueryParamsForStockMovement {
    searchString: string;
    sortParams: ISortParams<IProductCatalogItem>;
    pageParams: IPageParams;
    types: ProductCatalogItemType[];
    categories: string[];
    subcategories: string[];
}

export interface IProductCatalogQueryParamsForTailorMade {
    searchString: string;
    sortParams: ISortParams<IProductCatalogItem>;
    pageParams: IPageParams;
    types: ProductCatalogItemType[];
    categories: string[];
    subcategories: string[];
    isShowAll: boolean;
}

export interface IProductCatalogQueryParamsForTender {
    searchString: string;
    sortParams: ISortParams<IProductCatalogItem>;
    pageParams: IPageParams;
    types: ProductCatalogItemType[];
    categories: string[];
    subcategories: string[];
}

export interface IProductCatalogSearchData {
    manufacturers: string[];
    categories: string[];
    subcategories: string[];
    labels: string[];
    maxListPrice: number;
    minListPrice: number;
}

export interface IProductCatalogSettings {
    defaultVatPercentageHearingAids: number;
    defaultVatPercentageCharger: number;
    id: string;
}

export interface IProlongedWarrantyProductCatalogItemModel {
    category: string | undefined;
    subcategory: string | undefined;
    listPrice: number;
    vatPercentage: number;
    termUnit: string | undefined;
    termValue: number;
    isUnlimitedTerm: boolean;
    canAlsoPurchase: boolean;
    name: string;
}

export interface IPurchase {
    id: string;
    created: Date;
    lastUpdated: Date;
    reference: string | undefined;
    externalReference: string | undefined;
    purchaseDate: Date;
    validUntil: Date;
    supplier: IObjectWithIdAndIdentifier<string>;
    lines: IPurchaseLine[];
    creditedPurchase: IGuidObjectWithIdAndReference;
    payments: IPaymentLineData[];
    document: IDocumentSummary;
    isCreatedFromUbl: boolean;
    createdByUserId: string;
    labels: string[];
    isCreditNote: boolean;
    countItems: number;
    identifier: string;
    searchField: string | undefined;
    supplierId: string;
    supplierIdentifier: string | undefined;
    type: string | undefined;
    documentId: string | undefined;
    hasDocument: boolean;
    amountToPay: number;
    amountPaid: number;
    outstandingBalance: number;
    hasOutstandingBalance: boolean;
    isFullyPaid: boolean;
    isPartlyPaid: boolean;
    isNothingPaid: boolean;
    isOverDue: boolean;
    hasPayments: boolean;
    vatSplits: IVatSplit[];
    priceInVat: number;
    priceExVat: number;
    vatAmount: number;
    paymentStatus: string | undefined;
    needsNowAfter: Date | undefined;
    isCompleted: boolean;
    hasWarning: boolean;
    hasError: boolean;
    isFullyCredited: boolean;
    isPartlyCredited: boolean;
    isNothingCredited: boolean;
    canCreateCreditNote: boolean;
    creditedStatus: string | undefined;
    productCatalogItemIds: string[];
    storedNow: Date;
    storedNowPreviousToNeedsNowAfter: boolean;
}

export interface IPurchaseCreditNoteLineModel {
    purchaseLineId: string;
    quantity: number;
    zeroBasedIndexNumber: number;
}

export interface IPurchaseCreditNoteModel {
    purchaseId: string;
    reference: string | undefined;
    isAutoSelectReference: boolean;
    lines: IPurchaseCreditNoteLineModel[];
}

export interface IPurchaseFromInventoryItemModel {
    inventoryItemId: string;
    supplierId: string;
    reference: string | undefined;
    isAutoSelectReference: boolean;
    externalReference: string | undefined;
    purchaseDate: Date;
    validUntil: Date;
    vatPercentage: number;
    unitListPriceExVat: number;
    unitPriceExVat: number;
}

export interface IPurchaseLine {
    id: string;
    productCatalogItemId: string | undefined;
    inventoryItemId: string | undefined;
    description: string | undefined;
    indexNumber: number;
    parentLineId: string | undefined;
    childIndexNumber: number | undefined;
    serialNumber: string | undefined;
    creditedQuantity: number;
    assuredProductCatalogItemId: string | undefined;
    assuredInventoryItemId: string | undefined;
    unitPrice: number;
    unitListPrice: number;
    vatPercentage: number;
    quantity: number;
    isVatIncluded: boolean;
    isInventoryItem: boolean;
    hasProductCatalogItem: boolean;
    isCreditLine: boolean;
    isFullyCredited: boolean;
    isPartlyCredited: boolean;
    isNothingCredited: boolean;
    unitPriceInVat: number;
    unitListPriceInVat: number;
    linePriceInVat: number;
    lineListPriceInVat: number;
    unitPriceExVat: number;
    unitListPriceExVat: number;
    linePriceExVat: number;
    lineListPriceExVat: number;
    unitVatValue: number;
    lineVatValue: number;
    unitDiscountValueInVat: number;
    unitDiscountValueExVat: number;
    lineDiscountValueInVat: number;
    lineDiscountValueExVat: number;
    discountPercentage: number;
}

export interface IPurchaseSettings {
    defaultValidUntil: ITimeModel;
    referenceSettings: IReferenceSettings;
    id: string;
}

export interface IPurchaseUbl {
    supplierId: string | undefined;
    reference: string | undefined;
    issueDate: Date;
    dueDate: Date | undefined;
    lines: IPurchaseUblLine[];
    amountExVat: number;
    amountInVat: number;
    payableAmount: number;
}

export interface IPurchaseUblAllowanceCharge {
    isCharge: boolean;
    unitAmount: number;
    description: string | undefined;
    productCatalogItem: IProductCatalogItemSummaryForUblPurchase;
    invoicedUnitAmount: number;
    hasProductCatalogItem: boolean;
    isDiscount: boolean;
}

export interface IPurchaseUblBuffer {
    id: string;
    dateUploaded: Date;
    ublId: string | undefined;
    fileName: string;
    attachmentId: string;
    searchField: string | undefined;
}

export interface IPurchaseUblLine {
    ublLineId: string | undefined;
    manufacturerReference: string | undefined;
    quantity: number;
    description: string | undefined;
    allowanceCharges: IPurchaseUblAllowanceCharge[];
    serialNumber: string | undefined;
    unitAmount: number;
    lineAmount: number;
    vatPercentage: number;
    productCatalogItem: IProductCatalogItemSummaryForUblPurchase;
    inventoryItemId: string | undefined;
    calculatedLineAmount: number;
    hasProductCatalogItem: boolean;
    productCatalogItemId: string | undefined;
}

export interface IPurchasesExportParams {
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    validUntilBefore: Date | undefined;
    validUntilAfter: Date | undefined;
    purchaseReferenceDateBefore: Date | undefined;
    purchaseReferenceDateAfter: Date | undefined;
    priceExVatMoreThan: number | undefined;
    priceExVatLessThan: number | undefined;
    paymentStatuses: string[];
    types: string[];
    creditedStatuses: string[];
    supplierIds: string[];
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
    prefilter: PurchasesPrefilter;
    labels: string[];
}

export interface IPurchasesFilterData {
    labels: string[];
}

export interface IPurchasesForSupplierExportParams {
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    validUntilBefore: Date | undefined;
    validUntilAfter: Date | undefined;
    purchaseReferenceDateBefore: Date | undefined;
    purchaseReferenceDateAfter: Date | undefined;
    priceExVatMoreThan: number | undefined;
    priceExVatLessThan: number | undefined;
    paymentStatuses: string[];
    types: string[];
    creditedStatuses: string[];
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
    prefilter: PurchasesPrefilter;
    labels: string[];
}

export interface IPurchasesForSupplierQueryParams {
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    validUntilBefore: Date | undefined;
    validUntilAfter: Date | undefined;
    purchaseReferenceDateBefore: Date | undefined;
    purchaseReferenceDateAfter: Date | undefined;
    priceExVatMoreThan: number | undefined;
    priceExVatLessThan: number | undefined;
    paymentStatuses: string[];
    types: string[];
    creditedStatuses: string[];
    sortParams: ISortParams<IPurchase>;
    pageParams: IPageParams;
    prefilter: PurchasesPrefilter;
    labels: string[];
}

export interface IPurchasesQueryMetadata {
    countNotPaid: number;
    countOverdue: number;
}

export interface IPurchasesQueryParams {
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    validUntilBefore: Date | undefined;
    validUntilAfter: Date | undefined;
    purchaseReferenceDateBefore: Date | undefined;
    purchaseReferenceDateAfter: Date | undefined;
    priceExVatMoreThan: number | undefined;
    priceExVatLessThan: number | undefined;
    paymentStatuses: string[];
    types: string[];
    creditedStatuses: string[];
    supplierIds: string[];
    sortParams: ISortParams<IPurchase>;
    pageParams: IPageParams;
    prefilter: PurchasesPrefilter;
    labels: string[];
}

export interface IPurchasesUblBufferQueryParams {
    searchString: string;
    uploadedBefore: Date | undefined;
    uploadedAfter: Date | undefined;
    sortParams: ISortParams<IPurchaseUblBuffer>;
    pageParams: IPageParams;
}

export interface IPushCustomerAccountToExactOnlineRequest {
    hamsId: string;
}

export interface IPushPatientDataToRosaRequest {
    rosaPatientRecordId: string | undefined;
    hamsPatientId: string;
}

export interface IPushPatientsToRosaResponse {
    error: string | undefined;
    failedPatientNameKeys: IPatientWithIdAndNameKeyDto[];
    hasError: boolean;
    isSuccess: boolean;
}

export interface IReadOutRule {
    created: Date;
    productCatalogId: string;
    manufacturer: string | undefined;
    model: string | undefined;
    isDeleted: boolean;
    id: string;
    manufacturerCommaModel: string | undefined;
}

export interface IRecipient {
    name: string | undefined;
    vatNumber: string | undefined;
    addressLine: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    country: string | undefined;
    hasData: boolean;
    hasVatNumber: boolean;
    formattedAddressMultipleLines: string | undefined;
}

export interface IRecipientAndAddress {
    recipient: string | undefined;
    addressLine: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    country: string | undefined;
}

export interface IRecupelItemDto {
    code: string | undefined;
    weeeCategory: number;
    subCategory: number;
    weeeCategoryDescription: string | undefined;
    subCategoryDescription: string | undefined;
    currentPriceInVat: number;
    currentPriceExVat: number;
}

export interface IReferenceSettings {
    prefix: string | undefined;
    withYear: boolean;
    separator: string | undefined;
    countLeadingZeros: number;
    isShortYearFormat: boolean;
    withPrefix: boolean;
}

export interface IReferenceSettingsModel {
    prefix: string | undefined;
    withYear: boolean;
    separator: string | undefined;
    countLeadingZeros: number;
    isShortYearFormat: boolean;
}

export interface IRefundForSaleModel {
    reference: string | undefined;
    isAutoSelectReference: boolean;
    methodId: string;
    value: number;
    referenceDate: Date;
}

export interface IRegisterApprovalAdvisoryPhysicianModel {
    approvalDate: Date;
    expectedHandoverDate: Date;
}

export interface IRegisterArticlesInquiryLineRequest {
    zeroBasedIndex: number;
    productCatalogItemId: string;
    description: string | undefined;
    quantity: number;
    orientation: string | undefined;
    articleProperties: IArticlePropertyModel[];
}

export interface IRegisterArticlesInquiryRequest {
    reference: string | undefined;
    isAutoSelectReference: boolean;
    patientId: string;
    lines: IRegisterArticlesInquiryLineRequest[];
    handlingUserId: string;
}

export interface IRegisterAsACochlearSpecialistRequest {
    replyTo: string | undefined;
}

export interface IRegisterAudiologistForCochlearEventRequest {
    audiologistId: string;
    eventId: string;
    audiologistEmail: string | undefined;
    replyTo: string | undefined;
}

export interface IRegisterDeliveryFromInventoryItemRequest {
    inventoryItemId: string;
    reference: string | undefined;
    isAutoSelectReference: boolean;
    externalReference: string | undefined;
    deliveryDate: Date;
    supplierId: string;
    locationId: string;
    dispatchReference: string | undefined;
    dispatchDate: Date | undefined;
}

export interface IRegisterDeliveryLineRequest {
    description: string | undefined;
    productCatalogId: string;
    quantity: number;
    autoGenerateSerialNumber: boolean;
    serialNumber: string | undefined;
    zeroBasedIndex: number;
    tailorMadeForPatientId: string | undefined;
}

export interface IRegisterDeliveryRequest {
    reference: string | undefined;
    isAutoSelectReference: boolean;
    externalReference: string | undefined;
    deliveryDate: Date;
    supplierId: string;
    locationId: string;
    lines: IRegisterDeliveryLineRequest[];
    dispatchReference: string | undefined;
    dispatchDate: Date | undefined;
}

export interface IRegisterEntPhysicianRequest {
    firstName: string | undefined;
    lastName: string | undefined;
    salutation: string | undefined;
    rizivCode: string | undefined;
    gender: string | undefined;
    isImportedFromWeb: boolean;
}

export interface IRegisterGeneralPractitionerRequest {
    firstName: string | undefined;
    lastName: string | undefined;
    salutation: string | undefined;
    rizivCode: string | undefined;
    gender: string | undefined;
    isImportedFromWeb: boolean;
}

export interface IRegisterInventoryItemAsBrokenRequest {
    inventoryItemId: string;
}

export interface IRegisterInventoryItemAsSoldRequest {
    inventoryItemId: string;
    reference: string | undefined;
    referenceDate: Date;
    patientId: string;
}

export interface IRegisterLoanLineRequest {
    productCatalogItemId: string;
    inventoryItemId: string | undefined;
    zeroBasedIndexNumber: number;
    description: string | undefined;
    quantity: number;
    vatPercentage: number;
    unitListPriceInVat: number;
    unitPriceInVat: number;
}

export interface IRegisterLoanRequest {
    reference: string | undefined;
    isAutoSelectReference: boolean;
    patientId: string;
    lines: IRegisterLoanLineRequest[];
    startDate: Date;
    stopDate: Date;
}

export interface IRegisterOrderDeliveryLineRequest {
    orderLineId: string;
    quantity: number;
    autoGenerateSerialNumber: boolean;
    serialNumber: string | undefined;
    zeroBasedIndex: number;
}

export interface IRegisterOrderDeliveryRequest {
    orderId: string;
    reference: string | undefined;
    isAutoSelectReference: boolean;
    locationId: string;
    date: Date;
    lines: IRegisterOrderDeliveryLineRequest[];
    dispatchReference: string | undefined;
    dispatchDate: Date | undefined;
}

export interface IRegisterOrderLineRequest {
    productCatalogItemId: string;
    zeroBasedIndex: number;
    description: string | undefined;
    quantity: number;
    patientId: string | undefined;
    orientation: string | undefined;
    articleProperties: IArticlePropertyModel[];
}

export interface IRegisterOrderRequest {
    reference: string | undefined;
    isAutoSelectReference: boolean;
    externalReference: string | undefined;
    supplierId: string;
    locationId: string;
    expectedDeliveryDate: Date;
    lines: IRegisterOrderLineRequest[];
    placeOrderImmediately: boolean;
    handlingUserId: string;
}

export interface IRegisterPatientForCochlearEventRequest {
    patientId: string;
    eventId: string;
    patientEmail: string | undefined;
    replyTo: string | undefined;
}

export interface IRegisterPurchaseFromUblRequest {
    supplierId: string;
    reference: string | undefined;
    isAutoSelectReference: boolean;
    externalReference: string | undefined;
    purchaseDate: Date;
    validUntil: Date;
    lines: IRegisterPurchaseLineFromUblRequest[];
    ublBufferId: string | undefined;
}

export interface IRegisterPurchaseLineAllowanceChargeFromUblRequest {
    zeroBasedIndexNumber: number;
    isCharge: boolean;
    unitPriceExVat: number;
    description: string | undefined;
    productCatalogItemId: string | undefined;
    isIgnored: boolean;
}

export interface IRegisterPurchaseLineFromUblRequest {
    productCatalogItemId: string | undefined;
    zeroBasedIndexNumber: number;
    description: string | undefined;
    serialNumber: string | undefined;
    quantity: number;
    vatPercentage: number;
    unitPriceExVat: number;
    isIgnored: boolean;
    allowanceCharges: IRegisterPurchaseLineAllowanceChargeFromUblRequest[];
}

export interface IRegisterPurchaseRequest {
    supplierId: string;
    reference: string | undefined;
    isAutoSelectReference: boolean;
    externalReference: string | undefined;
    purchaseDate: Date;
    validUntil: Date;
    lines: IReqisterPurchaseLineRequest[];
}

export interface IRegisterRepairDeliveryRequest {
    reference: string | undefined;
    isAutoSelectReference: boolean;
    repairId: string;
    date: Date;
    expectedHandoverDate: Date;
    lines: IRepairDeliveryLineModel[];
    toLocationId: string;
}

export interface IRegisterRepairHandoverToPatientRequest {
    repairId: string;
    handoverDate: Date;
}

export interface IRegisterRepairRequest {
    reference: string | undefined;
    isAutoSelectReference: boolean;
    supplierId: string;
    patientId: string | undefined;
    steps: string[];
    handlingUserId: string;
}

export interface IRegisterRfiaFailureHandoverRequest {
    rfiaId: string;
    handoverDate: Date;
    reference: string | undefined;
    isAutoSelectReference: boolean;
    validUntil: Date;
    fee: IMedicalTreatmentFeeDto;
    vatPercentage: number;
    fromLocationId: string;
}

export interface IRegisterRfiaHandoverSingleRequest {
    rfiaId: string;
    handoverDate: Date;
    companyId: string | undefined;
    reference: string | undefined;
    isAutoSelectReference: boolean;
    validUntil: Date;
    lines: IRfiaHandoverLineModel[];
    fees: IMedicalTreatmentFeeDto[];
    recipientName: string | undefined;
    addressLine: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    country: string | undefined;
    fromLocationId: string;
    orderReference: string | undefined;
}

export interface IRegisterRfiaHandoverSplitRequest {
    rfiaId: string;
    handoverDate: Date;
    companyId: string | undefined;
    patientReference: string | undefined;
    isAutoSelectPatientReference: boolean;
    patientValidUntil: Date;
    rizivReference: string | undefined;
    isAutoSelectRizivReference: boolean;
    rizivValidUntil: Date;
    lines: IRfiaHandoverLineModel[];
    fees: IMedicalTreatmentFeeModel[];
    recipientName: string | undefined;
    addressLine: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    country: string | undefined;
    fromLocationId: string;
    orderReference: string | undefined;
}

export interface IRegisterRfiaProformaHandoverFailureRequest {
    rfiaId: string;
    handoverDate: Date | undefined;
    fee: IMedicalTreatmentFeeDto;
    vatPercentage: number;
}

export interface IRegisterRfiaProformaHandoverRequest {
    rfiaId: string;
    handoverDate: Date;
    lines: IRfiaHandoverLineModel[];
    fees: IMedicalTreatmentFeeDto[];
}

export interface IRegisterRfiaTrialRequest {
    rfiaId: string;
    startDate: Date;
    stopDate: Date;
    lines: ITrialLineModel[];
}

export interface IRegisterSendDocumentsModel {
    sentDate: Date;
    expectedReceptionDate: Date;
}

export interface IRegisterSupplierRequest {
    name: string | undefined;
    accountNumber: string | undefined;
    email: string | undefined;
    vatNumber: string | undefined;
    brands: string[];
    addressLine: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    country: string | undefined;
}

export interface IRegisterUserRequest {
    salutation: string | undefined;
    preferredLocationId: string;
    role: UserRole;
    email: string;
    firstName: string;
    lastName: string;
}

export interface IRegisterUserWithPasswordModel {
    salutation: string | undefined;
    preferredLocationId: string;
    role: UserRole;
    password: string | undefined;
    email: string;
    firstName: string;
    lastName: string;
}

export interface IRegisterVatCustomerRequest {
    name: string | undefined;
    vatNumber: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    salutation: string | undefined;
    addressLine: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    country: string | undefined;
    phone: string | undefined;
    email: string | undefined;
}

export interface IRemoveInvalidEidDataFromPatientRequest {
    patientId: string;
}

export interface IRemoveInvoiceForwardingEmailRequest {
    emailAddress: string | undefined;
}

export interface IRemovePurchaseUblBufferRequest {
    bufferId: string;
}

export interface IRenewApiTokenRequest {
    clientId: string;
    computerName: string | undefined;
}

export interface IRenewalInfo {
    rfias: IRfiaHandoverSummary[];
    manualHandoverDate: Date | undefined;
    lastHandoverDate: Date | undefined;
}

export interface IRepair {
    id: string;
    created: Date;
    lastUpdated: Date;
    reference: string | undefined;
    supplier: IObjectWithIdAndIdentifier<string>;
    forPatient: IObjectWithIdAndIdentifier<string>;
    lines: IRepairLine[];
    isCancelled: boolean;
    externalReference: string | undefined;
    sendToSupplierStep: ISendToSupplierStep;
    steps: string[];
    linkViewContexts: ILinkViewContext[];
    expectedHandoverDate: Date | undefined;
    handoverDate: Date | undefined;
    handlingUserId: string;
    isHandOverOverdue: boolean;
    isRedeliveryOverdue: boolean;
    isHandedOver: boolean;
    warning: string | undefined;
    isSentToSupplier: boolean;
    isCompletelyRedelivered: boolean;
    isPartialRedelivered: boolean;
    canAddLines: boolean;
    canSendToSupplier: boolean;
    canRegisterDelivery: boolean;
    canRedeliverToPatient: boolean;
    status: string | undefined;
    handoverToPatientStepIncluded: boolean;
    sentToSupplierDate: Date | undefined;
    expectedRedeliveryDate: Date | undefined;
    firstActualDeliveryDate: Date | undefined;
    lastActualDeliveryDate: Date | undefined;
    isDeliveredInMultipleSteps: boolean;
    redeliveryDates: Date[];
    isForPatient: boolean;
    forPatientId: string | undefined;
    forPatientIdentifier: string | undefined;
    supplierId: string;
    supplierIdentifier: string | undefined;
    countItems: number;
    notRedeliveredLines: IRepairLine[];
    serialNumbers: string[];
    inventoryItemIds: string[];
    searchField: string | undefined;
    reasonsDistinct: string[];
    hasLines: boolean;
    progressPercentage: number;
    fromLocationId: string | undefined;
    formattedContent: string | undefined;
    hasWarning: boolean;
    isCompleted: boolean;
    hasError: boolean;
    needsNowAfter: Date | undefined;
    storedNow: Date;
    storedNowPreviousToNeedsNowAfter: boolean;
}

export interface IRepairDeliveryLineModel {
    repairLineId: string;
    quantity: number;
    hasNewSerialNumber: boolean;
    newSerialNumber: string | undefined;
    zeroBasedIndexNumber: number;
}

export interface IRepairExportParams {
    searchString: string;
    statuses: string[];
    supplierIds: string[];
    locationIds: string[];
    handlingUserIds: string[];
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    warnings: string[];
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
    prefilter: RepairPrefilter;
}

export interface IRepairFromInventoryItemModel {
    inventoryItemId: string;
    reference: string | undefined;
    isAutoSelectReference: boolean;
    supplierId: string;
    patientId: string | undefined;
    steps: string[];
    reasons: string[];
    handlingUserId: string;
}

export interface IRepairLine {
    id: string;
    productCatalogItem: IObjectWithIdAndIdentifier<string>;
    inventoryItemId: string | undefined;
    serialNumber: string | undefined;
    redeliveryDate: Date | undefined;
    redeliveryId: string | undefined;
    newSerialNumber: string | undefined;
    quantity: number;
    reasons: string[];
    productCatalogItemId: string;
    isReplaced: boolean;
    isRedelivered: boolean;
    isInventoryItem: boolean;
    identifier: string;
    reasonsCsv: string | undefined;
}

export interface IRepairSettings {
    defaultExpectedReturnTime: ITimeModel;
    referenceSettings: IReferenceSettings;
    id: string;
}

export interface IRepairsQueryMetadata {
    count: number;
    countNotSentToSupplier: number;
    countInRepair: number;
    countToHandoverToPatient: number;
    countWithWarning: number;
}

export interface IRepairsQueryParams {
    searchString: string;
    sortParams: ISortParams<IRepair>;
    pageParams: IPageParams;
    supplierIds: string[];
    locationIds: string[];
    handlingUserIds: string[];
    statuses: string[];
    forPatientId: string | undefined;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    warnings: string[];
    prefilter: RepairPrefilter;
}

export interface IReplaceDocumentRequest {
    documentId: string;
    withSignature: boolean;
    contentAsBase64: string | undefined;
    fileName: string;
}

export interface IReqisterPurchaseLineRequest {
    productCatalogItemId: string | undefined;
    zeroBasedIndexNumber: number;
    description: string | undefined;
    serialNumber: string | undefined;
    quantity: number;
    vatPercentage: number;
    unitListPriceExVat: number;
    unitPriceExVat: number;
    assuredProductCatalogItemId: string | undefined;
    assuredSerialNumber: string | undefined;
    creditAssuranceLineId: string | undefined;
}

export interface IRequestForInsuranceAllowance {
    id: string;
    created: Date;
    lastUpdated: Date;
    reference: string | undefined;
    patient: IObjectWithIdAndIdentifier<string>;
    entPhysician: IObjectWithIdAndIdentifier<string>;
    entPhysicianOffice: IObjectWithIdAndIdentifier<string>;
    audiologist: IObjectWithIdAndIdentifier<string>;
    location: IObjectWithIdAndIdentifier<string>;
    healthInsuranceFundCode: string | undefined;
    hasThirdPartyPaymentScheme: boolean;
    mainMedicalTreatmentNomenclatureCode: string | undefined;
    secondaryMedicalTreatmentNomenclatureCodes: string[];
    isFailedTrial: boolean;
    prescriptionForTrialDate: Date | undefined;
    loanSummaries: ILoanSummary[];
    cosiQuestionnaire: ICosiQuestionnaireSummary;
    trialReportSummaries: ITrialReportSummary[];
    medicalPrescriptionSteps: IMedicalPrescriptionStep[];
    feedbackAdvisoryPhysicianSteps: IFeedbackAdvisoryPhysicianStep[];
    equipmentDeliveryStep: IEquipmentDeliveryStep;
    invoiceProcess: IRfiaInvoiceProcess;
    prescriptionScan: IPrescriptionScan;
    documents: IDocumentIdAndPredefinedType[];
    isCancelled: boolean;
    cancelReason: string | undefined;
    pseudoMedicalTreatmentNomenclatureCode: string | undefined;
    labels: string[];
    documentIds: string[];
    latestLoanEndOrAdministrativeOrExpectedEndDate: Date | undefined;
    lastLoanId: string | undefined;
    lastTrialReportId: string | undefined;
    anamnesisDocumentId: string | undefined;
    proformaHandoverCertificateId: string | undefined;
    cosiQuestionnaireDocumentId: string | undefined;
    lastLoanSlipId: string | undefined;
    handoverCertificateId: string | undefined;
    lastTrialReportDocumentId: string | undefined;
    entPhysicianId: string | undefined;
    hasEntPhysician: boolean;
    entPhysicianIdentifier: string | undefined;
    entPhysicianOfficeId: string | undefined;
    entPhysicianOfficeIdentifier: string | undefined;
    audiologistId: string | undefined;
    audiologistIdentifier: string | undefined;
    locationId: string | undefined;
    locationIdentifier: string | undefined;
    hasMainMedicalTreatmentNomenclatureDefined: boolean;
    hasPseudoMedicalTreatmentNomenclatureDefined: boolean;
    hasPrescriptionForTrialDate: boolean;
    searchField: string | undefined;
    patientId: string;
    patientName: string | undefined;
    status: string | undefined;
    invoiceProcessStatus: string | undefined;
    paymentStatus: string | undefined;
    hasCosiQuestionnaire: boolean;
    hasProformaHandoverCertificate: boolean;
    hasProformaHandoverLines: boolean;
    hasMissingDocuments: boolean;
    hasApprovedMedicalPrescription: boolean;
    hasApprovedFeedbackAdvisoryPhysician: boolean;
    hasTrialStep: boolean;
    prescriptionDate: Date | undefined;
    advisoryPhysicianApprovalDate: Date | undefined;
    equipmentDeliveryDate: Date | undefined;
    handoverDate: Date | undefined;
    isHandedOver: boolean;
    isHandedOverAndPaid: boolean;
    isHandedOverOrCancelled: boolean;
    isMainProcessCompletedExceptDocuments: boolean;
    canHandoverEquipment: boolean;
    hasEquipmentDeliveryStep: boolean;
    canCreateTestReport: boolean;
    canCreateLoanSlip: boolean;
    canReceiveMedicalPrescription: boolean;
    canReceiveFeedbackAdvisoryPhysician: boolean;
    requiredPrescriptionScanStep: number;
    allMedicalTreatmentNomenclatureCodes: string[];
    canStartNewTrial: boolean;
    warning: string | undefined;
    isFailedTrialOrHasAllApprovals: boolean;
    hasAllApprovals: boolean;
    medicalPrescriptionSentDate: Date | undefined;
    medicalPrescriptionApprovalDate: Date | undefined;
    feedbackAdvisoryPhysicianApprovalDate: Date | undefined;
    feedbackAdvisoryPhysicianSentDate: Date | undefined;
    progressPercentage: number;
    hasWarning: boolean;
    isCompleted: boolean;
    hasError: boolean;
    needsNowAfter: Date | undefined;
    storedNow: Date;
    storedNowPreviousToNeedsNowAfter: boolean;
}

export interface IRequestMetadata {
    remoteIp: string;
    browser: string;
    browserVersion: string;
    device: string;
    os: string;
}

export interface IRequestOAuthTokenFromAuthorizationCodeRequest {
    authorizationCode: string | undefined;
}

export interface IResetPasswordRequest {
    resetPasswordTokenId: string;
    email: string;
    password: string;
}

export interface IResetPasswordResponse {
    user: IUserInfo;
    errors: IValidationError<IResetPasswordRequest>[];
    locations: ILocationSummary[];
    hasError: boolean;
    mustSelectLocation: boolean;
}

export interface IResetUserPasswordRequest {
    userId: string;
    password: string | undefined;
}

export interface IRestoreEntPhysicianOfficeRequest {
    entPhysicianId: string;
    officeId: string;
}

export interface IRestoreEntPhysicianRequest {
    entPhysicianId: string;
}

export interface IRestoreGeneralPractitionerOfficeRequest {
    generalPractitionerId: string;
    officeId: string;
}

export interface IRestoreGeneralPractitionerRequest {
    generalPractitionerId: string;
}

export interface IRestoreProductCatalogItemRequest {
    productCatalogItemId: string;
}

export interface IRestoreSupplierRequest {
    supplierId: string;
}

export interface IReturn {
    id: string;
    created: Date;
    lastUpdated: Date;
    reference: string | undefined;
    externalReference: string | undefined;
    returnDate: Date;
    toSupplier: IObjectWithIdAndIdentifier<string>;
    fromLocation: IObjectWithIdAndIdentifier<string>;
    lines: IReturnLine[];
    toSupplierId: string;
    toSupplierIdentifier: string | undefined;
    countItems: number;
    fromLocationId: string;
    fromLocationIdentifier: string | undefined;
    searchField: string | undefined;
}

export interface IReturnFromInventoryItemModel {
    inventoryItemId: string;
    returnDate: Date;
    supplierId: string;
    locationId: string;
    reference: string | undefined;
    isAutoSelectReference: boolean;
}

export interface IReturnLine {
    id: string;
    index: number;
    productCatalogItem: IObjectWithIdAndIdentifier<string>;
    inventoryItemId: string | undefined;
    description: string | undefined;
    quantity: number;
    productCatalogItemId: string;
}

export interface IReturnLineModel {
    description: string | undefined;
    productCatalogId: string;
    inventoryItemId: string | undefined;
    quantity: number;
    zeroBasedIndex: number;
}

export interface IReturnModel {
    reference: string | undefined;
    isAutoSelectReference: boolean;
    externalReference: string | undefined;
    returnDate: Date;
    supplierId: string;
    locationId: string;
    lines: IReturnLineModel[];
}

export interface IReturnSettings {
    referenceSettings: IReferenceSettings;
    id: string;
}

export interface IReturnsExportParams {
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    returnedBefore: Date | undefined;
    returnedAfter: Date | undefined;
    supplierIds: string[];
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
}

export interface IReturnsQueryParams {
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    returnedBefore: Date | undefined;
    returnedAfter: Date | undefined;
    supplierIds: string[];
    sortParams: ISortParams<IReturn>;
    pageParams: IPageParams;
}

export interface IRevertIgnoreExactOnlineSaleRequest {
    hamsSalesId: string;
}

export interface IRevertIgnoreInvoiceForwardingRequest {
    salesId: string;
}

export interface IRevokeApiTokenRequest {
    tokenId: string;
}

export interface IRfiaAdvanceInvoiceModel {
    companyId: string | undefined;
    reference: string | undefined;
    isAutoSelectReference: boolean;
    validUntil: Date;
    lines: IAdvanceInvoiceLineModel[];
    recipientName: string | undefined;
    addressLine: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    country: string | undefined;
    fromLocationId: string;
}

export interface IRfiaDetail {
    rfia: IRequestForInsuranceAllowance;
    patient: IPatient;
    documents: IDocumentSummary[];
    isHifExist: boolean;
    trialSteps: ITrialStepDto[];
    anamnesisDocument: IDocumentSummary;
    cosiDocument: IDocumentSummary;
    lastLoanSlip: IDocumentSummary;
    lastTrialReportDocument: IDocumentSummary;
    handoverCertificate: IDocumentSummary;
    requiredDocumentIds: string[];
    otherDocuments: IDocumentSummary[];
    actualMedicalPrescriptionStep: IMedicalPrescriptionStep;
    actualFeedbackAdvisoryPhysicianStep: IFeedbackAdvisoryPhysicianStep;
}

export interface IRfiaFilterData {
    warnings: string[];
    labels: string[];
}

export interface IRfiaHandoverLineModel {
    productCatalogItemId: string | undefined;
    inventoryItemId: string | undefined;
    zeroBasedIndexNumber: number;
    description: string | undefined;
    manufacturer: string | undefined;
    model: string | undefined;
    serialNumber: string | undefined;
    isRizivRefundable: boolean;
    rizivHearingAidDefinitionV2IdentificationCode: number | undefined;
    quantity: number;
    vatPercentage: number;
    unitListPriceInVat: number;
    unitPriceInVat: number;
    isIncludeOnHandoverCertificate: boolean;
    assuredProductCatalogItemId: string | undefined;
    assuredInventoryItemId: string | undefined;
}

export interface IRfiaHandoverSummary {
    id: string;
    handoverDate: Date | undefined;
    isHandedOver: boolean;
    isNegativelyEvaluated: boolean;
}

export interface IRfiaInvoiceProcess {
    steps: string[];
    tenders: ITenderSummary[];
    sales: ISalesSummary[];
    hasTenders: boolean;
    hasSales: boolean;
    hasAdvanceInvoices: boolean;
    isFullyPaid: boolean;
    isFullyPaidByHif: boolean;
    isFullyPaidByPatient: boolean;
    isNothingPaid: boolean;
}

export interface IRfiaModel {
    patientId: string;
    applyThirdPartyPaymentScheme: boolean;
    entPhysicianId: string | undefined;
    entPhysicianOfficeId: string | undefined;
    prescriptionForTrialDate: Date | undefined;
    healthInsuranceFundCode: string | undefined;
    steps: string[];
    attendingAudiologistId: string;
    locationId: string;
}

export interface IRfiaQueryMetadata {
    countActive: number;
    startedYtd: IIntChange;
    handedOverYtd: IIntChange;
    failedTrialYtd: IIntChange;
}

export interface IRfiaSettings {
    defaultTrialDuration: ITimeModel;
    defaultSteps: string[];
    defaultApplyThirdPartyScheme: boolean;
    defaultExpectedReceptionTermForMedicalPrescription: ITimeModel;
    defaultExpectedReceptionTermForAdvisoryPhysician: ITimeModel;
    defaultExpectedHandoverTermAfterApproval: ITimeModel;
    defaultFailedTrialVatPercentage: number;
    defaultRizivRefundVatPercentage: number;
    handoverSaleGenerationMode: string | undefined;
    referenceSettings: IReferenceSettings;
    id: string;
}

export interface IRfiasExportParams {
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    prescriptionForTrialDateBefore: Date | undefined;
    prescriptionForTrialDateAfter: Date | undefined;
    handoverDateBefore: Date | undefined;
    handoverDateAfter: Date | undefined;
    medicalPrescriptionSentDateAfter: Date | undefined;
    medicalPrescriptionSentDateBefore: Date | undefined;
    statuses: string[];
    invoiceProcessStatuses: string[];
    paymentStatuses: string[];
    entPhysicianIds: string[];
    audiologistIds: string[];
    locationIds: string[];
    warnings: string[];
    isFailedTrial: boolean | undefined;
    hasMissingDocuments: boolean | undefined;
    hasWarning: boolean | undefined;
    isCompleted: boolean | undefined;
    labels: string[];
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
}

export interface IRfiasQueryParams {
    searchString: string;
    sortParams: ISortParams<IRequestForInsuranceAllowance>;
    pageParams: IPageParams;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    prescriptionForTrialDateBefore: Date | undefined;
    prescriptionForTrialDateAfter: Date | undefined;
    handoverDateBefore: Date | undefined;
    handoverDateAfter: Date | undefined;
    medicalPrescriptionSentDateAfter: Date | undefined;
    medicalPrescriptionSentDateBefore: Date | undefined;
    statuses: string[];
    invoiceProcessStatuses: string[];
    paymentStatuses: string[];
    entPhysicianIds: string[];
    audiologistIds: string[];
    locationIds: string[];
    warnings: string[];
    isFailedTrial: boolean | undefined;
    hasMissingDocuments: boolean | undefined;
    hasWarning: boolean | undefined;
    isCompleted: boolean | undefined;
    labels: string[];
}

export interface IRizivHearingAidDefinitionV2Dto {
    identificationCode: number;
    version: number;
    subListCode: number;
    distributor: string | undefined;
    manufacturer: string | undefined;
    name: string | undefined;
    reference: string | undefined;
    validFrom: Date;
    validTo: Date | undefined;
    updatedOn: Date | undefined;
    publicPrice: number | undefined;
    reimbursement: number | undefined;
    supplement: number | undefined;
    supplementCode: string | undefined;
    distortion: string | undefined;
    frequencyRange: string | undefined;
    privateLabel: string | undefined;
    originalIdentificationCode: number | undefined;
    originalBrand: string | undefined;
    originalName: string | undefined;
    originalReference: string | undefined;
    technologyLevel: number | undefined;
    identificationWarranty: number | undefined;
    priceExtensionWarranty: number | undefined;
    reimbursementWarranty: number | undefined;
    supplementWarranty: number | undefined;
    nomenValidFrom: Date | undefined;
    nomenValidTo: Date | undefined;
    nomenWarrantyValidFrom: Date | undefined;
    nomenWarrantyValidTo: Date | undefined;
    id: number;
    identificationCodeAsString: string | undefined;
    manufacturerCommaName: string | undefined;
    identificationCodeV1: string | undefined;
}

export interface IRizivHearingAidDefinitionV2FilterData {
    distributors: string[];
    manufacturers: string[];
}

export interface IRizivHearingAidDefinitionV2IdAndDistributorDto {
    identificationCode: number;
    distributor: string | undefined;
}

export interface IRizivHearingAidDefinitionV2ManufacturerAndNameGroupDto {
    id: string;
    manufacturer: string | undefined;
    name: string | undefined;
    matches: IRizivHearingAidDefinitionV2IdAndDistributorDto[];
    identificationCodes: number[];
    countIdentificationCodes: number;
    isSingleDistributor: boolean;
    hasMultipleDistributors: boolean;
    manufacturerCommaName: string | undefined;
    distributors: string[];
    distributorsCsv: string | undefined;
    identificationCodesCsv: string | undefined;
}

export interface IRizivHearingAidDefinitionsV2ManufacturerAndNameGroupQueryParams {
    searchString: string;
    sortParams: ISortParams<IRizivHearingAidDefinitionV2ManufacturerAndNameGroupDto>;
    pageParams: IPageParams;
    distributors: string[];
    manufacturers: string[];
    subListCodes: string[];
}

export interface IRoom {
    id: string;
    created: Date;
    lastUpdated: Date;
    location: IObjectWithIdAndIdentifier<string>;
    name: string | undefined;
    isDeleted: boolean;
    isLocationPlannable: boolean;
    calendarColor: string | undefined;
    identifier: string;
    locationId: string;
    locationIdentifier: string | undefined;
    isNotDeletedAndLocationPlannable: boolean;
}

export interface IRoomData {
    id: string;
    name: string | undefined;
}

export interface IRoomsCache {
    all: IRoom[];
    notDeletedAndLocationPlannable: IRoom[];
}

export interface IRosaCalendar {
    id: string | undefined;
    siteId: string | undefined;
    hpId: string | undefined;
    label: string | undefined;
    hexColor: string | undefined;
    defaultTimezone: string | undefined;
    hpNameFromLabel: string | undefined;
}

export interface IRosaEventDto {
    id: string | undefined;
    created: Date;
    lastUpdated: Date;
    title: string | undefined;
    status: string | undefined;
    description: string | undefined;
    patientNote: string | undefined;
    hpNote: string | undefined;
    startsAt: Date;
    endsAt: Date | undefined;
    isAllDay: boolean;
    type: string | undefined;
    groupId: string | undefined;
    calendarId: string | undefined;
    calendarLabel: string | undefined;
    calendarHexColor: string | undefined;
    hpId: string | undefined;
    hpNameFromCalendarLabel: string | undefined;
    hamsUserId: string | undefined;
    hamsUserName: string | undefined;
    siteId: string | undefined;
    siteName: string | undefined;
    motiveId: string | undefined;
    motiveLabel: string | undefined;
    motiveHexColor: string | undefined;
    patientRecordId: string | undefined;
    patientRecordName: string | undefined;
    patientAttendeeStatus: string | undefined;
    patientPrimaryPhoneNumber: string | undefined;
    patientPrimaryEmail: string | undefined;
    hamsPatientId: string | undefined;
    isRecurring: boolean;
    isDeleted: boolean;
    isNoShow: boolean;
    isAppointment: boolean;
    isActive: boolean;
    hasMotive: boolean;
    hasHamsPatient: boolean;
    hasPatient: boolean;
    hasCalendar: boolean;
    hasHp: boolean;
    hasHamsUser: boolean;
    hasPatientNote: boolean;
    hasHpNote: boolean;
    hasPhone: boolean;
    hasEmail: boolean;
    hasSite: boolean;
    display: string | undefined;
}

export interface IRosaEventsByPatientMetadata {
    hamsPatientId: string;
    redirectRosaPatientRecordId: string | undefined;
    hasRedirectId: boolean;
}

export interface IRosaEventsByPatientQueryParams {
    patientId: string;
    pageParams: IPageParams;
}

export interface IRosaEventsQueryParams {
    after: Date;
    before: Date;
}

export interface IRosaEventsResponse {
    events: IRosaEventDto[];
    concurrencyToken: number;
    lastSyncedDate: Date | undefined;
    myCalendars: IRosaCalendar[];
    otherCalendars: IRosaCalendar[];
    motives: IRosaMotiveSummaryDto[];
    calendars: IRosaCalendar[];
    hps: IRosaHpDto[];
}

export interface IRosaEventsSyncStatus {
    countInRosa: number;
    countInHams: number;
    areSynced: boolean;
}

export interface IRosaHamsSyncRecord {
    lastSyncedDate: Date | undefined;
    patientLastUpdatedSince: Date | undefined;
    eventsLastUpdatedSince: Date | undefined;
}

export interface IRosaHpDto {
    id: string | undefined;
    name: string | undefined;
    label: string | undefined;
}

export interface IRosaIntegrationStatusDto {
    isEnabled: boolean;
    tokenFirstFourChars: string | undefined;
    organizationId: string | undefined;
    environment: RosaEnvironment;
    hasToken: boolean;
}

export interface IRosaMotiveSummaryDto {
    id: string | undefined;
    label: string | undefined;
    hexColor: string | undefined;
    isHidden: boolean;
}

export interface IRosaPatientMatchResponse {
    matchedHamsPatientOnSocialSecurityNumber: IPatientMatchSummary[];
    matchedHamsPatientsOnName: IPatientMatchSummary[];
    countMatchedOnSocialSecurityNumber: number;
    hasMatchesOnSocialSecurityNumber: boolean;
    countMatchedOnName: number;
    hasMatchesOnName: boolean;
}

export interface IRosaPatientRecord {
    rosaPatientId: string | undefined;
    created: Date;
    lastUpdated: Date;
    firstName: string | undefined;
    lastName: string | undefined;
    socialSecurityNumber: string | undefined;
    primaryPhoneNumber: string | undefined;
    primaryEmail: string | undefined;
    dateOfBirth: Date | undefined;
    gender: string | undefined;
    language: string | undefined;
    address: IAddress;
    status: string | undefined;
    mergedFromIds: string[];
    mergedToId: string | undefined;
    hamsPatientId: string | undefined;
    isMergedTo: boolean;
    isMergedFrom: boolean;
    formattedSocialSecurityNumber: string | undefined;
    formattedPrimaryPhoneNumber: string | undefined;
    id: string | undefined;
    isLinkedToHamsPatient: boolean;
    searchField: string | undefined;
    lastNameCommaFirstName: string | undefined;
    formattedAddress: string | undefined;
    hasAddress: boolean;
}

export interface IRosaPatientRecordRedirectResponse {
    rosaPatientRecordId: string | undefined;
    data: IRosaPatientRecord;
    exists: boolean;
    hamsPatientId: string | undefined;
    isLinkedToHamsPatient: boolean;
}

export interface IRosaPatientRecordWithMemberEquality {
    rosaData: IRosaPatientRecord;
    hamsFirstName: string | undefined;
    hamsLastName: string | undefined;
    hamsFormattedSocialSecurityNumber: string | undefined;
    hamsFormattedPrimaryPhoneNumber: string | undefined;
    hamsPrimaryEmail: string | undefined;
    hamsGender: string | undefined;
    hamsLanguage: string | undefined;
    hamsDateOfBirth: Date | undefined;
    hamsAddress: IAddress;
    hamsStatus: string | undefined;
    isFirstNameEqual: boolean;
    isLastNameEqual: boolean;
    isSocialSecurityNumberEqual: boolean;
    isPrimaryPhoneNumberEqual: boolean;
    isPrimaryEmailEqual: boolean;
    isGenderEqual: boolean;
    isLanguageEqual: boolean;
    isAddressEqual: boolean;
    isDateOfBirthEqual: boolean;
    isMergedTo: boolean;
    areAllMembersEqual: boolean;
    oneOrMoreMembersAreDifferent: boolean;
}

export interface IRosaPatientRecordsQueryParams {
    searchString: string;
    sortParams: ISortParams<IRosaPatientRecord>;
    pageParams: IPageParams;
    isLinked: boolean | undefined;
    lastUpdatedAfter: Date | undefined;
    lastUpdatedBefore: Date | undefined;
}

export interface IRosaPatientsQueryMetadata {
    countRecords: number;
    countUnlinkedRecords: number;
    lastSyncedDate: Date | undefined;
}

export interface IRosaPatientsSyncStatus {
    countInRosa: number;
    countRosaPatientRecordsInHams: number;
    countPatientsInHams: number;
    areSynced: boolean;
}

export interface IRosaRegistrationRequest {
    rosaBearerToken: string | undefined;
    environment: RosaEnvironment;
}

export interface IRosaStatusDto {
    countPatientRecords: number;
    countUnlinkedPatientRecords: number;
    countUsers: number;
    countUnlinkedUsers: number;
    lastSyncedDate: Date | undefined;
    hasUnlinkedPatientRecords: boolean;
    hasUnlinkedUsers: boolean;
    hasNotification: boolean;
}

export interface IRosaSyncStatus {
    motiveIdsOnRosa: string[];
    motiveIdsLocal: string[];
    calendarIdsOnRosa: string[];
    calendarIdsLocal: string[];
    siteIdsOnRosa: string[];
    siteIdsLocal: string[];
    patientsSyncStatus: IRosaPatientsSyncStatus;
    eventsSyncStatus: IRosaEventsSyncStatus;
    notSyncedMotiveIds: string[];
    notSyncedCalendarIds: string[];
    notSyncedSiteIds: string[];
    hasNotSyncedMotiveIds: boolean;
    hasNotSyncedCalendarIds: boolean;
    hasNotSyncedSiteIds: boolean;
}

export interface IRosaSyncStatusResponse {
    syncRecord: IRosaHamsSyncRecord;
    status: IRosaSyncStatus;
    hasSyncRecord: boolean;
    hasStatus: boolean;
}

export interface IRosaUserToHamsUserLink {
    rosaId: string | undefined;
    rosaName: string | undefined;
    hamsId: string | undefined;
    hamsName: string | undefined;
    isLinked: boolean;
}

export interface IRosaUsersLinkDto {
    users: IRosaUserToHamsUserLink[];
    count: number;
    countUnlinked: number;
}

export interface IRosaViewPreferences {
    userId: string;
    showScheduleFromHour: number;
    showScheduleToHour: number;
    timeScale: number;
    showOnlyWeekDays: boolean;
    defaultView: string | undefined;
    showScheduleFromHourFormatted: string | undefined;
    showScheduleToHourFormatted: string | undefined;
    id: string;
}

export interface ISale {
    id: string;
    created: Date;
    lastUpdated: Date;
    externalReference: string | undefined;
    isInvoice: boolean;
    validUntil: Date;
    recipient: IRecipient;
    lines: ISalesLine[];
    customerAccountLines: ICustomerAccountLineData[];
    cashSalePayments: IPaymentLineData[];
    referencePatient: IObjectWithIdAndIdentifier<string>;
    cashSaleForPatient: IObjectWithIdAndIdentifier<string>;
    creditedInvoice: IGuidObjectWithIdAndReference;
    location: IObjectWithIdAndIdentifier<string>;
    createdByUserId: string;
    document: IDocumentSummary;
    isAdvance: boolean;
    linkViewContext: ILinkViewContext;
    commissionId: string | undefined;
    labels: string[];
    orderReference: string | undefined;
    reference: string;
    belgianStructuredCreditorReferenceCsv: string | undefined;
    defaultBelgianStructuredCreditorReference: string | undefined;
    hasDefaultBelgianStructuredCreditorReference: boolean;
    hasCommission: boolean;
    canSelectForCommission: boolean;
    linkViewContextType: string | undefined;
    linkViewContextId: string | undefined;
    locationId: string;
    locationIdentifier: string | undefined;
    isCreditNote: boolean;
    customerAccountLineIds: string[];
    customerAccountIds: string[];
    isCashSale: boolean;
    hasCustomerAccounts: boolean;
    hasSingleCustomerAccount: boolean;
    hasMultipleCustomerAccounts: boolean;
    singleCustomerAccount: ICustomerAccountLineData;
    countItems: number;
    countLines: number;
    recipientName: string | undefined;
    recipientAddressLine: string | undefined;
    recipientCountry: string | undefined;
    recipientZip: string | undefined;
    recipientCity: string | undefined;
    identifier: string;
    amountToPaySearchString: string | undefined;
    searchField: string | undefined;
    patientId: string | undefined;
    documentId: string | undefined;
    hasDocument: boolean;
    amountToPay: number;
    amountPaid: number;
    outstandingBalance: number;
    hasOutstandingBalance: boolean;
    isFullyPaid: boolean;
    isPartlyPaid: boolean;
    isNothingPaid: boolean;
    isOverDue: boolean;
    hasPayments: boolean;
    isPaidByPatientOrCompany: boolean;
    isPaidByHif: boolean;
    hasHifPayment: boolean;
    anyCustomerAccountOfTypeCompany: boolean;
    firstPaymentCreatedDate: Date | undefined;
    lastPaymentCreatedDate: Date | undefined;
    rfiaId: string | undefined;
    vatSplits: IVatSplit[];
    priceInVat: number;
    priceExVat: number;
    vatAmount: number;
    paymentStatus: string | undefined;
    type: string | undefined;
    priceDevicesExVat: number;
    priceDevicesInVat: number;
    canCreateRefund: boolean;
    needsNowAfter: Date | undefined;
    isCompleted: boolean;
    hasWarning: boolean;
    hasError: boolean;
    isFullyCredited: boolean;
    isPartlyCredited: boolean;
    isNothingCredited: boolean;
    canCreateCreditNote: boolean;
    creditedStatus: string | undefined;
    recupelInVat: number;
    bebatInVat: number;
    isRecipientVatCustomer: boolean;
    storedNow: Date;
    storedNowPreviousToNeedsNowAfter: boolean;
}

export interface ISaleCreditNoteLineModel {
    invoiceLineId: string;
    quantity: number;
    zeroBasedIndexNumber: number;
}

export interface ISaleCreditNoteModel {
    invoiceId: string;
    reference: string | undefined;
    isAutoSelectReference: boolean;
    lines: ISaleCreditNoteLineModel[];
    fromLocationId: string;
}

export interface ISalesAnalysisData {
    revenueByLocation: IKeyDoubleValue[];
    revenueByCategory: IKeyDoubleValue[];
    revenuesPerMonth: ISortableKeyDoubleValue[];
    revenuesPerWeek: ISortableKeyDoubleValue[];
}

export interface ISalesByPatientOverview {
    sales: ISalesSummary[];
    countWithOutstandingBalance: number;
    countTotal: number;
    totalValueInVat: number;
    amountToPay: number;
}

export interface ISalesByPatientResponse {
    patientId: string;
    sales: ISale[];
    count: number;
    totalValueInVat: number;
    countWithOutstandingBalance: number;
    outstandingBalance: number;
    countPaid: number;
    amountPaid: number;
}

export interface ISalesData {
    id: string;
    date: Date;
    reference: string | undefined;
    recipientName: string | undefined;
    priceInVat: number;
}

export interface ISalesDataWithType {
    id: string;
    date: Date;
    reference: string | undefined;
    recipientName: string | undefined;
    priceInVat: number;
    type: string | undefined;
}

export interface ISalesDto {
    data: ISale;
    peppolRecord: IPeppolRecord;
    hasPeppolRecord: boolean;
    canSendOnPeppolNetwork: boolean;
}

export interface ISalesExportParams {
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    validUntilBefore: Date | undefined;
    validUntilAfter: Date | undefined;
    priceInVatMoreThan: number | undefined;
    priceInVatLessThan: number | undefined;
    paymentStatuses: string[];
    types: string[];
    creditedStatuses: string[];
    locationIds: string[];
    hasDocument: boolean | undefined;
    searchMode: SalesSearchMode;
    labels: string[];
    zips: string[];
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
    isRecipientVatCustomer: boolean | undefined;
    prefilter: SalesPrefilter;
}

export interface ISalesFilterData {
    labels: string[];
    zips: string[];
}

export interface ISalesForCommissionQueryParams {
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    paymentStatuses: string[];
    types: string[];
    creditedStatuses: string[];
    sortParams: ISortParams<ISale>;
    pageParams: IPageParams;
    isShowAll: boolean;
}

export interface ISalesLine {
    id: string;
    productCatalogItemId: string | undefined;
    productCatalogItemType: ProductCatalogItemType;
    inventoryItemId: string | undefined;
    description: string | undefined;
    indexNumber: number;
    creditedQuantity: number;
    recupelCode: string | undefined;
    recupelUnitPriceInVat: number;
    recupelVatPercentage: number;
    bebatUnitPriceInVat: number;
    assuredProductCatalogItemId: string | undefined;
    assuredInventoryItemId: string | undefined;
    unitPrice: number;
    unitListPrice: number;
    vatPercentage: number;
    quantity: number;
    isVatIncluded: boolean;
    isInventoryItem: boolean;
    hasProductCatalogItem: boolean;
    isFullyCredited: boolean;
    isPartlyCredited: boolean;
    isNothingCredited: boolean;
    creditedStatus: string | undefined;
    recupelLinePriceInVat: number;
    hasRecupelCode: boolean;
    bebatLinePriceInVat: number;
    unitPriceInVat: number;
    unitListPriceInVat: number;
    linePriceInVat: number;
    lineListPriceInVat: number;
    unitPriceExVat: number;
    unitListPriceExVat: number;
    linePriceExVat: number;
    lineListPriceExVat: number;
    unitVatValue: number;
    lineVatValue: number;
    unitDiscountValueInVat: number;
    unitDiscountValueExVat: number;
    lineDiscountValueInVat: number;
    lineDiscountValueExVat: number;
    discountPercentage: number;
}

export interface ISalesLineDetails {
    id: string;
    productCatalogItemId: string | undefined;
    productCatalogItemType: ProductCatalogItemType;
    inventoryItemId: string | undefined;
    description: string | undefined;
    unitPrice: number;
    unitListPrice: number;
    vatPercentage: number;
    quantity: number;
    discountPercentage: number;
    linePriceInVat: number;
    creditedStatus: string | undefined;
    salesId: string;
    salesReference: string | undefined;
    salesDate: Date;
    category: string | undefined;
    subCategory: string | undefined;
    serialNumber: string | undefined;
    searchField: string | undefined;
}

export interface ISalesLineDto {
    description: string | undefined;
    linePriceInVat: number;
}

export interface ISalesLineForAssuranceDto {
    id: string;
    productCatalogItemId: string;
    inventoryItemId: string | undefined;
    description: string | undefined;
    nonCreditedQuantity: number;
    serialNumber: string | undefined;
    salesReference: string | undefined;
    salesDate: Date;
    canSelect: boolean;
}

export interface ISalesLineModel {
    productCatalogItemId: string | undefined;
    inventoryItemId: string | undefined;
    zeroBasedIndexNumber: number;
    description: string | undefined;
    quantity: number;
    vatPercentage: number;
    unitListPriceInVat: number;
    unitPriceInVat: number;
    assuredProductCatalogItemId: string | undefined;
    assuredInventoryItemId: string | undefined;
}

export interface ISalesLinesQueryParams {
    searchString: string;
    sortParams: ISortParams<ISalesLineDetails>;
    pageParams: IPageParams;
    salesDateBefore: Date | undefined;
    salesDateAfter: Date | undefined;
    creditedStatuses: string[];
    categories: string[];
    subCategories: string[];
    productCatalogItemTypes: ProductCatalogItemType[];
}

export interface ISalesQueryMetadata {
    countFilteredNonCashSales: number;
    countNotPaid: number;
    countNotPaidAndOverdue: number;
    totalOutstandingBalance: number;
    amountInvoicedYtd: IDoubleChange;
}

export interface ISalesQueryParams {
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    validUntilBefore: Date | undefined;
    validUntilAfter: Date | undefined;
    priceInVatMoreThan: number | undefined;
    priceInVatLessThan: number | undefined;
    paymentStatuses: string[];
    types: string[];
    creditedStatuses: string[];
    locationIds: string[];
    sortParams: ISortParams<ISale>;
    pageParams: IPageParams;
    hasDocument: boolean | undefined;
    searchMode: SalesSearchMode;
    labels: string[];
    zips: string[];
    isRecipientVatCustomer: boolean | undefined;
    prefilter: SalesPrefilter;
}

export interface ISalesSettings {
    defaultValidUntil: ITimeModel;
    invoiceReferenceSettings: IReferenceSettings;
    cashSaleReferenceSettings: IReferenceSettings;
    autoSetToPaid: boolean;
    id: string;
}

export interface ISalesStats {
    countNotPaid: number;
    countOverdue: number;
    hasData: boolean;
}

export interface ISalesSummary {
    id: string;
    date: Date;
    reference: string | undefined;
    recipientName: string | undefined;
    priceInVat: number;
    isAdvance: boolean;
    isCreditNote: boolean;
    isFullyCredited: boolean;
    customerAccountLines: ICustomerAccountLineSummary[];
    documentId: string | undefined;
    type: string | undefined;
    patientId: string | undefined;
    amountToPay: number;
    amountPaid: number;
    totalValue: number;
    isFullyPaid: boolean;
    isPartlyPaid: boolean;
    isNothingPaid: boolean;
    hasDocument: boolean;
    isPaidByPatientOrCompany: boolean;
    isPaidByHif: boolean;
    paymentStatus: string | undefined;
}

export interface ISalesTicket {
    sale: ICashSaleDto;
    businessData: IBusinessDataDto;
    logo: string | undefined;
}

export interface ISaveDocumentRequest {
    documentId: string;
    contentAsBase64: string | undefined;
}

export interface ISearchNoahDevicesQueryParams {
    searchString: string;
    sortParams: ISortParams<IProductCatalogItem>;
    pageParams: IPageParams;
}

export interface ISearchPhysicianByNameModel {
    codes: string[];
    name: string;
}

export interface ISearchPhysicianByRizivNumberModel {
    codes: string[];
    rizivNumber: string;
}

export interface ISendInvoiceToPeppolRequest {
    id: string;
}

export interface ISendLoginTokenRequest {
    email: string | undefined;
}

export interface ISendRepairToSupplierRequest {
    repairId: string;
    expectedRedeliveryDate: Date;
    fromLocationId: string;
}

export interface ISendResetPasswordLinkRequest {
    email: string;
}

export interface ISendToSupplierStep {
    date: Date;
    fromLocation: IObjectWithIdAndIdentifier<string>;
    expectedRedeliveryDate: Date;
}

export interface IServiceProductCatalogItemModel {
    listPrice: number;
    vatPercentage: number;
    category: string | undefined;
    subcategory: string | undefined;
    canAlsoPurchase: boolean;
    name: string;
}

export interface ISetRosaViewPreferencesRequest {
    showScheduleFromHour: number;
    showScheduleToHour: number;
    timeScale: number;
    showOnlyWeekDays: boolean;
    defaultView: string | undefined;
}

export interface ISettlementProposal {
    id: string;
    created: Date;
    lastUpdated: Date;
    documentDataLastUpdated: Date;
    metaReference: string | undefined;
    validUntil: Date;
    customerAccount: ICustomerAccountData;
    lines: ISettlementProposalLine[];
    payment: IGuidObjectWithIdAndReference;
    recipient: IRecipient;
    createdByUserId: string;
    document: IDocumentSummary;
    belgianStructuredCreditorReference: string | undefined;
    labels: string[];
    payments: ISpsPayment[];
    reference: string;
    isDocumentInSync: boolean;
    documentId: string | undefined;
    hasDocument: boolean;
    customerAccountId: string;
    customerAccountType: string;
    customerAccountIdentifier: string;
    customerAccountLineIds: string[];
    paymentId: string | undefined;
    paymentReference: string | undefined;
    totalValue: number;
    isHandled: boolean;
    isFullyPaid: boolean;
    isPartlyPaid: boolean;
    amountPaid: number;
    paymentStatus: string | undefined;
    isOverDue: boolean;
    searchField: string | undefined;
    needsNowAfter: Date | undefined;
    isCompleted: boolean;
    hasWarning: boolean;
    hasError: boolean;
    storedNow: Date;
    storedNowPreviousToNeedsNowAfter: boolean;
}

export interface ISettlementProposalFilterData {
    labels: string[];
}

export interface ISettlementProposalForCustomerAccountSummary {
    id: string;
    created: Date;
    reference: string | undefined;
    metaReference: string | undefined;
    totalValue: number;
    isHandled: boolean;
}

export interface ISettlementProposalLine {
    id: string;
    customerAccountLineId: string;
    sale: ISalesData;
    referencePatient: IObjectWithIdAndIdentifier<string>;
    referencePatientSocialSecurityNumber: string | undefined;
    value: number;
    paymentLineId: string | undefined;
    isOverrideSetToFullyPaid: boolean;
    referencePatientId: string | undefined;
    hasReferencePatient: boolean;
    saleId: string;
    salesReference: string | undefined;
    salesRecipientName: string | undefined;
    salesDate: Date;
    isPayed: boolean;
}

export interface ISettlementProposalModel {
    reference: string | undefined;
    isAutoSelectReference: boolean;
    referenceDate: Date;
    customerAccountId: string;
    validUntil: Date;
    customerAccountLineIds: string[];
    recipientName: string | undefined;
    addressLine: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    country: string | undefined;
}

export interface ISettlementProposalQueryMetadata {
    countUnhandled: number;
}

export interface ISettlementProposalSettings {
    created: Date;
    lastUpdated: Date;
    referenceSettings: IReferenceSettings;
    id: string;
}

export interface ISettlementProposalsExportParams {
    searchString: string;
    createdAfter: Date | undefined;
    createdBefore: Date | undefined;
    paymentStatuses: string[];
    isHandled: boolean | undefined;
    labels: string[];
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
}

export interface ISettlementProposalsForCustomerAccountExportParams {
    searchString: string;
    createdAfter: Date | undefined;
    createdBefore: Date | undefined;
    paymentStatuses: string[];
    isHandled: boolean | undefined;
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
}

export interface ISettlementProposalsForCustomerAccountQueryParams {
    searchString: string;
    createdAfter: Date | undefined;
    createdBefore: Date | undefined;
    paymentStatuses: string[];
    isHandled: boolean | undefined;
    sortParams: ISortParams<ISettlementProposal>;
    pageParams: IPageParams;
}

export interface ISettlementProposalsQueryParams {
    searchString: string;
    createdAfter: Date | undefined;
    createdBefore: Date | undefined;
    paymentStatuses: string[];
    isHandled: boolean | undefined;
    labels: string[];
    sortParams: ISortParams<ISettlementProposal>;
    pageParams: IPageParams;
}

export interface ISettlementProposalsStats {
    countNotPaid: number;
    countOverDue: number;
    hasData: boolean;
}

export interface IShadowIndexDebugInfo {
    id: string;
    shadowIndex: number | undefined;
    indexExists: boolean;
    rIndexExists: boolean;
    hasError: boolean;
}

export interface ISingleHandoverResponse {
    salesId: string;
    errors: IValidationError<IRegisterRfiaHandoverSingleRequest>[];
    hasError: boolean;
    isSuccess: boolean;
    error: string;
}

export interface ISortableKeyDoubleValue {
    key: string | undefined;
    sortableKey: number;
    value: number;
}

export interface ISpeechAudiogram {
    points: ISpeechPoint[];
    stimulusSignalOutput: string | undefined;
    hearingInstrumentConditionType: string | undefined;
    type: string | undefined;
    orderedPoints: ISpeechPoint[];
    calculatedPoints: ICalculatedSpeechPoint[];
    srtIntensity: number;
    icaScore: number;
    icaLeftSideEquation: string | undefined;
    biapScore: number;
    biapLeftSideEquation: string | undefined;
    scoreAt40dB: number;
    isReceptionThreshold: boolean;
    isDiscrimination: boolean;
    stimulusSignalOutputDisplay: string | undefined;
    hearingInstrumentConditionTypeDisplay: string | undefined;
    displayOrKey: string | undefined;
    leftRightOrStereo: string | undefined;
    isHeadphones: boolean;
    isAided: boolean;
    isUnaided: boolean;
    isLeft: boolean;
    isRight: boolean;
    isStereo: boolean;
    hasEntryPoints: boolean;
}

export interface ISpeechAudiogramTestModel {
    audiogramStandardId: string;
    aided: ISpeechAudiogram;
    unaided: ISpeechAudiogram;
}

export interface ISpeechImage {
    attachmentId: string;
    type: string | undefined;
}

export interface ISpeechImageDto {
    data: string | undefined;
    type: string | undefined;
}

export interface ISpeechImageModel {
    tests: ISpeechModel[];
}

export interface ISpeechInNoiseTest {
    list: ISpeechInNoiseTestWordsList;
    unaidedScoreInDbSnrFor50Percent: number;
    aidedScoreInDbSnrFor50Percent: number;
    aidedScoreAtDbSnrOfSrt: number;
    scoreDifferenceWithNormInDbSnrFor50Percent: number;
    absScoreDifferenceWithNormInDbSnrFor50Percent: number;
    speechIntelligibilityImprovement: number;
    improvementAidedVersusUnaidedInDbSnrFor50Percent: number;
}

export interface ISpeechInNoiseTestModel {
    listName: string | undefined;
    unaidedScoreInDbSnrFor50Percent: number;
    aidedScoreInDbSnrFor50Percent: number;
    aidedScoreAtDbSnrOfSrt: number;
}

export interface ISpeechInNoiseTestWordsList {
    name: string | undefined;
    normScoreInDbSnrFor50Percent: number;
}

export interface ISpeechModel {
    points: ISpeechPointModel[];
    leftRightOrStereo: string | undefined;
    isAided: boolean;
    isHeadphones: boolean;
}

export interface ISpeechPoint {
    stimulusLevel: number;
    scorePercentage: number;
    maskingLevel: number;
    intensity: number;
    x: number;
    y: number;
}

export interface ISpeechPointModel {
    intensity: number;
    scorePercentage: number;
}

export interface ISpeechTest {
    date: Date;
    audiogramStandardId: string;
    aided: ISpeechAudiogram;
    unaided: ISpeechAudiogram;
    improvementAgainstVocalIndex: number;
    improvementAtSrtIntensity: number;
    icaImprovement: number;
    icaImprovementRounded: number;
    biapImprovement: number;
    icaImprovementLeftSideEquation: string | undefined;
    biapImprovementLeftSideEquation: string | undefined;
}

export interface ISplitHandoverResponse {
    patientSalesId: string;
    rizivSalesId: string;
    errors: IValidationError<IRegisterRfiaHandoverSplitRequest>[];
    hasError: boolean;
    isSuccess: boolean;
    error: string;
}

export interface ISpsPayment {
    id: string;
    date: Date;
    reference: string | undefined;
}

export interface IStandardDocumentDto {
    id: string | undefined;
    created: Date;
    templateType: string | undefined;
    language: string | undefined;
    name: string | undefined;
    mustSign: boolean;
    canEdit: boolean;
    canViewOnline: boolean;
    extension: string | undefined;
}

export interface IStandardDocumentsQueryParams {
    type: string | undefined;
    date: Date | undefined;
}

export interface IStereoToneThresholdAudiogramTestModel {
    audiogramStandardId: string;
    leftData: IToneThresholdAudiogram;
    leftPointsForPta: number[];
    rightData: IToneThresholdAudiogram;
    rightPointsForPta: number[];
}

export interface IStockAtLocation {
    locationId: string;
    count: number;
    id: string;
}

export interface IStockEntriesQueryParams {
    beforeDate: Date | undefined;
    afterDate: Date | undefined;
    sortParams: ISortParams<IStockEntryDto>;
    pageParams: IPageParams;
}

export interface IStockEntryDate {
    date: Date;
    id: string | undefined;
}

export interface IStockEntryDto {
    stockEntryDate: IStockEntryDate;
    stockValueChange: IDoubleChange;
    countInStockChange: IIntChange;
    countInBackOrderChange: IIntChange;
    countInRepairChange: IIntChange;
    countInTestOrLoanChange: IIntChange;
    isDirty: boolean;
    date: Date;
    id: string | undefined;
}

export interface IStockInfo {
    pcId: string;
    stockAtLocations: IStockAtLocation[];
    countInRepair: number;
    countInBackOrder: number;
    countInTestOrLoan: number;
    stockValue: number;
    countPurchased: number;
    countSold: number;
    countInStock: number;
    financialQuantity: number;
    physicalQuantity: number;
    deltaFinancialAndPhysical: number;
    hasDeltaFinancialAndPhysical: boolean;
    stockAvailableAtLocationIds: string[];
}

export interface IStockItemDto {
    productCatalogItemId: string;
    hasSerialNumber: boolean;
    manufacturer: string | undefined;
    model: string | undefined;
    type: ProductCatalogItemType;
    category: string | undefined;
    subcategory: string | undefined;
    vatPercentage: number;
    internalReference: string | undefined;
    manufacturerReferences: string[];
    suppliers: IObjectWithIdAndIdentifier<string>[];
    stockAtLocations: IStockAtLocation[];
    countInRepair: number;
    countInBackOrder: number;
    countInTestOrLoan: number;
    stockValue: number;
    countPurchased: number;
    countSold: number;
    purchaseListPrice: number;
    manufacturerCommaModel: string | undefined;
    stockAvailableAtLocationIds: string[];
    supplierIds: string[];
    countInStock: number;
    searchField: string | undefined;
    supplierIdentifierCsv: string | undefined;
    financialQuantity: number;
    physicalQuantity: number;
    hasNegativePhysicalQuantity: boolean;
    deltaFinancialAndPhysical: number;
    hasDeltaFinancialAndPhysical: boolean;
    manufacturerReferencesCsv: string | undefined;
}

export interface IStockItemDtosExportParams {
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
    searchString: string;
    manufacturers: string[];
    types: ProductCatalogItemType[];
    categories: string[];
    subcategories: string[];
    vatPercentages: number[];
    hasSerialNumber: boolean | undefined;
    supplierIds: string[];
    availableOnLocationIds: string[];
    stockMoreThan: number | undefined;
    stockLessThan: number | undefined;
    stockValueMoreThan: number | undefined;
    stockValueLessThan: number | undefined;
    keyFilterType: ProductCatalogItemType | undefined;
}

export interface IStockItemDtosQueryParams {
    searchString: string;
    manufacturers: string[];
    types: ProductCatalogItemType[];
    categories: string[];
    subcategories: string[];
    vatPercentages: number[];
    hasSerialNumber: boolean | undefined;
    supplierIds: string[];
    availableOnLocationIds: string[];
    stockMoreThan: number | undefined;
    stockLessThan: number | undefined;
    stockValueMoreThan: number | undefined;
    stockValueLessThan: number | undefined;
    sortParams: ISortParams<IStockItemDto>;
    keyFilterType: ProductCatalogItemType | undefined;
    pageParams: IPageParams;
}

export interface IStockItemsQueryParamsForArticleProperties {
    searchString: string;
    manufacturers: string[];
    types: ProductCatalogItemType[];
    categories: string[];
    subcategories: string[];
}

export interface IStockItemsQueryParamsForLoan {
    searchString: string;
    sortParams: ISortParams<IProductCatalogItem>;
    pageParams: IPageParams;
    categories: string[];
    subcategories: string[];
    types: ProductCatalogItemType[];
}

export interface IStockItemsQueryParamsForRepair {
    searchString: string;
    sortParams: ISortParams<IProductCatalogItem>;
    pageParams: IPageParams;
    types: ProductCatalogItemType[];
    categories: string[];
    subcategories: string[];
    isShowAll: boolean;
}

export interface IStockMovement {
    id: string;
    created: Date;
    lastUpdated: Date;
    reference: string | undefined;
    fromLocation: IObjectWithIdAndIdentifier<string>;
    toLocation: IObjectWithIdAndIdentifier<string>;
    lines: IStockMovementLine[];
    countItems: number;
    toLocationId: string;
    toLocationIdentifier: string | undefined;
    fromLocationId: string;
    fromLocationIdentifier: string | undefined;
    locationIds: string[];
    searchField: string | undefined;
}

export interface IStockMovementFromInventoryItemModel {
    inventoryItemId: string;
    fromLocationId: string;
    toLocationId: string;
    reference: string | undefined;
    isAutoSelectReference: boolean;
}

export interface IStockMovementLine {
    id: string;
    index: number;
    productCatalogItem: IObjectWithIdAndIdentifier<string>;
    inventoryItemId: string | undefined;
    description: string | undefined;
    quantity: number;
    productCatalogItemId: string;
}

export interface IStockMovementLineModel {
    description: string | undefined;
    productCatalogId: string;
    inventoryItemId: string | undefined;
    quantity: number;
    zeroBasedIndex: number;
}

export interface IStockMovementModel {
    reference: string | undefined;
    isAutoSelectReference: boolean;
    fromLocationId: string;
    toLocationId: string;
    lines: IStockMovementLineModel[];
}

export interface IStockMovementSettings {
    referenceSettings: IReferenceSettings;
    id: string;
}

export interface IStockMovementsExportParams {
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    fromLocationIds: string[];
    toLocationIds: string[];
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
}

export interface IStockMovementsQueryParams {
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    fromLocationIds: string[];
    toLocationIds: string[];
    sortParams: ISortParams<IStockMovement>;
    pageParams: IPageParams;
}

export interface ISubscriptionSummary {
    key: string | undefined;
    isLive: boolean;
    pos: number;
    eventStorePos: number;
    backlog: number;
    isUpToDate: boolean;
    isProcessingBacklog: boolean;
    status: string | undefined;
}

export interface ISubscriptionsQueryParams {
    searchString: string;
    sortParams: ISortParams<ISubscriptionSummary>;
    pageParams: IPageParams;
    statuses: string[];
}

export interface ISupplier {
    id: string;
    created: Date;
    lastUpdated: Date;
    isDeleted: boolean;
    createdByUserId: string;
    name: string | undefined;
    addressLine: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    country: string | undefined;
    email: string | undefined;
    defaultDeliveryTime: ITimeModel;
    brands: string[];
    accountNumber: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    salutation: string | undefined;
    vatNumber: string | undefined;
    countOrders: number;
    countDeliveries: number;
    countPurchases: number;
    amountToPay: number;
    amountPaid: number;
    lastOrderRegisteredDate: Date | undefined;
    searchField: string | undefined;
    hasPurchases: boolean;
    hasDeliveries: boolean;
    hasOrders: boolean;
    addressFormatted: string | undefined;
    contactFormatted: string | undefined;
    brandsCsv: string | undefined;
    hasDefaultDeliveryTime: boolean;
    identifier: string;
    outstandingBalance: number;
    hasOutstandingBalance: boolean;
}

export interface ISupplierAccountOverview {
    countPurchases: number;
    countPurchasesWithOutstandingBalance: number;
    countPayments: number;
}

export interface ISupplierAccountsExportParams {
    searchString: string;
    outstandingBalanceLessThan: number | undefined;
    outstandingBalanceMoreThan: number | undefined;
    hasOutstandingBalance: boolean | undefined;
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
}

export interface ISupplierAccountsQueryParams {
    searchString: string;
    outstandingBalanceLessThan: number | undefined;
    outstandingBalanceMoreThan: number | undefined;
    hasOutstandingBalance: boolean | undefined;
    sortParams: ISortParams<ISupplier>;
    pageParams: IPageParams;
}

export interface ISupplierSummary {
    id: string;
    identifier: string;
    defaultDeliveryTime: ITimeModel;
    countPurchases: number;
    hasPurchases: boolean;
    hasDefaultDeliveryTime: boolean;
}

export interface ISupplierSummaryWithOrderStats {
    id: string;
    name: string | undefined;
    accountNumber: string | undefined;
    brands: string[];
    countOrders: number;
    countOrdersToPlaceWithSupplier: number;
    lastOrderDate: Date | undefined;
    defaultDeliveryTime: ITimeModel;
    hasOrdersToPlaceWithSupplier: boolean;
    hasOrders: boolean;
    countBrands: number;
    identifier: string;
    hasDefaultDeliveryTime: boolean;
}

export interface ISuppliersExportParams {
    searchString: string;
    brands: string[];
    hasOrders: boolean | undefined;
    hasDeliveries: boolean | undefined;
    hasPurchases: boolean | undefined;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    mustApplyFilter: boolean;
    headers: INamedProperty[];
    format: string;
    fileName: string;
    showDeleted: boolean;
}

export interface ISuppliersFilterData {
    brands: string[];
}

export interface ISuppliersQueryParams {
    searchString: string;
    sortParams: ISortParams<ISupplier>;
    pageParams: IPageParams;
    brands: string[];
    hasOrders: boolean | undefined;
    hasDeliveries: boolean | undefined;
    hasPurchases: boolean | undefined;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    showDeleted: boolean;
}

export interface ISwitchLocationRequest {
    locationId: string;
}

export interface ISwitchProductCatalogItemFromInventoryItemRequest {
    inventoryItemId: string;
    productCatalogItemId: string;
}

export interface ISyncOrPushSaleToExactOnlineRequest {
    hamsId: string;
}

export interface ITableDocumentKeyDto {
    description: string | undefined;
    type: string | undefined;
    key: string;
    keyWithBrackets: string;
}

export interface ITemplate {
    id: string;
    created: Date;
    lastUpdated: Date;
    name: string | undefined;
    language: string | undefined;
    predefinedType: string | undefined;
    mustSign: boolean;
    canEdit: boolean;
    canViewOnline: boolean;
    history: ITemplateHistory[];
    userDefinedMainContext: string | undefined;
    isDeleted: boolean;
    mainContext: string;
    historyOrderedDesc: ITemplateHistory[];
    lastDocument: ITemplateHistory;
    extension: string | undefined;
    lastHistoryAndAttachmentId: string;
    isPredefinedType: boolean;
    contexts: string[];
    keys: string[];
    isEntPhysicianRequired: boolean;
    isEntPhysicianOfficeRequired: boolean;
    isHifRequired: boolean;
    isTrialStepRequired: boolean;
    identifier: string;
    searchField: string | undefined;
}

export interface ITemplateHistory {
    attachmentId: string;
    date: Date;
    extension: string | undefined;
    keys: string[];
    id: string;
}

export interface ITemplateMetaModel {
    mustSign: boolean;
    canEdit: boolean;
    canViewOnline: boolean;
}

export interface ITemplateUploadModel {
    language: string | undefined;
    predefinedType: string | undefined;
    isFromPredefinedType: boolean;
    mainContext: string | undefined;
    mustSign: boolean;
    canEdit: boolean;
    canViewOnline: boolean;
    contentAsBase64: string | undefined;
    exampleId: string | undefined;
    name: string;
}

export interface ITemplatesQueryParams {
    searchString: string;
    sortParams: ISortParams<ITemplate>;
    pageParams: IPageParams;
    predefinedTypes: string[];
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    languages: string[];
    mainContexts: string[];
    alsoIncludeDeleted: boolean;
}

export interface ITender {
    id: string;
    created: Date;
    lastUpdated: Date;
    reference: string | undefined;
    validUntil: Date;
    recipient: IRecipient;
    forPatient: IObjectWithIdAndIdentifier<string>;
    forCompany: IObjectWithIdAndIdentifier<string>;
    lines: ITenderLine[];
    contributions: IContributionLine[];
    salesId: string | undefined;
    documents: IDocumentSummary[];
    linkViewContext: ILinkViewContext;
    location: IObjectWithIdAndIdentifier<string>;
    createdByUserId: string;
    isLost: boolean;
    isDeleted: boolean;
    tenderDocument: IDocumentSummary;
    orderFormDocument: IDocumentSummary;
    linkViewContextId: string | undefined;
    linkViewContextType: string | undefined;
    rfiaId: string | undefined;
    isSubProcess: boolean;
    status: string | undefined;
    hasSalesTransaction: boolean;
    isForPatient: boolean;
    isForCompany: boolean;
    forPatientId: string | undefined;
    companyId: string | undefined;
    isExpired: boolean;
    countItems: number;
    recipientName: string | undefined;
    searchField: string | undefined;
    hasContributions: boolean;
    tenderDocumentId: string | undefined;
    orderFormDocumentId: string | undefined;
    hasTenderDocument: boolean;
    hasOrderFormDocument: boolean;
    vatSplits: IVatSplit[];
    priceInVat: number;
    priceExVat: number;
    vatAmount: number;
    contributionsValue: number;
    priceInVatMinusContributions: number;
    needsNowAfter: Date | undefined;
    isCompleted: boolean;
    hasWarning: boolean;
    hasError: boolean;
    storedNow: Date;
    storedNowPreviousToNeedsNowAfter: boolean;
}

export interface ITenderLine {
    id: string;
    description: string | undefined;
    productCatalogItemId: string | undefined;
    indexNumber: number;
    unitPrice: number;
    unitListPrice: number;
    vatPercentage: number;
    quantity: number;
    isVatIncluded: boolean;
    hasProductCatalogItem: boolean;
    unitPriceInVat: number;
    unitListPriceInVat: number;
    linePriceInVat: number;
    lineListPriceInVat: number;
    unitPriceExVat: number;
    unitListPriceExVat: number;
    linePriceExVat: number;
    lineListPriceExVat: number;
    unitVatValue: number;
    lineVatValue: number;
    unitDiscountValueInVat: number;
    unitDiscountValueExVat: number;
    lineDiscountValueInVat: number;
    lineDiscountValueExVat: number;
    discountPercentage: number;
}

export interface ITenderLineModel {
    productCatalogItemId: string | undefined;
    indexNumber: number;
    description: string | undefined;
    quantity: number;
    vatPercentage: number;
    unitListPriceInVat: number;
    unitPriceInVat: number;
}

export interface ITenderModel {
    reference: string | undefined;
    isAutoSelectReference: boolean;
    validUntil: Date;
    lines: ITenderLineModel[];
    patientId: string | undefined;
    companyId: string | undefined;
    recipientName: string | undefined;
    addressLine: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    country: string | undefined;
}

export interface ITenderSettings {
    defaultValidUntil: ITimeModel;
    referenceSettings: IReferenceSettings;
    id: string;
}

export interface ITenderSummary {
    id: string;
    date: Date;
    validUntil: Date;
    reference: string | undefined;
    recipientName: string | undefined;
    priceInVat: number;
    tenderDocumentId: string | undefined;
    orderFormDocumentId: string | undefined;
    patientId: string | undefined;
    salesId: string | undefined;
    isDeleted: boolean;
    hasOrderForm: boolean;
    hasTenderDocument: boolean;
    isConverted: boolean;
    isOpen: boolean;
}

export interface ITendersExportParams {
    searchString: string;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    validUntilBefore: Date | undefined;
    validUntilAfter: Date | undefined;
    statuses: string[];
    isSubProcess: boolean | undefined;
    isForPatient: boolean | undefined;
    forPatientId: string | undefined;
    isForCompany: boolean | undefined;
    forCompanyId: string | undefined;
    alsoIncludeDeleted: boolean;
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
    prefilter: TendersPrefilter;
}

export interface ITendersQueryMetadata {
    count: number;
    countNotLostAndOverdue: number;
}

export interface ITendersQueryParams {
    searchString: string;
    sortParams: ISortParams<ITender>;
    pageParams: IPageParams;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    validUntilBefore: Date | undefined;
    validUntilAfter: Date | undefined;
    statuses: string[];
    isSubProcess: boolean | undefined;
    isForPatient: boolean | undefined;
    forPatientId: string | undefined;
    isForCompany: boolean | undefined;
    forCompanyId: string | undefined;
    alsoIncludeDeleted: boolean;
    prefilter: TendersPrefilter;
}

export interface ITimeModel {
    unit: string | undefined;
    value: number;
}

export interface ITonalAudiogramImage {
    id: string;
    noahLastModifiedDate: Date;
    bothEarImage: string | undefined;
    leftEarImage: string | undefined;
    rightEarImage: string | undefined;
    hasBothEarImage: boolean;
    hasLeftEarImage: boolean;
    hasRightEarImage: boolean;
    hasAnyImage: boolean;
}

export interface ITonalAudiogramImageSummary {
    id: string;
    noahLastModifiedDate: Date;
}

export interface ITonePoint {
    stimulusFrequency: number;
    stimulusLevel: number;
    statusType: string | undefined;
}

export interface IToneThresholdAudiogram {
    points: ITonePoint[];
    signalOutputType: string | undefined;
    hearingInstrumentConditionType: string | undefined;
    signalOutputTypeDisplay: string | undefined;
    hearingInstrumentConditionTypeDisplay: string | undefined;
    display: string | undefined;
    isLeft: boolean;
    isRight: boolean;
}

export interface IToneThresholdAudiogramTest {
    date: Date;
    audiogramStandardId: string;
    data: IToneThresholdAudiogram;
    attachmentId: string;
    pointsForPta: number[];
    orderedPointsForPta: number[];
    equation: string | undefined;
    pureToneAverage: number;
}

export interface IToneThresholdAudiogramTestsDto {
    left: IToneThresholdAudiogramTest;
    right: IToneThresholdAudiogramTest;
    leftImage: string | undefined;
    rightImage: string | undefined;
    bothImage: string | undefined;
}

export interface ITransactionDto {
    id: string;
    created: Date;
    type: string | undefined;
    reference: string | undefined;
    externalReference: string | undefined;
    referenceDate: Date | undefined;
    linkViewContextId: string | undefined;
    linkViewContextType: string | undefined;
    patients: IObjectWithIdAndIdentifier<string>[];
    supplierId: string | undefined;
    supplierIdentifier: string | undefined;
    fromLocationId: string | undefined;
    fromLocationIdentifier: string | undefined;
    toLocationId: string | undefined;
    toLocationIdentifier: string | undefined;
    quantity: number;
    hasLinkViewContext: boolean;
    patientIds: string[];
    patientIdentifiers: string[];
}

export interface ITransactionLineV2 {
    id: string;
    productCatalogItemId: string | undefined;
    inventoryItemId: string | undefined;
    quantity: number;
    patient: IObjectWithIdAndIdentifier<string>;
    patientId: string | undefined;
    patientIdentifier: string | undefined;
    productCatalogItemIdOrDefault: string | undefined;
    isCredited: boolean;
}

export interface ITransactionSummary {
    id: string;
    linkViewContext: ILinkViewContext;
    type: string | undefined;
    date: Date;
    reference: string | undefined;
    externalReference: string | undefined;
    referenceDate: Date | undefined;
    patient: IObjectWithIdAndIdentifier<string>;
    supplier: IObjectWithIdAndIdentifier<string>;
    fromLocation: IObjectWithIdAndIdentifier<string>;
    toLocation: IObjectWithIdAndIdentifier<string>;
    linkViewContextId: string | undefined;
    linkViewContextType: string | undefined;
    patientId: string | undefined;
    patientIdentifier: string | undefined;
    supplierId: string | undefined;
    supplierIdentifier: string | undefined;
    fromLocationId: string | undefined;
    fromLocationIdentifier: string | undefined;
    toLocationId: string | undefined;
    toLocationIdentifier: string | undefined;
    hasReferenceDate: boolean;
    hasPatient: boolean;
    hasReference: boolean;
    hasSupplier: boolean;
    hasFromLocation: boolean;
    hasToLocation: boolean;
    hasExternalReference: boolean;
    referenceOrEntryDate: Date;
}

export interface ITransactionSummaryForInventoryItem {
    id: string;
    type: string | undefined;
    referenceOrEntryDate: Date;
    toLocationId: string | undefined;
    fromLocationId: string | undefined;
}

export interface ITransactionV2 {
    id: string;
    created: Date;
    linkViewContext: ILinkViewContext;
    type: string | undefined;
    reference: string | undefined;
    externalReference: string | undefined;
    referenceDate: Date | undefined;
    lines: ITransactionLineV2[];
    supplier: IObjectWithIdAndIdentifier<string>;
    fromLocation: IObjectWithIdAndIdentifier<string>;
    toLocation: IObjectWithIdAndIdentifier<string>;
    patients: IObjectWithIdAndIdentifier<string>[];
    patientIds: string[];
    patientIdentifiers: string[];
    productCatalogItemIds: string[];
    inventoryItemIds: string[];
    supplierId: string | undefined;
    supplierIdentifier: string | undefined;
    fromLocationId: string | undefined;
    fromLocationIdentifier: string | undefined;
    toLocationId: string | undefined;
    toLocationIdentifier: string | undefined;
    locationIds: string[];
    searchField: string | undefined;
}

export interface ITransactionsQueryParams {
    searchString: string;
    sortParams: ISortParams<ITransactionDto>;
    pageParams: IPageParams;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    types: string[];
}

export interface ITrialLineModel {
    productCatalogItemId: string;
    inventoryItemId: string | undefined;
    zeroBasedIndexNumber: number;
    description: string | undefined;
    quantity: number;
    vatPercentage: number;
    unitListPriceInVat: number;
    unitPriceInVat: number;
}

export interface ITrialReport {
    id: string;
    rfiaId: string;
    created: Date;
    lastUpdated: Date;
    documentDataLastUpdated: Date;
    leftToneThresholdAudiogramTest: IToneThresholdAudiogramTest;
    rightToneThresholdAudiogramTest: IToneThresholdAudiogramTest;
    bothEarsToneThresholdImageAttachmentId: string | undefined;
    averageNumberOfHoursPerDayWearingHearingAids: number;
    orientationTest: IOrientationTest;
    cltTest: ICltTest;
    leftSpeechTest: ISpeechTest;
    rightSpeechTest: ISpeechTest;
    stereoSpeechTest: ISpeechTest;
    speechInNoiseTest: ISpeechInNoiseTest;
    document: IDocumentSummary;
    speechImages: ISpeechImage[];
    isDocumentInSync: boolean;
    documentId: string | undefined;
    hasDocument: boolean;
    hasLeftToneThresholdAudiogramTest: boolean;
    hasRightToneThresholdAudiogramTest: boolean;
    hasBothEarsToneThresholdImageAttachmentId: boolean;
    hasOrientationTest: boolean;
    hasCltTest: boolean;
    hasSpeechInNoiseTest: boolean;
    hasLeftSpeechTest: boolean;
    hasRightSpeechTest: boolean;
    hasStereoSpeechTest: boolean;
    hasSpeechImages: boolean;
}

export interface ITrialReportSummary {
    id: string;
    rfiaId: string;
    documentId: string | undefined;
    hasDocument: boolean;
}

export interface ITrialStepDto {
    id: string;
    startDate: Date;
    expectedStopDate: Date;
    onlyAdministrativeTrialEndDate: Date | undefined;
    loanEndDate: Date | undefined;
    loanSlipId: string | undefined;
    trialReportDocumentId: string | undefined;
    isEnded: boolean;
    loanId: string;
    hasTrialReportDocument: boolean;
    hasLoanSlip: boolean;
    actualOrExpectedEndDate: Date;
}

export interface ITypesAndCategoriesProductCatalogQueryParams {
    sortParams: ISortParams<IProductCatalogItem>;
    pageParams: IPageParams;
    searchString: string;
    types: ProductCatalogItemType[];
    categories: string[];
    subcategories: string[];
}

export interface IUblPurchaseFileUploadResponse {
    error: string | undefined;
    value: IPurchaseUbl;
    hasError: boolean;
    isSuccess: boolean;
}

export interface IUndoIgnorePeppolRecordRequest {
    id: string;
}

export interface IUndoPlaceOrderWithSupplierRequest {
    orderId: string;
}

export interface IUndoRegisterInventoryItemAsBrokenRequest {
    inventoryItemId: string;
}

export interface IUndoRegisterInventoryItemAsSoldRequest {
    inventoryItemId: string;
    referenceDate: Date;
}

export interface IUnhandledCustomerAccountLinesQueryParams {
    searchString: string;
    sortParams: ISortParams<ICustomerAccountLine>;
    pageParams: IPageParams;
    customerAccountIds: string[];
    salesDateBefore: Date | undefined;
    salesDateCreatedAfter: Date | undefined;
}

export interface IUnlinkCustomerAccountWithExactOnlineAccountRequest {
    hamsId: string;
}

export interface IUnlinkExactGlobeLocationRequest {
    hamsLocationId: string;
}

export interface IUnlinkExactGlobeProductCatalogItemRequest {
    hamsProductCatalogItemId: string;
}

export interface IUnlinkLocationFromExactOnlineCostCenterRequest {
    locationId: string;
}

export interface IUnlinkProductCatalogItemFromExactOnlineCostCenterRequest {
    productCatalogItemId: string;
}

export interface IUnlinkProductCatalogItemWithExactOnlineGLAccountRequest {
    productCatalogItemId: string;
}

export interface IUnlinkRepairFromPatientRequest {
    repairId: string;
}

export interface IUnlinkRosaPatientRecordFromHamsPatientRequest {
    rosaPatientRecordId: string | undefined;
}

export interface IUnmarkInventoryItemAsDemoRequest {
    inventoryItemId: string;
}

export interface IUpcomingRosaEventsForPatientResponse {
    events: IRosaEventDto[];
    hamsPatientId: string;
    redirectRosaPatientRecordId: string | undefined;
    hasRedirectId: boolean;
}

export interface IUploadDocumentRequest {
    predefinedType: string | undefined;
    contextId: string;
    linkViewContextType: string | undefined;
    hasSignature: boolean;
    mustSign: boolean;
    contentAsBase64: string | undefined;
    fileName: string;
}

export interface IUploadMultipleFilesRequest {
    files: IFileUploadRequest[];
}

export interface IUploadPrescriptionScanRequest {
    rfiaId: string;
    contentAsBase64: string | undefined;
    fileName: string;
    signedStep: number;
}

export interface IUserDto {
    id: string;
    created: Date;
    lastUpdated: Date;
    salutation: string | undefined;
    blocked: boolean;
    authData: IAuthDto[];
    initials: string | undefined;
    isAdmin: boolean;
    hasConfirmed: boolean;
    lastLoggedInDate: Date | undefined;
    rizivNumber: string | undefined;
    isAudiologist: boolean;
    externalLoginEnabled: boolean;
    preferredLocationId: string | undefined;
    isPlannable: boolean;
    pageClaims: string[];
    role: UserRole;
    functionalClaims: string[];
    isRegistrationTokenExpired: boolean;
    email: string;
    firstName: string;
    lastName: string;
    conventionedRizivNumber: string | undefined;
    lastActivity: Date | undefined;
    isActiveNow: boolean;
    isLoggedIn: boolean;
    searchField: string | undefined;
    lastNameCommaFirstName: string | undefined;
}

export interface IUserInfo {
    id: string;
    email: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    initials: string | undefined;
    preferredLocationId: string | undefined;
    pageClaims: string[];
    role: UserRole;
    functionalClaims: string[];
    clientClaims: string[];
    hasPreferredLocation: boolean;
    isSuperUser: boolean;
}

export interface IUserPreferences {
    userId: string;
    patientDetailOverviewLayoutView: IPatientDetailOverviewLayoutViewPreferences;
    id: string;
}

export interface IUserSummary {
    id: string;
    identifier: string;
    lastNameCommaFirstName: string | undefined;
    rizivNumber: string | undefined;
    isAudiologist: boolean;
    blocked: boolean;
    isPlannable: boolean;
    calendarColor: string | undefined;
    email: string | undefined;
}

export interface IUsersCache {
    users: IUserSummary[];
}

export interface IUsersQueryParams {
    searchString: string;
    sortParams: ISortParams<IUserDto>;
    pageParams: IPageParams;
    canLogin: boolean | undefined;
    isLoggedIn: boolean | undefined;
    hasConfirmed: boolean | undefined;
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    lastLoggedInBefore: Date | undefined;
    lastLoggedInAfter: Date | undefined;
}

export interface IValidateResponse {
    error: string;
    hasError: boolean;
}

export interface IVatSplit {
    percentage: number;
    amountInVat: number;
    value: number;
    amountExVat: number;
}

export interface IViewColumnSelection {
    view: string | undefined;
    created: Date;
    lastUpdated: Date;
    columnSelections: IColumnSelection[];
    id: string | undefined;
    default: IColumnSelection;
    hasDefault: boolean;
}

export interface IWebPhysician {
    isConventionalized: boolean;
    gender: string | undefined;
    firstName: string;
    lastName: string;
    rizivNumber: string;
    qualification: string;
    rizivNumberFormatted: string;
    rizivNumberWithQualificationFormatted: string;
}

export interface IWiniproAppointment {
    id: string | undefined;
    startDate: Date;
    endDate: Date;
    activityNumber: string | undefined;
    type: string | undefined;
    object: string | undefined;
    duration: string | undefined;
    employeeName: string | undefined;
    location: string | undefined;
    winiproPatientId: string | undefined;
    lastName: string | undefined;
    firstName: string | undefined;
    comments: string | undefined;
}

export interface IWiniproEarMouldData {
    type: string | undefined;
    supplierId: string | undefined;
    form: string | undefined;
    material: string | undefined;
    color: string | undefined;
    transmission: string | undefined;
    supplement: string | undefined;
    ventingType: string | undefined;
    ventingDiameter: string | undefined;
}

export interface IWiniproEarMouldOrderData {
    patientId: string | undefined;
    orderId: string | undefined;
    orderType: string | undefined;
    fittingNumber: string | undefined;
    fittingDate: Date | undefined;
    rightEarMould: IWiniproEarMouldData;
    leftEarMould: IWiniproEarMouldData;
    id: string | undefined;
}

export interface IWiniproHearingAidData {
    type: string | undefined;
    supplierId: string | undefined;
    color: string | undefined;
    catalogueNumber: string | undefined;
    serialNumber: string | undefined;
    salesPrice: number;
    discount: number;
    rizivNumber: number | undefined;
    hasRizivNumber: boolean;
    hasSerialNumber: boolean;
}

export interface IWiniproHearingAidOrderData {
    patientId: string | undefined;
    orderId: string | undefined;
    procedureType: string | undefined;
    procedureNumber: string | undefined;
    procedureDate: Date | undefined;
    trialUntilDate: Date | undefined;
    deviceLentOut: boolean;
    deviceSoldOut: boolean;
    captureUsedDevice: boolean;
    returnDateBool: boolean;
    crossProvision: boolean;
    bicrossProvision: boolean;
    rightHearingAid: IWiniproHearingAidData;
    leftHearingAid: IWiniproHearingAidData;
    id: string | undefined;
    hearingAids: IWiniproHearingAidData[];
    trialStartDate: Date | undefined;
}

export interface IWiniproOrderData {
    patientId: string | undefined;
    orderId: string | undefined;
    locationId: string | undefined;
    auftragsArt: string | undefined;
    orderDate: Date | undefined;
    prescriptionDate: Date | undefined;
    prescriberId: string | undefined;
    employeeId: string | undefined;
    insuranceId: string | undefined;
    billNumber: string | undefined;
    realOrderId: string | undefined;
    paymentDate: Date | undefined;
    pickedUpDate: Date | undefined;
    billingDate: Date | undefined;
    authorizationStatus: string | undefined;
    billNumberSingleInvoiceToInsurance: string | undefined;
    dateSingleInvoiceToInsurance: Date | undefined;
    submittedDate: Date | undefined;
    approvedDate: Date | undefined;
    settledDate: Date | undefined;
    oldFileCard: boolean;
    quotation: boolean;
    salesValue: number;
    insuranceCoverTotal: number;
    insuranceVoerWithoutExcess: number;
    additionalPayment: number;
    additionalPlusExcess: number;
    partPay: number;
    excess: number;
    repairFlat: number;
    id: string | undefined;
    hasEntPhysician: boolean;
    entPhysicianId: string | undefined;
    isBilled: boolean;
    hasSalesValue: boolean;
    hasInsuranceCover: boolean;
    threeDigitsLocationId: string | undefined;
}

export interface IWiniproOrderExt {
    order: IWiniproOrderData;
    hearingAids: IWiniproHearingAidOrderData[];
    earmoulds: IWiniproEarMouldOrderData[];
    patientLastNameCommaFirstName: string | undefined;
    import: boolean;
    id: string | undefined;
    withHearingAids: boolean;
    withEarmoulds: boolean;
    withHearingAidsAndEarmoulds: boolean;
    patientId: string | undefined;
    orderId: string | undefined;
    hearingAidsData: IWiniproHearingAidData[];
}

export interface IWiniproPatientData {
    patientId: string;
    winiproId: string | undefined;
    kundenNummer: string | undefined;
    orders: IWiniproOrderExt[];
    appointments: IWiniproAppointment[];
    id: string;
}

export interface IWorkflowSummary {
    id: string;
    created: Date;
    type: string | undefined;
    reference: string | undefined;
    status: string | undefined;
    progressPercentage: number;
    isCompleted: boolean;
    isCancelled: boolean;
    hasWarning: boolean;
    hasError: boolean;
    mainProcessId: string | undefined;
    isActive: boolean;
    isPrimary: boolean;
    isSub: boolean;
}

export interface IWorksheetInfo {
    name: string | undefined;
    headers: IHeaderInfo[];
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}


export interface IQueryResult<T> {
    values: T[];
    unfilteredCount: number;
    filteredCount: number;
    pageIndex: number;
    pageSize: number;
    concurrencyToken: number;
    zeroBasedPageIndex: number;
    totalPages: number;
    currentFrom: number;
    currentTo: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}


export interface IQueryResultWithMetadata<T, TMetadata> {
    values: T[];
    unfilteredCount: number;
    filteredCount: number;
    pageIndex: number;
    pageSize: number;
    concurrencyToken: number;
    zeroBasedPageIndex: number;
    totalPages: number;
    currentFrom: number;
    currentTo: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    metadata: TMetadata;
}


export interface IObjectWithIdAndIdentifier<T> {
    id: T;
    identifier: string;
}


export interface IObjectWithIdIdentifierAndType<T> {
    id: T;
    identifier: string;
    type: string;
}


export interface IObjectWithIdManufacturerModelAndType<T> {
    id: T;
    manufacturer: string;
    model: string;
    type: string;
    manufacturerCommaModel: string;
}


export interface IConcurrencyData<T> {
    value: T;
    concurrencyToken: number;
}


export interface ICreateResponse<T> {
    objectId: string;
    errors: IValidationError<T>[];
    hasError: boolean;
    isSuccess: boolean;
    error: string;
}


export interface IUpdateResponse<T> {
    errors: IValidationError<T>[];
    hasError: boolean;
    isSuccess: boolean;
    error: string;
}


export interface IValidationError<T> {
    property: string;
    error: string;
    zeroBasedIndex: number | undefined;
}


export interface IExportParams {
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
}


export interface ISortParams<T> {
    property: keyof T;
    direction: 'asc' | 'desc'
}

export type IFileResponse = { }

export type IBlob = { }


export type CompanyExportProp = 'Id' | 'Created' | 'LastUpdated' | 'Name' | 'VatNumber' | 'FirstName' | 'LastName' | 'Salutation' | 'AddressLine' | 'Zip' | 'City' | 'Country';
export const CompanyExportProps: CompanyExportProp[] = ['Id', 'Created', 'LastUpdated', 'Name', 'VatNumber', 'FirstName', 'LastName', 'Salutation', 'AddressLine', 'Zip', 'City', 'Country'];

export type EntPhysicianExportProp = 'Id' | 'Created' | 'LastUpdated' | 'FirstName' | 'LastName' | 'Salutation' | 'RizivCode' | 'Gender' | 'OfficesCsv' | 'CountRequestsToInsuranceAllowance';
export const EntPhysicianExportProps: EntPhysicianExportProp[] = ['Id', 'Created', 'LastUpdated', 'FirstName', 'LastName', 'Salutation', 'RizivCode', 'Gender', 'OfficesCsv', 'CountRequestsToInsuranceAllowance'];

export type GeneralPractitionerExportProp = 'Id' | 'Created' | 'LastUpdated' | 'FirstName' | 'LastName' | 'Salutation' | 'RizivCode' | 'Gender' | 'OfficesCsv';
export const GeneralPractitionerExportProps: GeneralPractitionerExportProp[] = ['Id', 'Created', 'LastUpdated', 'FirstName', 'LastName', 'Salutation', 'RizivCode', 'Gender', 'OfficesCsv'];

export type StockItemDtoExportProp = 'ProductCatalogItemId' | 'Manufacturer' | 'Model' | 'Category' | 'Subcategory' | 'InternalReference' | 'ManufacturerReferencesCsv' | 'Type' | 'HasSerialNumber' | 'CountPurchased' | 'CountSold' | 'CountInRepair' | 'CountInBackOrder' | 'CountInTestOrLoan' | 'SupplierIdentifierCsv' | 'ManufacturerCommaModel' | 'StockValue' | 'VatPercentage' | 'FinancialQuantity' | 'PhysicalQuantity' | 'DeltaFinancialAndPhysical' | 'HasDeltaFinancialAndPhysical' | 'PurchaseListPrice';
export const StockItemDtoExportProps: StockItemDtoExportProp[] = ['ProductCatalogItemId', 'Manufacturer', 'Model', 'Category', 'Subcategory', 'InternalReference', 'ManufacturerReferencesCsv', 'Type', 'HasSerialNumber', 'CountPurchased', 'CountSold', 'CountInRepair', 'CountInBackOrder', 'CountInTestOrLoan', 'SupplierIdentifierCsv', 'ManufacturerCommaModel', 'StockValue', 'VatPercentage', 'FinancialQuantity', 'PhysicalQuantity', 'DeltaFinancialAndPhysical', 'HasDeltaFinancialAndPhysical', 'PurchaseListPrice'];

export type InventoryItemExportProp = 'Id' | 'Created' | 'LastUpdated' | 'ProductCatalogId' | 'Manufacturer' | 'Model' | 'SerialNumber' | 'SalesListPrice' | 'PurchaseListPrice' | 'SalesPrice' | 'PurchasePrice' | 'VatPercentage' | 'Category' | 'Subcategory' | 'Type' | 'IsElectronics' | 'HasBatteries' | 'IsHearingInstrument' | 'IsRemoteControl' | 'IsTailorMade' | 'IsSold' | 'IsPurchased' | 'IsSalesCredited' | 'IsPurchaseCredited' | 'IsInRepair' | 'IsReturnedToSupplier' | 'IsInLoan' | 'IsInOrder' | 'PurchaseDate' | 'DateSold' | 'OrderDate' | 'FirstDeliveryDate' | 'ReturnToSupplierDate' | 'DateSentToSupplierForRepair' | 'Status' | 'CurrentLocationType' | 'HasSerialNumberDefined' | 'PropertyOf' | 'CurrentLocationIdentifier' | 'DispatchReference' | 'DispatchDate' | 'IsDemo' | 'ConsignmentReturnBeforeDate' | 'SupplierIdentifier' | 'IsReserved' | 'ReservedForPatientIdentifier' | 'HasSoldInsurance' | 'HasSoldProlongedWarranty' | 'HasPurchasedInsurance' | 'HasPurchasedProlongedWarranty' | 'OldSerialNumbersCsv' | 'PurchaseCreditDate' | 'SalesCreditDate' | 'PurchaseReference' | 'SalesReference' | 'SalesCreditNoteReference' | 'PurchaseCreditNoteReference' | 'BebatUnitPriceInVat' | 'ReservedForPatientId' | 'LocationWhereSoldId' | 'LocationWhereSoldIdentifier' | 'LastLoanStartedDate' | 'LastLoanFromLocationIdentifier' | 'PatientIdentifier' | 'PatientId' | 'PatientNumber' | 'PatientEmail' | 'PatientAddressFormatted' | 'PatientAge' | 'SoldProlongedWarrantyIdentifier' | 'SoldInsuranceIdentifier';
export const InventoryItemExportProps: InventoryItemExportProp[] = ['Id', 'Created', 'LastUpdated', 'ProductCatalogId', 'Manufacturer', 'Model', 'SerialNumber', 'SalesListPrice', 'PurchaseListPrice', 'SalesPrice', 'PurchasePrice', 'VatPercentage', 'Category', 'Subcategory', 'Type', 'IsElectronics', 'HasBatteries', 'IsHearingInstrument', 'IsRemoteControl', 'IsTailorMade', 'IsSold', 'IsPurchased', 'IsSalesCredited', 'IsPurchaseCredited', 'IsInRepair', 'IsReturnedToSupplier', 'IsInLoan', 'IsInOrder', 'PurchaseDate', 'DateSold', 'OrderDate', 'FirstDeliveryDate', 'ReturnToSupplierDate', 'DateSentToSupplierForRepair', 'Status', 'CurrentLocationType', 'HasSerialNumberDefined', 'PropertyOf', 'CurrentLocationIdentifier', 'DispatchReference', 'DispatchDate', 'IsDemo', 'ConsignmentReturnBeforeDate', 'SupplierIdentifier', 'IsReserved', 'ReservedForPatientIdentifier', 'HasSoldInsurance', 'HasSoldProlongedWarranty', 'HasPurchasedInsurance', 'HasPurchasedProlongedWarranty', 'OldSerialNumbersCsv', 'PurchaseCreditDate', 'SalesCreditDate', 'PurchaseReference', 'SalesReference', 'SalesCreditNoteReference', 'PurchaseCreditNoteReference', 'BebatUnitPriceInVat', 'ReservedForPatientId', 'LocationWhereSoldId', 'LocationWhereSoldIdentifier', 'LastLoanStartedDate', 'LastLoanFromLocationIdentifier', 'PatientIdentifier', 'PatientId', 'PatientNumber', 'PatientEmail', 'PatientAddressFormatted', 'PatientAge', 'SoldProlongedWarrantyIdentifier', 'SoldInsuranceIdentifier'];

export type LoanExportProp = 'Id' | 'Created' | 'LastUpdated' | 'Reference' | 'StartDate' | 'StopDate' | 'OnlyAdministrativeTrialEndDate' | 'ActualStopDate' | 'IsCancelled' | 'HasReturnedItems' | 'CanReturnItems' | 'Status' | 'ForPatientId' | 'ForPatientIdentifier' | 'CountItems' | 'HasWarning' | 'IsCompleted' | 'RfiaId';
export const LoanExportProps: LoanExportProp[] = ['Id', 'Created', 'LastUpdated', 'Reference', 'StartDate', 'StopDate', 'OnlyAdministrativeTrialEndDate', 'ActualStopDate', 'IsCancelled', 'HasReturnedItems', 'CanReturnItems', 'Status', 'ForPatientId', 'ForPatientIdentifier', 'CountItems', 'HasWarning', 'IsCompleted', 'RfiaId'];

export type OrderExportProp = 'Id' | 'Created' | 'LastUpdated' | 'Status' | 'ExternalReference' | 'Reference' | 'CountItems' | 'SupplierIdentifier' | 'SinglePatientIdentifier' | 'PatientIdentifiersCsv' | 'LocationIdentifier' | 'ExpectedDeliveryDate';
export const OrderExportProps: OrderExportProp[] = ['Id', 'Created', 'LastUpdated', 'Status', 'ExternalReference', 'Reference', 'CountItems', 'SupplierIdentifier', 'SinglePatientIdentifier', 'PatientIdentifiersCsv', 'LocationIdentifier', 'ExpectedDeliveryDate'];

export type DeliveryExportProp = 'Id' | 'Created' | 'LastUpdated' | 'Reference' | 'ExternalReference' | 'DeliveryDate' | 'SupplierIdentifier' | 'CountItems' | 'LocationIdentifier' | 'DispatchReference' | 'DispatchDate';
export const DeliveryExportProps: DeliveryExportProp[] = ['Id', 'Created', 'LastUpdated', 'Reference', 'ExternalReference', 'DeliveryDate', 'SupplierIdentifier', 'CountItems', 'LocationIdentifier', 'DispatchReference', 'DispatchDate'];

export type StockMovementExportProp = 'Id' | 'Created' | 'LastUpdated' | 'Reference' | 'CountItems' | 'ToLocationIdentifier' | 'FromLocationIdentifier';
export const StockMovementExportProps: StockMovementExportProp[] = ['Id', 'Created', 'LastUpdated', 'Reference', 'CountItems', 'ToLocationIdentifier', 'FromLocationIdentifier'];

export type ReturnExportProp = 'Id' | 'Created' | 'LastUpdated' | 'Reference' | 'ExternalReference' | 'ReturnDate' | 'ToSupplierIdentifier' | 'CountItems' | 'FromLocationIdentifier';
export const ReturnExportProps: ReturnExportProp[] = ['Id', 'Created', 'LastUpdated', 'Reference', 'ExternalReference', 'ReturnDate', 'ToSupplierIdentifier', 'CountItems', 'FromLocationIdentifier'];

export type TenderExportProp = 'Id' | 'Created' | 'LastUpdated' | 'Reference' | 'ValidUntil' | 'SalesId' | 'IsLost' | 'Status' | 'HasSalesTransaction' | 'IsForPatient' | 'IsForCompany' | 'ForPatientId' | 'CompanyId' | 'IsExpired' | 'CountItems' | 'RecipientName' | 'PriceInVat' | 'PriceExVat' | 'VatAmount';
export const TenderExportProps: TenderExportProp[] = ['Id', 'Created', 'LastUpdated', 'Reference', 'ValidUntil', 'SalesId', 'IsLost', 'Status', 'HasSalesTransaction', 'IsForPatient', 'IsForCompany', 'ForPatientId', 'CompanyId', 'IsExpired', 'CountItems', 'RecipientName', 'PriceInVat', 'PriceExVat', 'VatAmount'];

export type ProductCatalogItemExportProp = 'Id' | 'Created' | 'LastUpdated' | 'Name' | 'Manufacturer' | 'Model' | 'Category' | 'Subcategory' | 'SalesListPrice' | 'PurchaseListPrice' | 'VatPercentage' | 'InternalReference' | 'ManufacturerReferencesCsv' | 'Type' | 'IsElectronics' | 'HasBatteries' | 'HasSerialNumber' | 'SupplierIdentifierCsv' | 'Identifier' | 'RizivHearingAidDefinitionV2IdentificationCodesCsv' | 'LabelsCsv';
export const ProductCatalogItemExportProps: ProductCatalogItemExportProp[] = ['Id', 'Created', 'LastUpdated', 'Name', 'Manufacturer', 'Model', 'Category', 'Subcategory', 'SalesListPrice', 'PurchaseListPrice', 'VatPercentage', 'InternalReference', 'ManufacturerReferencesCsv', 'Type', 'IsElectronics', 'HasBatteries', 'HasSerialNumber', 'SupplierIdentifierCsv', 'Identifier', 'RizivHearingAidDefinitionV2IdentificationCodesCsv', 'LabelsCsv'];

export type RepairExportProp = 'Id' | 'Created' | 'LastUpdated' | 'Reference' | 'ExternalReference' | 'Status' | 'ForPatientIdentifier' | 'SupplierIdentifier' | 'IsCancelled' | 'IsCompleted' | 'CountItems';
export const RepairExportProps: RepairExportProp[] = ['Id', 'Created', 'LastUpdated', 'Reference', 'ExternalReference', 'Status', 'ForPatientIdentifier', 'SupplierIdentifier', 'IsCancelled', 'IsCompleted', 'CountItems'];

export type SupplierExportProp = 'Id' | 'Created' | 'LastUpdated' | 'Name' | 'AddressLine' | 'Zip' | 'City' | 'Country' | 'Email' | 'DefaultDeliveryTime' | 'AccountNumber' | 'FirstName' | 'LastName' | 'Salutation' | 'CountOrders' | 'CountDeliveries' | 'CountPurchases' | 'BrandsCsv';
export const SupplierExportProps: SupplierExportProp[] = ['Id', 'Created', 'LastUpdated', 'Name', 'AddressLine', 'Zip', 'City', 'Country', 'Email', 'DefaultDeliveryTime', 'AccountNumber', 'FirstName', 'LastName', 'Salutation', 'CountOrders', 'CountDeliveries', 'CountPurchases', 'BrandsCsv'];

export type CustomerAccountExportProp = 'Id' | 'Created' | 'LastUpdated' | 'AccountType' | 'OutstandingBalance' | 'HasOutstandingBalance' | 'Identifier';
export const CustomerAccountExportProps: CustomerAccountExportProp[] = ['Id', 'Created', 'LastUpdated', 'AccountType', 'OutstandingBalance', 'HasOutstandingBalance', 'Identifier'];

export type SaleExportProp = 'Id' | 'Created' | 'LastUpdated' | 'Reference' | 'ExternalReference' | 'IsInvoice' | 'ValidUntil' | 'IsCashSale' | 'CountItems' | 'RecipientName' | 'RecipientAddressLine' | 'RecipientCountry' | 'RecipientZip' | 'RecipientCity' | 'AmountPaid' | 'OutstandingBalance' | 'HasOutstandingBalance' | 'IsFullyPaid' | 'IsPartlyPaid' | 'IsOverDue' | 'PriceInVat' | 'PriceExVat' | 'VatAmount' | 'LocationIdentifier' | 'DefaultBelgianStructuredCreditorReference' | 'PatientReference' | 'Vat0AmountExVat' | 'Vat0AmountInVat' | 'Vat0VatAmount' | 'Vat6AmountExVat' | 'Vat6AmountInVat' | 'Vat6VatAmount' | 'Vat9AmountExVat' | 'Vat9AmountInVat' | 'Vat9VatAmount' | 'Vat12AmountExVat' | 'Vat12AmountInVat' | 'Vat12VatAmount' | 'Vat21AmountExVat' | 'Vat21AmountInVat' | 'Vat21VatAmount';
export const SaleExportProps: SaleExportProp[] = ['Id', 'Created', 'LastUpdated', 'Reference', 'ExternalReference', 'IsInvoice', 'ValidUntil', 'IsCashSale', 'CountItems', 'RecipientName', 'RecipientAddressLine', 'RecipientCountry', 'RecipientZip', 'RecipientCity', 'AmountPaid', 'OutstandingBalance', 'HasOutstandingBalance', 'IsFullyPaid', 'IsPartlyPaid', 'IsOverDue', 'PriceInVat', 'PriceExVat', 'VatAmount', 'LocationIdentifier', 'DefaultBelgianStructuredCreditorReference', 'PatientReference', 'Vat0AmountExVat', 'Vat0AmountInVat', 'Vat0VatAmount', 'Vat6AmountExVat', 'Vat6AmountInVat', 'Vat6VatAmount', 'Vat9AmountExVat', 'Vat9AmountInVat', 'Vat9VatAmount', 'Vat12AmountExVat', 'Vat12AmountInVat', 'Vat12VatAmount', 'Vat21AmountExVat', 'Vat21AmountInVat', 'Vat21VatAmount'];

export type SalesLineExportProp = 'Id' | 'ProductCatalogItemId' | 'ProductCatalogItemType' | 'InventoryItemId' | 'Description' | 'UnitPrice' | 'UnitListPrice' | 'VatPercentage' | 'Quantity' | 'DiscountPercentage' | 'LinePriceInVat' | 'LinePriceExVat' | 'CreditedStatus' | 'SalesId' | 'SalesReference' | 'SalesDate' | 'SalesLabelsCsv' | 'LocationIdentifier' | 'SerialNumber' | 'PatientReference';
export const SalesLineExportProps: SalesLineExportProp[] = ['Id', 'ProductCatalogItemId', 'ProductCatalogItemType', 'InventoryItemId', 'Description', 'UnitPrice', 'UnitListPrice', 'VatPercentage', 'Quantity', 'DiscountPercentage', 'LinePriceInVat', 'LinePriceExVat', 'CreditedStatus', 'SalesId', 'SalesReference', 'SalesDate', 'SalesLabelsCsv', 'LocationIdentifier', 'SerialNumber', 'PatientReference'];

export type RfiaExportProp = 'Created' | 'LastUpdated' | 'Reference' | 'HealthInsuranceFundCode' | 'HasThirdPartyPaymentScheme' | 'MainMedicalTreatmentNomenclatureCode' | 'IsFailedTrial' | 'IsCancelled' | 'CancelReason' | 'EntPhysicianIdentifier' | 'EntPhysicianId' | 'EntPhysicianOfficeIdentifier' | 'LocationIdentifier' | 'PatientId' | 'PatientName' | 'HasMissingDocuments' | 'HasApprovedMedicalPrescription' | 'HasApprovedFeedbackAdvisoryPhysician' | 'HasTrialStep' | 'PrescriptionDate' | 'AdvisoryPhysicianApprovalDate' | 'HasCosiQuestionnaire' | 'EquipmentDeliveryDate' | 'IsHandedOver' | 'MedicalPrescriptionSentDate' | 'MedicalPrescriptionApprovalDate' | 'FeedbackAdvisoryPhysicianApprovalDate' | 'FeedbackAdvisoryPhysicianSentDate' | 'IsHandedOverAndPaid' | 'AudiologistIdentifier' | 'Id' | 'Status' | 'InvoiceProcessStatus' | 'PaymentStatus' | 'DateNextAppointment' | 'HasNextAppointment' | 'HasSentMedicalPrescription' | 'RosaMotive';
export const RfiaExportProps: RfiaExportProp[] = ['Created', 'LastUpdated', 'Reference', 'HealthInsuranceFundCode', 'HasThirdPartyPaymentScheme', 'MainMedicalTreatmentNomenclatureCode', 'IsFailedTrial', 'IsCancelled', 'CancelReason', 'EntPhysicianIdentifier', 'EntPhysicianId', 'EntPhysicianOfficeIdentifier', 'LocationIdentifier', 'PatientId', 'PatientName', 'HasMissingDocuments', 'HasApprovedMedicalPrescription', 'HasApprovedFeedbackAdvisoryPhysician', 'HasTrialStep', 'PrescriptionDate', 'AdvisoryPhysicianApprovalDate', 'HasCosiQuestionnaire', 'EquipmentDeliveryDate', 'IsHandedOver', 'MedicalPrescriptionSentDate', 'MedicalPrescriptionApprovalDate', 'FeedbackAdvisoryPhysicianApprovalDate', 'FeedbackAdvisoryPhysicianSentDate', 'IsHandedOverAndPaid', 'AudiologistIdentifier', 'Id', 'Status', 'InvoiceProcessStatus', 'PaymentStatus', 'DateNextAppointment', 'HasNextAppointment', 'HasSentMedicalPrescription', 'RosaMotive'];

export type PatientExportProp = 'Created' | 'LastUpdated' | 'FirstName' | 'LastName' | 'Gender' | 'DateOfBirth' | 'Salutation' | 'Zip' | 'City' | 'AddressLine' | 'Country' | 'SocialSecurityNumber' | 'EidDataLastRead' | 'HealthInsuranceFundCode' | 'IsDeceased' | 'IsMarkedAsInactive' | 'OriginsCsv' | 'Status' | 'IsActive' | 'AttendingAudiologistIdentifier' | 'LocationIdentifier' | 'AttendingGeneralPractitionerIdentifier' | 'AttendingEntPhysicianIdentifier' | 'Age' | 'LabelsCsv' | 'AttendingEntPhysicianId' | 'AttendingGeneralPractitionerId' | 'Id' | 'LastHandoverDate' | 'Phone' | 'Email' | 'Reference' | 'OriginalPatientNo' | 'Bsn';
export const PatientExportProps: PatientExportProp[] = ['Created', 'LastUpdated', 'FirstName', 'LastName', 'Gender', 'DateOfBirth', 'Salutation', 'Zip', 'City', 'AddressLine', 'Country', 'SocialSecurityNumber', 'EidDataLastRead', 'HealthInsuranceFundCode', 'IsDeceased', 'IsMarkedAsInactive', 'OriginsCsv', 'Status', 'IsActive', 'AttendingAudiologistIdentifier', 'LocationIdentifier', 'AttendingGeneralPractitionerIdentifier', 'AttendingEntPhysicianIdentifier', 'Age', 'LabelsCsv', 'AttendingEntPhysicianId', 'AttendingGeneralPractitionerId', 'Id', 'LastHandoverDate', 'Phone', 'Email', 'Reference', 'OriginalPatientNo', 'Bsn'];

export type PaymentExportProp = 'Id' | 'Created' | 'LastUpdated' | 'Reference' | 'PaymentDate' | 'IsCashSale' | 'IsSingleLine' | 'IsMultipleLines' | 'AmountPaid' | 'CustomerAccountIdentifier' | 'CashSaleForPatientIdentifier' | 'PaymentMethodIdentifier' | 'Comment' | 'HasComment' | 'SaleOrPurchaseReferencesCsv' | 'RecipientsCsv' | 'PatientReference';
export const PaymentExportProps: PaymentExportProp[] = ['Id', 'Created', 'LastUpdated', 'Reference', 'PaymentDate', 'IsCashSale', 'IsSingleLine', 'IsMultipleLines', 'AmountPaid', 'CustomerAccountIdentifier', 'CashSaleForPatientIdentifier', 'PaymentMethodIdentifier', 'Comment', 'HasComment', 'SaleOrPurchaseReferencesCsv', 'RecipientsCsv', 'PatientReference'];

export type CustomerAccountLineExportProp = 'Id' | 'Created' | 'LastUpdated' | 'Value' | 'CustomerAccountIdentifier' | 'SalesReference' | 'SalesRecipientName' | 'SalesDate' | 'SalesTotalPriceInVat' | 'AmountPaid' | 'OutstandingBalance' | 'HasOutstandingBalance';
export const CustomerAccountLineExportProps: CustomerAccountLineExportProp[] = ['Id', 'Created', 'LastUpdated', 'Value', 'CustomerAccountIdentifier', 'SalesReference', 'SalesRecipientName', 'SalesDate', 'SalesTotalPriceInVat', 'AmountPaid', 'OutstandingBalance', 'HasOutstandingBalance'];

export type SettlementProposalExportProp = 'Created' | 'LastUpdated' | 'Reference' | 'CustomerAccountIdentifier' | 'PaymentReference' | 'TotalValue' | 'IsHandled' | 'IsFullyPaid' | 'IsPartlyPaid' | 'AmountPaid';
export const SettlementProposalExportProps: SettlementProposalExportProp[] = ['Created', 'LastUpdated', 'Reference', 'CustomerAccountIdentifier', 'PaymentReference', 'TotalValue', 'IsHandled', 'IsFullyPaid', 'IsPartlyPaid', 'AmountPaid'];

export type NoahDeviceInventoryItemMapExportProp = 'SerialNumber' | 'IsHearingInstrument' | 'IsRemoteControl' | 'Type' | 'Manufacturer' | 'InstrumentTypeName' | 'FirstUsageDate' | 'LastUsageDate';
export const NoahDeviceInventoryItemMapExportProps: NoahDeviceInventoryItemMapExportProp[] = ['SerialNumber', 'IsHearingInstrument', 'IsRemoteControl', 'Type', 'Manufacturer', 'InstrumentTypeName', 'FirstUsageDate', 'LastUsageDate'];

export type PurchaseExportProp = 'Id' | 'Created' | 'LastUpdated' | 'PurchaseDate' | 'Reference' | 'ExternalReference' | 'ValidUntil' | 'IsCreditNote' | 'CountItems' | 'AmountToPay' | 'AmountPaid' | 'OutstandingBalance' | 'HasOutstandingBalance' | 'IsFullyPaid' | 'IsPartlyPaid' | 'IsNothingPaid' | 'IsOverDue' | 'HasPayments' | 'PriceInVat' | 'PriceExVat' | 'VatAmount' | 'IsFullyCredited' | 'IsPartlyCredited' | 'IsNothingCredited' | 'SupplierIdentifier';
export const PurchaseExportProps: PurchaseExportProp[] = ['Id', 'Created', 'LastUpdated', 'PurchaseDate', 'Reference', 'ExternalReference', 'ValidUntil', 'IsCreditNote', 'CountItems', 'AmountToPay', 'AmountPaid', 'OutstandingBalance', 'HasOutstandingBalance', 'IsFullyPaid', 'IsPartlyPaid', 'IsNothingPaid', 'IsOverDue', 'HasPayments', 'PriceInVat', 'PriceExVat', 'VatAmount', 'IsFullyCredited', 'IsPartlyCredited', 'IsNothingCredited', 'SupplierIdentifier'];

export type DailyReceiptExportProp = 'LocationIdentifier' | 'OnDate' | 'PriceInVat' | 'PriceExVat' | 'VatAmount' | 'PriceInVatAt0' | 'PriceInVatAt6' | 'PriceInVatAt9' | 'PriceInVatAt12' | 'PriceInVatAt21' | 'IsGlobal';
export const DailyReceiptExportProps: DailyReceiptExportProp[] = ['LocationIdentifier', 'OnDate', 'PriceInVat', 'PriceExVat', 'VatAmount', 'PriceInVatAt0', 'PriceInVatAt6', 'PriceInVatAt9', 'PriceInVatAt12', 'PriceInVatAt21', 'IsGlobal'];

export type CashRegisterEntryExportProp = 'Index' | 'LocationIdentifier' | 'ReferenceDate' | 'Value' | 'GlobalResultingBalance' | 'PaymentReferenceOrDescription';
export const CashRegisterEntryExportProps: CashRegisterEntryExportProp[] = ['Index', 'LocationIdentifier', 'ReferenceDate', 'Value', 'GlobalResultingBalance', 'PaymentReferenceOrDescription'];

export type CalendarEventExportProp = 'FormTitle' | 'Contact' | 'StartDate' | 'EndDate' | 'AllDay' | 'UserIdentifiersCsv' | 'Description' | 'RoomIdentifier' | 'EventTypeIdentifier' | 'PatientIdentifier';
export const CalendarEventExportProps: CalendarEventExportProp[] = ['FormTitle', 'Contact', 'StartDate', 'EndDate', 'AllDay', 'UserIdentifiersCsv', 'Description', 'RoomIdentifier', 'EventTypeIdentifier', 'PatientIdentifier'];

export type ArticlesInquiryExportProp = 'Id' | 'Created' | 'LastUpdated' | 'Status' | 'Reference' | 'CountItems' | 'PatientIdentifier';
export const ArticlesInquiryExportProps: ArticlesInquiryExportProp[] = ['Id', 'Created', 'LastUpdated', 'Status', 'Reference', 'CountItems', 'PatientIdentifier'];

export type CommissionExportProp = 'Created' | 'UserIdentifier' | 'IsPaidOut' | 'Value' | 'RuleMethod' | 'RuleName' | 'RulePercentage' | 'SalesReference' | 'SalesDate' | 'SalesRecipientName' | 'TotalValueExVatOfSale' | 'TotalValueExVatOfDevices' | 'PayoutDate';
export const CommissionExportProps: CommissionExportProp[] = ['Created', 'UserIdentifier', 'IsPaidOut', 'Value', 'RuleMethod', 'RuleName', 'RulePercentage', 'SalesReference', 'SalesDate', 'SalesRecipientName', 'TotalValueExVatOfSale', 'TotalValueExVatOfDevices', 'PayoutDate'];

export type CochlearPatientExportProp = 'Id' | 'FirstName' | 'LastName' | 'InformedDate' | 'ReferralDate' | 'ImplantedDate' | 'BimodallyFittedDate' | 'MaxPta' | 'IsCiCandidate' | 'DateOfBirth' | 'SocialSecurityNumber' | 'Gender' | 'Zip' | 'City' | 'AddressLine' | 'Country' | 'FormattedAddress' | 'Email';
export const CochlearPatientExportProps: CochlearPatientExportProp[] = ['Id', 'FirstName', 'LastName', 'InformedDate', 'ReferralDate', 'ImplantedDate', 'BimodallyFittedDate', 'MaxPta', 'IsCiCandidate', 'DateOfBirth', 'SocialSecurityNumber', 'Gender', 'Zip', 'City', 'AddressLine', 'Country', 'FormattedAddress', 'Email'];

export type CochlearInfoEventExportProp = 'Title' | 'Description' | 'Type' | 'Date' | 'PostalCode' | 'FormattedAddress' | 'RegistrationUrl' | 'RegistrationEmail';
export const CochlearInfoEventExportProps: CochlearInfoEventExportProp[] = ['Title', 'Description', 'Type', 'Date', 'PostalCode', 'FormattedAddress', 'RegistrationUrl', 'RegistrationEmail'];

export type CochlearReferralCenterExportProp = 'Name' | 'FormattedAddress' | 'PostalCode' | 'PhoneNumber' | 'Email';
export const CochlearReferralCenterExportProps: CochlearReferralCenterExportProp[] = ['Name', 'FormattedAddress', 'PostalCode', 'PhoneNumber', 'Email'];

export interface ICompaniesFilterParams {
  createdBefore: Date | undefined;
  createdAfter: Date | undefined;
  searchString: string;
}

export interface IEntPhysicianFilterParams {
  zips: string[];
  hasRequestsToInsuranceAllowance: boolean | undefined;
  createdBefore: Date | undefined;
  createdAfter: Date | undefined;
  gender: string | undefined;
  hasOffices: boolean | undefined;
  showDeleted: boolean;
  searchString: string;
}

export interface IGeneralPractitionerFilterParams {
  zips: string[];
  createdBefore: Date | undefined;
  createdAfter: Date | undefined;
  gender: string | undefined;
  hasOffices: boolean | undefined;
  showDeleted: boolean;
  searchString: string;
}

export interface IStockItemDtosFilterParams {
  searchString: string;
  manufacturers: string[];
  types: ProductCatalogItemType[];
  categories: string[];
  subcategories: string[];
  vatPercentages: number[];
  hasSerialNumber: boolean | undefined;
  supplierIds: string[];
  availableOnLocationIds: string[];
  stockMoreThan: number | undefined;
  stockLessThan: number | undefined;
  stockValueMoreThan: number | undefined;
  stockValueLessThan: number | undefined;
  keyFilterType: ProductCatalogItemType | undefined;
}

export interface IInventoryItemFilterParams {
  manufacturers: string[];
  types: ProductCatalogItemType[];
  categories: string[];
  subcategories: string[];
  statuses: string[];
  vatPercentage: number | undefined;
  isElectronics: boolean | undefined;
  hasBatteries: boolean | undefined;
  isSold: boolean | undefined;
  isPurchased: boolean | undefined;
  isSalesCredited: boolean | undefined;
  isPurchaseCredited: boolean | undefined;
  isAtSupplierForRepair: boolean | undefined;
  isReturnedToSupplier: boolean | undefined;
  salesPriceLessThan: number | undefined;
  salesPriceMoreThan: number | undefined;
  listPriceLessThan: number | undefined;
  listPriceMoreThan: number | undefined;
  orderedBefore: Date | undefined;
  orderedAfter: Date | undefined;
  deliveredBefore: Date | undefined;
  deliveredAfter: Date | undefined;
  returnedBefore: Date | undefined;
  returnedAfter: Date | undefined;
  purchasedBefore: Date | undefined;
  purchasedAfter: Date | undefined;
  soldBefore: Date | undefined;
  soldAfter: Date | undefined;
  createdBefore: Date | undefined;
  createdAfter: Date | undefined;
  lastUpdatedBefore: Date | undefined;
  lastUpdatedAfter: Date | undefined;
  atLocationIds: string[];
  supplierIds: string[];
  vatPercentages: number[];
  keyFilterType: ProductCatalogItemType | undefined;
  isDemo: boolean | undefined;
  isReserved: boolean | undefined;
  locationTypes: string[];
  propertyOfTypes: string[];
  consignmentReturnBeforeDateAfter: Date | undefined;
  consignmentReturnBeforeDateBefore: Date | undefined;
  isOnConsignment: boolean | undefined;
  isConsignmentExpired: boolean | undefined;
  consignmentExpiresWithinAWeek: boolean | undefined;
  hasSoldInsurance: boolean | undefined;
  hasSoldProlongedWarranty: boolean | undefined;
  hasPurchasedInsurance: boolean | undefined;
  hasPurchasedProlongedWarranty: boolean | undefined;
  purchaseCreditDateBefore: Date | undefined;
  purchaseCreditDateAfter: Date | undefined;
  salesCreditDateBefore: Date | undefined;
  salesCreditDateAfter: Date | undefined;
  isTailorMade: boolean | undefined;
  hasBebat: boolean | undefined;
  labels: string[];
  searchString: string;
}

export interface ILoansFilterParams {
  createdBefore: Date | undefined;
  createdAfter: Date | undefined;
  statuses: string[];
  forPatientId: string | undefined;
  stopDateBefore: Date | undefined;
  stopDateAfter: Date | undefined;
  prefilter: LoansPrefilter;
  searchString: string;
}

export interface IOrderFilterParams {
  createdBefore: Date | undefined;
  createdAfter: Date | undefined;
  supplierIds: string[];
  statuses: string[];
  handlingUserIds: string[];
  locationIds: string[];
  patientId: string | undefined;
  isCompletelyDelivered: boolean | undefined;
  deliveredBefore: Date | undefined;
  deliveredAfter: Date | undefined;
  prefilter: OrderPrefilter;
  searchString: string;
}

export interface IDeliveriesFilterParams {
  createdBefore: Date | undefined;
  createdAfter: Date | undefined;
  deliveredBefore: Date | undefined;
  deliveredAfter: Date | undefined;
  supplierIds: string[];
  searchString: string;
}

export interface IStockMovementsFilterParams {
  createdBefore: Date | undefined;
  createdAfter: Date | undefined;
  fromLocationIds: string[];
  toLocationIds: string[];
  searchString: string;
}

export interface IReturnsFilterParams {
  createdBefore: Date | undefined;
  createdAfter: Date | undefined;
  returnedBefore: Date | undefined;
  returnedAfter: Date | undefined;
  supplierIds: string[];
  searchString: string;
}

export interface IProductCatalogFilterParams {
  alsoIncludeDeleted: boolean;
  isDeleted: boolean | undefined;
  manufacturers: string[];
  vatPercentages: number[];
  createdBefore: Date | undefined;
  createdAfter: Date | undefined;
  lastUpdatedBefore: Date | undefined;
  lastUpdatedAfter: Date | undefined;
  listPriceLessThan: number | undefined;
  listPriceMoreThan: number | undefined;
  isElectronics: boolean | undefined;
  hasBatteries: boolean | undefined;
  rizivHearingAidDefinitionV2LinkStatuses: string[];
  isTailorMade: boolean | undefined;
  hasSerialNumber: boolean | undefined;
  suppliers: string[];
  keyFilterType: ProductCatalogItemType | undefined;
  isTangible: boolean | undefined;
  labels: string[];
  types: ProductCatalogItemType[];
  categories: string[];
  subcategories: string[];
  searchString: string;
}

export interface IPurchasesFilterParams {
  supplierIds: string[];
  createdBefore: Date | undefined;
  createdAfter: Date | undefined;
  validUntilBefore: Date | undefined;
  validUntilAfter: Date | undefined;
  purchaseReferenceDateBefore: Date | undefined;
  purchaseReferenceDateAfter: Date | undefined;
  priceExVatMoreThan: number | undefined;
  priceExVatLessThan: number | undefined;
  paymentStatuses: string[];
  types: string[];
  creditedStatuses: string[];
  prefilter: PurchasesPrefilter;
  labels: string[];
  searchString: string;
}

export interface ISupplierAccountsFilterParams {
  outstandingBalanceLessThan: number | undefined;
  outstandingBalanceMoreThan: number | undefined;
  hasOutstandingBalance: boolean | undefined;
  searchString: string;
}

export interface IRepairFilterParams {
  statuses: string[];
  supplierIds: string[];
  locationIds: string[];
  handlingUserIds: string[];
  createdBefore: Date | undefined;
  createdAfter: Date | undefined;
  warnings: string[];
  prefilter: RepairPrefilter;
  searchString: string;
}

export interface ISupplierFilterParams {
  brands: string[];
  hasOrders: boolean | undefined;
  hasDeliveries: boolean | undefined;
  hasPurchases: boolean | undefined;
  createdBefore: Date | undefined;
  createdAfter: Date | undefined;
  showDeleted: boolean;
  searchString: string;
}

export interface ITendersFilterParams {
  createdBefore: Date | undefined;
  createdAfter: Date | undefined;
  validUntilBefore: Date | undefined;
  validUntilAfter: Date | undefined;
  statuses: string[];
  isSubProcess: boolean | undefined;
  isForPatient: boolean | undefined;
  forPatientId: string | undefined;
  isForCompany: boolean | undefined;
  forCompanyId: string | undefined;
  alsoIncludeDeleted: boolean;
  prefilter: TendersPrefilter;
  searchString: string;
}

export interface IPaymentsFilterParams {
  customerAccountTypes: string[];
  saleTypes: string[];
  isLinkedToASale: boolean | undefined;
  isLinkedToAPurchase: boolean | undefined;
  createdBefore: Date | undefined;
  createdAfter: Date | undefined;
  paymentDateBefore: Date | undefined;
  paymentDateAfter: Date | undefined;
  paymentMethodIds: string[];
  amountPaidLessThan: number | undefined;
  amountPaidMoreThan: number | undefined;
  expenseOrIncomeTypes: string[];
  hasComment: boolean | undefined;
  searchString: string;
}

export interface ISalesFilterParams {
  createdBefore: Date | undefined;
  createdAfter: Date | undefined;
  validUntilBefore: Date | undefined;
  validUntilAfter: Date | undefined;
  priceInVatMoreThan: number | undefined;
  priceInVatLessThan: number | undefined;
  paymentStatuses: string[];
  types: string[];
  creditedStatuses: string[];
  locationIds: string[];
  hasDocument: boolean | undefined;
  searchMode: SalesSearchMode;
  labels: string[];
  zips: string[];
  isRecipientVatCustomer: boolean | undefined;
  prefilter: SalesPrefilter;
  searchString: string;
}

export interface IRfiasFilterParams {
  createdBefore: Date | undefined;
  createdAfter: Date | undefined;
  prescriptionForTrialDateBefore: Date | undefined;
  prescriptionForTrialDateAfter: Date | undefined;
  handoverDateBefore: Date | undefined;
  handoverDateAfter: Date | undefined;
  medicalPrescriptionSentDateAfter: Date | undefined;
  medicalPrescriptionSentDateBefore: Date | undefined;
  statuses: string[];
  invoiceProcessStatuses: string[];
  paymentStatuses: string[];
  entPhysicianIds: string[];
  audiologistIds: string[];
  locationIds: string[];
  warnings: string[];
  isFailedTrial: boolean | undefined;
  hasMissingDocuments: boolean | undefined;
  hasWarning: boolean | undefined;
  isCompleted: boolean | undefined;
  labels: string[];
  searchString: string;
}

export interface IPatientsFilterParams {
  gender: string | undefined;
  statuses: string[];
  origins: string[];
  generalPractitionerIds: string[];
  entPhysicianIds: string[];
  audiologistIds: string[];
  locationIds: string[];
  createdBefore: Date | undefined;
  createdAfter: Date | undefined;
  lastUpdatedBefore: Date | undefined;
  lastUpdatedAfter: Date | undefined;
  canRenewBefore: Date | undefined;
  canRenewAfter: Date | undefined;
  lastHandoverDateBefore: Date | undefined;
  lastHandoverDateAfter: Date | undefined;
  keyStatus: string | undefined;
  searchMode: string | undefined;
  monthsOfBirth: number[];
  labels: string[];
  zips: string[];
  searchString: string;
}

export interface ICochlearPatientsFilterParams {
  searchString: string;
  statuses: CochlearPatientStatus[];
  isCiCandidate: boolean | undefined;
  informedDateBefore: Date | undefined;
  informedDateAfter: Date | undefined;
  referralDateBefore: Date | undefined;
  referralDateAfter: Date | undefined;
  implantedDateBefore: Date | undefined;
  implantedDateAfter: Date | undefined;
  bimodallyFittedDateBefore: Date | undefined;
  bimodallyFittedDateAfter: Date | undefined;
  patientId: string | undefined;
}

export interface ICustomerAccountsFilterParams {
  outstandingBalanceLessThan: number | undefined;
  outstandingBalanceMoreThan: number | undefined;
  hasOutstandingBalance: boolean | undefined;
  hasOutstandingBalanceNotOnSettlementProposals: boolean | undefined;
  accountTypes: string[];
  searchString: string;
}

export interface ICustomerAccountLinesFilterParams {
  outstandingBalanceLessThan: number | undefined;
  outstandingBalanceMoreThan: number | undefined;
  salesDateBefore: Date | undefined;
  salesDateCreatedAfter: Date | undefined;
  hasOutstandingBalance: boolean | undefined;
  hasSettlementProposal: boolean | undefined;
  searchString: string;
}

export interface ISettlementProposalsForCustomerAccountFilterParams {
  createdAfter: Date | undefined;
  createdBefore: Date | undefined;
  paymentStatuses: string[];
  isHandled: boolean | undefined;
  searchString: string;
}

export interface ISettlementProposalsFilterParams {
  createdAfter: Date | undefined;
  createdBefore: Date | undefined;
  paymentStatuses: string[];
  isHandled: boolean | undefined;
  labels: string[];
  searchString: string;
}

export interface IPaymentsForCustomerAccountFilterParams {
  saleTypes: string[];
  isMultipleLines: boolean | undefined;
  isSingleLine: boolean | undefined;
  createdBefore: Date | undefined;
  createdAfter: Date | undefined;
  paymentDateBefore: Date | undefined;
  paymentDateAfter: Date | undefined;
  paymentMethodIds: string[];
  amountPaidLessThan: number | undefined;
  amountPaidMoreThan: number | undefined;
  expenseOrIncomeTypes: string[];
  hasComment: boolean | undefined;
  searchString: string;
}

export interface IPaymentsForSupplierAccountFilterParams {
  isMultipleLines: boolean | undefined;
  isSingleLine: boolean | undefined;
  createdBefore: Date | undefined;
  createdAfter: Date | undefined;
  paymentDateBefore: Date | undefined;
  paymentDateAfter: Date | undefined;
  paymentMethodIds: string[];
  amountPaidLessThan: number | undefined;
  amountPaidMoreThan: number | undefined;
  expenseOrIncomeTypes: string[];
  hasComment: boolean | undefined;
  searchString: string;
}

export interface INoahDeviceInventoryItemMapsWithUsagesFilterParams {
  firstUsageBefore: Date | undefined;
  firstUsageAfter: Date | undefined;
  lastUsageBefore: Date | undefined;
  lastUsageAfter: Date | undefined;
  types: string[];
  isLinkedToInventoryItem: boolean | undefined;
  hasDifferentReadOuts: boolean | undefined;
  searchString: string;
}

export interface ICommonPurchasesFilterParams {
  createdBefore: Date | undefined;
  createdAfter: Date | undefined;
  validUntilBefore: Date | undefined;
  validUntilAfter: Date | undefined;
  purchaseReferenceDateBefore: Date | undefined;
  purchaseReferenceDateAfter: Date | undefined;
  priceExVatMoreThan: number | undefined;
  priceExVatLessThan: number | undefined;
  paymentStatuses: string[];
  types: string[];
  creditedStatuses: string[];
  prefilter: PurchasesPrefilter;
  labels: string[];
  searchString: string;
}

export interface IDailyReceiptsFilterParams {
  referenceDateBefore: Date | undefined;
  referenceDateAfter: Date | undefined;
  locationIds: string[];
  isGlobal: boolean;
  searchString: string;
}

export interface ICashRegisterEntriesFilterParams {
  referenceDateBefore: Date | undefined;
  referenceDateAfter: Date | undefined;
  locationIds: string[];
  searchString: string;
}

export interface IArticlesInquiriesFilterParams {
  createdBefore: Date | undefined;
  createdAfter: Date | undefined;
  statuses: string[];
  handlingUserIds: string[];
  locationIds: string[];
  isAssigned: boolean | undefined;
  prefilter: ArticlesInquiriesPrefilter;
  searchString: string;
}

export interface ICommissionsFilterParams {
  searchString: string;
  userIds: string[];
  createdBefore: Date | undefined;
  createdAfter: Date | undefined;
  commissionRuleIds: string[];
  isPaidOut: boolean | undefined;
}

export type Gender = 'Male' | 'Female' | 'X';
export const Genders: Gender[] = ['Male', 'Female', 'X'];

export type CommissionRuleMethod = 'TotalValueOfSale' | 'TotalValueOfDevices';
export const CommissionRuleMethods: CommissionRuleMethod[] = ['TotalValueOfSale', 'TotalValueOfDevices'];

export type LanguageOption = 'nl' | 'en' | 'fr';
export const LanguageOptions: LanguageOption[] = ['nl', 'en', 'fr'];

export type PatientLanguageOption = 'nl' | 'en' | 'fr' | 'de';
export const PatientLanguageOptions: PatientLanguageOption[] = ['nl', 'en', 'fr', 'de'];

export type DocumentAction = 'CreatedFromTemplate' | 'CreatedFromUploadWithoutSignature' | 'CreatedFromUploadWithSignature' | 'Saved' | 'ReplacedWithoutSignature' | 'ReplacedWithSignature' | 'RebuildFromTemplate';
export const DocumentActions: DocumentAction[] = ['CreatedFromTemplate', 'CreatedFromUploadWithoutSignature', 'CreatedFromUploadWithSignature', 'Saved', 'ReplacedWithoutSignature', 'ReplacedWithSignature', 'RebuildFromTemplate'];

export type DocumentExportFormat = 'Native' | 'Pdf';
export const DocumentExportFormats: DocumentExportFormat[] = ['Native', 'Pdf'];

export type DocumentPredefinedType = 'RfiaPrescriptionScan' | 'DeliveryNote' | 'RfiaProformaHandoverCertificate' | 'RfiaAnamnesis' | 'RfiaCosi' | 'RfiaLoanSlip' | 'RfiaEntLetter' | 'RfiaAdvisoryPhysicianLetter' | 'RfiaTrialReport' | 'RfiaHandoverCertificate' | 'Invoice' | 'OrderFormToCustomer' | 'OrderFormToSupplier' | 'RepairFormToCustomer' | 'RepairFormToSupplier' | 'SettlementProposal' | 'Tender' | 'TenderOrderForm' | 'LoanSlip' | 'ReturnSlip';
export const DocumentPredefinedTypes: DocumentPredefinedType[] = ['RfiaPrescriptionScan', 'DeliveryNote', 'RfiaProformaHandoverCertificate', 'RfiaAnamnesis', 'RfiaCosi', 'RfiaLoanSlip', 'RfiaEntLetter', 'RfiaAdvisoryPhysicianLetter', 'RfiaTrialReport', 'RfiaHandoverCertificate', 'Invoice', 'OrderFormToCustomer', 'OrderFormToSupplier', 'RepairFormToCustomer', 'RepairFormToSupplier', 'SettlementProposal', 'Tender', 'TenderOrderForm', 'LoanSlip', 'ReturnSlip'];

export type CurrentLocationType = 'Supplier' | 'Location' | 'Patient' | 'Unknown';
export const CurrentLocationTypes: CurrentLocationType[] = ['Supplier', 'Location', 'Patient', 'Unknown'];

export type PropertyOfType = 'HearingCentre' | 'Supplier' | 'Patient';
export const PropertyOfTypes: PropertyOfType[] = ['HearingCentre', 'Supplier', 'Patient'];

export type InventoryStatus = 'Ordered' | 'InStock' | 'InTestOrLoan' | 'InRepair' | 'Sold' | 'ReturnedToSupplier' | 'NotInventoried' | 'Broken';
export const InventoryStatuses: InventoryStatus[] = ['Ordered', 'InStock', 'InTestOrLoan', 'InRepair', 'Sold', 'ReturnedToSupplier', 'NotInventoried', 'Broken'];

export type LoanProcessStatus = 'Started' | 'Ended' | 'Cancelled';
export const LoanProcessStatuses: LoanProcessStatus[] = ['Started', 'Ended', 'Cancelled'];

export type LoanProcessStep = 'Start' | 'Stop';
export const LoanProcessSteps: LoanProcessStep[] = ['Start', 'Stop'];

export type OrderProcessStatus = 'PlacedWithSupplier' | 'CompletelyDelivered' | 'PartialDelivered' | 'Cancelled' | 'CancelledAfterPartialDelivery' | 'Registered';
export const OrderProcessStatuses: OrderProcessStatus[] = ['PlacedWithSupplier', 'CompletelyDelivered', 'PartialDelivered', 'Cancelled', 'CancelledAfterPartialDelivery', 'Registered'];

export type OrderLineStatus = 'CompletelyDelivered' | 'PartiallyDelivered' | 'Cancelled' | 'CancelledAfterPartialDelivery' | 'NotDelivered';
export const OrderLineStatuses: OrderLineStatus[] = ['CompletelyDelivered', 'PartiallyDelivered', 'Cancelled', 'CancelledAfterPartialDelivery', 'NotDelivered'];

export type RepairProcessStatus = 'Registered' | 'SentToSupplier' | 'Redelivered' | 'PartialRedelivered' | 'DeliveredToPatient' | 'CancelledBeforeSentToSupplier' | 'CancelledAfterSentToSupplier';
export const RepairProcessStatuses: RepairProcessStatus[] = ['Registered', 'SentToSupplier', 'Redelivered', 'PartialRedelivered', 'DeliveredToPatient', 'CancelledBeforeSentToSupplier', 'CancelledAfterSentToSupplier'];

export type RepairProcessStep = 'Define' | 'SendToSupplier' | 'Redelivery' | 'DeliverToPatient';
export const RepairProcessSteps: RepairProcessStep[] = ['Define', 'SendToSupplier', 'Redelivery', 'DeliverToPatient'];

export type RepairWarning = 'NoItemsDefined' | 'NotSendToSupplier' | 'DeliveryOverDue' | 'HandoverOverDue';
export const RepairWarnings: RepairWarning[] = ['NoItemsDefined', 'NotSendToSupplier', 'DeliveryOverDue', 'HandoverOverDue'];

export type PredefinedPaymentMethod = 'Cash' | 'Bancontact' | 'BankTransfer' | 'CreditNote';
export const PredefinedPaymentMethods: PredefinedPaymentMethod[] = ['Cash', 'Bancontact', 'BankTransfer', 'CreditNote'];

export type CosiDegreeOfChange = 'NotApplicable' | 'Worse' | 'NoDifference' | 'SlightlyBetter' | 'Better' | 'MuchBetter';
export const CosiDegreeOfChanges: CosiDegreeOfChange[] = ['NotApplicable', 'Worse', 'NoDifference', 'SlightlyBetter', 'Better', 'MuchBetter'];

export type CosiEndResult = 'NotApplicable' | 'AlmostNever' | 'Sometimes' | 'HalfOfTime' | 'MostOfTime' | 'AlmostAlways';
export const CosiEndResults: CosiEndResult[] = ['NotApplicable', 'AlmostNever', 'Sometimes', 'HalfOfTime', 'MostOfTime', 'AlmostAlways'];

export type RfiaInvoiceProcessStatus = 'NotApplicable' | 'Tendered' | 'Ordered' | 'Delivered' | 'Invoiced' | 'IsFullyPaid';
export const RfiaInvoiceProcessStatuses: RfiaInvoiceProcessStatus[] = ['NotApplicable', 'Tendered', 'Ordered', 'Delivered', 'Invoiced', 'IsFullyPaid'];

export type RfiaPaymentStatus = 'NotApplicable' | 'FullyPaid' | 'OnlyHifFullyPaid' | 'OnlyPatientFullyPaid' | 'PartlyPaid' | 'NotPaid';
export const RfiaPaymentStatuses: RfiaPaymentStatus[] = ['NotApplicable', 'FullyPaid', 'OnlyHifFullyPaid', 'OnlyPatientFullyPaid', 'PartlyPaid', 'NotPaid'];

export type RfiaStatus = 'HandedOverAndPaidBeforeApprovals' | 'HandedOverAndPaid' | 'HandedOverBeforeApprovals' | 'HandedOver' | 'ApprovedByAdvisoryPhysician' | 'DocumentsSentToAdvisoryPhysician' | 'MedicalPrescriptionReceived' | 'DocumentsSentToEntPhysician' | 'TrialRunning' | 'TrialEnded' | 'PrescriptionForTrialReceived' | 'Created' | 'Cancelled' | 'FailedTrial';
export const RfiaStatuses: RfiaStatus[] = ['HandedOverAndPaidBeforeApprovals', 'HandedOverAndPaid', 'HandedOverBeforeApprovals', 'HandedOver', 'ApprovedByAdvisoryPhysician', 'DocumentsSentToAdvisoryPhysician', 'MedicalPrescriptionReceived', 'DocumentsSentToEntPhysician', 'TrialRunning', 'TrialEnded', 'PrescriptionForTrialReceived', 'Created', 'Cancelled', 'FailedTrial'];

export type RfiaWarning = 'PrescriptionForTrialNotReceived' | 'NoTrialStarted' | 'TrialsExpiredNoDocumentsSentForMedicalPrescription' | 'ExpectedReceptionMedicalPrescriptionExpired' | 'MedicalPrescriptionReceivedNotSentToAdvisoryPhysician' | 'ExpectedReceptionAdvisoryPhysicianExpired' | 'ExpectedHandoverDateExpired' | 'TrialFailHandoverNotRegistered' | 'HandedOverWithoutApprovals';
export const RfiaWarnings: RfiaWarning[] = ['PrescriptionForTrialNotReceived', 'NoTrialStarted', 'TrialsExpiredNoDocumentsSentForMedicalPrescription', 'ExpectedReceptionMedicalPrescriptionExpired', 'MedicalPrescriptionReceivedNotSentToAdvisoryPhysician', 'ExpectedReceptionAdvisoryPhysicianExpired', 'ExpectedHandoverDateExpired', 'TrialFailHandoverNotRegistered', 'HandedOverWithoutApprovals'];

export type PatientStatus = 'Deceased' | 'Inactive' | 'Active';
export const PatientStatuses: PatientStatus[] = ['Deceased', 'Inactive', 'Active'];

export type Application = 'Eid' | 'Client' | 'ImageScanner' | 'ThermalPrinter';
export const Applications: Application[] = ['Eid', 'Client', 'ImageScanner', 'ThermalPrinter'];

export type PatientNavigationLink = 'NoahOverview' | 'Overview' | 'Comments' | 'FollowUp' | 'Processes' | 'SalesAndTenders' | 'InventoryItems' | 'Appointments' | 'Documents';
export const PatientNavigationLinks: PatientNavigationLink[] = ['NoahOverview', 'Overview', 'Comments', 'FollowUp', 'Processes', 'SalesAndTenders', 'InventoryItems', 'Appointments', 'Documents'];

export type TemplateType = 'RfiaEntLetter' | 'RfiaAdvisoryPhysicianLetter' | 'LoanSlip' | 'RfiaLoanSlip' | 'RfiaTrialReport' | 'RfiaAnamnesis' | 'RfiaCosi' | 'RfiaHandoverCertificate' | 'Invoice' | 'Tender' | 'TenderOrderForm' | 'OrderFormToSupplier' | 'OrderFormToCustomer' | 'RepairFormToSupplier' | 'RepairFormToCustomer' | 'SettlementProposal' | 'ReturnSlip';
export const TemplateTypes: TemplateType[] = ['RfiaEntLetter', 'RfiaAdvisoryPhysicianLetter', 'LoanSlip', 'RfiaLoanSlip', 'RfiaTrialReport', 'RfiaAnamnesis', 'RfiaCosi', 'RfiaHandoverCertificate', 'Invoice', 'Tender', 'TenderOrderForm', 'OrderFormToSupplier', 'OrderFormToCustomer', 'RepairFormToSupplier', 'RepairFormToCustomer', 'SettlementProposal', 'ReturnSlip'];

export type DeliveryTimeUnit = 'Days' | 'Weeks' | 'Months';
export const DeliveryTimeUnits: DeliveryTimeUnit[] = ['Days', 'Weeks', 'Months'];

export type ValidUntilTimeUnit = 'Days' | 'Weeks' | 'Months';
export const ValidUntilTimeUnits: ValidUntilTimeUnit[] = ['Days', 'Weeks', 'Months'];

export type InsuranceOrProlongedWarrantyTimeUnit = 'Months' | 'Years';
export const InsuranceOrProlongedWarrantyTimeUnits: InsuranceOrProlongedWarrantyTimeUnit[] = ['Months', 'Years'];

export type TenderProcessStatus = 'Created' | 'Expired' | 'ConvertedToSales' | 'Lost' | 'Deleted';
export const TenderProcessStatuses: TenderProcessStatus[] = ['Created', 'Expired', 'ConvertedToSales', 'Lost', 'Deleted'];

export type ExportFormat = 'Xlsx' | 'Csv';
export const ExportFormats: ExportFormat[] = ['Xlsx', 'Csv'];

export type TimeUnit = 'Seconds' | 'Minutes' | 'Hours' | 'Days' | 'Weeks' | 'Months' | 'Years';
export const TimeUnits: TimeUnit[] = ['Seconds', 'Minutes', 'Hours', 'Days', 'Weeks', 'Months', 'Years'];

export type TrialTimeUnit = 'Days' | 'Weeks' | 'Months';
export const TrialTimeUnits: TrialTimeUnit[] = ['Days', 'Weeks', 'Months'];

export type CalendarEventTimeUnit = 'Minutes' | 'Hours';
export const CalendarEventTimeUnits: CalendarEventTimeUnit[] = ['Minutes', 'Hours'];

export type SalesType = 'Invoice' | 'AdvanceInvoice' | 'CashSale' | 'CreditNote';
export const SalesTypes: SalesType[] = ['Invoice', 'AdvanceInvoice', 'CashSale', 'CreditNote'];

export type CreditedStatus = 'FullyCredited' | 'PartlyCredited' | 'NothingCredited';
export const CreditedStatuses: CreditedStatus[] = ['FullyCredited', 'PartlyCredited', 'NothingCredited'];

export type WorkflowType = 'Rfia' | 'Order' | 'Repair' | 'Loan' | 'ArticlesInquiry';
export const WorkflowTypes: WorkflowType[] = ['Rfia', 'Order', 'Repair', 'Loan', 'ArticlesInquiry'];

export type PaymentStatus = 'FullyPaid' | 'PartlyPaid' | 'NothingPaid';
export const PaymentStatuses: PaymentStatus[] = ['FullyPaid', 'PartlyPaid', 'NothingPaid'];

export type CustomerAccountType = 'Patient' | 'Company' | 'HealthInsuranceFund';
export const CustomerAccountTypes: CustomerAccountType[] = ['Patient', 'Company', 'HealthInsuranceFund'];

export type NoahDeviceType = 'HearingInstrument' | 'RemoteControl' | 'Unknown';
export const NoahDeviceTypes: NoahDeviceType[] = ['HearingInstrument', 'RemoteControl', 'Unknown'];

export type TransactionType = 'Sale' | 'CreditSale' | 'Order' | 'OrderCancelled' | 'Purchase' | 'CreditPurchase' | 'StartLoan' | 'EndLoan' | 'Delivery' | 'ReturnToSupplier' | 'SentToSupplierForRepair' | 'ImportedFromNoah' | 'MovedToOtherLocation' | 'Reserved' | 'ReservationCleared' | 'TreatmentArticleNeedLinked' | 'TreatmentArticleNeedUnlinked' | 'RegisteredAsSold' | 'RegisteredAsSoldUndone' | 'RegisteredAsPurchasedByScript' | 'DeliveryScript' | 'RegisteredAsBroken' | 'RegisteredAsBrokenUndone';
export const TransactionTypes: TransactionType[] = ['Sale', 'CreditSale', 'Order', 'OrderCancelled', 'Purchase', 'CreditPurchase', 'StartLoan', 'EndLoan', 'Delivery', 'ReturnToSupplier', 'SentToSupplierForRepair', 'ImportedFromNoah', 'MovedToOtherLocation', 'Reserved', 'ReservationCleared', 'TreatmentArticleNeedLinked', 'TreatmentArticleNeedUnlinked', 'RegisteredAsSold', 'RegisteredAsSoldUndone', 'RegisteredAsPurchasedByScript', 'DeliveryScript', 'RegisteredAsBroken', 'RegisteredAsBrokenUndone'];

export type NoahDeviceReadOutMode = 'AlwaysCreateAnInventoryItem' | 'OnlyCreateAnInventoryItemIfNewNoahAction' | 'NeverCreateAnInventoryItem';
export const NoahDeviceReadOutModes: NoahDeviceReadOutMode[] = ['AlwaysCreateAnInventoryItem', 'OnlyCreateAnInventoryItemIfNewNoahAction', 'NeverCreateAnInventoryItem'];

export type NoahDeviceReadOutStatus = 'Ignored' | 'LinkedToSingle' | 'NotLinked' | 'LinkedToMultiple';
export const NoahDeviceReadOutStatuses: NoahDeviceReadOutStatus[] = ['Ignored', 'LinkedToSingle', 'NotLinked', 'LinkedToMultiple'];

export type ProductCatalogItemRizivHearingAidDefinitionV2LinkStatus = 'LinkedWithSingle' | 'LinkedWithMultiple' | 'NotLinked' | 'NotApplicable';
export const ProductCatalogItemRizivHearingAidDefinitionV2LinkStatuses: ProductCatalogItemRizivHearingAidDefinitionV2LinkStatus[] = ['LinkedWithSingle', 'LinkedWithMultiple', 'NotLinked', 'NotApplicable'];

export type FailedEventStatus = 'Open' | 'Ignored' | 'Resolved';
export const FailedEventStatuses: FailedEventStatus[] = ['Open', 'Ignored', 'Resolved'];

export type SubscriptionStatus = 'UpToDate' | 'ProcessingBacklog' | 'Down' | 'Unknown';
export const SubscriptionStatuses: SubscriptionStatus[] = ['UpToDate', 'ProcessingBacklog', 'Down', 'Unknown'];

export type RfiaInvoiceProcessStep = 'Tender' | 'AdvanceInvoice' | 'HandoverBeforeApprovals' | 'Payment';
export const RfiaInvoiceProcessSteps: RfiaInvoiceProcessStep[] = ['Tender', 'AdvanceInvoice', 'HandoverBeforeApprovals', 'Payment'];

export type LeftRightOrStereoType = 'Left' | 'Right' | 'Stereo';
export const LeftRightOrStereoTypes: LeftRightOrStereoType[] = ['Left', 'Right', 'Stereo'];

export type PaymentType = 'CustomerAccount' | 'CashSale' | 'SupplierAccount';
export const PaymentTypes: PaymentType[] = ['CustomerAccount', 'CashSale', 'SupplierAccount'];

export type PurchaseType = 'Invoice' | 'CreditNote';
export const PurchaseTypes: PurchaseType[] = ['Invoice', 'CreditNote'];

export type ExpenseOrIncomeType = 'Expense' | 'Income' | 'NotApplicable';
export const ExpenseOrIncomeTypes: ExpenseOrIncomeType[] = ['Expense', 'Income', 'NotApplicable'];

export type LinkViewContextType = 'Patient' | 'Rfia' | 'Sale' | 'Tender' | 'Loan' | 'Cosi' | 'TrialReport' | 'Order' | 'Repair' | 'SettlementProposal' | 'InventoryItem' | 'ProductCatalogItem' | 'RfiaHandover' | 'Delivery' | 'Purchase' | 'Return' | 'StockMovement' | 'ArticlesInquiry';
export const LinkViewContextTypes: LinkViewContextType[] = ['Patient', 'Rfia', 'Sale', 'Tender', 'Loan', 'Cosi', 'TrialReport', 'Order', 'Repair', 'SettlementProposal', 'InventoryItem', 'ProductCatalogItem', 'RfiaHandover', 'Delivery', 'Purchase', 'Return', 'StockMovement', 'ArticlesInquiry'];

export type TemplateMainContext = 'Patient' | 'Rfia' | 'Purchase' | 'Return';
export const TemplateMainContexts: TemplateMainContext[] = ['Patient', 'Rfia', 'Purchase', 'Return'];

export type DashboardNotificationType = 'InventoryItemsSoldNotPurchased' | 'InventoryItemsConsignmentExpired' | 'InventoryItemsConsignmentExpiresWithinAWeek';
export const DashboardNotificationTypes: DashboardNotificationType[] = ['InventoryItemsSoldNotPurchased', 'InventoryItemsConsignmentExpired', 'InventoryItemsConsignmentExpiresWithinAWeek'];

export type DashboardNotificationLevel = 'Warning' | 'Error';
export const DashboardNotificationLevels: DashboardNotificationLevel[] = ['Warning', 'Error'];

export type DocumentKeyType = 'String' | 'Number' | 'Date' | 'List' | 'Image';
export const DocumentKeyTypes: DocumentKeyType[] = ['String', 'Number', 'Date', 'List', 'Image'];

export type StringFormatting = 'LC' | 'UC' | 'AU' | 'AL';
export const StringFormattings: StringFormatting[] = ['LC', 'UC', 'AU', 'AL'];

export type DateFormatting = 'D' | 'DT' | 'IN';
export const DateFormattings: DateFormatting[] = ['D', 'DT', 'IN'];

export type NumberFormatting = 'N0' | 'N1' | 'N2';
export const NumberFormattings: NumberFormatting[] = ['N0', 'N1', 'N2'];

export type SpeechImageType = 'Aided' | 'Unaided' | 'StereoComparison' | 'StereoComparisonSmall' | 'AllComparison' | 'StereoComparisonDotted' | 'HeadphonesLeftRight';
export const SpeechImageTypes: SpeechImageType[] = ['Aided', 'Unaided', 'StereoComparison', 'StereoComparisonSmall', 'AllComparison', 'StereoComparisonDotted', 'HeadphonesLeftRight'];

export type PageClaim = 'Dashboard' | 'Calendar' | 'Patients' | 'Orders' | 'Repairs' | 'Rfias' | 'TailorMadeProducts' | 'Loans' | 'ProductCatalog' | 'InventoryItems' | 'Stock' | 'StockEntries' | 'Deliveries' | 'Returns' | 'StockMovements' | 'NoahDevices' | 'SearchOnSerialNumbers' | 'Tenders' | 'Sales' | 'SalesDetail' | 'Purchases' | 'CustomerAccounts' | 'SettlementProposals' | 'SupplierAccounts' | 'Payments' | 'DailyReceipts' | 'AllCommissions' | 'AllCommissionPayouts' | 'MyCommissions' | 'MyCommissionPayouts' | 'CashRegisterEntries' | 'CashRegister' | 'EntPhysicians' | 'GeneralPractitioners' | 'Suppliers' | 'VatCustomers' | 'Hifs' | 'RosaIntegration' | 'ExactOnlineIntegration' | 'ExactGlobeIntegration' | 'InvoiceForwardingIntegration' | 'PeppolIntegration' | 'CochlearIntegration' | 'Templates' | 'Locations' | 'Users' | 'BusinessData' | 'PaymentMethods';
export const PageClaims: PageClaim[] = ['Dashboard', 'Calendar', 'Patients', 'Orders', 'Repairs', 'Rfias', 'TailorMadeProducts', 'Loans', 'ProductCatalog', 'InventoryItems', 'Stock', 'StockEntries', 'Deliveries', 'Returns', 'StockMovements', 'NoahDevices', 'SearchOnSerialNumbers', 'Tenders', 'Sales', 'SalesDetail', 'Purchases', 'CustomerAccounts', 'SettlementProposals', 'SupplierAccounts', 'Payments', 'DailyReceipts', 'AllCommissions', 'AllCommissionPayouts', 'MyCommissions', 'MyCommissionPayouts', 'CashRegisterEntries', 'CashRegister', 'EntPhysicians', 'GeneralPractitioners', 'Suppliers', 'VatCustomers', 'Hifs', 'RosaIntegration', 'ExactOnlineIntegration', 'ExactGlobeIntegration', 'InvoiceForwardingIntegration', 'PeppolIntegration', 'CochlearIntegration', 'Templates', 'Locations', 'Users', 'BusinessData', 'PaymentMethods'];

export type FunctionalClaim = 'vepp' | 'cenhaxf';
export const FunctionalClaims: FunctionalClaim[] = ['vepp', 'cenhaxf'];

export type ClientClaim = 'vfu' | 'vsa' | 'ais' | 'CanImportUblPurchase' | 'hcr' | 'ExactGlobeIntegration' | 'ExactOnlineIntegration' | 'CochlearIntegration';
export const ClientClaims: ClientClaim[] = ['vfu', 'vsa', 'ais', 'CanImportUblPurchase', 'hcr', 'ExactGlobeIntegration', 'ExactOnlineIntegration', 'CochlearIntegration'];

export type PatientRequiredProperty = 'SocialSecurityNumber' | 'DateOfBirth' | 'Address' | 'PhoneNumber' | 'Email' | 'HealthInsuranceFund' | 'AttendingAudiologist' | 'OnLocation' | 'AttendingEntPhysician' | 'AttendingGeneralPractitioner' | 'Origins' | 'Labels' | 'Reference';
export const PatientRequiredPropertys: PatientRequiredProperty[] = ['SocialSecurityNumber', 'DateOfBirth', 'Address', 'PhoneNumber', 'Email', 'HealthInsuranceFund', 'AttendingAudiologist', 'OnLocation', 'AttendingEntPhysician', 'AttendingGeneralPractitioner', 'Origins', 'Labels', 'Reference'];

export type CalendarEventRequiredProperty = 'Contact' | 'Title' | 'EventType' | 'Description' | 'Room';
export const CalendarEventRequiredPropertys: CalendarEventRequiredProperty[] = ['Contact', 'Title', 'EventType', 'Description', 'Room'];

export type PatientSearchMode = 'AllFields' | 'Name' | 'Phone' | 'SocialSecurityNumber' | 'DateOfBirth' | 'Address';
export const PatientSearchModes: PatientSearchMode[] = ['AllFields', 'Name', 'Phone', 'SocialSecurityNumber', 'DateOfBirth', 'Address'];

export type OriginalOrLatestDocumentExportMode = 'OriginalDocument' | 'LastDocument';
export const OriginalOrLatestDocumentExportModes: OriginalOrLatestDocumentExportMode[] = ['OriginalDocument', 'LastDocument'];

export type NotificationType = 'ReleaseNote' | 'Information';
export const NotificationTypes: NotificationType[] = ['ReleaseNote', 'Information'];

export type BatteryType = '312' | '10' | '13' | '675' | 'R';
export const BatteryTypes: BatteryType[] = ['312', '10', '13', '675', 'R'];

export type HearingAidType = 'BTE' | 'ITE';
export const HearingAidTypes: HearingAidType[] = ['BTE', 'ITE'];

export type Orientation = 'Left' | 'Right';
export const Orientations: Orientation[] = ['Left', 'Right'];

export type RosaCalendarViewType = 'Day' | 'Week' | 'Month' | 'Year' | 'Timeline' | 'List';
export const RosaCalendarViewTypes: RosaCalendarViewType[] = ['Day', 'Week', 'Month', 'Year', 'Timeline', 'List'];

export type PatientDetailOverviewLayoutElementType = 'Comments' | 'TonalAudiogram' | 'AssignedArticles' | 'Workflows' | 'Sales' | 'LastAppointments';
export const PatientDetailOverviewLayoutElementTypes: PatientDetailOverviewLayoutElementType[] = ['Comments', 'TonalAudiogram', 'AssignedArticles', 'Workflows', 'Sales', 'LastAppointments'];

export type ArticlesInquiryLineStatusType = 'Assigned' | 'PartialAssigned' | 'Unassigned';
export const ArticlesInquiryLineStatusTypes: ArticlesInquiryLineStatusType[] = ['Assigned', 'PartialAssigned', 'Unassigned'];

export type ArticlesInquiryStatusType = 'Assigned' | 'PartialAssigned' | 'Unassigned' | 'Cancelled';
export const ArticlesInquiryStatusTypes: ArticlesInquiryStatusType[] = ['Assigned', 'PartialAssigned', 'Unassigned', 'Cancelled'];

export type RfiaHandoverSaleGenerationMode = 'GenerateSingleInvoice' | 'GenerateMultipleInvoices' | 'AskEveryTime';
export const RfiaHandoverSaleGenerationModes: RfiaHandoverSaleGenerationMode[] = ['GenerateSingleInvoice', 'GenerateMultipleInvoices', 'AskEveryTime'];

export type RosaEventStatus = 'Active' | 'Pending' | 'Canceled' | 'Deleted' | 'NoShow' | 'InWaitingRoom' | 'InConsultation' | 'Overdue' | 'Seen';
export const RosaEventStatuses: RosaEventStatus[] = ['Active', 'Pending', 'Canceled', 'Deleted', 'NoShow', 'InWaitingRoom', 'InConsultation', 'Overdue', 'Seen'];

export type PhoneNumberRegion = 'BE' | 'NL' | 'LU';
export const PhoneNumberRegions: PhoneNumberRegion[] = ['BE', 'NL', 'LU'];

export type ContactInfoType = 'Email' | 'Phone';
export const ContactInfoTypes: ContactInfoType[] = ['Email', 'Phone'];

export type ProductCatalogItemType = 'HearingInstrument' | 'RemoteControl' | 'Earmould' | 'HearingProtection' | 'Receiver' | 'Charger' | 'Dome' | 'Other' | 'Service' | 'ProlongedWarranty' | 'Insurance' | 'DiscountArticle';
export const ProductCatalogItemTypes: ProductCatalogItemType[] = ['HearingInstrument', 'RemoteControl', 'Earmould', 'HearingProtection', 'Receiver', 'Charger', 'Dome', 'Other', 'Service', 'ProlongedWarranty', 'Insurance', 'DiscountArticle'];

export type RosaEnvironment = 'Staging' | 'Prod';
export const RosaEnvironments: RosaEnvironment[] = ['Staging', 'Prod'];

export type ExactOnlineGLAccountMatchMode = 'UseProductCatalog' | 'UseFallback';
export const ExactOnlineGLAccountMatchModes: ExactOnlineGLAccountMatchMode[] = ['UseProductCatalog', 'UseFallback'];

export type ExactOnlineCostCenterMode = 'DontFillIn' | 'FillIn';
export const ExactOnlineCostCenterModes: ExactOnlineCostCenterMode[] = ['DontFillIn', 'FillIn'];

export type PurchasesPrefilter = 'All' | 'NotPaid' | 'Overdue';
export const PurchasesPrefilters: PurchasesPrefilter[] = ['All', 'NotPaid', 'Overdue'];

export type SalesPrefilter = 'All' | 'NotPaid' | 'Overdue';
export const SalesPrefilters: SalesPrefilter[] = ['All', 'NotPaid', 'Overdue'];

export type TendersPrefilter = 'All' | 'Expired' | 'NotLostAndExpired' | 'Invoiced';
export const TendersPrefilters: TendersPrefilter[] = ['All', 'Expired', 'NotLostAndExpired', 'Invoiced'];

export type SalesSearchMode = 'AllFields' | 'Reference' | 'AmountToPay';
export const SalesSearchModes: SalesSearchMode[] = ['AllFields', 'Reference', 'AmountToPay'];

export type InvoiceForwardingMode = 'OnInvoiceCreated' | 'OnDocumentCreated';
export const InvoiceForwardingModes: InvoiceForwardingMode[] = ['OnInvoiceCreated', 'OnDocumentCreated'];

export type InvoiceForwardingPrefilter = 'All' | 'NotIgnoredNorForwarded';
export const InvoiceForwardingPrefilters: InvoiceForwardingPrefilter[] = ['All', 'NotIgnoredNorForwarded'];

export type UserRole = 'Normal' | 'Admin' | 'SuperUser';
export const UserRoles: UserRole[] = ['Normal', 'Admin', 'SuperUser'];

export type ExactOnlineCustomerAccountPrefilter = 'All' | 'NotLinked' | 'Linked';
export const ExactOnlineCustomerAccountPrefilters: ExactOnlineCustomerAccountPrefilter[] = ['All', 'NotLinked', 'Linked'];

export type ExactOnlineSalePrefilter = 'All' | 'NotIgnoredNorSynced' | 'Synced' | 'Ignored';
export const ExactOnlineSalePrefilters: ExactOnlineSalePrefilter[] = ['All', 'NotIgnoredNorSynced', 'Synced', 'Ignored'];

export type OrderPrefilter = 'All' | 'NotDeliveredYet' | 'Overdue' | 'ToPlaceWithSupplier';
export const OrderPrefilters: OrderPrefilter[] = ['All', 'NotDeliveredYet', 'Overdue', 'ToPlaceWithSupplier'];

export type RepairPrefilter = 'All' | 'NotSentToSupplier' | 'InRepair' | 'ToHandoverToPatient' | 'WithWarning';
export const RepairPrefilters: RepairPrefilter[] = ['All', 'NotSentToSupplier', 'InRepair', 'ToHandoverToPatient', 'WithWarning'];

export type ArticlesInquiriesPrefilter = 'All' | 'Unassigned';
export const ArticlesInquiriesPrefilters: ArticlesInquiriesPrefilter[] = ['All', 'Unassigned'];

export type LoansPrefilter = 'All' | 'LentOut';
export const LoansPrefilters: LoansPrefilter[] = ['All', 'LentOut'];

export type CalendarMode = 'Hams' | 'Rosa' | 'NotSet';
export const CalendarModes: CalendarMode[] = ['Hams', 'Rosa', 'NotSet'];

export type ApplicationLogoutMode = 'Never' | 'After20Minutes';
export const ApplicationLogoutModes: ApplicationLogoutMode[] = ['Never', 'After20Minutes'];

export type ExactGlobeSaleStatus = 'Created' | 'Exported' | 'Handled';
export const ExactGlobeSaleStatuses: ExactGlobeSaleStatus[] = ['Created', 'Exported', 'Handled'];

export type ExactGlobeSalePrefilter = 'All' | 'Unhandled' | 'Exported' | 'Handled' | 'HasError';
export const ExactGlobeSalePrefilters: ExactGlobeSalePrefilter[] = ['All', 'Unhandled', 'Exported', 'Handled', 'HasError'];

export type ExactGlobeProductCatalogItemPrefilter = 'All' | 'NotLinked' | 'Linked';
export const ExactGlobeProductCatalogItemPrefilters: ExactGlobeProductCatalogItemPrefilter[] = ['All', 'NotLinked', 'Linked'];

export type ExactGlobeCustomerAccountPrefilter = 'All' | 'Unhandled' | 'Exported' | 'Handled';
export const ExactGlobeCustomerAccountPrefilters: ExactGlobeCustomerAccountPrefilter[] = ['All', 'Unhandled', 'Exported', 'Handled'];

export type ExactGlobeCustomerAccountType = 'Patient' | 'Company' | 'Hif';
export const ExactGlobeCustomerAccountTypes: ExactGlobeCustomerAccountType[] = ['Patient', 'Company', 'Hif'];

export type ExactGlobeCustomerAccountStatus = 'Created' | 'Exported' | 'Handled';
export const ExactGlobeCustomerAccountStatuses: ExactGlobeCustomerAccountStatus[] = ['Created', 'Exported', 'Handled'];

export type HpCosiDegreeOfChange = 'Worse' | 'NoDifference' | 'SlightlyBetter' | 'Better' | 'MuchBetter';
export const HpCosiDegreeOfChanges: HpCosiDegreeOfChange[] = ['Worse', 'NoDifference', 'SlightlyBetter', 'Better', 'MuchBetter'];

export type HpCosiEndResult = 'AlmostNever' | 'Sometimes' | 'HalfTheTime' | 'MostOfTheTime' | 'Always';
export const HpCosiEndResults: HpCosiEndResult[] = ['AlmostNever', 'Sometimes', 'HalfTheTime', 'MostOfTheTime', 'Always'];

export type HpCosiDomain = 'SoundDetection' | 'SpeechReceptionWithoutNoise' | 'SpeechReceptionWithNoise' | 'NoiseTolerance' | 'Focus' | 'Localization';
export const HpCosiDomains: HpCosiDomain[] = ['SoundDetection', 'SpeechReceptionWithoutNoise', 'SpeechReceptionWithNoise', 'NoiseTolerance', 'Focus', 'Localization'];

export type FrequencyIntensity = 'NotApplicable' | 'AlmostNever' | 'Sometimes' | 'Often' | 'Always';
export const FrequencyIntensitys: FrequencyIntensity[] = ['NotApplicable', 'AlmostNever', 'Sometimes', 'Often', 'Always'];

export type FrequencyPeriodicity = 'Daily' | 'Weekly' | 'Monthly';
export const FrequencyPeriodicitys: FrequencyPeriodicity[] = ['Daily', 'Weekly', 'Monthly'];

export type IntensityLevel = 'NotApplicable' | 'VeryMuch' | 'Much' | 'Somewhat' | 'None';
export const IntensityLevels: IntensityLevel[] = ['NotApplicable', 'VeryMuch', 'Much', 'Somewhat', 'None'];

export type PeppolRecordStatus = 'New' | 'Ignored' | 'Sending' | 'Sent' | 'Invalid' | 'Failed';
export const PeppolRecordStatuses: PeppolRecordStatus[] = ['New', 'Ignored', 'Sending', 'Sent', 'Invalid', 'Failed'];

export type PeppolRecordPrefilter = 'All' | 'Unhandled' | 'Ignored';
export const PeppolRecordPrefilters: PeppolRecordPrefilter[] = ['All', 'Unhandled', 'Ignored'];

export type PeppolEnvironment = 'Staging' | 'Production';
export const PeppolEnvironments: PeppolEnvironment[] = ['Staging', 'Production'];

export type CochlearInfoEventType = 'Patient' | 'Audiologist';
export const CochlearInfoEventTypes: CochlearInfoEventType[] = ['Patient', 'Audiologist'];

export type CochlearMediaType = 'Image' | 'Video' | 'Pdf' | 'Unknown';
export const CochlearMediaTypes: CochlearMediaType[] = ['Image', 'Video', 'Pdf', 'Unknown'];

export type CochlearPatientStatus = 'Registered' | 'Informed' | 'Referred' | 'Implanted' | 'BimodallyFitted';
export const CochlearPatientStatuses: CochlearPatientStatus[] = ['Registered', 'Informed', 'Referred', 'Implanted', 'BimodallyFitted'];

export type CochlearReferralMaterialType = 'Patient' | 'Professional';
export const CochlearReferralMaterialTypes: CochlearReferralMaterialType[] = ['Patient', 'Professional'];

export type CochlearReferralMaterialLanguage = 'nl' | 'fr' | 'en';
export const CochlearReferralMaterialLanguages: CochlearReferralMaterialLanguage[] = ['nl', 'fr', 'en'];

export type InterchangeableTangibleType = 'Earmould' | 'HearingProtection' | 'Receiver' | 'Charger' | 'Dome' | 'Other';
export const InterchangeableTangibleTypes: InterchangeableTangibleType[] = ['Earmould', 'HearingProtection', 'Receiver', 'Charger', 'Dome', 'Other'];

export type IntangibleType = 'Service' | 'Insurance' | 'ProlongedWarranty' | 'DiscountArticle';
export const IntangibleTypes: IntangibleType[] = ['Service', 'Insurance', 'ProlongedWarranty', 'DiscountArticle'];

export type TangibleType = 'HearingInstrument' | 'RemoteControl' | 'Earmould' | 'HearingProtection' | 'Receiver' | 'Charger' | 'Dome' | 'Other';
export const TangibleTypes: TangibleType[] = ['HearingInstrument', 'RemoteControl', 'Earmould', 'HearingProtection', 'Receiver', 'Charger', 'Dome', 'Other'];

export type HearingInstrumentReceiverEarmouldType = 'HearingInstrument' | 'Receiver' | 'Earmould';
export const HearingInstrumentReceiverEarmouldTypes: HearingInstrumentReceiverEarmouldType[] = ['HearingInstrument', 'Receiver', 'Earmould'];
